import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from '@apollo/client'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
	[K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]: Maybe<T[SubKey]>
}
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: string
	String: string
	Boolean: boolean
	Int: number
	Float: number
	AccountNumber: any
	BigInt: any
	Byte: any
	CountryCode: any
	CountryName: any
	Cuid: any
	Cuid2: any
	Currency: any
	DID: any
	Date: any
	DateTime: any
	DateTimeISO: any
	DeweyDecimal: any
	Duration: any
	EmailAddress: any
	GUID: any
	GeoJSON: any
	HSL: any
	HSLA: any
	HexColorCode: any
	Hexadecimal: any
	IBAN: any
	IP: any
	IPCPatent: any
	IPv4: any
	IPv6: any
	ISBN: any
	ISO8601Duration: any
	JSON: any
	JSONObject: any
	JWT: any
	LCCSubclass: any
	Latitude: any
	LocalDate: any
	LocalDateTime: any
	LocalEndTime: any
	LocalTime: any
	Locale: any
	Long: any
	Longitude: any
	MAC: any
	NegativeFloat: any
	NegativeInt: any
	NonEmptyString: any
	NonNegativeFloat: any
	NonNegativeInt: any
	NonPositiveFloat: any
	NonPositiveInt: any
	ObjectID: any
	PhoneNumber: any
	Port: any
	PositiveFloat: any
	PositiveInt: any
	PostalCode: any
	RGB: any
	RGBA: any
	RoutingNumber: any
	SESSN: any
	SafeInt: any
	SemVer: any
	Time: any
	TimeZone: any
	Timestamp: any
	ULID: any
	URL: any
	USCurrency: any
	UUID: any
	UnsignedFloat: any
	UnsignedInt: any
	Upload: any
	UtcOffset: any
	Void: any
}

export enum Action_Type {
	Create = 'CREATE',
	Delete = 'DELETE',
	Read = 'READ',
	Update = 'UPDATE',
}

export type ActivateBarResponse = {
	__typename?: 'ActivateBarResponse'
	bar?: Maybe<Bar>
	errors?: Maybe<Array<Error>>
	storageToken?: Maybe<Scalars['String']>
}

export type AddButton = {
	name: Scalars['String']
	rootId: Scalars['Int']
	routerId?: InputMaybe<Scalars['Int']>
	serialNumber: Scalars['MAC']
}

export type AddButtonResponse = {
	__typename?: 'AddButtonResponse'
	button?: Maybe<Button>
	errors?: Maybe<Array<Error>>
}

export type AddCalendarInput = {
	calendarId?: InputMaybe<Scalars['String']>
	calendarName?: InputMaybe<Scalars['String']>
	calendarProvider: CalendarProvider
	calendarType: CalendarType
	email: Scalars['String']
	name: Scalars['String']
	taskListId?: InputMaybe<Scalars['String']>
	taskListName?: InputMaybe<Scalars['String']>
	templateVariantId: Scalars['Int']
	tenantId?: InputMaybe<Scalars['String']>
	userId: Scalars['Int']
	userUuid?: InputMaybe<Scalars['String']>
}

export type AddCalendarResponse = {
	__typename?: 'AddCalendarResponse'
	calendar?: Maybe<Calendar>
	errors?: Maybe<Array<Error>>
	success: Scalars['Boolean']
}

export type AddChannelInput = {
	channelItems: Array<ChannelItemInput>
	displayType?: InputMaybe<DisplayType>
	marketId?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	orientation?: InputMaybe<ChannelOrientation>
	tags?: InputMaybe<Array<Scalars['String']>>
}

export type AddDeviceAlarmReportInput = {
	batteryPercentage?: InputMaybe<Scalars['Int']>
	batteryUnderCount?: InputMaybe<Scalars['Boolean']>
	days: Array<DayEnum>
	deviceErrCount?: InputMaybe<Scalars['Boolean']>
	deviceOffline?: InputMaybe<Scalars['Boolean']>
	includeAllLocations?: InputMaybe<Scalars['Boolean']>
	name: Scalars['String']
	rootIds: Array<Scalars['Int']>
	routerOffline?: InputMaybe<Scalars['Boolean']>
	time?: InputMaybe<Scalars['DateTime']>
	userIds: Array<Scalars['Int']>
}

export type AddDeviceAlarmReportResponse = {
	__typename?: 'AddDeviceAlarmReportResponse'
	deviceAlarmReport?: Maybe<DeviceAlarmReport>
	errors?: Maybe<Array<Error>>
	success: Scalars['Boolean']
}

export type AddFlowInput = {
	flowStatements: Array<AddFlowStatementInput>
	name?: InputMaybe<Scalars['String']>
	validFrom?: InputMaybe<Scalars['DateTime']>
	validTo?: InputMaybe<Scalars['DateTime']>
}

export type AddFlowResponse = {
	__typename?: 'AddFlowResponse'
	errors?: Maybe<Array<Error>>
	flow?: Maybe<Flow>
	success?: Maybe<Scalars['Boolean']>
}

export type AddFlowStatementInput = {
	flowComponents: Array<FlowComponentInput>
	products?: InputMaybe<Array<FlowProductInput>>
	templateId?: InputMaybe<Scalars['Int']>
	type: FlowStatementType
}

export type AddIntegrationInput = {
	cron?: InputMaybe<Scalars['String']>
	cronUpdateUrl: Scalars['String']
	name: Scalars['String']
	preset?: InputMaybe<CronPreset>
	secretKey: Scalars['String']
	syncTime?: InputMaybe<Scalars['String']>
	token: Scalars['String']
	triggerUrl: Scalars['String']
	weekDays?: InputMaybe<Array<WeekDay>>
}

export type AddIntegrationResponse = {
	__typename?: 'AddIntegrationResponse'
	errors?: Maybe<Array<Maybe<Error>>>
	integration?: Maybe<Integration>
}

export type AddMarketInput = {
	key: Scalars['String']
	name: Scalars['String']
}

export type AddOrderInput = {
	costumerId?: InputMaybe<Scalars['Int']>
	mode?: InputMaybe<OrderMode>
	orderItems?: InputMaybe<Array<AddOrderItemInput>>
	orderNumber: Scalars['String']
	orderType: OrderType
	rootId?: InputMaybe<Scalars['Int']>
	supplierId?: InputMaybe<Scalars['Int']>
}

export type AddOrderItemInput = {
	completedDate?: InputMaybe<Scalars['DateTime']>
	deliveryDate: Scalars['DateTime']
	productId: Scalars['Int']
	quantity: Scalars['Int']
	status: OrderStatus
}

export type AddOrderResponse = {
	__typename?: 'AddOrderResponse'
	errors?: Maybe<Array<Maybe<Error>>>
	order?: Maybe<Order>
}

export type AddPlaylistInput = {
	name: Scalars['String']
	playlistItems: Array<PlaylistItemInput>
}

export type AddProductResponse = {
	__typename?: 'AddProductResponse'
	errors?: Maybe<Array<Error>>
	/** product added by the mutation */
	product?: Maybe<Product>
	success?: Maybe<Scalars['Boolean']>
}

export type AddRoleInput = {
	permissions: Array<Scalars['String']>
	rank?: InputMaybe<Scalars['Int']>
	value: Scalars['String']
}

export type AddRootInput = {
	address?: InputMaybe<Scalars['String']>
	burninPrevention?: InputMaybe<Scalars['Boolean']>
	key?: InputMaybe<Scalars['String']>
	latitude?: InputMaybe<Scalars['Float']>
	longitude?: InputMaybe<Scalars['Float']>
	marketId?: InputMaybe<Scalars['Int']>
	mode?: InputMaybe<RootMode>
	name: Scalars['String']
	tags?: InputMaybe<Array<Scalars['String']>>
	timezone?: InputMaybe<Scalars['String']>
}

export type AddRouterInput = {
	name: Scalars['String']
	rootId: Scalars['Int']
}

export type AddRouterProvisioningInput = {
	customer: Scalars['String']
	name?: InputMaybe<Scalars['String']>
	rootId: Scalars['Int']
	routerUuid: Scalars['String']
}

export type AddRouterProvisioningResponse = {
	__typename?: 'AddRouterProvisioningResponse'
	errors?: Maybe<Array<Error>>
	routerProvisioning?: Maybe<RouterProvisioning>
	success?: Maybe<Scalars['Boolean']>
}

export type AddRouterResponse = {
	__typename?: 'AddRouterResponse'
	errors?: Maybe<Array<Error>>
	router?: Maybe<Router>
}

export type AddSensorInput = {
	name: Scalars['String']
	rootId: Scalars['Int']
	sensorType?: InputMaybe<SensorType>
	serialNumber: Scalars['MAC']
	tags?: InputMaybe<Array<Scalars['String']>>
}

export type AddSignageButton = {
	buttonId: Scalars['Int']
	channelId: Scalars['Int']
	durationSeconds: Scalars['Int']
	virtualStoreDeviceId: Scalars['Int']
}

export type AddSignageButtonResponse = {
	__typename?: 'AddSignageButtonResponse'
	errors?: Maybe<Array<Error>>
	signageButton?: Maybe<SignageButton>
}

export type AddSupplier = {
	address: Scalars['String']
	addressNumber: Scalars['String']
	city: Scalars['String']
	companyName: Scalars['String']
	country: Country
	email: Scalars['String']
	postCode: Scalars['String']
	supplierId: Scalars['String']
	supplierRootSettings?: InputMaybe<Array<SupplierRootSettingsInput>>
	vat: Scalars['String']
}

export type AddSupplierResponse = {
	__typename?: 'AddSupplierResponse'
	errors?: Maybe<Array<Error>>
	supplier?: Maybe<Supplier>
}

export type AddSynchronizationInput = {
	integrationId?: InputMaybe<Scalars['Int']>
	integrationToken?: InputMaybe<Scalars['String']>
	note?: InputMaybe<Scalars['String']>
	status: SynchronizationStatus
	time?: InputMaybe<Scalars['DateTime']>
	updatedProducts: Array<Scalars['String']>
}

export type AddSynchronizationResponse = {
	__typename?: 'AddSynchronizationResponse'
	errors?: Maybe<Array<Maybe<Error>>>
	synchronization?: Maybe<Synchronization>
}

export type AddTenantInput = {
	address: Scalars['String']
	addressNumber: Scalars['String']
	adminUser: AdminUserInput
	city: Scalars['String']
	companyName: Scalars['String']
	contractLength: ContractLength
	contractorName: Scalars['String']
	contractorsMail?: InputMaybe<Scalars['String']>
	country: Country
	loginLogo?: InputMaybe<Scalars['String']>
	logo?: InputMaybe<Scalars['String']>
	maxRoots: Scalars['Int']
	maxUsers: Scalars['Int']
	name: Scalars['String']
	postCode: Scalars['String']
	primaryColor?: InputMaybe<Scalars['String']>
	purchasedModules: Array<PurchasedModules>
	startDate?: InputMaybe<Scalars['DateTime']>
	textColor?: InputMaybe<Scalars['String']>
	usesDeviceName?: InputMaybe<Scalars['Boolean']>
	usesDualProduct?: InputMaybe<Scalars['Boolean']>
	usesMarkets?: InputMaybe<Scalars['Boolean']>
	usesPlanogram?: InputMaybe<Scalars['Boolean']>
	usesRootProducts?: InputMaybe<Scalars['Boolean']>
	vat: Scalars['String']
}

export type AddTenantResponse = {
	__typename?: 'AddTenantResponse'
	errors?: Maybe<Array<Error>>
	success?: Maybe<Scalars['Boolean']>
	tenant?: Maybe<Tenant>
}

export type AddUserInput = {
	allowedIPs?: InputMaybe<Array<Scalars['IPv4']>>
	email?: InputMaybe<Scalars['String']>
	firstName: Scalars['String']
	lastName: Scalars['String']
	ledConfig?: InputMaybe<LedConfigInput>
	marketIDs?: InputMaybe<Array<Scalars['Int']>>
	password: Scalars['String']
	roleIDs: Array<Scalars['Int']>
	rootIDs?: InputMaybe<Array<Scalars['Int']>>
	sendVerificationEmail?: InputMaybe<Scalars['Boolean']>
	username: Scalars['String']
}

export type AddVirtualCategoryPointInput = {
	name?: InputMaybe<Scalars['String']>
	virtualRackIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>
}

export type AddVirtualCategoryPointPosition = {
	virtualCategoryPointId: Scalars['Int']
	x: Scalars['Int']
	y: Scalars['Int']
}

export type AddVirtualCategoryScreenInput = {
	backgroundFileId?: InputMaybe<Scalars['Int']>
	catalogMode?: InputMaybe<Scalars['Boolean']>
	channelId?: InputMaybe<Scalars['Int']>
	fileId?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	timeout?: InputMaybe<Scalars['Int']>
	virtualCategoryPointPositions?: InputMaybe<
		Array<InputMaybe<AddVirtualCategoryPointPosition>>
	>
}

export type AddVirtualMultiScreenInput = {
	name?: InputMaybe<Scalars['String']>
	virtualMultiScreenPositions?: InputMaybe<
		Array<InputMaybe<AddVirtualMultiScreenPositionInput>>
	>
}

export type AddVirtualMultiScreenPositionInput = {
	channelId?: InputMaybe<Scalars['Int']>
	virtualCategoryPointId?: InputMaybe<Scalars['Int']>
	virtualRackId?: InputMaybe<Scalars['Int']>
}

export type AddVirtualProductPositionInput = {
	itemCount?: InputMaybe<Scalars['Int']>
	productId: Scalars['Int']
	rotation?: InputMaybe<Scalars['Int']>
	zoom?: InputMaybe<Scalars['Int']>
}

export type AddVirtualRackInput = {
	fileId?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	removePadding?: InputMaybe<Scalars['Boolean']>
	virtualShelfPositions: Array<AddVirtualShelfPositionInput>
	virtualStoreDeviceIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>
}

export type AddVirtualShelfInput = {
	fileId?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	spacing?: InputMaybe<Scalars['Float']>
	variant: VirtualShelfVariant
	virtualProductPositions?: InputMaybe<Array<AddVirtualProductPositionInput>>
}

export type AddVirtualShelfPositionInput = {
	virtualShelfId: Scalars['Int']
}

export type AddVirtualStoreDeviceInput = {
	channelId?: InputMaybe<Scalars['Int']>
	ip?: InputMaybe<Scalars['IPv4']>
	name?: InputMaybe<Scalars['String']>
	note?: InputMaybe<Scalars['String']>
	powerWindows?: InputMaybe<Array<DevicePowerWindowInput>>
	rootId: Scalars['Int']
	tags?: InputMaybe<Array<Scalars['String']>>
	token: Scalars['String']
	virtualCategoryPointId?: InputMaybe<Scalars['Int']>
	virtualCategoryScreenId?: InputMaybe<Scalars['Int']>
	virtualMultiScreenId?: InputMaybe<Scalars['Int']>
}

export type AdminUserInput = {
	email: Scalars['String']
	password: Scalars['String']
	username: Scalars['String']
}

export type AdminUserUpdateInput = {
	email?: InputMaybe<Scalars['String']>
	id: Scalars['Int']
	password?: InputMaybe<Scalars['String']>
	username?: InputMaybe<Scalars['String']>
}

export type Aisle = {
	__typename?: 'Aisle'
	/** bays connected to a aisle */
	bays?: Maybe<Array<Bay>>
	depth?: Maybe<Scalars['Int']>
	height?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	/** aisle key */
	key: Scalars['String']
	name?: Maybe<Scalars['String']>
	orientation?: Maybe<Orientation>
	root?: Maybe<Root>
	/** @deprecated Use `bays`. */
	shelves?: Maybe<Array<Shelf>>
	width?: Maybe<Scalars['Int']>
	x?: Maybe<Scalars['Int']>
	y?: Maybe<Scalars['Int']>
}

export type AisleResponse = {
	__typename?: 'AisleResponse'
	aisle?: Maybe<Aisle>
	errors?: Maybe<Array<Maybe<Error>>>
	success?: Maybe<Scalars['Boolean']>
}

export enum AlarmType {
	Expiration = 'expiration',
	Express = 'express',
	None = 'none',
	Normal = 'normal',
}

export type ApiClientInfo = {
	__typename?: 'ApiClientInfo'
	clientKey: Scalars['String']
	createdAt: Scalars['String']
	expiresAt?: Maybe<Scalars['String']>
	id: Scalars['ID']
	isActive: Scalars['Boolean']
	lastUsed?: Maybe<Scalars['String']>
	name: Scalars['String']
	roleIDs: Array<Scalars['Int']>
	rootIDs?: Maybe<Array<Scalars['Int']>>
}

export type AssetDownload = {
	__typename?: 'AssetDownload'
	token?: Maybe<Scalars['String']>
	url?: Maybe<Scalars['String']>
}

export type AuditLog = {
	__typename?: 'AuditLog'
	author?: Maybe<User>
	authorId?: Maybe<Scalars['Int']>
	authorType: Scalars['String']
	createdAt: Scalars['DateTime']
	entityAfter?: Maybe<Scalars['String']>
	entityBefore?: Maybe<Scalars['String']>
	entityId: Scalars['String']
	entityType: Scalars['String']
	event: Scalars['String']
	id: Scalars['Int']
}

export enum AuditLogEntityType {
	Device = 'Device',
	Product = 'Product',
	User = 'User',
}

export enum AuditLogEntityTypeFilter {
	All = 'All',
	Device = 'Device',
	Product = 'Product',
	User = 'User',
}

export type AuditLogsFilter = {
	authorId?: InputMaybe<Scalars['Int']>
	authorType?: InputMaybe<AuthorType>
	endDate?: InputMaybe<Scalars['DateTime']>
	entityType?: InputMaybe<AuditLogEntityTypeFilter>
	startDate?: InputMaybe<Scalars['DateTime']>
}

export type AuditLogsPagination = {
	__typename?: 'AuditLogsPagination'
	nodes: Array<AuditLog>
	totalCount: Scalars['Int']
}

export enum AuthorType {
	Api = 'api',
	User = 'user',
}

export type AutofillCoordinatesResponse = {
	__typename?: 'AutofillCoordinatesResponse'
	eligibleCount: Scalars['Int']
	errorCount: Scalars['Int']
	errors?: Maybe<Array<Error>>
	success: Scalars['Boolean']
	successCount: Scalars['Int']
}

export type Bar = {
	__typename?: 'Bar'
	backgroundFile?: Maybe<File>
	devices?: Maybe<Array<Device>>
	fileId?: Maybe<Scalars['Int']>
	group?: Maybe<Group>
	groupId?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	macAddress?: Maybe<Scalars['MAC']>
	name?: Maybe<Scalars['String']>
	root?: Maybe<Root>
	rootId?: Maybe<Scalars['Int']>
	shelf?: Maybe<Shelf>
	shelfId?: Maybe<Scalars['Int']>
	size: DeviceSize
	x?: Maybe<Scalars['Int']>
	y?: Maybe<Scalars['Int']>
	z?: Maybe<Scalars['Int']>
}

export type BarRegisterInput = {
	deviceIds?: InputMaybe<Array<Scalars['Int']>>
	rootId: Scalars['Int']
	shelfId?: InputMaybe<Scalars['Int']>
	size: DeviceSize
	token: Scalars['String']
	x?: InputMaybe<Scalars['Int']>
}

export type BarResponse = {
	__typename?: 'BarResponse'
	bar?: Maybe<Bar>
	errors?: Maybe<Array<Error>>
}

export type BarsFilter = {
	barMacAddress?: InputMaybe<Scalars['String']>
	rootId?: InputMaybe<Scalars['Int']>
}

export type BarsPagination = {
	__typename?: 'BarsPagination'
	nodes: Array<Maybe<Bar>>
	totalCount: Scalars['Int']
}

export type Bay = {
	__typename?: 'Bay'
	aisle?: Maybe<Aisle>
	id: Scalars['Int']
	/** bay key */
	key: Scalars['String']
	/** @deprecated Use `key`. */
	name?: Maybe<Scalars['String']>
	/** @deprecated Never used */
	orientation?: Maybe<Orientation>
	root?: Maybe<Root>
	sequence?: Maybe<Scalars['Int']>
	/** shelves connected to a bay */
	shelves?: Maybe<Array<Shelf>>
	width?: Maybe<Scalars['Int']>
}

export type BayInput = {
	aisleId: Scalars['Int']
	key: Scalars['String']
	sequence?: InputMaybe<Scalars['Int']>
	width?: InputMaybe<Scalars['Int']>
}

export type BayResponse = {
	__typename?: 'BayResponse'
	bay?: Maybe<Bay>
	errors?: Maybe<Array<Maybe<Error>>>
	success?: Maybe<Scalars['Boolean']>
}

export enum BlinkSpeed {
	Fast = 'FAST',
	Slow = 'SLOW',
	Standard = 'STANDARD',
}

export enum BlinkTime {
	Long = 'LONG',
	Short = 'SHORT',
	Standard = 'STANDARD',
	VeryLong = 'VERY_LONG',
}

export type BulkAssignRouterInput = {
	rootId: Scalars['Int']
	routerId: Scalars['Int']
}

export type BulkUnassignRouterInput = {
	rootId: Scalars['Int']
}

export type Button = {
	__typename?: 'Button'
	active?: Maybe<Scalars['Boolean']>
	batteryLevel?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	name?: Maybe<Scalars['String']>
	root: Root
	rootId: Scalars['Int']
	router?: Maybe<Router>
	routerId?: Maybe<Scalars['Int']>
	rssi?: Maybe<Scalars['Int']>
	serialNumber: Scalars['String']
}

export enum ButtonActions {
	ExpressOrder = 'EXPRESS_ORDER',
}

export type ButtonResponse = {
	__typename?: 'ButtonResponse'
	button?: Maybe<Button>
	errors?: Maybe<Array<Error>>
}

export type ButtonsFilter = {
	any?: InputMaybe<Scalars['String']>
	rootId?: InputMaybe<Scalars['Int']>
}

export type ButtonsPagination = {
	__typename?: 'ButtonsPagination'
	nodes?: Maybe<Array<Button>>
	totalCount: Scalars['Int']
}

export type Calendar = {
	__typename?: 'Calendar'
	calendarId?: Maybe<Scalars['String']>
	calendarName?: Maybe<Scalars['String']>
	calendarProvider: CalendarProvider
	calendarType: CalendarType
	email: Scalars['String']
	id: Scalars['Int']
	product: Product
	refreshToken?: Maybe<Scalars['String']>
	taskListId?: Maybe<Scalars['String']>
	taskListName?: Maybe<Scalars['String']>
	templateVariant?: Maybe<TemplateVariant>
	templateVariantId?: Maybe<Scalars['Int']>
	tenantId?: Maybe<Scalars['String']>
	userUuid?: Maybe<Scalars['String']>
}

export enum CalendarProvider {
	Google = 'GOOGLE',
	Microsoft = 'MICROSOFT',
}

export type CalendarResponse = {
	__typename?: 'CalendarResponse'
	calendar?: Maybe<Calendar>
	errors?: Maybe<Array<Error>>
}

export enum CalendarType {
	Calendar = 'CALENDAR',
	Room = 'ROOM',
}

export type CalendarsFilter = {
	deviceSize?: InputMaybe<TemplateType>
	name?: InputMaybe<Scalars['String']>
}

export type CalendarsPaginations = {
	__typename?: 'CalendarsPaginations'
	nodes: Array<Calendar>
	totalCount: Scalars['Int']
}

export type Channel = {
	__typename?: 'Channel'
	channelItems?: Maybe<Array<ChannelItem>>
	devices?: Maybe<Array<Maybe<Device>>>
	displays?: Maybe<Array<Display>>
	id: Scalars['Int']
	market?: Maybe<Market>
	marketId?: Maybe<Scalars['Int']>
	name?: Maybe<Scalars['String']>
	orientation?: Maybe<ChannelOrientation>
	scales?: Maybe<Array<Maybe<Scale>>>
	tags?: Maybe<Array<Scalars['String']>>
	tvDevices?: Maybe<Array<Maybe<TvDevice>>>
	type: SignageDeviceType
}

export type ChannelItem = {
	__typename?: 'ChannelItem'
	display?: Maybe<Display>
	duration?: Maybe<Scalars['Int']>
	file?: Maybe<File>
	id: Scalars['Int']
	playlist?: Maybe<Playlist>
	priority?: Maybe<Scalars['Boolean']>
	schedule: Schedule
	sequence: Scalars['Int']
}

export type ChannelItemInput = {
	displayId?: InputMaybe<Scalars['Int']>
	duration?: InputMaybe<Scalars['Int']>
	fileId?: InputMaybe<Scalars['Int']>
	id?: InputMaybe<Scalars['Int']>
	playlistId?: InputMaybe<Scalars['Int']>
	priority?: InputMaybe<Scalars['Boolean']>
	schedule: ScheduleInput
}

export enum ChannelOrientation {
	Horizontal = 'HORIZONTAL',
	Vertical = 'VERTICAL',
}

export type ChannelResponse = {
	__typename?: 'ChannelResponse'
	channel?: Maybe<Channel>
	errors?: Maybe<Array<Error>>
}

export type ChannelsFilter = {
	displayType?: InputMaybe<DisplayType>
	marketId?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	type?: InputMaybe<SignageDeviceType>
}

export type ChannelsPagination = {
	__typename?: 'ChannelsPagination'
	nodes?: Maybe<Array<Channel>>
	totalCount: Scalars['Int']
}

export type Component = {
	__typename?: 'Component'
	h?: Maybe<Scalars['Int']>
	htmlContent?: Maybe<Scalars['String']>
	id: Scalars['Int']
	name?: Maybe<Scalars['String']>
	styleType?: Maybe<Scalars['String']>
	type?: Maybe<ComponentType>
	w?: Maybe<Scalars['Int']>
	x?: Maybe<Scalars['Int']>
	y?: Maybe<Scalars['Int']>
}

export enum ComponentType {
	Barcode = 'BARCODE',
	Image = 'IMAGE',
	Itemlist = 'ITEMLIST',
	Price = 'PRICE',
	Text = 'TEXT',
}

export type ComponentVar = {
	__typename?: 'ComponentVar'
	id: Scalars['Int']
	maxLength?: Maybe<Scalars['Int']>
	name?: Maybe<Scalars['String']>
	templateKey?: Maybe<Scalars['String']>
	type?: Maybe<DeviceValueType>
}

export type ComponentVarsFilter = {
	name?: InputMaybe<Scalars['String']>
	templateKey?: InputMaybe<Scalars['String']>
}

export type ComponentVarsPagination = {
	__typename?: 'ComponentVarsPagination'
	nodes?: Maybe<Array<ComponentVar>>
	totalCount: Scalars['Int']
}

export type ConfigTransaction = {
	__typename?: 'ConfigTransaction'
	deviceserialnumber?: Maybe<Scalars['String']>
	receivedate?: Maybe<Scalars['String']>
	senddate?: Maybe<Scalars['String']>
	stage?: Maybe<TransactionStage>
	transactionid?: Maybe<Scalars['String']>
}

export type ConfigTransactionResponse = {
	__typename?: 'ConfigTransactionResponse'
	errors?: Maybe<Array<Error>>
	transaction?: Maybe<Transaction>
}

export enum Connection {
	/** RSSI < -90 */
	Bad = 'BAD',
	/** RSSI > -70 */
	Perfect = 'PERFECT',
	/** RSSI -70 <=> -90 */
	Standard = 'STANDARD',
}

export enum ContractLength {
	Monthly = 'MONTHLY',
	Yearly = 'YEARLY',
}

export enum Country {
	Austria = 'AUSTRIA',
	Belgium = 'BELGIUM',
	Bulgaria = 'BULGARIA',
	Croatia = 'CROATIA',
	Cyprus = 'CYPRUS',
	CzechRepublic = 'CZECH_REPUBLIC',
	Denmark = 'DENMARK',
	Estonia = 'ESTONIA',
	Finland = 'FINLAND',
	France = 'FRANCE',
	Germany = 'GERMANY',
	Greece = 'GREECE',
	Hungary = 'HUNGARY',
	Iceland = 'ICELAND',
	Ireland = 'IRELAND',
	Italy = 'ITALY',
	Latvia = 'LATVIA',
	Liechtenstein = 'LIECHTENSTEIN',
	Lithuania = 'LITHUANIA',
	Luxembourg = 'LUXEMBOURG',
	Malta = 'MALTA',
	Netherlands = 'NETHERLANDS',
	Norway = 'NORWAY',
	Poland = 'POLAND',
	Portugal = 'PORTUGAL',
	Romania = 'ROMANIA',
	Slovakia = 'SLOVAKIA',
	Slovenia = 'SLOVENIA',
	Spain = 'SPAIN',
	Sweden = 'SWEDEN',
	Switzerland = 'SWITZERLAND',
	UnitedKingdom = 'UNITED_KINGDOM',
}

export type CreateApiClientResponse = {
	__typename?: 'CreateApiClientResponse'
	clientKey: Scalars['String']
	clientSecret: Scalars['String']
	id: Scalars['ID']
	name: Scalars['String']
}

export type CreateFolderResponse = {
	__typename?: 'CreateFolderResponse'
	errors?: Maybe<Array<Error>>
	folder?: Maybe<File>
	success: Scalars['Boolean']
}

export enum CronPreset {
	Custom = 'CUSTOM',
	Daily = 'DAILY',
	Every_2Days = 'EVERY_2_DAYS',
	Every_2Hours = 'EVERY_2_HOURS',
	Every_5Minutes = 'EVERY_5_MINUTES',
	Every_10Minutes = 'EVERY_10_MINUTES',
	Every_12Hours = 'EVERY_12_HOURS',
	Every_15Minutes = 'EVERY_15_MINUTES',
	Every_30Minutes = 'EVERY_30_MINUTES',
	Hourly = 'HOURLY',
	Monthly = 'MONTHLY',
	Weekly = 'WEEKLY',
}

export type CustomerInfoResponse = {
	__typename?: 'CustomerInfoResponse'
	purchasedModules?: Maybe<Array<PurchasedModules>>
}

export type CustomerSettings = {
	__typename?: 'CustomerSettings'
	usesDeviceName?: Maybe<Scalars['Boolean']>
	usesDualProduct?: Maybe<Scalars['Boolean']>
	usesMarkets?: Maybe<Scalars['Boolean']>
	usesPlanogram?: Maybe<Scalars['Boolean']>
	usesRootProducts?: Maybe<Scalars['Boolean']>
}

export type DailyQuantityData = {
	__typename?: 'DailyQuantityData'
	date: Scalars['DateTime']
	isKnown?: Maybe<Scalars['Boolean']>
	quantity: Scalars['Float']
}

export enum DayEnum {
	Daily = 'DAILY',
	Friday = 'FRIDAY',
	Monday = 'MONDAY',
	Saturday = 'SATURDAY',
	Sunday = 'SUNDAY',
	Thursday = 'THURSDAY',
	Tuesday = 'TUESDAY',
	Wednesday = 'WEDNESDAY',
}

export type DeleteAisleInput = {
	aisleId?: InputMaybe<Scalars['Int']>
	key?: InputMaybe<Scalars['String']>
	rootId?: InputMaybe<Scalars['Int']>
}

export type DeleteBayInput = {
	aisleId?: InputMaybe<Scalars['Int']>
	bayId?: InputMaybe<Scalars['Int']>
	key?: InputMaybe<Scalars['String']>
}

export type DeleteLandingTemplateInput = {
	id: Scalars['Int']
}

export type DeleteProductInput = {
	internalIds: Array<Scalars['String']>
}

export type DeleteProductResponse = {
	__typename?: 'DeleteProductResponse'
	errors?: Maybe<Array<Error>>
	success?: Maybe<Scalars['Boolean']>
}

export type DeleteResponse = {
	__typename?: 'DeleteResponse'
	affected?: Maybe<Scalars['Int']>
	errors?: Maybe<Array<Error>>
	success?: Maybe<Scalars['Boolean']>
}

export type DeleteShelfInput = {
	bayId?: InputMaybe<Scalars['Int']>
	key?: InputMaybe<Scalars['String']>
	shelfId?: InputMaybe<Scalars['Int']>
}

export type DeleteTemplateInput = {
	id: Scalars['Int']
}

export type DeleteTemplateVariantInput = {
	id: Scalars['Int']
}

export type DeleteTemplatesInput = {
	ids: Array<Scalars['Int']>
}

export type DemoScreenResponse = {
	__typename?: 'DemoScreenResponse'
	filename?: Maybe<Scalars['String']>
	success: Scalars['Boolean']
}

export type Device = {
	__typename?: 'Device'
	active?: Maybe<Scalars['Boolean']>
	batteryCharging?: Maybe<Scalars['Boolean']>
	batteryError?: Maybe<Scalars['Boolean']>
	/** batteryLevel: 0-100% */
	batteryLevel?: Maybe<Scalars['Int']>
	channel?: Maybe<Channel>
	channelId?: Maybe<Scalars['Int']>
	config?: Maybe<DeviceConfig>
	configId?: Maybe<Scalars['Int']>
	deviceMode?: Maybe<DeviceMode>
	deviceType?: Maybe<DeviceType>
	firmwareVersion?: Maybe<Scalars['String']>
	flipped?: Maybe<Scalars['Boolean']>
	group?: Maybe<Group>
	groupId?: Maybe<Scalars['Int']>
	/** @deprecated Use `batteryLevel` instead */
	health?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	lastConfigTransaction?: Maybe<Transaction>
	lastSeen?: Maybe<Scalars['DateTime']>
	lastSync?: Maybe<Scalars['String']>
	lastTransaction?: Maybe<Transaction>
	lastTransactionStatus?: Maybe<TransactionStage>
	longPressAction?: Maybe<ButtonActions>
	longPressEnabled: Scalars['Boolean']
	name?: Maybe<Scalars['String']>
	position?: Maybe<Position>
	positionId?: Maybe<Scalars['Int']>
	product?: Maybe<Product>
	product2nd?: Maybe<Product>
	productId?: Maybe<Scalars['Int']>
	productId2nd?: Maybe<Scalars['Int']>
	root?: Maybe<Root>
	rootId?: Maybe<Scalars['Int']>
	rotated?: Maybe<Scalars['Boolean']>
	router?: Maybe<Router>
	routerId?: Maybe<Scalars['Int']>
	rssi?: Maybe<Scalars['Int']>
	screenType?: Maybe<Scalars['String']>
	serialNumber: Scalars['String']
	shelf?: Maybe<Shelf>
	shelfId?: Maybe<Scalars['Int']>
	shortPressAction?: Maybe<ButtonActions>
	shortPressEnabled: Scalars['Boolean']
	size?: Maybe<DeviceSize>
	softwareVersion?: Maybe<Scalars['String']>
	ssid?: Maybe<Scalars['String']>
	template?: Maybe<Template>
	templateId?: Maybe<Scalars['Int']>
	x?: Maybe<Scalars['Int']>
	y?: Maybe<Scalars['Int']>
	z?: Maybe<Scalars['Int']>
}

export type DeviceAlarmReport = {
	__typename?: 'DeviceAlarmReport'
	batteryPercentage?: Maybe<Scalars['Int']>
	batteryUnderCount?: Maybe<Scalars['Boolean']>
	created: Scalars['DateTime']
	days?: Maybe<Array<DayEnum>>
	deviceErrCount?: Maybe<Scalars['Boolean']>
	deviceOffline?: Maybe<Scalars['Boolean']>
	id: Scalars['Int']
	includeAllLocations?: Maybe<Scalars['Boolean']>
	name: Scalars['String']
	roots?: Maybe<Array<Root>>
	routerOffline?: Maybe<Scalars['Boolean']>
	time?: Maybe<Scalars['DateTime']>
	updated: Scalars['DateTime']
	users?: Maybe<Array<User>>
}

export type DeviceAlarmReportResponse = {
	__typename?: 'DeviceAlarmReportResponse'
	deviceAlarmReport?: Maybe<DeviceAlarmReport>
	errors?: Maybe<Array<Error>>
}

export type DeviceAlarmReportsFilter = {
	name?: InputMaybe<Scalars['String']>
	userId?: InputMaybe<Scalars['Int']>
}

export type DeviceAlarmReportsPagination = {
	__typename?: 'DeviceAlarmReportsPagination'
	nodes: Array<DeviceAlarmReport>
	totalCount: Scalars['Int']
}

export type DeviceConfig = {
	__typename?: 'DeviceConfig'
	awakeTime?: Maybe<Scalars['Int']>
	device: Device
	deviceId: Scalars['Int']
	highPowerMode: Scalars['Boolean']
	id: Scalars['Int']
	sleepTime?: Maybe<Scalars['Int']>
	version?: Maybe<Scalars['String']>
}

export type DeviceConfigInput = {
	awakeTime?: InputMaybe<Scalars['Int']>
	deviceId: Scalars['Int']
	highPowerMode?: InputMaybe<Scalars['Boolean']>
	sleepTime: Scalars['Int']
	version?: InputMaybe<Scalars['String']>
}

export type DeviceConfigResponse = {
	__typename?: 'DeviceConfigResponse'
	deviceConfig?: Maybe<DeviceConfig>
	errors?: Maybe<Array<Error>>
}

export type DeviceConfiguration = {
	ledColor?: InputMaybe<Scalars['String']>
	ledMode?: InputMaybe<Led_Mode>
	rootId?: InputMaybe<Scalars['Int']>
	templateVariantKey?: InputMaybe<Scalars['String']>
}

export enum DeviceMode {
	Bluetooth = 'BLUETOOTH',
	Wifi = 'WIFI',
}

export enum DeviceOrder {
	CreatedAsc = 'CREATED_ASC',
	CreatedDesc = 'CREATED_DESC',
	Default = 'DEFAULT',
	NameAsc = 'NAME_ASC',
	NameDesc = 'NAME_DESC',
}

export type DevicePlanogramInput = {
	deletePositions: Array<Scalars['Int']>
}

export type DevicePowerWindow = {
	__typename?: 'DevicePowerWindow'
	from: Scalars['String']
	to: Scalars['String']
	weekday: WeekDay
}

export type DevicePowerWindowInput = {
	from: Scalars['String']
	to: Scalars['String']
	weekday: WeekDay
}

export type DevicePreviewData = {
	__typename?: 'DevicePreviewData'
	flipped?: Maybe<Scalars['Boolean']>
	image?: Maybe<Scalars['String']>
}

export type DevicePreviewResponse = {
	__typename?: 'DevicePreviewResponse'
	current?: Maybe<Scalars['String']>
	currentData?: Maybe<DevicePreviewData>
	preview?: Maybe<Scalars['String']>
	previewData?: Maybe<DevicePreviewData>
}

export type DeviceRegisterInput = {
	channelId?: InputMaybe<Scalars['Int']>
	deviceMode?: InputMaybe<DeviceMode>
	deviceType?: InputMaybe<DeviceType>
	flipped?: InputMaybe<Scalars['Boolean']>
	groupId?: InputMaybe<Scalars['Int']>
	internalId?: InputMaybe<Scalars['String']>
	longPressAction?: InputMaybe<ButtonActions>
	longPressEnabled?: InputMaybe<Scalars['Boolean']>
	name?: InputMaybe<Scalars['String']>
	positionId?: InputMaybe<Scalars['Int']>
	productId?: InputMaybe<Scalars['Int']>
	productId2nd?: InputMaybe<Scalars['Int']>
	rootId: Scalars['Int']
	rotated?: InputMaybe<Scalars['Boolean']>
	routerId?: InputMaybe<Scalars['Int']>
	screenType: Scalars['String']
	serialNumber: Scalars['MAC']
	shelfId?: InputMaybe<Scalars['Int']>
	shortPressAction?: InputMaybe<ButtonActions>
	shortPressEnabled?: InputMaybe<Scalars['Boolean']>
	ssid?: InputMaybe<Scalars['String']>
	templateVariantId?: InputMaybe<Scalars['Int']>
}

export type DeviceResponse = {
	__typename?: 'DeviceResponse'
	device?: Maybe<Device>
	errors?: Maybe<Array<Error>>
}

export enum DeviceSize {
	Epaper_152x152 = 'EPAPER_152x152',
	Epaper_200X200 = 'EPAPER_200X200',
	Epaper_296X128Bw = 'EPAPER_296X128_BW',
	Epaper_296X128R = 'EPAPER_296X128_R',
	Epaper_296X128Ry = 'EPAPER_296X128_RY',
	Epaper_296X128Y = 'EPAPER_296X128_Y',
	Epaper_400X300R = 'EPAPER_400X300_R',
	Epaper_400X300Ry = 'EPAPER_400X300_RY',
	Epaper_400X300Y = 'EPAPER_400X300_Y',
	Epaper_792x272Ry = 'EPAPER_792x272_RY',
	Epaper_800x480R = 'EPAPER_800x480_R',
	Epaper_800x480Ry = 'EPAPER_800x480_RY',
	Epaper_800x480S6 = 'EPAPER_800x480_S6',
	Epaper_1600x1200S6 = 'EPAPER_1600x1200_S6',
	Epaper_2560x1440S6 = 'EPAPER_2560x1440_S6',
	EpaperNone = 'EPAPER_NONE',
	Lcd_1920X158 = 'LCD_1920X158',
	Lcd_1920X1080 = 'LCD_1920X1080',
	Lcd_2180X180 = 'LCD_2180X180',
}

export type DeviceSocData = {
	__typename?: 'DeviceSocData'
	charging: Scalars['Boolean']
	routerName?: Maybe<Scalars['String']>
	routerUuid?: Maybe<Scalars['String']>
	rssi?: Maybe<Scalars['Int']>
	soc: Scalars['Int']
	timestamp: Scalars['DateTime']
	voltage?: Maybe<Scalars['Int']>
}

export type DeviceSocHighLow = {
	__typename?: 'DeviceSocHighLow'
	deviceSerialNumber: Scalars['String']
	estimatedBatteryLifeMs?: Maybe<Scalars['Float']>
	highSoc?: Maybe<Scalars['Int']>
	highTimestamp?: Maybe<Scalars['DateTime']>
	lowSoc?: Maybe<Scalars['Int']>
	lowTimestamp?: Maybe<Scalars['DateTime']>
	socDropPerDay?: Maybe<Scalars['Float']>
}

export type DeviceTempData = {
	__typename?: 'DeviceTempData'
	panelTemp?: Maybe<Scalars['Float']>
	timestamp: Scalars['DateTime']
}

export enum DeviceType {
	SmartLabel = 'SMART_LABEL',
	SmartScale = 'SMART_SCALE',
}

export type DeviceValueInput = {
	/** value name (only for display purposes) */
	name?: InputMaybe<Scalars['String']>
	/** value can be assigned to a single root (e.g. the same product can have a different price in a specific root)) */
	rootId?: InputMaybe<Scalars['Int']>
	/** placeholder replaced with value in template (e.g. {{PRICE}}) */
	templateKey: Scalars['String']
	/** value type (formats value) */
	type: DeviceValueType
	/** product value */
	value: Scalars['String']
}

export enum DeviceValueType {
	Base64 = 'BASE64',
	Ean = 'EAN',
	Image = 'IMAGE',
	Number = 'NUMBER',
	Price = 'PRICE',
	Qr = 'QR',
	QrDirect = 'QR_DIRECT',
	Text = 'TEXT',
}

export type DevicesFilter = {
	activated?: InputMaybe<Scalars['Boolean']>
	active?: InputMaybe<Scalars['Boolean']>
	/** search by device serialnumber or product name or product internal id or software version */
	any?: InputMaybe<Scalars['String']>
	connection?: InputMaybe<Connection>
	deviceIds?: InputMaybe<Array<Scalars['Int']>>
	deviceMode?: InputMaybe<DeviceMode>
	deviceSerialNumber?: InputMaybe<Scalars['String']>
	deviceType?: InputMaybe<DeviceType>
	hasNoProductAssigned?: InputMaybe<Scalars['Boolean']>
	hasPosition?: InputMaybe<Scalars['Boolean']>
	health?: InputMaybe<Health>
	marketId?: InputMaybe<Scalars['Int']>
	productId?: InputMaybe<Scalars['Int']>
	productType?: InputMaybe<ProductType>
	rootId?: InputMaybe<Scalars['Int']>
	rotated?: InputMaybe<Scalars['Boolean']>
	status?: InputMaybe<TransactionStage>
	supportsTemplateVariantId?: InputMaybe<Scalars['Int']>
	templateVariantId?: InputMaybe<Scalars['Int']>
	type?: InputMaybe<DeviceSize>
	virtual?: InputMaybe<Scalars['Boolean']>
}

export type DevicesPagination = {
	__typename?: 'DevicesPagination'
	nodes?: Maybe<Array<Device>>
	totalCount: Scalars['Int']
}

export type Disable2FaResponse = {
	__typename?: 'Disable2FAResponse'
	delta?: Maybe<Scalars['Int']>
	errors?: Maybe<Array<Error>>
	success: Scalars['Boolean']
}

export type Display = {
	__typename?: 'Display'
	height: Scalars['Int']
	id: Scalars['Int']
	name?: Maybe<Scalars['String']>
	path: Scalars['String']
	type: DisplayType
	width: Scalars['Int']
}

export enum DisplayType {
	A730S6 = 'A730_S6',
	A750R = 'A750_R',
	A1330S6 = 'A1330_S6',
	A3150S6 = 'A3150_S6',
	BizerbaKhiiPro_800 = 'BIZERBA_KHIIPro_800',
	DibalD900 = 'DIBAL_D900',
	DibalS500 = 'DIBAL_S500',
	DigiSm5300L = 'DIGI_SM5300L',
	DigiSm6000Ssp = 'DIGI_SM6000SSP',
	VirtualStore = 'VIRTUAL_STORE',
}

export type DownloadPrice = {
	__typename?: 'DownloadPrice'
	internalId: Scalars['String']
	price: Scalars['Float']
}

export type DownloadPricesResponse = {
	__typename?: 'DownloadPricesResponse'
	nodes: Array<DownloadPrice>
}

export type EditAisleInput = {
	depth?: InputMaybe<Scalars['Int']>
	height?: InputMaybe<Scalars['Int']>
	key?: InputMaybe<Scalars['String']>
	width?: InputMaybe<Scalars['Int']>
	x?: InputMaybe<Scalars['Int']>
	y?: InputMaybe<Scalars['Int']>
}

export type EditBarInput = {
	devices?: InputMaybe<Array<EditDeviceInput>>
	fileId?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	shelfId?: InputMaybe<Scalars['Int']>
	x?: InputMaybe<Scalars['Int']>
}

export type EditBayInput = {
	key?: InputMaybe<Scalars['String']>
	sequence?: InputMaybe<Scalars['Int']>
	width?: InputMaybe<Scalars['Int']>
}

export type EditButton = {
	id: Scalars['Int']
	name?: InputMaybe<Scalars['String']>
	rootId?: InputMaybe<Scalars['Int']>
	routerId?: InputMaybe<Scalars['Int']>
}

export type EditButtonResponse = {
	__typename?: 'EditButtonResponse'
	button?: Maybe<Button>
	errors?: Maybe<Array<Error>>
	success?: Maybe<Scalars['Boolean']>
}

export type EditCalendarInput = {
	calendarName?: InputMaybe<Scalars['String']>
	email?: InputMaybe<Scalars['String']>
	id: Scalars['Int']
	name?: InputMaybe<Scalars['String']>
	taskListName?: InputMaybe<Scalars['String']>
	templateVariantId?: InputMaybe<Scalars['Int']>
}

export type EditCalendarResponse = {
	__typename?: 'EditCalendarResponse'
	calendar?: Maybe<Calendar>
	errors?: Maybe<Array<Error>>
	success: Scalars['Boolean']
}

export type EditChannelInput = {
	channelItems?: InputMaybe<Array<ChannelItemInput>>
	marketId?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	orientation?: InputMaybe<ChannelOrientation>
	tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type EditDemoScreenInput = {
	fileId: Scalars['Int']
}

export type EditDeviceAlarmReportInput = {
	batteryPercentage?: InputMaybe<Scalars['Int']>
	batteryUnderCount?: InputMaybe<Scalars['Boolean']>
	days?: InputMaybe<Array<DayEnum>>
	deviceErrCount?: InputMaybe<Scalars['Boolean']>
	deviceOffline?: InputMaybe<Scalars['Boolean']>
	id: Scalars['Int']
	includeAllLocations?: InputMaybe<Scalars['Boolean']>
	name?: InputMaybe<Scalars['String']>
	rootIds?: InputMaybe<Array<Scalars['Int']>>
	routerOffline?: InputMaybe<Scalars['Boolean']>
	time?: InputMaybe<Scalars['DateTime']>
	userIds?: InputMaybe<Array<Scalars['Int']>>
}

export type EditDeviceAlarmReportResponse = {
	__typename?: 'EditDeviceAlarmReportResponse'
	deviceAlarmReport?: Maybe<DeviceAlarmReport>
	errors?: Maybe<Array<Error>>
	success: Scalars['Boolean']
}

export type EditDeviceConfigInput = {
	awakeTime?: InputMaybe<Scalars['Int']>
	highPowerMode?: InputMaybe<Scalars['Boolean']>
	id: Scalars['Int']
	sleepTime?: InputMaybe<Scalars['Int']>
	version?: InputMaybe<Scalars['String']>
}

export type EditDeviceInput = {
	channelId?: InputMaybe<Scalars['Int']>
	flipped?: InputMaybe<Scalars['Boolean']>
	longPressAction?: InputMaybe<ButtonActions>
	longPressEnabled?: InputMaybe<Scalars['Boolean']>
	name?: InputMaybe<Scalars['String']>
	positionId?: InputMaybe<Scalars['Int']>
	productId?: InputMaybe<Scalars['Int']>
	productId2nd?: InputMaybe<Scalars['Int']>
	rotated?: InputMaybe<Scalars['Boolean']>
	routerId?: InputMaybe<Scalars['Int']>
	shelfId?: InputMaybe<Scalars['Int']>
	shortPressAction?: InputMaybe<ButtonActions>
	shortPressEnabled?: InputMaybe<Scalars['Boolean']>
	templateVariantId?: InputMaybe<Scalars['Int']>
	x?: InputMaybe<Scalars['Int']>
	y?: InputMaybe<Scalars['Int']>
	z?: InputMaybe<Scalars['Int']>
}

export type EditDeviceResponse = {
	__typename?: 'EditDeviceResponse'
	device?: Maybe<Device>
	errors?: Maybe<Array<Error>>
	success: Scalars['Boolean']
}

export type EditDeviceTemplatesResponse = {
	__typename?: 'EditDeviceTemplatesResponse'
	errors?: Maybe<Array<Error>>
	failedDevices?: Maybe<Array<FailedDevice>>
	success: Scalars['Boolean']
}

export type EditFileInput = {
	originalname?: InputMaybe<Scalars['String']>
	parentFolderId?: InputMaybe<Scalars['Int']>
}

export type EditFlowComponentInput = {
	type: FlowComponentType
	value: Scalars['String']
}

export type EditFlowInput = {
	flowStatements: Array<EditFlowStatementInput>
	name?: InputMaybe<Scalars['String']>
	validFrom?: InputMaybe<Scalars['DateTime']>
	validTo?: InputMaybe<Scalars['DateTime']>
}

export type EditFlowStatementInput = {
	flowComponents: Array<FlowComponentInput>
	products?: InputMaybe<Array<FlowProductInput>>
	templateId?: InputMaybe<Scalars['Int']>
	type: FlowStatementType
}

export type EditGroupInput = {
	level?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	parentGroupId?: InputMaybe<Scalars['Int']>
}

export type EditIntegrationInput = {
	cron?: InputMaybe<Scalars['String']>
	cronUpdateUrl?: InputMaybe<Scalars['String']>
	id: Scalars['Int']
	name?: InputMaybe<Scalars['String']>
	preset?: InputMaybe<CronPreset>
	syncTime?: InputMaybe<Scalars['String']>
	token?: InputMaybe<Scalars['String']>
	triggerUrl?: InputMaybe<Scalars['String']>
	weekDays?: InputMaybe<Array<WeekDay>>
}

export type EditLandingTemplateInput = {
	components?: InputMaybe<Array<EditPostComponent>>
	height?: InputMaybe<Scalars['Int']>
	isCustom?: InputMaybe<Scalars['Boolean']>
	name?: InputMaybe<Scalars['String']>
	width?: InputMaybe<Scalars['Int']>
}

export type EditMarketInput = {
	key?: InputMaybe<Scalars['String']>
	name?: InputMaybe<Scalars['String']>
}

export type EditOrderInput = {
	archive?: InputMaybe<Scalars['Boolean']>
	costumerId?: InputMaybe<Scalars['Int']>
	id?: InputMaybe<Scalars['Int']>
	mode?: InputMaybe<OrderMode>
	orderItems?: InputMaybe<Array<AddOrderItemInput>>
	orderNumber?: InputMaybe<Scalars['String']>
	orderType?: InputMaybe<OrderType>
	rootId?: InputMaybe<Scalars['Int']>
	supplierId?: InputMaybe<Scalars['Int']>
}

export type EditOrderItemInput = {
	deliveryDate?: InputMaybe<Scalars['DateTime']>
	quantity?: InputMaybe<Scalars['Int']>
	status?: InputMaybe<OrderStatus>
}

export type EditOrderItemResponse = {
	__typename?: 'EditOrderItemResponse'
	archivedOrder?: Maybe<Scalars['Boolean']>
	errors?: Maybe<Array<Error>>
	success?: Maybe<Scalars['Boolean']>
}

export type EditPlaylistInput = {
	name?: InputMaybe<Scalars['String']>
	playlistItems?: InputMaybe<Array<PlaylistItemInput>>
}

export type EditPositionInput = {
	deviceId?: InputMaybe<Scalars['Int']>
	key?: InputMaybe<Scalars['String']>
	name?: InputMaybe<Scalars['String']>
	productId?: InputMaybe<Scalars['Int']>
	sequence?: InputMaybe<Scalars['Int']>
	templateVariantId?: InputMaybe<Scalars['Int']>
	x?: InputMaybe<Scalars['Int']>
	y?: InputMaybe<Scalars['Int']>
	z?: InputMaybe<Scalars['Int']>
}

export type EditPostComponent = {
	h: Scalars['Int']
	htmlContent: Scalars['String']
	name?: InputMaybe<Scalars['String']>
	styleType?: InputMaybe<Scalars['String']>
	type: ComponentType
	w: Scalars['Int']
	x: Scalars['Int']
	y: Scalars['Int']
}

export type EditPostComponentVar = {
	defaultValue?: InputMaybe<Scalars['String']>
	maxLength?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	templateKey: Scalars['String']
	type?: InputMaybe<DeviceValueType>
}

export type EditProductInput = {
	active?: InputMaybe<Scalars['Boolean']>
	deletedValueEntitiesIds?: InputMaybe<Array<Scalars['Int']>>
	deviceConfig?: InputMaybe<DeviceConfiguration>
	eanCodes?: InputMaybe<Array<Scalars['String']>>
	expirationDate?: InputMaybe<Scalars['Time']>
	fileId?: InputMaybe<Scalars['Int']>
	id: Scalars['Int']
	internalId?: InputMaybe<Scalars['String']>
	marketId?: InputMaybe<Scalars['Int']>
	marketKey?: InputMaybe<Scalars['String']>
	name?: InputMaybe<Scalars['String']>
	parentProductId?: InputMaybe<Scalars['Int']>
	productType?: InputMaybe<ProductType>
	rootId?: InputMaybe<Scalars['Int']>
	rootKeys?: InputMaybe<Array<Scalars['String']>>
	supplierId?: InputMaybe<Scalars['Int']>
	tags?: InputMaybe<Array<Scalars['String']>>
	templateVariantId?: InputMaybe<Scalars['Int']>
	valueEntities?: InputMaybe<Array<DeviceValueInput>>
}

export type EditProductResponse = {
	__typename?: 'EditProductResponse'
	errors?: Maybe<Array<Error>>
	isAssignedToShelves?: Maybe<Scalars['Boolean']>
	success?: Maybe<Scalars['Boolean']>
}

export type EditRoleInput = {
	permissions?: InputMaybe<Array<Scalars['String']>>
	rank?: InputMaybe<Scalars['Int']>
	value?: InputMaybe<Scalars['String']>
}

export type EditRootInput = {
	address?: InputMaybe<Scalars['String']>
	burninPrevention?: InputMaybe<Scalars['Boolean']>
	key?: InputMaybe<Scalars['String']>
	latitude?: InputMaybe<Scalars['Float']>
	longitude?: InputMaybe<Scalars['Float']>
	marketId?: InputMaybe<Scalars['Int']>
	mode?: InputMaybe<RootMode>
	name?: InputMaybe<Scalars['String']>
	tags?: InputMaybe<Array<Scalars['String']>>
	timezone?: InputMaybe<Scalars['String']>
}

export type EditRouterInput = {
	dhcp?: InputMaybe<Scalars['Boolean']>
	name?: InputMaybe<Scalars['String']>
	routerNetwork?: InputMaybe<RouterNetworkInput>
}

export type EditScaleInput = {
	channelId?: InputMaybe<Scalars['Int']>
	ip?: InputMaybe<Scalars['IPv4']>
	name?: InputMaybe<Scalars['String']>
	password?: InputMaybe<Scalars['String']>
	tags?: InputMaybe<Array<Scalars['String']>>
	username?: InputMaybe<Scalars['String']>
}

export type EditScheduleInput = {
	dateRange?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>
	timeFrames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
	weekdays?: InputMaybe<Array<WeekDay>>
}

export type EditSensorInput = {
	name?: InputMaybe<Scalars['String']>
	tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type EditShelfInput = {
	key?: InputMaybe<Scalars['String']>
	name?: InputMaybe<Scalars['String']>
	sequence?: InputMaybe<Scalars['Int']>
}

export type EditSignageButton = {
	buttonId?: InputMaybe<Scalars['Int']>
	channelId?: InputMaybe<Scalars['Int']>
	durationSeconds?: InputMaybe<Scalars['Int']>
	id: Scalars['Int']
	virtualStoreDeviceId?: InputMaybe<Scalars['Int']>
}

export type EditSignageButtonResponse = {
	__typename?: 'EditSignageButtonResponse'
	errors?: Maybe<Array<Error>>
	signageButton?: Maybe<SignageButton>
	success?: Maybe<Scalars['Boolean']>
}

export type EditStatusInput = {
	isUpdating: Scalars['Boolean']
}

export type EditSupplier = {
	address?: InputMaybe<Scalars['String']>
	addressNumber?: InputMaybe<Scalars['String']>
	city?: InputMaybe<Scalars['String']>
	companyName?: InputMaybe<Scalars['String']>
	country?: InputMaybe<Country>
	email?: InputMaybe<Scalars['String']>
	id: Scalars['Int']
	postCode?: InputMaybe<Scalars['String']>
	supplierId?: InputMaybe<Scalars['String']>
	supplierRootSettings?: InputMaybe<Array<SupplierRootSettingsInput>>
	vat?: InputMaybe<Scalars['String']>
}

export type EditSynchronizationInput = {
	id: Scalars['Int']
	note?: InputMaybe<Scalars['String']>
	status?: InputMaybe<SynchronizationStatus>
	time?: InputMaybe<Scalars['DateTime']>
	updatedProducts?: InputMaybe<Array<Scalars['String']>>
}

export type EditTemplateInput = {
	components?: InputMaybe<Array<EditPostComponent>>
	height?: InputMaybe<Scalars['Int']>
	isCustom?: InputMaybe<Scalars['Boolean']>
	landingTemplateId?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	templateVariables?: InputMaybe<Array<EditPostComponentVar>>
	templateVariantId?: InputMaybe<Scalars['Int']>
	width?: InputMaybe<Scalars['Int']>
}

export type EditTemplateVariantInput = {
	isActive?: InputMaybe<Scalars['Boolean']>
	isDefault?: InputMaybe<Scalars['Boolean']>
	key: Scalars['String']
	marketIDs?: InputMaybe<Array<Scalars['Int']>>
	name?: InputMaybe<Scalars['String']>
	orbisType?: InputMaybe<OrbisType>
}

export type EditTenantInput = {
	address?: InputMaybe<Scalars['String']>
	addressNumber?: InputMaybe<Scalars['String']>
	adminUser?: InputMaybe<AdminUserUpdateInput>
	city?: InputMaybe<Scalars['String']>
	companyName?: InputMaybe<Scalars['String']>
	contractLength?: InputMaybe<ContractLength>
	contractorName?: InputMaybe<Scalars['String']>
	contractorsMail?: InputMaybe<Scalars['String']>
	country?: InputMaybe<Country>
	id: Scalars['Int']
	isActive?: InputMaybe<Scalars['Boolean']>
	loginLogo?: InputMaybe<Scalars['String']>
	logo?: InputMaybe<Scalars['String']>
	maxRoots?: InputMaybe<Scalars['Int']>
	maxUsers?: InputMaybe<Scalars['Int']>
	postCode?: InputMaybe<Scalars['String']>
	primaryColor?: InputMaybe<Scalars['String']>
	purchasedModules?: InputMaybe<Array<PurchasedModules>>
	startDate?: InputMaybe<Scalars['DateTime']>
	textColor?: InputMaybe<Scalars['String']>
	usesDeviceName?: InputMaybe<Scalars['Boolean']>
	usesDualProduct?: InputMaybe<Scalars['Boolean']>
	usesMarkets?: InputMaybe<Scalars['Boolean']>
	usesPlanogram?: InputMaybe<Scalars['Boolean']>
	usesRootProducts?: InputMaybe<Scalars['Boolean']>
	vat?: InputMaybe<Scalars['String']>
}

export type EditTvDeviceInput = {
	channelId?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	tags?: InputMaybe<Array<Scalars['String']>>
}

export type EditUserInput = {
	allowedIPs?: InputMaybe<Array<Scalars['IPv4']>>
	email?: InputMaybe<Scalars['String']>
	firstName?: InputMaybe<Scalars['String']>
	googleAuth?: InputMaybe<GoogleAuthInput>
	lastName?: InputMaybe<Scalars['String']>
	ledConfig?: InputMaybe<LedConfigInput>
	marketIDs?: InputMaybe<Array<Scalars['Int']>>
	microsoftAuth?: InputMaybe<MicrosoftAuthInput>
	password?: InputMaybe<Scalars['String']>
	roleIDs?: InputMaybe<Array<Scalars['Int']>>
	rootIDs?: InputMaybe<Array<Scalars['Int']>>
	sendVerificationEmail?: InputMaybe<Scalars['Boolean']>
	username?: InputMaybe<Scalars['String']>
}

export type EditVirtualCategoryPointInput = {
	id: Scalars['Int']
	name?: InputMaybe<Scalars['String']>
	virtualRackIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>
}

export type EditVirtualCategoryScreenInput = {
	backgroundFileId?: InputMaybe<Scalars['Int']>
	catalogMode?: InputMaybe<Scalars['Boolean']>
	channelId?: InputMaybe<Scalars['Int']>
	fileId?: InputMaybe<Scalars['Int']>
	id: Scalars['Int']
	name?: InputMaybe<Scalars['String']>
	timeout?: InputMaybe<Scalars['Int']>
	virtualCategoryPointPositions?: InputMaybe<
		Array<InputMaybe<AddVirtualCategoryPointPosition>>
	>
}

export type EditVirtualMultiScreenInput = {
	id: Scalars['Int']
	name?: InputMaybe<Scalars['String']>
	virtualMultiScreenPositions?: InputMaybe<
		Array<InputMaybe<AddVirtualMultiScreenPositionInput>>
	>
}

export type EditVirtualRackInput = {
	fileId?: InputMaybe<Scalars['Int']>
	id: Scalars['Int']
	name?: InputMaybe<Scalars['String']>
	removePadding?: InputMaybe<Scalars['Boolean']>
	virtualShelfPositions: Array<AddVirtualShelfPositionInput>
	virtualStoreDeviceIds: Array<InputMaybe<Scalars['Int']>>
}

export type EditVirtualShelfInput = {
	fileId?: InputMaybe<Scalars['Int']>
	id: Scalars['Int']
	name?: InputMaybe<Scalars['String']>
	spacing?: InputMaybe<Scalars['Float']>
	variant: VirtualShelfVariant
	virtualProductPositions: Array<InputMaybe<AddVirtualProductPositionInput>>
	virtualRackId?: InputMaybe<Scalars['Int']>
}

export type EditVirtualShelfPositionInput = {
	virtualShelfId: Scalars['Int']
}

export type EditVirtualStoreDeviceInput = {
	channelId?: InputMaybe<Scalars['Int']>
	id: Scalars['Int']
	ip?: InputMaybe<Scalars['IPv4']>
	name?: InputMaybe<Scalars['String']>
	note?: InputMaybe<Scalars['String']>
	powerWindows?: InputMaybe<Array<DevicePowerWindowInput>>
	tags?: InputMaybe<Array<Scalars['String']>>
	virtualCategoryPointId?: InputMaybe<Scalars['Int']>
	virtualCategoryScreenId?: InputMaybe<Scalars['Int']>
	virtualMultiScreenId?: InputMaybe<Scalars['Int']>
}

export type Enable2FaResponse = {
	__typename?: 'Enable2FAResponse'
	delta?: Maybe<Scalars['Int']>
	errors?: Maybe<Array<Error>>
	success: Scalars['Boolean']
}

export type Error = {
	__typename?: 'Error'
	message: Scalars['String']
	path: Scalars['String']
}

export enum Esp32Version {
	Version_0_1_4 = 'VERSION_0_1_4',
	Version_0_1_5 = 'VERSION_0_1_5',
	Version_0_1_8 = 'VERSION_0_1_8',
	Version_0_1_15 = 'VERSION_0_1_15',
	Version_0_1_18 = 'VERSION_0_1_18',
}

export type FailedDevice = {
	__typename?: 'FailedDevice'
	device: Device
	errors?: Maybe<Array<Error>>
}

export type File = {
	__typename?: 'File'
	duration?: Maybe<Scalars['Int']>
	encoding?: Maybe<Scalars['String']>
	filename?: Maybe<Scalars['String']>
	height?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	isFolder: Scalars['Boolean']
	mimetype?: Maybe<Scalars['String']>
	originalname?: Maybe<Scalars['String']>
	parentFolder?: Maybe<File>
	sizes?: Maybe<Array<Scalars['String']>>
	thumbnail?: Maybe<Scalars['String']>
	url?: Maybe<Scalars['String']>
	width?: Maybe<Scalars['Int']>
}

export type FileChainFilter = {
	moduleType: Module_Type
	subfolderType?: InputMaybe<SubfolderType>
}

export type FileChainNode = {
	__typename?: 'FileChainNode'
	filename?: Maybe<Scalars['String']>
	id: Scalars['Int']
	originalname?: Maybe<Scalars['String']>
	type?: Maybe<FolderType>
}

export type FileFilter = {
	fileId?: InputMaybe<Scalars['Int']>
	filename?: InputMaybe<Scalars['String']>
	height?: InputMaybe<Scalars['Int']>
	isFolder?: InputMaybe<Scalars['Boolean']>
	mimeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
	originalname?: InputMaybe<Scalars['String']>
	width?: InputMaybe<Scalars['Int']>
}

export type FileOrderBy = {
	created?: InputMaybe<SortEnum>
	folder?: InputMaybe<SortEnum>
	name?: InputMaybe<SortEnum>
}

export type FileStructureFilter = {
	height?: InputMaybe<Scalars['Int']>
	isFolder?: InputMaybe<Scalars['Boolean']>
	mimeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
	moduleType?: InputMaybe<Module_Type>
	orderBy?: InputMaybe<FileOrderBy>
	originalname?: InputMaybe<Scalars['String']>
	parentFolderId?: InputMaybe<Scalars['Int']>
	subfolderType?: InputMaybe<SubfolderType>
	width?: InputMaybe<Scalars['Int']>
}

export type FileStructureResponse = {
	__typename?: 'FileStructureResponse'
	nodes: Array<File>
	totalCount: Scalars['Int']
}

export type FilesFilter = {
	filename?: InputMaybe<Scalars['String']>
	height?: InputMaybe<Scalars['Int']>
	isFolder?: InputMaybe<Scalars['Boolean']>
	mimeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
	orderBy?: InputMaybe<FileOrderBy>
	originalname?: InputMaybe<Scalars['String']>
	width?: InputMaybe<Scalars['Int']>
}

export type FilesResponsePagination = {
	__typename?: 'FilesResponsePagination'
	nodes: Array<File>
	totalCount: Scalars['Int']
}

export type Flow = {
	__typename?: 'Flow'
	flowStatements?: Maybe<Array<FlowStatement>>
	id: Scalars['Int']
	isDone: Scalars['Boolean']
	name?: Maybe<Scalars['String']>
	validFrom?: Maybe<Scalars['DateTime']>
	validTo?: Maybe<Scalars['DateTime']>
}

export type FlowComponent = {
	__typename?: 'FlowComponent'
	type: FlowComponentType
	value?: Maybe<Scalars['String']>
}

export type FlowComponentInput = {
	type: FlowComponentType
	value?: InputMaybe<Scalars['String']>
}

export enum FlowComponentType {
	ChangeTemplate = 'CHANGE_TEMPLATE',
	DataService = 'DATA_SERVICE',
	Decrease = 'DECREASE',
	Equals = 'EQUALS',
	Exist = 'EXIST',
	GreaterThan = 'GREATER_THAN',
	Increase = 'INCREASE',
	LowerThan = 'LOWER_THAN',
	Sensor = 'SENSOR',
	Set = 'SET',
	ValueNumber = 'VALUE_NUMBER',
	ValueProcentage = 'VALUE_PROCENTAGE',
	Variable = 'VARIABLE',
}

export type FlowProduct = {
	__typename?: 'FlowProduct'
	id: Scalars['Int']
	product?: Maybe<Product>
	valueEntities?: Maybe<Array<FlowValueEntity>>
}

export type FlowProductInput = {
	id: Scalars['Int']
	name?: InputMaybe<Scalars['String']>
	valueEntities: Array<FlowValueEntityInput>
}

export type FlowResponse = {
	__typename?: 'FlowResponse'
	errors?: Maybe<Array<Error>>
	flow?: Maybe<Flow>
}

export type FlowStatement = {
	__typename?: 'FlowStatement'
	flowComponents?: Maybe<Array<FlowComponent>>
	id: Scalars['Int']
	products?: Maybe<Array<FlowProduct>>
	type: FlowStatementType
}

export enum FlowStatementType {
	Do = 'DO',
	If = 'IF',
}

export type FlowValueEntity = {
	__typename?: 'FlowValueEntity'
	initialValue: Scalars['String']
	name: Scalars['String']
	root?: Maybe<Root>
	rootId?: Maybe<Scalars['Int']>
	templateKey: Scalars['String']
	type: DeviceValueType
	value: Scalars['String']
}

export type FlowValueEntityInput = {
	initialValue: Scalars['String']
	name?: InputMaybe<Scalars['String']>
	rootId?: InputMaybe<Scalars['Int']>
	templateKey: Scalars['String']
	type: DeviceValueType
	value: Scalars['String']
}

export type FlowsFilter = {
	isDone?: InputMaybe<Scalars['Boolean']>
	name?: InputMaybe<Scalars['String']>
}

export type FlowsPaginations = {
	__typename?: 'FlowsPaginations'
	nodes: Array<Flow>
	totalCount: Scalars['Int']
}

export type FolderInput = {
	name: Scalars['String']
	parentFolderId?: InputMaybe<Scalars['Int']>
}

export enum FolderType {
	Module = 'MODULE',
	Subfolder = 'SUBFOLDER',
}

export type Generate2FaSecretResponse = {
	__typename?: 'Generate2FASecretResponse'
	secret: Scalars['String']
	uri: Scalars['String']
}

export type GoogleAuth = {
	__typename?: 'GoogleAuth'
	accessToken?: Maybe<Scalars['String']>
	email?: Maybe<Scalars['String']>
	expiresAt?: Maybe<Scalars['DateTime']>
	name?: Maybe<Scalars['String']>
	refreshToken?: Maybe<Scalars['String']>
}

export type GoogleAuthInput = {
	accessToken?: InputMaybe<Scalars['String']>
	email?: InputMaybe<Scalars['String']>
	expiresAt?: InputMaybe<Scalars['DateTime']>
	name?: InputMaybe<Scalars['String']>
	refreshToken?: InputMaybe<Scalars['String']>
}

export type GoogleAuthResponse = {
	__typename?: 'GoogleAuthResponse'
	errors?: Maybe<Array<Error>>
	googleAuth?: Maybe<GoogleAuth>
	success: Scalars['Boolean']
}

export type Group = {
	__typename?: 'Group'
	id: Scalars['Int']
	level?: Maybe<Scalars['Int']>
	name?: Maybe<Scalars['String']>
	root?: Maybe<Root>
	rootId?: Maybe<Scalars['Int']>
	updated?: Maybe<Scalars['DateTime']>
}

export type GroupsFilter = {
	name?: InputMaybe<Scalars['String']>
	rootId?: InputMaybe<Scalars['Int']>
}

export type GroupsPaginations = {
	__typename?: 'GroupsPaginations'
	nodes: Array<Group>
	totalCount: Scalars['Int']
}

export enum Health {
	Bat_20_0 = 'BAT_20_0',
	Bat_50_20 = 'BAT_50_20',
	Bat_75_50 = 'BAT_75_50',
	Bat_100_75 = 'BAT_100_75',
}

export type IncompleteTransactionsInput = {
	rootId?: InputMaybe<Scalars['Int']>
}

export type InfoResponse = {
	__typename?: 'InfoResponse'
	apiErrCount?: Maybe<Scalars['Int']>
	batteryUnderCount?: Maybe<Scalars['Int']>
	deviceErrCount?: Maybe<Scalars['Int']>
	deviceOffline?: Maybe<Scalars['Int']>
	deviceProcessingCount?: Maybe<Scalars['Int']>
	hasLocationCoordinates?: Maybe<Scalars['Boolean']>
	industrialScaleCount?: Maybe<Scalars['Int']>
	openWarehouseOrderCount?: Maybe<Scalars['Int']>
	orbisBatteryUnderCount?: Maybe<Scalars['Int']>
	orbisDeviceErrCount?: Maybe<Scalars['Int']>
	orbisDeviceOffline?: Maybe<Scalars['Int']>
	orbisDeviceProcessingCount?: Maybe<Scalars['Int']>
	orbisLabelCount?: Maybe<Scalars['Int']>
	processingErrCount?: Maybe<Scalars['Int']>
	rootCount?: Maybe<Scalars['Int']>
	routerCount?: Maybe<Scalars['Int']>
	routerOffline?: Maybe<Scalars['Int']>
	scaleBatteryUnderCount?: Maybe<Scalars['Int']>
	scaleDeviceErrCount?: Maybe<Scalars['Int']>
	scaleDeviceOffline?: Maybe<Scalars['Int']>
	scaleDeviceProcessingCount?: Maybe<Scalars['Int']>
	sensorLabelCount?: Maybe<Scalars['Int']>
	shelfBarCount?: Maybe<Scalars['Int']>
	signageDeviceCount?: Maybe<Scalars['Int']>
	smartLabelCount?: Maybe<Scalars['Int']>
	tenant: Scalars['String']
	totalWarehouseOrderCount?: Maybe<Scalars['Int']>
	warehouseProductCount?: Maybe<Scalars['Int']>
}

export type Integration = {
	__typename?: 'Integration'
	cron?: Maybe<Scalars['String']>
	cronUpdateUrl?: Maybe<Scalars['String']>
	id: Scalars['Int']
	name?: Maybe<Scalars['String']>
	preset?: Maybe<CronPreset>
	syncTime?: Maybe<Scalars['String']>
	token: Scalars['String']
	triggerUrl?: Maybe<Scalars['String']>
	weekDays?: Maybe<Array<WeekDay>>
}

export type IntegrationResponse = {
	__typename?: 'IntegrationResponse'
	errors?: Maybe<Array<Maybe<Error>>>
	integration?: Maybe<Integration>
}

export type IntegrationsFilter = {
	filter?: InputMaybe<Scalars['String']>
}

export type IntegrationsPagination = {
	__typename?: 'IntegrationsPagination'
	nodes?: Maybe<Array<Integration>>
	totalCount: Scalars['Int']
}

export type IsleInput = {
	depth?: InputMaybe<Scalars['Int']>
	height?: InputMaybe<Scalars['Int']>
	key: Scalars['String']
	rootId: Scalars['Int']
	width?: InputMaybe<Scalars['Int']>
	x?: InputMaybe<Scalars['Int']>
	y?: InputMaybe<Scalars['Int']>
}

export type IslesFilter = {
	key?: InputMaybe<Scalars['String']>
	rootId?: InputMaybe<Scalars['Int']>
}

export type IslesPaginations = {
	__typename?: 'IslesPaginations'
	nodes: Array<Aisle>
	totalCount: Scalars['Int']
}

export type KeyValuePair = {
	__typename?: 'KeyValuePair'
	key?: Maybe<Scalars['String']>
	value?: Maybe<Scalars['String']>
}

export enum Led_Mode {
	Blink = 'BLINK',
}

export type LandingTemplate = {
	__typename?: 'LandingTemplate'
	components?: Maybe<Array<Component>>
	height?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	inUse?: Maybe<Scalars['Boolean']>
	isCustom?: Maybe<Scalars['Boolean']>
	key: Scalars['String']
	name: Scalars['String']
	width?: Maybe<Scalars['Int']>
}

export type LandingTemplateInput = {
	components: Array<PostComponent>
	height: Scalars['Int']
	isCustom?: InputMaybe<Scalars['Boolean']>
	key: Scalars['String']
	name: Scalars['String']
	width: Scalars['Int']
}

export type LandingTemplateResponse = {
	__typename?: 'LandingTemplateResponse'
	errors?: Maybe<Array<Error>>
	landingTemplate?: Maybe<LandingTemplate>
}

export type LandingTemplatesFilter = {
	any?: InputMaybe<Scalars['String']>
}

export type LandingTemplatesPagination = {
	__typename?: 'LandingTemplatesPagination'
	nodes?: Maybe<Array<LandingTemplate>>
	totalCount: Scalars['Int']
}

export enum LedColor {
	Blue = 'BLUE',
	Cyan = 'CYAN',
	Green = 'GREEN',
	Magenta = 'MAGENTA',
	Red = 'RED',
	White = 'WHITE',
	Yellow = 'YELLOW',
}

export type LedConfig = {
	__typename?: 'LedConfig'
	blinkSpeed?: Maybe<BlinkSpeed>
	blinkTime?: Maybe<BlinkTime>
	color?: Maybe<LedColor>
}

export type LedConfigInput = {
	blinkSpeed: BlinkSpeed
	blinkTime: BlinkTime
	color: LedColor
}

export type LicenseCount = {
	__typename?: 'LicenseCount'
	count: Scalars['Int']
	module: PurchasedModules
}

export enum LogType {
	Create = 'CREATE',
	Update = 'UPDATE',
}

export type LoginPageSettings = {
	__typename?: 'LoginPageSettings'
	customer: Scalars['String']
	loginLogo?: Maybe<Scalars['String']>
	logo?: Maybe<Scalars['String']>
	primaryColor?: Maybe<Scalars['String']>
	textColor?: Maybe<Scalars['String']>
}

export type LoginResponse = {
	__typename?: 'LoginResponse'
	delta?: Maybe<Scalars['Int']>
	errors?: Maybe<Array<Error>>
	needOTP?: Maybe<Scalars['Boolean']>
	scopes?: Maybe<Array<Scalars['String']>>
	tokens?: Maybe<Scalars['JSON']>
}

export type LogoutAllResponse = {
	__typename?: 'LogoutAllResponse'
	affectedUsers: Scalars['Int']
	success: Scalars['Boolean']
}

export enum Module_Type {
	Admin = 'ADMIN',
	Analytics = 'ANALYTICS',
	ApiClient = 'API_CLIENT',
	AuditLogs = 'AUDIT_LOGS',
	Bar = 'BAR',
	Button = 'BUTTON',
	DeviceLed = 'DEVICE_LED',
	DevTools = 'DEV_TOOLS',
	FirmwareUpdate = 'FIRMWARE_UPDATE',
	Flow = 'FLOW',
	Integration = 'INTEGRATION',
	LandingPage = 'LANDING_PAGE',
	Management = 'MANAGEMENT',
	Orbis = 'ORBIS',
	OrbisAdmin = 'ORBIS_ADMIN',
	Order = 'ORDER',
	Planogram = 'PLANOGRAM',
	Product = 'PRODUCT',
	ProductHistory = 'PRODUCT_HISTORY',
	Root = 'ROOT',
	Router = 'ROUTER',
	Signage = 'SIGNAGE',
	SmartLabel = 'SMART_LABEL',
	SmartLabelSocHistory = 'SMART_LABEL_SOC_HISTORY',
	SmartSensor = 'SMART_SENSOR',
	Storage = 'STORAGE',
	Template = 'TEMPLATE',
	User = 'USER',
	VirtualStore = 'VIRTUAL_STORE',
	Warehouse = 'WAREHOUSE',
	WarehouseReport = 'WAREHOUSE_REPORT',
}

export type ManagementDashInfo = {
	__typename?: 'ManagementDashInfo'
	numOfLicenses?: Maybe<Array<LicenseCount>>
	numOfTotalActiveCustomers?: Maybe<Scalars['Int']>
	numOfTotalDevices?: Maybe<Scalars['Int']>
	numOfTotalInactiveCustomers?: Maybe<Scalars['Int']>
	numOfTotalRoots?: Maybe<Scalars['Int']>
	numOfTotalRouters?: Maybe<Scalars['Int']>
	numOfTotalScales?: Maybe<Scalars['Int']>
	numOfTotalSmartLabels?: Maybe<Scalars['Int']>
	numOfTotalUsers?: Maybe<Scalars['Int']>
}

export type Market = {
	__typename?: 'Market'
	id: Scalars['Int']
	key?: Maybe<Scalars['String']>
	name?: Maybe<Scalars['String']>
	roots?: Maybe<Array<Root>>
	rootsCount?: Maybe<Scalars['Int']>
}

export type MarketResponse = {
	__typename?: 'MarketResponse'
	errors?: Maybe<Array<Maybe<Error>>>
	market?: Maybe<Market>
	success?: Maybe<Scalars['Boolean']>
}

export type MarketSuccessfulTransactionLocations = {
	__typename?: 'MarketSuccessfulTransactionLocations'
	id: Scalars['Int']
	locationCount: Scalars['Int']
	locations: Array<SuccessfulTransactionLocation>
	name?: Maybe<Scalars['String']>
}

export type MarketsFilter = {
	name?: InputMaybe<Scalars['String']>
}

export type MarketsPaginations = {
	__typename?: 'MarketsPaginations'
	nodes: Array<Market>
	totalCount: Scalars['Int']
}

export type MeResponse = {
	__typename?: 'MeResponse'
	allowedIPs?: Maybe<Array<Maybe<Scalars['IPv4']>>>
	email?: Maybe<Scalars['String']>
	fullName?: Maybe<Scalars['String']>
	googleAuth?: Maybe<GoogleAuth>
	id: Scalars['Int']
	ledConfig?: Maybe<LedConfig>
	locationRestrictions?: Maybe<Array<Root>>
	marketIDs?: Maybe<Array<Scalars['Int']>>
	marketRestrictions?: Maybe<Array<Market>>
	microsoftAuth?: Maybe<MicrosoftAuth>
	permissions?: Maybe<Array<Scalars['String']>>
	roles?: Maybe<Array<Role>>
	rootIDs?: Maybe<Array<Scalars['Int']>>
}

export type Measurement = {
	__typename?: 'Measurement'
	_time?: Maybe<Scalars['DateTime']>
	_value?: Maybe<Scalars['Float']>
}

export enum MeasurementType {
	Accuracy = 'ACCURACY',
	AirQualityIndex = 'AIR_QUALITY_INDEX',
	Eco2 = 'ECO2',
	Humidity = 'HUMIDITY',
	Pressure = 'PRESSURE',
	Temperature = 'TEMPERATURE',
	Tvoc = 'TVOC',
}

export type MicrosoftAuth = {
	__typename?: 'MicrosoftAuth'
	accessToken?: Maybe<Scalars['String']>
	email?: Maybe<Scalars['String']>
	expiresAt?: Maybe<Scalars['DateTime']>
	name?: Maybe<Scalars['String']>
	scopes?: Maybe<Array<Scalars['String']>>
	tenantId?: Maybe<Scalars['String']>
	uuid?: Maybe<Scalars['String']>
}

export type MicrosoftAuthInput = {
	accessToken?: InputMaybe<Scalars['String']>
	email?: InputMaybe<Scalars['String']>
	expiresAt?: InputMaybe<Scalars['DateTime']>
	name?: InputMaybe<Scalars['String']>
	scopes?: InputMaybe<Array<Scalars['String']>>
	tenantId?: InputMaybe<Scalars['String']>
	uuid?: InputMaybe<Scalars['String']>
}

export enum ModeEnum {
	Automatic = 'AUTOMATIC',
	Manual = 'MANUAL',
}

export type MultiUploadResponse = {
	__typename?: 'MultiUploadResponse'
	errors?: Maybe<Array<Error>>
	file?: Maybe<File>
}

export type Mutation = {
	__typename?: 'Mutation'
	/** Activate a Smart Bar (internal) */
	activateBar: ActivateBarResponse
	/** Activate a AS100 device */
	activateTVDevice: TvDeviceResponse
	/** Add a new Aisle */
	addAisle: AisleResponse
	/** Add a new Shelf */
	addBay: BayResponse
	/** Add a new button */
	addButton: AddButtonResponse
	/** Add a new calendar product */
	addCalendar: AddCalendarResponse
	/** Add a new Channel */
	addChannel: ChannelResponse
	/** Add a new device alarm report */
	addDeviceAlarmReport: AddDeviceAlarmReportResponse
	/** Add device configuration */
	addDeviceConfig: DeviceConfigResponse
	/** Add or edit products. If internal IDs exist, products will be edited. (can change device image) */
	addEditProducts: AddEditProductsResponse
	/** Add flow */
	addFlow: AddFlowResponse
	/** Add group */
	addGroup: StandardResponse
	/** Add integration */
	addIntegration: AddIntegrationResponse
	/** Add a new landing template */
	addLandingTemplate: StandardResponse
	/** Add market */
	addMarket: MarketResponse
	/** Add order */
	addOrder: AddOrderResponse
	/** Add a new Playlist */
	addPlaylist: StandardResponse
	/** Add a new Position */
	addPosition: PositionResponse
	/** Add product */
	addProduct: AddProductResponse
	/** Add a new user role */
	addRole: StandardResponse
	/** Add root (main location) */
	addRoot: RootResponse
	/** Add a new router (DASHBOARD) */
	addRouter?: Maybe<AddRouterResponse>
	/** Add a smart sensor */
	addSensor: SensorResponse
	/** Add a new Shelf */
	addShelf: ShelfResponse
	/** Add a new Shelf Structure (AAA-BB-SS) */
	addShelfStruct: ShelfStructResponse
	/** Add a new signage button */
	addSignageButton: AddSignageButtonResponse
	/** Add a new supplier */
	addSupplier: AddSupplierResponse
	/** Add synchronization */
	addSynchronization: AddSynchronizationResponse
	/** Add a new template */
	addTemplate: StandardResponse
	/** Add a new template variant */
	addTemplateVariant: TemplateVariantResponse
	/** Add a new user */
	addUser: StandardResponse
	/** Add a new Virtual Shelf */
	addVirtualCategoryPoint: VirtualCategoryPointResponse
	/** Add a new Virtual Category Screen */
	addVirtualCategoryScreen: VirtualCategoryScreenResponse
	/** Register a Smart Bar */
	addVirtualDevice: DeviceResponse
	/** Add a new Virtual Multi Screen */
	addVirtualMultiScreen: VirtualMultiScreenResponse
	/** Add a new Virtual Rack */
	addVirtualRack: VirtualRackResponse
	/** Add a new Virtual Shelf */
	addVirtualShelf: VirtualShelfResponse
	/** Add a Virtual Store Device */
	addVirtualStoreDevice: VirtualStoreDeviceResponse
	/** Support for admin to disable user's 2FA */
	adminDisable2FA: StandardResponse
	/** Autofill coordinates */
	autofillCoordinates: AutofillCoordinatesResponse
	/** Bulk assing router to devices */
	bulkAssignRouter: StandardResponse
	/** Bulk unassign router from devices */
	bulkUnassignRouter: StandardResponse
	/** Reset a Smart Label */
	clearDevice: StandardResponse
	createApiClient: CreateApiClientResponse
	/** create a new folder for asset management */
	createFolder: CreateFolderResponse
	/** Delete an Aisle */
	deleteAisle: StandardResponse
	/** Delete a Bay */
	deleteBay: StandardResponse
	/** Delete a Button */
	deleteButton: StandardResponse
	/** Delete calendar */
	deleteCalendar: StandardResponse
	/** Delete a Channel */
	deleteChannel: StandardResponse
	/** Delete a Smart Label */
	deleteDevice: StandardResponse
	/** Delete device alarm report */
	deleteDeviceAlarmReport: StandardResponse
	/** delete  file */
	deleteFile: StandardResponse
	/** Delete flow */
	deleteFlow: StandardResponse
	/** Delete a Integration */
	deleteIntegration: StandardResponse
	/** Delete landing template by ID */
	deleteLandingTemplate: DeleteResponse
	/** Delete market */
	deleteMarket: StandardResponse
	/** Delete an ORBIS device */
	deleteOrbisDevice: StandardResponse
	/** Delete a playlist */
	deletePlaylist: StandardResponse
	/** Delete a Position */
	deletePosition: StandardResponse
	/** Delete a Position and untie device */
	deletePositionAndUntieDevice: StandardResponse
	/** Delete product */
	deleteProduct: DeleteProductResponse
	/** delete  product image */
	deleteProductImage: StandardResponse
	/** delete all productImages for proudcts */
	deleteProductImages: StandardResponse
	/** Delete all products with internal IDs */
	deleteProducts: DeleteResponse
	/** Delete all resized image variants from S3 and reset sizes to null. Admin only; run per customer. */
	deleteResizedImages: StandardResponse
	/** Delete a Role */
	deleteRole: StandardResponse
	/** Delete a Root */
	deleteRoot: StandardResponse
	/** Delete a Router */
	deleteRouter: StandardResponse
	/** Delete a Router Provisioning (MANAGEMENT) */
	deleteRouterProvisioning: StandardResponse
	/** Delete a Scale */
	deleteScale: StandardResponse
	/** Delete a sensor */
	deleteSensor: StandardResponse
	/** Delete a Shelf */
	deleteShelf: StandardResponse
	/** Delete a Signage Button */
	deleteSignageButton: StandardResponse
	/** Delete supplier */
	deleteSupplier: StandardResponse
	/** Delete a TV Device */
	deleteTVDevice: StandardResponse
	/** Delete template by ID */
	deleteTemplate: DeleteResponse
	/** Delete templateVariant by ID */
	deleteTemplateVariant: DeleteResponse
	/** Delete all templates by IDs */
	deleteTemplates: DeleteResponse
	/** Delete a User */
	deleteUser: StandardResponse
	/** Delete value entity */
	deleteValueEntities: StandardResponse
	/** Delete a VirtualCategoryPoint */
	deleteVirtualCategoryPoint: StandardResponse
	/** Delete a VirtualCategoryScreen */
	deleteVirtualCategoryScreen: StandardResponse
	/** delete virtualCategoryScreen image */
	deleteVirtualCategoryScreenImage: StandardResponse
	/** Delete VirtualMultiScreen */
	deleteVirtualMultiScreen: StandardResponse
	/** Delete a VirtualRack */
	deleteVirtualRack: StandardResponse
	/** Delete a VirtualShelf */
	deleteVirtualShelf: StandardResponse
	/** Delete a VirtualStoreDevice */
	deleteVirtualStoreDevice: StandardResponse
	/** Disable 2FA */
	disable2FA: Disable2FaResponse
	/** Edit Aisle */
	editAisle: StandardResponse
	/** Edit a Bar (can change bar images) */
	editBar: StandardResponse
	/** Edit Bay */
	editBay: StandardResponse
	/** Edit an existing button */
	editButton: EditButtonResponse
	/** Edit a calendar product */
	editCalendar: EditCalendarResponse
	/** Edit a Channel */
	editChannel: StandardResponse
	/**
	 * Edit demo screen
	 * @deprecated Not in use (was used for demoing e-paper screen connected to RPi)
	 */
	editDemoScreen: DemoScreenResponse
	/** Edit a device (can change device image) */
	editDevice: EditDeviceResponse
	/** Edit a device alarm report */
	editDeviceAlarmReport: EditDeviceAlarmReportResponse
	/** Edit a device config */
	editDeviceConfig: StandardResponse
	/** Edit device name only */
	editDeviceName: EditDeviceResponse
	/** Multi-force refresh devices */
	editDeviceTemplates: EditDeviceTemplatesResponse
	editFile: StandardResponse
	/** Edit flow */
	editFlow: StandardResponse
	/** Edit group */
	editGroup: StandardResponse
	/** Edit integration */
	editIntegration: StandardResponse
	/** Edit a landing template */
	editLandingTemplate: StandardResponse
	/** Update market */
	editMarket: StandardResponse
	/** Edit Order */
	editOrder: StandardResponse
	/** Edit Order Item */
	editOrderItem: EditOrderItemResponse
	/** Edit a Playlist */
	editPlaylist: StandardResponse
	/** Edit position (can change device image) */
	editPosition: StandardResponse
	/** Edit product */
	editProduct: EditProductResponse
	/** Edit a user role */
	editRole: StandardResponse
	/** Edit root */
	editRoot: StandardResponse
	/** Edit a router */
	editRouter: StandardResponse
	/** Edit a scale */
	editScale: StandardResponse
	/** Edit a sensor */
	editSensor: StandardResponse
	/** Edit shelf */
	editShelf: StandardResponse
	/** Edit an existing signage button */
	editSignageButton: EditSignageButtonResponse
	/** Edit an existing supplier */
	editSupplier: StandardResponse
	/** Edit synchronization */
	editSynchronization: StandardResponse
	/** Edit a template */
	editTemplate: StandardResponse
	/** Edit a template variant */
	editTemplateVariant: StandardResponse
	/** Edit a TV Device */
	editTvDevice: StandardResponse
	/** Edit a user */
	editUser: StandardResponse
	/** Edit a Virtual Category */
	editVirtualCategoryPoint: StandardResponse
	/** Edit a Virtual Category Screen */
	editVirtualCategoryScreen: StandardResponse
	/** Edit a Virtual Multi Screen */
	editVirtualMultiScreen: StandardResponse
	/** Edit a Virtual Rack */
	editVirtualRack: StandardResponse
	/** Edit a Virtual Shelf */
	editVirtualShelf: StandardResponse
	/** Edit a Virtual Store Device */
	editVirtualStoreDevice: StandardResponse
	/** Enable 2FA */
	enable2FA: Enable2FaResponse
	/** Force refresh a device */
	forceRefreshDevice: StandardResponse
	/** Force refresh devices */
	forceRefreshDevices: StandardResponse
	/** Force Reset a Smart Label */
	forceResetDevice: StandardResponse
	/** Generate secret for 2FA */
	generate2FASecret: Generate2FaSecretResponse
	/** Get access token for Google */
	getGoogleAuth: GoogleAuthResponse
	login: LoginResponse
	logout?: Maybe<Scalars['Boolean']>
	logoutAllUsers: LogoutAllResponse
	/** Generate multi-resolution variants for images that have sizes=null. Admin only; run per customer. */
	migrateImageSizes: StandardResponse
	/** upload multiple files for use in template editor */
	multiUpload?: Maybe<Array<MultiUploadResponse>>
	/** upload multiple files for use in template editor */
	multiUploadDibal?: Maybe<Array<File>>
	/** Provision a router (ROUTER CALL) */
	provisionRouter?: Maybe<ProvisionRouterResponse>
	/** Refresh devices */
	refreshDevices: StandardResponse
	/** Refresh all Virtual Store Devices */
	refreshVirtualStoreDevices: StandardResponse
	/** Register a Smart Bar */
	registerBar: BarResponse
	/** Register a Smart Label */
	registerDevice: DeviceResponse
	/** Register a router with token (ROUTER CALL) */
	registerRouter?: Maybe<RegisterRouterResponse>
	/** Register a Scale */
	registerScale: ScaleResponse
	revokeApiClient: Scalars['Boolean']
	rotateApiClientSecret: CreateApiClientResponse
	/** Set template to all devices containing a product */
	setProductTemplate: StandardResponse
	/** Swap the product used by devices. Replaces fromProductId with toProductId on either productId or productId2nd. Both products must belong to the same market as the device root. */
	swapDeviceProducts: EditDeviceTemplatesResponse
	/** Switch all devices using productA to productB (checks both productId and productId2nd) */
	switchDeviceProduct: StandardResponse
	/** Trigger device LED */
	triggerDeviceLed: StandardResponse
	/** Trigger synchronization */
	triggerSync: StandardResponse
	/** Unassign a product from devices. If the device has a secondary product, it is promoted to primary. */
	unassignDeviceProduct: EditDeviceTemplatesResponse
	/** Update all active devices in the system */
	updateActiveDevices: StandardResponse
	/** Update all Virtual Store Devices with new data */
	updateAllVirtualStoreDevices: StandardResponse
	/** Update firmware version for multiple devices */
	updateDevices: StandardResponse
	/** Update all devices on a root where productId is not null (if rootId is not provided, updates devices across all roots) */
	updateRootDevices: StandardResponse
	/** upload product image */
	uploadProductImage?: Maybe<UploadProductImageResponse>
	/** upload virtual store screen image */
	uploadVirtualStoreScreen?: Maybe<File>
	/** Verify 2FA */
	verify2FA: StandardResponse
	/** Verify user email with token */
	verifyEmail: StandardResponse
}

export type MutationActivateBarArgs = {
	macAddress?: InputMaybe<Scalars['MAC']>
	token: Scalars['String']
}

export type MutationActivateTvDeviceArgs = {
	input: TvDeviceActivateInput
	token?: InputMaybe<Scalars['String']>
}

export type MutationAddAisleArgs = {
	input: IsleInput
}

export type MutationAddBayArgs = {
	input: BayInput
}

export type MutationAddButtonArgs = {
	input: AddButton
}

export type MutationAddCalendarArgs = {
	input: AddCalendarInput
}

export type MutationAddChannelArgs = {
	input: AddChannelInput
}

export type MutationAddDeviceAlarmReportArgs = {
	input: AddDeviceAlarmReportInput
}

export type MutationAddDeviceConfigArgs = {
	input: DeviceConfigInput
}

export type MutationAddEditProductsArgs = {
	input: Array<ProductInput>
	overrideExisting?: InputMaybe<Scalars['Boolean']>
}

export type MutationAddFlowArgs = {
	input: AddFlowInput
}

export type MutationAddGroupArgs = {
	name: Scalars['String']
	parentId?: InputMaybe<Scalars['Int']>
	rootId: Scalars['Int']
}

export type MutationAddIntegrationArgs = {
	input: AddIntegrationInput
}

export type MutationAddLandingTemplateArgs = {
	input: LandingTemplateInput
}

export type MutationAddMarketArgs = {
	input: AddMarketInput
}

export type MutationAddOrderArgs = {
	input: AddOrderInput
}

export type MutationAddPlaylistArgs = {
	input: AddPlaylistInput
}

export type MutationAddPositionArgs = {
	input: PositionInput
}

export type MutationAddProductArgs = {
	input: ProductInput
}

export type MutationAddRoleArgs = {
	input: AddRoleInput
}

export type MutationAddRootArgs = {
	input: AddRootInput
}

export type MutationAddRouterArgs = {
	input: AddRouterInput
}

export type MutationAddSensorArgs = {
	input: AddSensorInput
}

export type MutationAddShelfArgs = {
	input: ShelfInput
}

export type MutationAddShelfStructArgs = {
	input: ShelfStructInput
}

export type MutationAddSignageButtonArgs = {
	input: AddSignageButton
}

export type MutationAddSupplierArgs = {
	input: AddSupplier
}

export type MutationAddSynchronizationArgs = {
	input: AddSynchronizationInput
}

export type MutationAddTemplateArgs = {
	input: TemplateInput
}

export type MutationAddTemplateVariantArgs = {
	input: TemplateVariantInput
}

export type MutationAddUserArgs = {
	input: AddUserInput
}

export type MutationAddVirtualCategoryPointArgs = {
	input: AddVirtualCategoryPointInput
}

export type MutationAddVirtualCategoryScreenArgs = {
	input: AddVirtualCategoryScreenInput
}

export type MutationAddVirtualDeviceArgs = {
	input: VirtualDeviceInput
}

export type MutationAddVirtualMultiScreenArgs = {
	input: AddVirtualMultiScreenInput
}

export type MutationAddVirtualRackArgs = {
	input: AddVirtualRackInput
}

export type MutationAddVirtualShelfArgs = {
	input: AddVirtualShelfInput
}

export type MutationAddVirtualStoreDeviceArgs = {
	input: AddVirtualStoreDeviceInput
}

export type MutationAdminDisable2FaArgs = {
	userId: Scalars['Int']
}

export type MutationBulkAssignRouterArgs = {
	input: BulkAssignRouterInput
}

export type MutationBulkUnassignRouterArgs = {
	input: BulkUnassignRouterInput
}

export type MutationClearDeviceArgs = {
	deviceSerialNumber?: InputMaybe<Scalars['String']>
	id?: InputMaybe<Scalars['Int']>
}

export type MutationCreateApiClientArgs = {
	expiresAt?: InputMaybe<Scalars['String']>
	name: Scalars['String']
	roleIDs: Array<Scalars['Int']>
	rootIDs?: InputMaybe<Array<Scalars['Int']>>
}

export type MutationCreateFolderArgs = {
	input: FolderInput
}

export type MutationDeleteAisleArgs = {
	input: DeleteAisleInput
}

export type MutationDeleteBayArgs = {
	input: DeleteBayInput
}

export type MutationDeleteButtonArgs = {
	id: Scalars['Int']
}

export type MutationDeleteCalendarArgs = {
	id: Scalars['Int']
}

export type MutationDeleteChannelArgs = {
	channelId: Scalars['Int']
}

export type MutationDeleteDeviceArgs = {
	deviceSerialNumber?: InputMaybe<Scalars['String']>
	id?: InputMaybe<Scalars['Int']>
}

export type MutationDeleteDeviceAlarmReportArgs = {
	id: Scalars['Int']
}

export type MutationDeleteFileArgs = {
	fileId: Scalars['Int']
}

export type MutationDeleteFlowArgs = {
	id: Scalars['Int']
}

export type MutationDeleteIntegrationArgs = {
	id: Scalars['Int']
}

export type MutationDeleteLandingTemplateArgs = {
	input: DeleteLandingTemplateInput
}

export type MutationDeleteMarketArgs = {
	id: Scalars['Int']
}

export type MutationDeleteOrbisDeviceArgs = {
	deviceSerialNumber?: InputMaybe<Scalars['String']>
	id?: InputMaybe<Scalars['Int']>
}

export type MutationDeletePlaylistArgs = {
	playlistId: Scalars['Int']
}

export type MutationDeletePositionArgs = {
	positionId: Scalars['Int']
}

export type MutationDeletePositionAndUntieDeviceArgs = {
	positionId: Scalars['Int']
}

export type MutationDeleteProductArgs = {
	id: Scalars['Int']
}

export type MutationDeleteProductImageArgs = {
	productImageId: Scalars['Int']
}

export type MutationDeleteProductImagesArgs = {
	internalIds: Array<Scalars['String']>
}

export type MutationDeleteProductsArgs = {
	input: DeleteProductInput
}

export type MutationDeleteResizedImagesArgs = {
	customer: Scalars['String']
}

export type MutationDeleteRoleArgs = {
	id: Scalars['Int']
}

export type MutationDeleteRootArgs = {
	id: Scalars['Int']
}

export type MutationDeleteRouterArgs = {
	id: Scalars['Int']
}

export type MutationDeleteRouterProvisioningArgs = {
	id: Scalars['Int']
}

export type MutationDeleteScaleArgs = {
	id: Scalars['Int']
}

export type MutationDeleteSensorArgs = {
	sensorId: Scalars['Int']
}

export type MutationDeleteShelfArgs = {
	input: DeleteShelfInput
}

export type MutationDeleteSignageButtonArgs = {
	id: Scalars['Int']
}

export type MutationDeleteSupplierArgs = {
	id: Scalars['Int']
}

export type MutationDeleteTvDeviceArgs = {
	id: Scalars['Int']
}

export type MutationDeleteTemplateArgs = {
	input: DeleteTemplateInput
}

export type MutationDeleteTemplateVariantArgs = {
	input: DeleteTemplateVariantInput
}

export type MutationDeleteTemplatesArgs = {
	input: DeleteTemplatesInput
}

export type MutationDeleteUserArgs = {
	id: Scalars['Int']
}

export type MutationDeleteValueEntitiesArgs = {
	ids?: InputMaybe<Array<Scalars['Int']>>
}

export type MutationDeleteVirtualCategoryPointArgs = {
	id: Scalars['Int']
}

export type MutationDeleteVirtualCategoryScreenArgs = {
	id: Scalars['Int']
}

export type MutationDeleteVirtualCategoryScreenImageArgs = {
	categoryId: Scalars['Int']
}

export type MutationDeleteVirtualMultiScreenArgs = {
	id: Scalars['Int']
}

export type MutationDeleteVirtualRackArgs = {
	id: Scalars['Int']
}

export type MutationDeleteVirtualShelfArgs = {
	id: Scalars['Int']
}

export type MutationDeleteVirtualStoreDeviceArgs = {
	id: Scalars['Int']
}

export type MutationDisable2FaArgs = {
	code: Scalars['String']
}

export type MutationEditAisleArgs = {
	aisleId: Scalars['Int']
	input: EditAisleInput
}

export type MutationEditBarArgs = {
	barId: Scalars['Int']
	input: EditBarInput
}

export type MutationEditBayArgs = {
	bayId: Scalars['Int']
	input: EditBayInput
}

export type MutationEditButtonArgs = {
	input: EditButton
}

export type MutationEditCalendarArgs = {
	input: EditCalendarInput
}

export type MutationEditChannelArgs = {
	channelId: Scalars['Int']
	input: EditChannelInput
}

export type MutationEditDemoScreenArgs = {
	input: EditDemoScreenInput
}

export type MutationEditDeviceArgs = {
	deviceId: Scalars['Int']
	input: EditDeviceInput
}

export type MutationEditDeviceAlarmReportArgs = {
	input: EditDeviceAlarmReportInput
}

export type MutationEditDeviceConfigArgs = {
	input: EditDeviceConfigInput
}

export type MutationEditDeviceNameArgs = {
	deviceId: Scalars['Int']
	name: Scalars['String']
}

export type MutationEditDeviceTemplatesArgs = {
	deviceIds: Array<Scalars['Int']>
	templateVariantId: Scalars['Int']
}

export type MutationEditFileArgs = {
	fileId: Scalars['Int']
	input: EditFileInput
}

export type MutationEditFlowArgs = {
	id: Scalars['Int']
	input: EditFlowInput
}

export type MutationEditGroupArgs = {
	groupId: Scalars['Int']
	input: EditGroupInput
}

export type MutationEditIntegrationArgs = {
	input: EditIntegrationInput
}

export type MutationEditLandingTemplateArgs = {
	input: EditLandingTemplateInput
	landingTemplateId: Scalars['Int']
}

export type MutationEditMarketArgs = {
	input: EditMarketInput
	marketId: Scalars['Int']
}

export type MutationEditOrderArgs = {
	input: EditOrderInput
}

export type MutationEditOrderItemArgs = {
	id: Scalars['Int']
	input: EditOrderItemInput
}

export type MutationEditPlaylistArgs = {
	input: EditPlaylistInput
	playlistId: Scalars['Int']
}

export type MutationEditPositionArgs = {
	input: EditPositionInput
	positionId: Scalars['Int']
}

export type MutationEditProductArgs = {
	input: EditProductInput
}

export type MutationEditRoleArgs = {
	input: EditRoleInput
	roleId: Scalars['Int']
}

export type MutationEditRootArgs = {
	input: EditRootInput
	rootId: Scalars['Int']
}

export type MutationEditRouterArgs = {
	input: EditRouterInput
	routerId: Scalars['Int']
}

export type MutationEditScaleArgs = {
	input: EditScaleInput
	scaleId: Scalars['Int']
}

export type MutationEditSensorArgs = {
	input: EditSensorInput
	sensorId: Scalars['Int']
}

export type MutationEditShelfArgs = {
	input: EditShelfInput
	shelfId: Scalars['Int']
}

export type MutationEditSignageButtonArgs = {
	input: EditSignageButton
}

export type MutationEditSupplierArgs = {
	input: EditSupplier
}

export type MutationEditSynchronizationArgs = {
	input: EditSynchronizationInput
}

export type MutationEditTemplateArgs = {
	input: EditTemplateInput
	templateId: Scalars['Int']
}

export type MutationEditTemplateVariantArgs = {
	input: EditTemplateVariantInput
	templateVariantId: Scalars['Int']
}

export type MutationEditTvDeviceArgs = {
	input: EditTvDeviceInput
	tvDeviceId: Scalars['Int']
}

export type MutationEditUserArgs = {
	input: EditUserInput
	userId: Scalars['Int']
}

export type MutationEditVirtualCategoryPointArgs = {
	input: EditVirtualCategoryPointInput
}

export type MutationEditVirtualCategoryScreenArgs = {
	input: EditVirtualCategoryScreenInput
}

export type MutationEditVirtualMultiScreenArgs = {
	input: EditVirtualMultiScreenInput
}

export type MutationEditVirtualRackArgs = {
	input: EditVirtualRackInput
}

export type MutationEditVirtualShelfArgs = {
	input: EditVirtualShelfInput
}

export type MutationEditVirtualStoreDeviceArgs = {
	input: EditVirtualStoreDeviceInput
}

export type MutationEnable2FaArgs = {
	code: Scalars['String']
}

export type MutationForceRefreshDeviceArgs = {
	deviceId: Scalars['Int']
}

export type MutationForceRefreshDevicesArgs = {
	deviceIds: Array<Scalars['Int']>
}

export type MutationForceResetDeviceArgs = {
	id: Scalars['Int']
}

export type MutationGetGoogleAuthArgs = {
	code: Scalars['String']
	redirectUri: Scalars['String']
}

export type MutationLoginArgs = {
	otp?: InputMaybe<Scalars['String']>
	password: Scalars['String']
	username: Scalars['String']
}

export type MutationMigrateImageSizesArgs = {
	customer: Scalars['String']
}

export type MutationMultiUploadArgs = {
	files: Array<Scalars['Upload']>
	parentFolderId?: InputMaybe<Scalars['Int']>
	productAssign?: InputMaybe<Scalars['Boolean']>
}

export type MutationMultiUploadDibalArgs = {
	files: Array<Scalars['Upload']>
	parentFolderId?: InputMaybe<Scalars['Int']>
}

export type MutationProvisionRouterArgs = {
	uuid: Scalars['String']
}

export type MutationRefreshDevicesArgs = {
	deviceIds: Array<Scalars['Int']>
}

export type MutationRegisterBarArgs = {
	input: BarRegisterInput
}

export type MutationRegisterDeviceArgs = {
	input: DeviceRegisterInput
}

export type MutationRegisterRouterArgs = {
	token: Scalars['String']
	uuid: Scalars['String']
}

export type MutationRegisterScaleArgs = {
	input: ScaleRegisterInput
}

export type MutationRevokeApiClientArgs = {
	id: Scalars['ID']
}

export type MutationRotateApiClientSecretArgs = {
	id: Scalars['ID']
}

export type MutationSetProductTemplateArgs = {
	input: SetProductTemplateInput
}

export type MutationSwapDeviceProductsArgs = {
	deviceIds: Array<Scalars['Int']>
	fromProductId: Scalars['Int']
	toProductId: Scalars['Int']
}

export type MutationSwitchDeviceProductArgs = {
	fromProductId: Scalars['Int']
	marketId?: InputMaybe<Scalars['Int']>
	toProductId: Scalars['Int']
}

export type MutationTriggerDeviceLedArgs = {
	input: TriggerDeviceLedInput
}

export type MutationTriggerSyncArgs = {
	input: TriggerSyncInput
}

export type MutationUnassignDeviceProductArgs = {
	deviceIds: Array<Scalars['Int']>
	productId: Scalars['Int']
}

export type MutationUpdateActiveDevicesArgs = {
	marketId?: InputMaybe<Scalars['Int']>
}

export type MutationUpdateDevicesArgs = {
	input: UpdateDevicesInput
}

export type MutationUpdateRootDevicesArgs = {
	active: Scalars['Boolean']
	deviceType?: InputMaybe<DeviceType>
	erroredOnly: Scalars['Boolean']
	hasProduct: Scalars['Boolean']
	limitToRandom?: InputMaybe<Scalars['Int']>
	rootId?: InputMaybe<Scalars['Int']>
	skipRecentlyRefreshed?: InputMaybe<Scalars['Boolean']>
	type?: InputMaybe<DeviceSize>
}

export type MutationUploadProductImageArgs = {
	file: Scalars['Upload']
	internalId?: InputMaybe<Scalars['String']>
	primary?: InputMaybe<Scalars['Boolean']>
	productType?: InputMaybe<ProductType>
}

export type MutationUploadVirtualStoreScreenArgs = {
	file: Scalars['Upload']
	virtualCategoryScreenId?: InputMaybe<Scalars['Int']>
}

export type MutationVerify2FaArgs = {
	code: Scalars['String']
	secret: Scalars['String']
}

export type MutationVerifyEmailArgs = {
	token: Scalars['String']
}

export type Option = {
	__typename?: 'Option'
	name?: Maybe<Scalars['String']>
	value?: Maybe<Scalars['String']>
}

export enum OrbisType {
	OrbisCalendar = 'ORBIS_CALENDAR',
	OrbisCombined = 'ORBIS_COMBINED',
	OrbisTasklist = 'ORBIS_TASKLIST',
}

export type Order = {
	__typename?: 'Order'
	costumerId?: Maybe<Scalars['Int']>
	created?: Maybe<Scalars['DateTime']>
	id: Scalars['Int']
	mode?: Maybe<OrderMode>
	orderItems?: Maybe<Array<OrderItem>>
	orderNumber?: Maybe<Scalars['String']>
	orderType?: Maybe<OrderType>
	rootId?: Maybe<Scalars['Int']>
	supplier?: Maybe<Supplier>
	supplierId?: Maybe<Scalars['Int']>
}

export type OrderFilter = {
	aisleId?: InputMaybe<Scalars['Int']>
	any?: InputMaybe<Scalars['String']>
	archive?: InputMaybe<Scalars['Boolean']>
	bayId?: InputMaybe<Scalars['Int']>
	costumerId?: InputMaybe<Scalars['Int']>
	deliveryDateFrom?: InputMaybe<Scalars['DateTime']>
	deliveryDateTo?: InputMaybe<Scalars['DateTime']>
	orderMode?: InputMaybe<OrderMode>
	orderType?: InputMaybe<OrderType>
	productId?: InputMaybe<Scalars['Int']>
	rootId?: InputMaybe<Scalars['Int']>
	shelfId?: InputMaybe<Scalars['Int']>
	status?: InputMaybe<OrderStatus>
	supplierId?: InputMaybe<Scalars['Int']>
}

export type OrderItem = {
	__typename?: 'OrderItem'
	deliveryDate?: Maybe<Scalars['DateTime']>
	id: Scalars['Int']
	internalId?: Maybe<Scalars['String']>
	partnerId?: Maybe<Scalars['String']>
	product?: Maybe<Product>
	productId?: Maybe<Scalars['Int']>
	productName?: Maybe<Scalars['String']>
	quantity?: Maybe<Scalars['Int']>
	status?: Maybe<OrderStatus>
}

export type OrderItemLog = {
	__typename?: 'OrderItemLog'
	deliveryDate?: Maybe<Scalars['DateTime']>
	id: Scalars['Int']
	orderItem?: Maybe<OrderItem>
	orderItemId?: Maybe<Scalars['Int']>
	quantity?: Maybe<Scalars['Int']>
	status?: Maybe<OrderStatus>
	time?: Maybe<Scalars['DateTime']>
	type?: Maybe<LogType>
	user?: Maybe<User>
	userId?: Maybe<Scalars['Int']>
}

export type OrderItemLogsFilter = {
	orderItemId?: InputMaybe<Scalars['Int']>
}

export type OrderItemLogsPagination = {
	__typename?: 'OrderItemLogsPagination'
	nodes: Array<Maybe<OrderItemLog>>
	totalCount: Scalars['Int']
}

export enum OrderMode {
	Automatic = 'AUTOMATIC',
	Express = 'EXPRESS',
	Manual = 'MANUAL',
}

export type OrderResponse = {
	__typename?: 'OrderResponse'
	errors?: Maybe<Array<Error>>
	order?: Maybe<Order>
}

export enum OrderStatus {
	Delivered = 'DELIVERED',
	Failed = 'FAILED',
	PartiallyDelivered = 'PARTIALLY_DELIVERED',
	Pending = 'PENDING',
	Processing = 'PROCESSING',
}

export enum OrderType {
	VirtualStore = 'VIRTUAL_STORE',
	Warehouse = 'WAREHOUSE',
}

export type OrdersPagination = {
	__typename?: 'OrdersPagination'
	nodes: Array<Maybe<Order>>
	totalCount: Scalars['Int']
}

export enum Orientation {
	Bottomleft = 'BOTTOMLEFT',
	Bottoright = 'BOTTORIGHT',
	Topleft = 'TOPLEFT',
	Topright = 'TOPRIGHT',
}

export type ParseTemplateResponse = {
	__typename?: 'ParseTemplateResponse'
	errors?: Maybe<Array<Error>>
	template?: Maybe<Scalars['String']>
}

export type Playlist = {
	__typename?: 'Playlist'
	id: Scalars['Int']
	name: Scalars['String']
	playlistItems: Array<PlaylistItem>
}

export type PlaylistItem = {
	__typename?: 'PlaylistItem'
	duration: Scalars['Int']
	file?: Maybe<File>
	id: Scalars['Int']
	playlist: Playlist
	sequence?: Maybe<Scalars['Int']>
}

export type PlaylistItemInput = {
	duration: Scalars['Int']
	fileId: Scalars['Int']
	sequence?: InputMaybe<Scalars['Int']>
}

export type PlaylistResponse = {
	__typename?: 'PlaylistResponse'
	errors?: Maybe<Array<Error>>
	playlist?: Maybe<Playlist>
}

export type PlaylistsFilter = {
	name?: InputMaybe<Scalars['String']>
}

export type PlaylistsPagination = {
	__typename?: 'PlaylistsPagination'
	nodes?: Maybe<Array<Playlist>>
	totalCount: Scalars['Int']
}

export type Position = {
	__typename?: 'Position'
	device?: Maybe<Device>
	id: Scalars['Int']
	/** @deprecated Never used */
	key?: Maybe<Scalars['String']>
	name?: Maybe<Scalars['String']>
	/** @deprecated Never used */
	orientation?: Maybe<Orientation>
	product?: Maybe<Product>
	root?: Maybe<Root>
	/** sequenca number on shelf (starts with 1) */
	sequence?: Maybe<Scalars['Int']>
	/** conncted shelf */
	shelf?: Maybe<Shelf>
	templateVariant?: Maybe<TemplateVariant>
	/** offset for shelf edge */
	x?: Maybe<Scalars['Int']>
	y?: Maybe<Scalars['Int']>
	z?: Maybe<Scalars['Int']>
}

export type PositionInput = {
	name?: InputMaybe<Scalars['String']>
	productId?: InputMaybe<Scalars['Int']>
	productInternalId?: InputMaybe<Scalars['String']>
	sequence?: InputMaybe<Scalars['Int']>
	shelfId: Scalars['Int']
	templateVariantId?: InputMaybe<Scalars['Int']>
	x?: InputMaybe<Scalars['Int']>
	y?: InputMaybe<Scalars['Int']>
	z?: InputMaybe<Scalars['Int']>
}

export type PositionResponse = {
	__typename?: 'PositionResponse'
	errors?: Maybe<Array<Maybe<Error>>>
	position?: Maybe<Position>
	success?: Maybe<Scalars['Boolean']>
}

export type PositionStructInput = {
	name?: InputMaybe<Scalars['String']>
	productInternalId?: InputMaybe<Scalars['String']>
	templateVariantKey?: InputMaybe<Scalars['String']>
	x: Scalars['Int']
	y?: InputMaybe<Scalars['Int']>
	z?: InputMaybe<Scalars['Int']>
}

export type PositionsFilter = {
	aisleId?: InputMaybe<Scalars['Int']>
	key?: InputMaybe<Scalars['String']>
	rootId?: InputMaybe<Scalars['Int']>
	shelfId?: InputMaybe<Scalars['Int']>
}

export type PositionsPaginations = {
	__typename?: 'PositionsPaginations'
	nodes: Array<Position>
	totalCount: Scalars['Int']
}

export type PostComponent = {
	h: Scalars['Int']
	htmlContent: Scalars['String']
	name?: InputMaybe<Scalars['String']>
	styleType?: InputMaybe<Scalars['String']>
	type: ComponentType
	w: Scalars['Int']
	x: Scalars['Int']
	y: Scalars['Int']
}

export type PostComponentVar = {
	defaultValue?: InputMaybe<Scalars['String']>
	maxLength?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	templateKey: Scalars['String']
	type: DeviceValueType
}

export type PredictOrderQuantityResponse = {
	__typename?: 'PredictOrderQuantityResponse'
	avgDailyConsumption?: Maybe<Scalars['Float']>
	cleanedDataPoints?: Maybe<Scalars['Int']>
	deliveryTimeDays?: Maybe<Scalars['Int']>
	detectedDeliveries?: Maybe<Scalars['Int']>
	errors?: Maybe<Array<Error>>
	quantity: Scalars['Int']
	regressionSlope?: Maybe<Scalars['Float']>
}

export type Product = {
	__typename?: 'Product'
	/** active product */
	active?: Maybe<Scalars['Boolean']>
	/** devices assigned to a specific product (root, group, template) */
	devices?: Maybe<Array<Device>>
	/** product can have multiple unique ean codes */
	eanCodes?: Maybe<Array<Scalars['String']>>
	/** expiration date */
	expirationDate?: Maybe<Scalars['Time']>
	id: Scalars['Int']
	/** internal product identification (e.g. EAN code) */
	internalId: Scalars['String']
	market?: Maybe<Market>
	/** market id */
	marketId?: Maybe<Scalars['Int']>
	/** product name (only for display purposes) */
	name?: Maybe<Scalars['String']>
	/** only variations have parent products */
	parentProduct?: Maybe<Product>
	positions?: Maybe<Array<Maybe<Position>>>
	productImages?: Maybe<Array<Maybe<ProductImage>>>
	/** product type */
	productType?: Maybe<ProductType>
	/** product variations */
	products?: Maybe<Array<Product>>
	quantityHistory?: Maybe<Array<QuantityHistory>>
	root?: Maybe<Root>
	/** root id */
	rootId?: Maybe<Scalars['Int']>
	/** limit product to specific roots */
	rootKeys?: Maybe<Array<Scalars['String']>>
	supplier?: Maybe<Supplier>
	/** supplier Id */
	supplierId?: Maybe<Scalars['Int']>
	/** define/sort products with specific tags */
	tags?: Maybe<Array<Scalars['String']>>
	/** product values (e.g. PRICE, EAN CODE, TITLE, ...) */
	valueEntities?: Maybe<Array<Value>>
	virtualProductPositions?: Maybe<Array<VirtualProductPosition>>
}

export type ProductDevicesArgs = {
	where?: InputMaybe<ProductDevicesFilter>
}

export type ProductProductsArgs = {
	aisleId?: InputMaybe<Scalars['Int']>
	alarmType?: InputMaybe<AlarmType>
	bayId?: InputMaybe<Scalars['Int']>
	marketId?: InputMaybe<Scalars['Int']>
	rootId?: InputMaybe<Scalars['Int']>
	shelfId?: InputMaybe<Scalars['Int']>
	supplierId?: InputMaybe<Scalars['Int']>
}

export type ProductValueEntitiesArgs = {
	rootId?: InputMaybe<Scalars['Int']>
}

export type ProductDevicesFilter = {
	groupId?: InputMaybe<Scalars['Int']>
	rootId?: InputMaybe<Scalars['Int']>
	templateId?: InputMaybe<Scalars['Int']>
}

export type ProductImage = {
	__typename?: 'ProductImage'
	file: File
	id: Scalars['Int']
	primary: Scalars['Boolean']
}

export type ProductInput = {
	/** active */
	active?: InputMaybe<Scalars['Boolean']>
	/** apply multiple device configurations - only for devices connected to this product */
	deviceConfig?: InputMaybe<DeviceConfiguration>
	/** one product can have multiple unique ean codes */
	eanCodes?: InputMaybe<Array<Scalars['String']>>
	/** expiration date */
	expirationDate?: InputMaybe<Scalars['Time']>
	/** by setting a parent product you're turning this in to a product variation */
	fileId?: InputMaybe<Scalars['Int']>
	/** internal product identification (e.g. EAN code) */
	internalId: Scalars['String']
	/** market id */
	marketId?: InputMaybe<Scalars['Int']>
	/** market key */
	marketKey?: InputMaybe<Scalars['String']>
	/** product name (only for display purposes) */
	name?: InputMaybe<Scalars['String']>
	/** parent product internal id */
	parentInternalId?: InputMaybe<Scalars['String']>
	/** by setting a parent product you're turning this in to a product variation */
	parentProductId?: InputMaybe<Scalars['Int']>
	/** product type */
	productType?: InputMaybe<ProductType>
	/** root id */
	rootId?: InputMaybe<Scalars['Int']>
	/** limit product to specific roots */
	rootKeys?: InputMaybe<Array<Scalars['String']>>
	/** supplier id */
	supplierId?: InputMaybe<Scalars['Int']>
	/** define/sort products with specific tags */
	tags?: InputMaybe<Array<Scalars['String']>>
	templateVariantId?: InputMaybe<Scalars['Int']>
	/** product values (e.g. PRICE, EAN CODE, TITLE, ...) */
	valueEntities?: InputMaybe<Array<DeviceValueInput>>
}

export type ProductLog = {
	__typename?: 'ProductLog'
	columnName: Scalars['String']
	created: Scalars['DateTime']
	description?: Maybe<Scalars['String']>
	id: Scalars['Int']
	newValue: Scalars['String']
	oldValue: Scalars['String']
	position?: Maybe<Scalars['String']>
	root?: Maybe<Root>
	user?: Maybe<User>
}

export type ProductLogFilter = {
	productId: Scalars['Int']
}

export type ProductLogsPaginations = {
	__typename?: 'ProductLogsPaginations'
	nodes: Array<Maybe<ProductLog>>
	totalCount: Scalars['Int']
}

export type ProductResponse = {
	__typename?: 'ProductResponse'
	errors?: Maybe<Array<Error>>
	product?: Maybe<Product>
}

export enum ProductType {
	Orbis = 'ORBIS',
	VirtualStore = 'VIRTUAL_STORE',
	Warehouse = 'WAREHOUSE',
}

export type ProductUsageReportFilter = {
	rootIDs?: InputMaybe<Array<Scalars['Int']>>
}

export type ProductUsageReportItem = {
	__typename?: 'ProductUsageReportItem'
	internalId: Scalars['String']
	locationName: Scalars['String']
	productName: Scalars['String']
	serialNumber: Scalars['String']
	valueEntities?: Maybe<Array<Value>>
}

export type ProductUsageReportResponse = {
	__typename?: 'ProductUsageReportResponse'
	nodes?: Maybe<Array<ProductUsageReportItem>>
	totalCount: Scalars['Int']
}

export type ProductsFilter = {
	/** limit by active products */
	active?: InputMaybe<Scalars['Boolean']>
	/** limit by aisleId */
	aisleId?: InputMaybe<Scalars['Int']>
	/** alarm type */
	alarmType?: InputMaybe<AlarmType>
	/** limit search for products containing string in name, ean code or internal id */
	any?: InputMaybe<Scalars['String']>
	/** limit by bayId */
	bayId?: InputMaybe<Scalars['Int']>
	/** internal product identification (e.g. EAN code) */
	internalId?: InputMaybe<Scalars['String']>
	/** limit search by marketId */
	marketId?: InputMaybe<Scalars['Int']>
	/** display variations of a product */
	parentProductId?: InputMaybe<Scalars['Int']>
	/** limit search by product type */
	productType?: InputMaybe<ProductType>
	/** limit search by rootId */
	rootId?: InputMaybe<Scalars['Int']>
	/** limit search to a specific root */
	rootKey?: InputMaybe<Scalars['String']>
	/** limit by shelfId */
	shelfId?: InputMaybe<Scalars['Int']>
	/** limit search by supplierId */
	supplierId?: InputMaybe<Scalars['Int']>
	/** limit search for products containing specific tags */
	tags?: InputMaybe<Array<Scalars['String']>>
	/** value entities filter */
	valueEntities?: InputMaybe<Array<ValueEntitiesFilter>>
	/** display only products with children */
	withChild?: InputMaybe<Scalars['Boolean']>
	/** products with parent */
	withParent?: InputMaybe<Scalars['Boolean']>
	/** display only products not product variations */
	withoutChild?: InputMaybe<Scalars['Boolean']>
	/** products without parent */
	withoutParent?: InputMaybe<Scalars['Boolean']>
}

export type ProductsPaginations = {
	__typename?: 'ProductsPaginations'
	nodes: Array<Product>
	totalCount: Scalars['Int']
}

export type ProvisionRouterResponse = {
	__typename?: 'ProvisionRouterResponse'
	customer?: Maybe<Scalars['String']>
	errors?: Maybe<Array<Error>>
	imageTopicPostfix?: Maybe<Scalars['String']>
	machineName?: Maybe<Scalars['String']>
	name?: Maybe<Scalars['String']>
	options?: Maybe<Array<Option>>
	rootId?: Maybe<Scalars['Int']>
}

export enum PurchasedModules {
	Basic = 'BASIC',
	Orbis = 'ORBIS',
	Signage = 'SIGNAGE',
	VirtualStore = 'VIRTUAL_STORE',
	Warehouse = 'WAREHOUSE',
}

export type QuantityHistory = {
	__typename?: 'QuantityHistory'
	created: Scalars['DateTime']
	id: Scalars['Int']
	mode: ModeEnum
	productId: Scalars['Int']
	quantity?: Maybe<Scalars['Int']>
	quantityChange?: Maybe<Scalars['Int']>
}

export type QuantityHistoryFilter = {
	endDate?: InputMaybe<Scalars['DateTime']>
	mode?: InputMaybe<ModeEnum>
	startDate?: InputMaybe<Scalars['DateTime']>
	type?: InputMaybe<Scalars['Int']>
}

export type QuantityHistoryResponse = {
	__typename?: 'QuantityHistoryResponse'
	nodes: Array<Maybe<QuantityHistory>>
	totalCount: Scalars['Int']
}

export type QuantityUsageFilter = {
	endDate: Scalars['DateTime']
	mode?: InputMaybe<ModeEnum>
	startDate: Scalars['DateTime']
}

export type QuantityUsageResponse = {
	__typename?: 'QuantityUsageResponse'
	deliveries: Array<DailyQuantityData>
	quantity: Array<DailyQuantityData>
	usage: Array<DailyQuantityData>
}

export type Query = {
	__typename?: 'Query'
	/** Get aisle by id */
	aisle: AisleResponse
	/** Get all aisles */
	aisles: IslesPaginations
	apiClients: Array<ApiClientInfo>
	/** Get all audit logs */
	auditLogs: AuditLogsPagination
	/** Find Bar by token or id */
	bar: BarResponse
	/** Get all bars */
	bars: BarsPagination
	/** Get all transactions for a batch */
	batchTransactions?: Maybe<TransactionResponse>
	/** Get bay by id */
	bay: BayResponse
	/** Get all bays */
	bays: BaysPaginations
	/** Get Button by ID */
	button: ButtonResponse
	/** Get Buttons */
	buttons: ButtonsPagination
	/** Get calendar */
	calendar: CalendarResponse
	/** Get all calendars */
	calendars: CalendarsPaginations
	/** Get a Channel */
	channel: ChannelResponse
	/** Get all Channels */
	channels: ChannelsPagination
	checkAuth: Scalars['Boolean']
	/** Get all used variables */
	componentVars: ComponentVarsPagination
	/** Get customer's purchased modules */
	customerInfo: CustomerInfoResponse
	/** Find customer settings */
	customerSettings?: Maybe<CustomerSettings>
	/** Find device by exact MAC address */
	device: DeviceResponse
	/** Get device alarm report by ID */
	deviceAlarmReport: DeviceAlarmReportResponse
	/** Get all device alarm reports with pagination and filtering */
	deviceAlarmReports: DeviceAlarmReportsPagination
	/** Get all config transactions for a specific device */
	deviceConfigTransactions?: Maybe<ConfigTransactionResponse>
	/** Get device current image in base64 */
	devicePreview: DevicePreviewResponse
	/** Get all devices */
	deviceSizes: Array<DeviceSize>
	/** Get last SOC high and subsequent low for all devices on a root */
	deviceSocHighLowByRoot: Array<DeviceSocHighLow>
	/** Get device SOC history */
	deviceSocHistory: Array<DeviceSocData>
	/** Get device master and slave temperature history */
	deviceTempHistory: Array<DeviceTempData>
	/** Get all transactions for a specific device */
	deviceTransactions?: Maybe<TransactionResponse>
	/** Get all devices */
	devices: DevicesPagination
	/**
	 * Devices in a market with no successful transactions in the last 2 months
	 * and at least 10 failed burn-in prevention transactions in the same period
	 */
	devicesWithBurnInPreventionIssues: DevicesPagination
	/** Get all device alarm reports with pagination and filtering */
	downloadPrices: DownloadPricesResponse
	files?: Maybe<FilesResponsePagination>
	/** Get a single flow */
	flow: FlowResponse
	/** Get all flows */
	flows: FlowsPaginations
	getAsset?: Maybe<AssetDownload>
	getFile?: Maybe<File>
	getFileChain: Array<FileChainNode>
	getFileStructure?: Maybe<FileStructureResponse>
	/** Get all groups */
	groups: GroupsPaginations
	/** Check if there are flows that affect a specific product */
	hasFlows: Array<Scalars['Int']>
	/** Get all incomplete/unfinshed transactions */
	incompleteTransactions?: Maybe<TransactionResponse>
	info?: Maybe<InfoResponse>
	/** Get Integration by id or token */
	integration: IntegrationResponse
	/** Get Integrations */
	integrations: IntegrationsPagination
	/** Get a landing template */
	landingTemplate: LandingTemplateResponse
	/** Get all landing templates */
	landingTemplates: LandingTemplatesPagination
	/** Locations with at least one device that completed a non-cached transaction, grouped by market */
	locationsWithSuccessfulTransactions: Array<MarketSuccessfulTransactionLocations>
	/** Find login settings (public) */
	loginPageSettings?: Maybe<LoginPageSettings>
	/** Get market by id */
	market: MarketResponse
	/** Get all markets */
	markets?: Maybe<MarketsPaginations>
	me?: Maybe<MeResponse>
	/** Get order */
	order: OrderResponse
	/** Get Orders */
	orderItemLogs: OrderItemLogsPagination
	/** Get Orders */
	orders: OrdersPagination
	parseTemplate: ParseTemplateResponse
	/** Get a playlist */
	playlist: PlaylistResponse
	/** Get all Playlists */
	playlists: PlaylistsPagination
	/** Get position by id */
	position: PositionResponse
	/** Get all positions */
	positions: PositionsPaginations
	predictOrderQuantity: PredictOrderQuantityResponse
	/** Get a product */
	product: ProductResponse
	/** get all product logs */
	productLogs: ProductLogsPaginations
	/** Get product report without pagination */
	productUsageReport: ProductUsageReportResponse
	/** Get all products */
	products: ProductsPaginations
	/** get product history */
	quantityHistory: QuantityHistoryResponse
	quantityUsage: QuantityUsageResponse
	/** Get user role */
	role: RoleResponse
	/** Get all user roles */
	roles: RolesPaginations
	/** Get root by id */
	root: RootResponse
	/** Get all roots */
	roots?: Maybe<RootsPaginations>
	/** Get the number of roots and max number of roots */
	rootsInfo: RootsInfoResponse
	/** Get router details */
	routerDetails: RouterDetailsResponse
	/** Get all routers without details (DASHBOARD) */
	routers: RoutersPaginations
	/** Find scale by id */
	scale: ScaleResponse
	/** Get all scales */
	scales: ScalesPagination
	/** Find sensor by serialnumber */
	sensor: SensorExtendedResponse
	/** Get sensor measurement history by serial number */
	sensorMeasurementHistory: Array<SensorDataPoint>
	/** Get all sensors */
	sensors: SensorsPagination
	/** Get shelf by id */
	shelf: ShelfResponse
	/** Get all shelves */
	shelves: ShelvesPaginations
	/** Get Signage Button by ID */
	signageButton: SignageButtonResponse
	/** Get Signage Buttons */
	signageButtons: SignageButtonsPagination
	/** Get supplier */
	supplier: SupplierResponse
	/** Get all suppliers */
	suppliers: SuppliersPaginations
	/** Get Synchronization by id */
	synchronization: SynchronizationResponse
	/** Get Synchronizations */
	synchronizations: SynchronizationsPagination
	/** Get all tags */
	tags: TagsPagination
	/** Get a template */
	template: TemplateResponse
	/** Get a template variant */
	templateVariant: TemplateVariantResponse
	/** Find if template variant supports rotated */
	templateVariantSupportsRotated?: Maybe<Scalars['Boolean']>
	/** Find if template variant supports split */
	templateVariantSupportsSplit?: Maybe<Scalars['Boolean']>
	/** Get all existing template types on a template variant */
	templateVariantTemplateTypes?: Maybe<Array<TemplateType>>
	/** Get all template variants */
	templateVariants: TemplateVariantsPagination
	/** Get all templates */
	templates: TemplatesPagination
	timezoneLookup?: Maybe<Scalars['String']>
	/** Get transaction by ID */
	transaction?: Maybe<TransactionResponse>
	/** Get all TV Devices */
	tvDevices: TvDevicesPagination
	/** get unique valueEntity columns */
	uniqueValueEntityColumns: UniqueValueEntityColumnsResponse
	/** Get url analytics */
	urlAnalytics: UrlAnalyticsPagination
	/** Get url analytics chart data */
	urlAnalyticsChart: UrlAnalyticsChartResponse
	/** Get url analytics */
	urlAnalyticsGroupBy: UrlAnalyticsGroupByPagination
	/** Get url analytics info */
	urlAnalyticsInfo: UrlAnalyticsInfoResponse
	/** Get user */
	user: UserResponse
	/** Get all users */
	users: UsersPaginations
	/** Get the number of users and max number of users */
	usersInfo: UsersInfoResponse
	/** Get Virtual Category Point */
	virtualCategoryPoint: VirtualCategoryPointResponse
	/** Get Virtual Categories */
	virtualCategoryPoints: VirtualCategoryPointsPagination
	/** Get Virtual Category Screen */
	virtualCategoryScreen: VirtualCategoryScreenResponse
	/** Get Virtual Category Screens */
	virtualCategoryScreens: VirutalCategoryScreensPagination
	/** Get Virtual Multi Screen */
	virtualMultiScreen: VirtualMultiScreenResponse
	/** Get Virtual Multi Screens */
	virtualMultiScreens: VirutalMultiScreensPagination
	/** Get Virtual Rack */
	virtualRack: VirtualRackResponse
	/** Get Virtual Racks */
	virtualRacks: VirtualRacksPagination
	/** Get Virtual Shelf */
	virtualShelf: VirtualShelfResponse
	/** Get Virtual Shelves */
	virtualShelves: VirtualShelvesPagination
	/** Get Virtual Store Device */
	virtualStoreDevice: VirtualStoreDeviceResponse
	/** Get Virtual Store Devices */
	virtualStoreDevices: VirtualStoreDevicesPagination
	/** Get warehouse alarms count */
	warehouseAlarmsCount: WarehouseAlarmsCountResponse
	/** Get warehouse children */
	warehouseChildren: ProductsPaginations
	/** Get order report */
	warehouseOrderReport: WarehouseOrderReport
	/** Get warehouse parent products with children - filtering is on children */
	warehouseParentsWithChildren: ProductsPaginations
	/** warehouse product report */
	warehouseProductReport: Array<WarehouseProduct>
	/** warehouse product value report */
	warehouseProductValueReport: WarehouseProductValueReports
}

export type QueryAisleArgs = {
	aisleId: Scalars['Int']
}

export type QueryAislesArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<IslesFilter>
}

export type QueryAuditLogsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<AuditLogsFilter>
}

export type QueryBarArgs = {
	barId?: InputMaybe<Scalars['Int']>
	token?: InputMaybe<Scalars['String']>
}

export type QueryBarsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<BarsFilter>
}

export type QueryBatchTransactionsArgs = {
	batchUUID: Scalars['String']
}

export type QueryBayArgs = {
	bayId: Scalars['Int']
}

export type QueryBaysArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<BaysFilter>
}

export type QueryButtonArgs = {
	buttonId: Scalars['Int']
}

export type QueryButtonsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<ButtonsFilter>
}

export type QueryCalendarArgs = {
	id: Scalars['Int']
}

export type QueryCalendarsArgs = {
	limit?: InputMaybe<Scalars['Int']>
	offset?: InputMaybe<Scalars['Int']>
	where?: InputMaybe<CalendarsFilter>
}

export type QueryChannelArgs = {
	id: Scalars['Int']
}

export type QueryChannelsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<ChannelsFilter>
}

export type QueryComponentVarsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<ComponentVarsFilter>
}

export type QueryCustomerSettingsArgs = {
	customer: Scalars['String']
}

export type QueryDeviceArgs = {
	deviceSerialNumber: Scalars['String']
}

export type QueryDeviceAlarmReportArgs = {
	id: Scalars['Int']
}

export type QueryDeviceAlarmReportsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<DeviceAlarmReportsFilter>
}

export type QueryDeviceConfigTransactionsArgs = {
	deviceId: Scalars['Int']
}

export type QueryDevicePreviewArgs = {
	deviceSerialNumber: Scalars['String']
}

export type QueryDeviceSizesArgs = {
	virtual?: InputMaybe<Scalars['Boolean']>
}

export type QueryDeviceSocHighLowByRootArgs = {
	highThreshold?: InputMaybe<Scalars['Int']>
	minHighAgeDays?: InputMaybe<Scalars['Int']>
	rechargeThreshold?: InputMaybe<Scalars['Int']>
	rootId: Scalars['Int']
}

export type QueryDeviceSocHistoryArgs = {
	deviceSerialNumber: Scalars['String']
	from: Scalars['DateTime']
	to?: InputMaybe<Scalars['DateTime']>
}

export type QueryDeviceTempHistoryArgs = {
	deviceSerialNumber: Scalars['String']
	from: Scalars['DateTime']
	to?: InputMaybe<Scalars['DateTime']>
}

export type QueryDeviceTransactionsArgs = {
	deviceId: Scalars['Int']
	limit: Scalars['Int']
	offset: Scalars['Int']
}

export type QueryDevicesArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	order?: InputMaybe<DeviceOrder>
	where?: InputMaybe<DevicesFilter>
}

export type QueryDevicesWithBurnInPreventionIssuesArgs = {
	limit: Scalars['Int']
	marketId: Scalars['Int']
	offset: Scalars['Int']
}

export type QueryDownloadPricesArgs = {
	productType: ProductType
	rootId?: InputMaybe<Scalars['Int']>
	supplierId?: InputMaybe<Scalars['Int']>
}

export type QueryFilesArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<FilesFilter>
}

export type QueryFlowArgs = {
	flowId: Scalars['Int']
}

export type QueryFlowsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<FlowsFilter>
}

export type QueryGetAssetArgs = {
	fileId: Scalars['Int']
}

export type QueryGetFileArgs = {
	where?: InputMaybe<FileFilter>
}

export type QueryGetFileChainArgs = {
	where: FileChainFilter
}

export type QueryGetFileStructureArgs = {
	limit?: InputMaybe<Scalars['Int']>
	offset?: InputMaybe<Scalars['Int']>
	where?: InputMaybe<FileStructureFilter>
}

export type QueryGroupsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<GroupsFilter>
}

export type QueryHasFlowsArgs = {
	productId: Scalars['Int']
}

export type QueryIncompleteTransactionsArgs = {
	where?: InputMaybe<IncompleteTransactionsInput>
}

export type QueryIntegrationArgs = {
	id?: InputMaybe<Scalars['Int']>
	token?: InputMaybe<Scalars['String']>
}

export type QueryIntegrationsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<IntegrationsFilter>
}

export type QueryLandingTemplateArgs = {
	id: Scalars['Int']
}

export type QueryLandingTemplatesArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<LandingTemplatesFilter>
}

export type QueryLoginPageSettingsArgs = {
	customer: Scalars['String']
}

export type QueryMarketArgs = {
	marketId: Scalars['Int']
}

export type QueryMarketsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<MarketsFilter>
}

export type QueryOrderArgs = {
	id: Scalars['Int']
}

export type QueryOrderItemLogsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<OrderItemLogsFilter>
}

export type QueryOrdersArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<OrderFilter>
}

export type QueryParseTemplateArgs = {
	productId: Scalars['Int']
	templateId: Scalars['Int']
}

export type QueryPlaylistArgs = {
	id: Scalars['Int']
}

export type QueryPlaylistsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<PlaylistsFilter>
}

export type QueryPositionArgs = {
	positionId: Scalars['Int']
}

export type QueryPositionsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<PositionsFilter>
}

export type QueryPredictOrderQuantityArgs = {
	deliveryTime: Scalars['Int']
	endDate: Scalars['DateTime']
	productId: Scalars['Int']
	startDate: Scalars['DateTime']
}

export type QueryProductArgs = {
	eanCode?: InputMaybe<Scalars['String']>
	id?: InputMaybe<Scalars['Int']>
	internalId?: InputMaybe<Scalars['String']>
}

export type QueryProductLogsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where: ProductLogFilter
}

export type QueryProductUsageReportArgs = {
	limit?: InputMaybe<Scalars['Int']>
	offset?: InputMaybe<Scalars['Int']>
	where?: InputMaybe<ProductUsageReportFilter>
}

export type QueryProductsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<ProductsFilter>
}

export type QueryQuantityHistoryArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	productId: Scalars['Int']
	where?: InputMaybe<QuantityHistoryFilter>
}

export type QueryQuantityUsageArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	productId: Scalars['Int']
	where: QuantityUsageFilter
}

export type QueryRoleArgs = {
	roleId: Scalars['Int']
}

export type QueryRolesArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<RolesFilter>
}

export type QueryRootArgs = {
	rootId: Scalars['Int']
}

export type QueryRootsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<RootsFilter>
}

export type QueryRouterDetailsArgs = {
	id?: InputMaybe<Scalars['Int']>
	uuid?: InputMaybe<Scalars['String']>
}

export type QueryRoutersArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<RoutersFilter>
}

export type QueryScaleArgs = {
	scaleId: Scalars['Int']
}

export type QueryScalesArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<ScalesFilter>
}

export type QuerySensorArgs = {
	serialNumber: Scalars['String']
}

export type QuerySensorMeasurementHistoryArgs = {
	from: Scalars['DateTime']
	serialNumber: Scalars['String']
	to?: InputMaybe<Scalars['DateTime']>
}

export type QuerySensorsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<SensorsFilter>
}

export type QueryShelfArgs = {
	aisleKey?: InputMaybe<Scalars['String']>
	bayKey?: InputMaybe<Scalars['String']>
	key?: InputMaybe<Scalars['String']>
	shelfId?: InputMaybe<Scalars['Int']>
}

export type QueryShelvesArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<ShelvesFilter>
}

export type QuerySignageButtonArgs = {
	signageButtonId: Scalars['Int']
}

export type QuerySignageButtonsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<SignageButtonsFilter>
}

export type QuerySupplierArgs = {
	supplierId: Scalars['Int']
}

export type QuerySuppliersArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<SuppliersFilter>
}

export type QuerySynchronizationArgs = {
	id: Scalars['Int']
}

export type QuerySynchronizationsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<SynchronizationsFilter>
}

export type QueryTagsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<TagsFilter>
}

export type QueryTemplateArgs = {
	id: Scalars['Int']
}

export type QueryTemplateVariantArgs = {
	id: Scalars['Int']
}

export type QueryTemplateVariantSupportsRotatedArgs = {
	deviceSize: DeviceSize
	templateVariantId: Scalars['Int']
}

export type QueryTemplateVariantSupportsSplitArgs = {
	deviceSize: DeviceSize
	templateVariantId: Scalars['Int']
}

export type QueryTemplateVariantTemplateTypesArgs = {
	templateVariantId: Scalars['Int']
}

export type QueryTemplateVariantsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<TemplateVariantsFilter>
}

export type QueryTemplatesArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<TemplatesFilter>
}

export type QueryTimezoneLookupArgs = {
	latitude: Scalars['Float']
	longitude: Scalars['Float']
}

export type QueryTransactionArgs = {
	transactionId: Scalars['String']
}

export type QueryTvDevicesArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<TvDevicesFilter>
}

export type QueryUniqueValueEntityColumnsArgs = {
	templateKey: Scalars['String']
}

export type QueryUrlAnalyticsArgs = {
	limit?: InputMaybe<Scalars['Int']>
	offset?: InputMaybe<Scalars['Int']>
	where?: InputMaybe<UrlAnalyticsFilter>
}

export type QueryUrlAnalyticsChartArgs = {
	where?: InputMaybe<UrlAnalyticsChartFilter>
}

export type QueryUrlAnalyticsGroupByArgs = {
	limit?: InputMaybe<Scalars['Int']>
	offset?: InputMaybe<Scalars['Int']>
	where?: InputMaybe<UrlAnalyticsGroupByFilter>
}

export type QueryUserArgs = {
	userId: Scalars['Int']
}

export type QueryUsersArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<UsersFilter>
}

export type QueryVirtualCategoryPointArgs = {
	virtualCategoryPointId: Scalars['Int']
}

export type QueryVirtualCategoryPointsArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<VirtualCategoryPointsFilter>
}

export type QueryVirtualCategoryScreenArgs = {
	virtualCategoryScreenId: Scalars['Int']
}

export type QueryVirtualCategoryScreensArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<VirtualCategoryScreensFilter>
}

export type QueryVirtualMultiScreenArgs = {
	virtualMultiScreenId: Scalars['Int']
}

export type QueryVirtualMultiScreensArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<VirtualMultiScreensFilter>
}

export type QueryVirtualRackArgs = {
	virtualRackId: Scalars['Int']
}

export type QueryVirtualRacksArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<VirtualRacksFilter>
}

export type QueryVirtualShelfArgs = {
	virtualShelfId: Scalars['Int']
}

export type QueryVirtualShelvesArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<VirtualShelvesFilter>
}

export type QueryVirtualStoreDeviceArgs = {
	virtualStoreDeviceId: Scalars['Int']
}

export type QueryVirtualStoreDevicesArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<VirtualStoreDevicesFilter>
}

export type QueryWarehouseChildrenArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<ProductsFilter>
}

export type QueryWarehouseOrderReportArgs = {
	input: WarehouseOrderReportInput
}

export type QueryWarehouseParentsWithChildrenArgs = {
	limit: Scalars['Int']
	offset: Scalars['Int']
	where?: InputMaybe<WarehouseParentsWithChildrenFilter>
}

export type QueryWarehouseProductReportArgs = {
	aisleId?: InputMaybe<Scalars['Int']>
	bayId?: InputMaybe<Scalars['Int']>
	date: Scalars['DateTime']
	rootId?: InputMaybe<Scalars['Int']>
	shelfId?: InputMaybe<Scalars['Int']>
	supplierId?: InputMaybe<Scalars['Int']>
}

export type QueryWarehouseProductValueReportArgs = {
	aisleId?: InputMaybe<Scalars['Int']>
	bayId?: InputMaybe<Scalars['Int']>
	rootId?: InputMaybe<Scalars['Int']>
	shelfId?: InputMaybe<Scalars['Int']>
	startDate: Scalars['DateTime']
	supplierId?: InputMaybe<Scalars['Int']>
}

export type RegisterRouterResponse = {
	__typename?: 'RegisterRouterResponse'
	configuration?: Maybe<Array<KeyValuePair>>
	imageTopicPostfix?: Maybe<Scalars['String']>
	machineName?: Maybe<Scalars['String']>
	name?: Maybe<Scalars['String']>
	options?: Maybe<Array<Option>>
}

export type Role = {
	__typename?: 'Role'
	id: Scalars['Int']
	permissions: Array<Scalars['String']>
	rank?: Maybe<Scalars['Int']>
	value?: Maybe<Scalars['String']>
}

export type RoleResponse = {
	__typename?: 'RoleResponse'
	errors?: Maybe<Array<Error>>
	role?: Maybe<Role>
}

export type RolesFilter = {
	rank?: InputMaybe<Scalars['Int']>
	value?: InputMaybe<Scalars['String']>
}

export type RolesPaginations = {
	__typename?: 'RolesPaginations'
	nodes: Array<Role>
	totalCount: Scalars['Int']
}

export type Root = {
	__typename?: 'Root'
	address?: Maybe<Scalars['String']>
	batteryUnderCount?: Maybe<Scalars['Int']>
	burninPrevention?: Maybe<Scalars['Boolean']>
	deviceCount?: Maybe<Scalars['Int']>
	deviceErrCount?: Maybe<Scalars['Int']>
	deviceOffline?: Maybe<Scalars['Int']>
	deviceProcessingCount?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	key?: Maybe<Scalars['String']>
	latitude?: Maybe<Scalars['Float']>
	longitude?: Maybe<Scalars['Float']>
	market?: Maybe<Market>
	marketId?: Maybe<Scalars['Int']>
	mode?: Maybe<RootMode>
	name?: Maybe<Scalars['String']>
	routerCount?: Maybe<Scalars['Int']>
	routerOffline?: Maybe<Scalars['Int']>
	routers?: Maybe<Array<Router>>
	tags?: Maybe<Array<Scalars['String']>>
	timezone?: Maybe<Scalars['String']>
}

export enum RootMode {
	Aisle = 'AISLE',
	Bay = 'BAY',
	Default = 'DEFAULT',
	Shelf = 'SHELF',
}

export type RootResponse = {
	__typename?: 'RootResponse'
	errors?: Maybe<Array<Maybe<Error>>>
	root?: Maybe<Root>
	success?: Maybe<Scalars['Boolean']>
}

export type RootsFilter = {
	active?: InputMaybe<Scalars['Boolean']>
	marketId?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	status?: InputMaybe<TransactionStage>
	tags?: InputMaybe<Array<Scalars['String']>>
	validCoordinates?: InputMaybe<Scalars['Boolean']>
}

export type RootsInfoResponse = {
	__typename?: 'RootsInfoResponse'
	maxRoots?: Maybe<Scalars['Int']>
	numOfRoots?: Maybe<Scalars['Int']>
}

export type RootsPaginations = {
	__typename?: 'RootsPaginations'
	nodes: Array<Root>
	totalCount: Scalars['Int']
}

export type Router = {
	__typename?: 'Router'
	deviceCount?: Maybe<Scalars['Int']>
	dhcp?: Maybe<Scalars['Boolean']>
	id: Scalars['Int']
	lastSeen?: Maybe<Scalars['DateTime']>
	macAddress?: Maybe<Scalars['MAC']>
	name?: Maybe<Scalars['String']>
	online?: Maybe<Scalars['Boolean']>
	root?: Maybe<Root>
	rootId?: Maybe<Scalars['Int']>
	routerNetwork?: Maybe<RouterNetwork>
	token?: Maybe<Scalars['String']>
	type?: Maybe<RouterType>
	uuid?: Maybe<Scalars['String']>
	version?: Maybe<Scalars['String']>
}

export type RouterDetails = {
	__typename?: 'RouterDetails'
	cpu_temp?: Maybe<Scalars['Int']>
	cpu_usage?: Maybe<Scalars['Int']>
	ip_address?: Maybe<Scalars['String']>
	is_connected_to_vpn?: Maybe<Scalars['Boolean']>
	is_online?: Maybe<Scalars['Boolean']>
	is_undervolted?: Maybe<Scalars['Boolean']>
	last_seen?: Maybe<Scalars['DateTime']>
	mac_address?: Maybe<Scalars['String']>
	memory_total?: Maybe<Scalars['Int']>
	memory_usage?: Maybe<Scalars['Int']>
	router?: Maybe<Router>
	status?: Maybe<Scalars['String']>
	storage_total?: Maybe<Scalars['Int']>
	storage_usage?: Maybe<Scalars['Int']>
	uuid?: Maybe<Scalars['String']>
}

export type RouterDetailsResponse = {
	__typename?: 'RouterDetailsResponse'
	errors?: Maybe<Array<Error>>
	routerDetails?: Maybe<RouterDetails>
}

export type RouterNetwork = {
	__typename?: 'RouterNetwork'
	dns1?: Maybe<Scalars['IPv4']>
	dns2?: Maybe<Scalars['IPv4']>
	gateway?: Maybe<Scalars['IPv4']>
	ip?: Maybe<Scalars['IPv4']>
	subnet?: Maybe<Scalars['IPv4']>
	wifichannel?: Maybe<Scalars['Int']>
	wifimode?: Maybe<WifiMode>
}

export type RouterNetworkInput = {
	dns1?: InputMaybe<Scalars['IPv4']>
	dns2?: InputMaybe<Scalars['IPv4']>
	gateway?: InputMaybe<Scalars['IPv4']>
	ip?: InputMaybe<Scalars['IPv4']>
	subnet?: InputMaybe<Scalars['IPv4']>
	wifichannel?: InputMaybe<Scalars['Int']>
	wifimode?: InputMaybe<WifiMode>
}

export type RouterProvisioning = {
	__typename?: 'RouterProvisioning'
	customer: Scalars['String']
	id: Scalars['Int']
	provisioned?: Maybe<Scalars['Boolean']>
	router?: Maybe<Router>
	routerUuid: Scalars['String']
	token: Scalars['String']
}

export type RouterProvisioningResponse = {
	__typename?: 'RouterProvisioningResponse'
	errors?: Maybe<Array<Error>>
	routerProvisioning?: Maybe<RouterProvisioning>
}

export type RouterProvisioningsFilter = {
	any?: InputMaybe<Scalars['String']>
	customer?: InputMaybe<Scalars['String']>
	provisioned?: InputMaybe<Scalars['Boolean']>
}

export type RouterProvisioningsPaginations = {
	__typename?: 'RouterProvisioningsPaginations'
	errors?: Maybe<Array<Error>>
	nodes?: Maybe<Array<RouterProvisioning>>
	totalCount?: Maybe<Scalars['Int']>
}

export enum RouterType {
	Ar50 = 'AR50',
	Ar100 = 'AR100',
}

export type RoutersFilter = {
	active?: InputMaybe<Scalars['Boolean']>
	marketId?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	rootId?: InputMaybe<Scalars['Int']>
}

export type RoutersPaginations = {
	__typename?: 'RoutersPaginations'
	nodes: Array<Router>
	totalCount: Scalars['Int']
}

export type Scale = {
	__typename?: 'Scale'
	channel?: Maybe<Channel>
	channelId?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	ip: Scalars['IPv4']
	name?: Maybe<Scalars['String']>
	root?: Maybe<Root>
	rootId?: Maybe<Scalars['Int']>
	tags?: Maybe<Array<Scalars['String']>>
	type: DisplayType
	username: Scalars['String']
}

export type ScaleRegisterInput = {
	channelId?: InputMaybe<Scalars['Int']>
	ip: Scalars['IPv4']
	name?: InputMaybe<Scalars['String']>
	password: Scalars['String']
	rootId: Scalars['Int']
	tags: Array<Scalars['String']>
	type: DisplayType
	username: Scalars['String']
}

export type ScaleResponse = {
	__typename?: 'ScaleResponse'
	errors?: Maybe<Array<Error>>
	scale?: Maybe<Scale>
}

export type ScalesFilter = {
	channelId?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	rootId?: InputMaybe<Scalars['Int']>
	tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type ScalesPagination = {
	__typename?: 'ScalesPagination'
	nodes: Array<Maybe<Scale>>
	totalCount: Scalars['Int']
}

export type Schedule = {
	__typename?: 'Schedule'
	dateRange?: Maybe<Array<Maybe<Scalars['DateTime']>>>
	id: Scalars['Int']
	timeFrames?: Maybe<Array<Maybe<Scalars['String']>>>
	weekdays: Array<WeekDay>
}

export type ScheduleInput = {
	dateRange?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>
	timeFrames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
	weekdays: Array<WeekDay>
}

export type SearchTenantInput = {
	contractLength?: InputMaybe<ContractLength>
	name?: InputMaybe<Scalars['String']>
	purchasedModules?: InputMaybe<Array<PurchasedModules>>
}

export type Sensor = {
	__typename?: 'Sensor'
	battery?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	name?: Maybe<Scalars['String']>
	root: Root
	rootId: Scalars['Int']
	sensorType?: Maybe<SensorType>
	serialNumber: Scalars['MAC']
	tags?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type SensorDataPoint = {
	__typename?: 'SensorDataPoint'
	accuracy?: Maybe<Scalars['Int']>
	airQualityIndex?: Maybe<Scalars['Int']>
	battery: Scalars['Int']
	eco2?: Maybe<Scalars['Float']>
	humidity: Scalars['Float']
	pressure?: Maybe<Scalars['Float']>
	rssi: Scalars['Int']
	serialNumber: Scalars['MAC']
	temperature: Scalars['Float']
	time: Scalars['DateTime']
	tvoc?: Maybe<Scalars['Float']>
}

export type SensorExtended = {
	__typename?: 'SensorExtended'
	active?: Maybe<Scalars['Boolean']>
	battery?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	latestData?: Maybe<SensorDataPoint>
	measurement?: Maybe<Array<Maybe<Measurement>>>
	name?: Maybe<Scalars['String']>
	root?: Maybe<Root>
	rootId?: Maybe<Scalars['Int']>
	sensorType?: Maybe<SensorType>
	serialNumber: Scalars['MAC']
	tags?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type SensorExtendedMeasurementArgs = {
	from: Scalars['DateTime']
	to?: InputMaybe<Scalars['DateTime']>
	type: MeasurementType
}

export type SensorExtendedResponse = {
	__typename?: 'SensorExtendedResponse'
	errors?: Maybe<Array<Error>>
	sensor?: Maybe<SensorExtended>
}

export type SensorResponse = {
	__typename?: 'SensorResponse'
	errors?: Maybe<Array<Error>>
	sensor?: Maybe<Sensor>
}

export enum SensorType {
	AqsSensor = 'AQS_SENSOR',
	SmartSensor = 'SMART_SENSOR',
}

export type SensorsFilter = {
	rootId?: InputMaybe<Scalars['Int']>
	serialNumber?: InputMaybe<Scalars['String']>
	serialNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type SensorsPagination = {
	__typename?: 'SensorsPagination'
	nodes: Array<Maybe<SensorExtended>>
	totalCount: Scalars['Int']
}

export type SetProductTemplateInput = {
	productInternalId: Scalars['String']
	rootId: Scalars['Int']
	templateVariantId: Scalars['Int']
}

export type Shelf = {
	__typename?: 'Shelf'
	/** @deprecated Use `bay`. */
	aisle?: Maybe<Aisle>
	bay?: Maybe<Bay>
	device?: Maybe<Device>
	height?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	/** shelf key */
	key: Scalars['String']
	name?: Maybe<Scalars['String']>
	/** @deprecated Never used */
	orientation?: Maybe<Orientation>
	/** positions connected to a shelf */
	positions?: Maybe<Array<Position>>
	root?: Maybe<Root>
	sequence?: Maybe<Scalars['Int']>
}

export type ShelfInput = {
	bayId: Scalars['Int']
	key: Scalars['String']
	name?: InputMaybe<Scalars['String']>
	sequence?: InputMaybe<Scalars['Int']>
}

export type ShelfResponse = {
	__typename?: 'ShelfResponse'
	errors?: Maybe<Array<Maybe<Error>>>
	shelf?: Maybe<Shelf>
	success?: Maybe<Scalars['Boolean']>
}

/** combined input for adding a new shelf (if bay or aisle don't exist, they wil be created) */
export type ShelfStructInput = {
	aisleKey: Scalars['String']
	bayKey: Scalars['String']
	positions?: InputMaybe<Array<PositionStructInput>>
	rootId: Scalars['Int']
	shelfKey: Scalars['String']
	shelfName?: InputMaybe<Scalars['String']>
}

export type ShelfStructResponse = {
	__typename?: 'ShelfStructResponse'
	errors?: Maybe<Array<Error>>
	positions?: Maybe<Array<Position>>
	shelf?: Maybe<Shelf>
	success?: Maybe<Scalars['Boolean']>
}

export type SignageButton = {
	__typename?: 'SignageButton'
	button: Button
	buttonId: Scalars['Int']
	channel: Channel
	channelId: Scalars['Int']
	durationSeconds?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	virtualStoreDevice: VirtualStoreDevice
	virtualStoreDeviceId: Scalars['Int']
}

export type SignageButtonResponse = {
	__typename?: 'SignageButtonResponse'
	errors?: Maybe<Array<Error>>
	signageButton?: Maybe<SignageButton>
}

export type SignageButtonsFilter = {
	virtualStoreDeviceId?: InputMaybe<Scalars['Int']>
}

export type SignageButtonsPagination = {
	__typename?: 'SignageButtonsPagination'
	nodes?: Maybe<Array<SignageButton>>
	totalCount: Scalars['Int']
}

export enum SignageDeviceType {
	Hdmi = 'HDMI',
	Hf = 'HF',
	SmartLabel = 'SMART_LABEL',
	VirtualStore = 'VIRTUAL_STORE',
}

export enum SortEnum {
	Asc = 'ASC',
	Desc = 'DESC',
}

export type StandardResponse = {
	__typename?: 'StandardResponse'
	errors?: Maybe<Array<Error>>
	success?: Maybe<Scalars['Boolean']>
}

export type StatusResponse = {
	__typename?: 'StatusResponse'
	isUpdating: Scalars['Boolean']
}

export enum SubfolderType {
	ProductImages = 'PRODUCT_IMAGES',
}

export type SuccessfulTransactionLocation = {
	__typename?: 'SuccessfulTransactionLocation'
	id: Scalars['Int']
	name?: Maybe<Scalars['String']>
}

export type Supplier = {
	__typename?: 'Supplier'
	address?: Maybe<Scalars['String']>
	addressNumber?: Maybe<Scalars['String']>
	city?: Maybe<Scalars['String']>
	companyName: Scalars['String']
	country?: Maybe<Country>
	email?: Maybe<Scalars['String']>
	id: Scalars['Int']
	postCode?: Maybe<Scalars['String']>
	supplierId?: Maybe<Scalars['String']>
	supplierRootSettings?: Maybe<Array<SupplierRootSettings>>
	vat?: Maybe<Scalars['String']>
	verifiedEmail?: Maybe<Scalars['Boolean']>
}

export type SupplierResponse = {
	__typename?: 'SupplierResponse'
	errors?: Maybe<Array<Error>>
	supplier?: Maybe<Supplier>
}

export type SupplierRootSettings = {
	__typename?: 'SupplierRootSettings'
	deliveryTime: Scalars['Int']
	id: Scalars['Int']
	root: Root
	rootId: Scalars['Int']
	supplier: Supplier
	supplierId: Scalars['Int']
}

export type SupplierRootSettingsInput = {
	deliveryTime: Scalars['Int']
	rootId: Scalars['Int']
}

export type SuppliersFilter = {
	any?: InputMaybe<Scalars['String']>
	country?: InputMaybe<Country>
}

export type SuppliersPaginations = {
	__typename?: 'SuppliersPaginations'
	nodes: Array<Maybe<Supplier>>
	totalCount: Scalars['Int']
}

export type Synchronization = {
	__typename?: 'Synchronization'
	id: Scalars['Int']
	integration: Integration
	note?: Maybe<Scalars['String']>
	status: SynchronizationStatus
	time: Scalars['DateTime']
	updatedProducts: Array<Scalars['String']>
}

export type SynchronizationResponse = {
	__typename?: 'SynchronizationResponse'
	errors?: Maybe<Array<Maybe<Error>>>
	synchronization?: Maybe<Synchronization>
}

export enum SynchronizationStatus {
	Complete = 'COMPLETE',
	Failed = 'FAILED',
	Processing = 'PROCESSING',
}

export type SynchronizationsFilter = {
	filter?: InputMaybe<Scalars['String']>
	integrationId?: InputMaybe<Scalars['Int']>
	status?: InputMaybe<SynchronizationStatus>
}

export type SynchronizationsPagination = {
	__typename?: 'SynchronizationsPagination'
	nodes?: Maybe<Array<Synchronization>>
	totalCount: Scalars['Int']
}

export type TvDevice = {
	__typename?: 'TVDevice'
	channel?: Maybe<Channel>
	channelId?: Maybe<Scalars['Int']>
	height?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	name?: Maybe<Scalars['String']>
	root?: Maybe<Root>
	rootId?: Maybe<Scalars['Int']>
	tags?: Maybe<Array<Maybe<Scalars['String']>>>
	token?: Maybe<Scalars['String']>
	uuid?: Maybe<Scalars['String']>
	width?: Maybe<Scalars['Int']>
}

export type TvDeviceActivateInput = {
	channelId?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	rootId: Scalars['Int']
	tags: Array<Scalars['String']>
}

export type TvDeviceRegisterInput = {
	height?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	rootId?: InputMaybe<Scalars['Int']>
	tags?: InputMaybe<Array<Scalars['String']>>
	token: Scalars['String']
	weight?: InputMaybe<Scalars['Int']>
}

export type TvDeviceResponse = {
	__typename?: 'TVDeviceResponse'
	errors?: Maybe<Array<Error>>
	tvDevice?: Maybe<TvDevice>
}

export type TvDevicesFilter = {
	channelId?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	rootId?: InputMaybe<Scalars['Int']>
	tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type TvDevicesPagination = {
	__typename?: 'TVDevicesPagination'
	nodes: Array<Maybe<TvDevice>>
	totalCount: Scalars['Int']
}

export type TagsFilter = {
	name?: InputMaybe<Scalars['String']>
}

export type TagsPagination = {
	__typename?: 'TagsPagination'
	nodes?: Maybe<Array<Scalars['String']>>
	totalCount: Scalars['Int']
}

export type Template = {
	__typename?: 'Template'
	components?: Maybe<Array<Component>>
	deviceSize?: Maybe<TemplateType>
	height?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	isCustom?: Maybe<Scalars['Boolean']>
	landingTemplate?: Maybe<LandingTemplate>
	name?: Maybe<Scalars['String']>
	root?: Maybe<Root>
	templateVariables?: Maybe<Array<ComponentVar>>
	templateVariant?: Maybe<TemplateVariant>
	width?: Maybe<Scalars['Int']>
}

export type TemplateInput = {
	components?: InputMaybe<Array<PostComponent>>
	deviceSize: TemplateType
	height: Scalars['Int']
	isCustom: Scalars['Boolean']
	landingTemplateId?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	templateVariables?: InputMaybe<Array<PostComponentVar>>
	templateVariantId: Scalars['Int']
	width: Scalars['Int']
}

export type TemplateResponse = {
	__typename?: 'TemplateResponse'
	errors?: Maybe<Array<Error>>
	template?: Maybe<Template>
}

export enum TemplateType {
	Epaper_152x152 = 'EPAPER_152x152',
	Epaper_200X200 = 'EPAPER_200X200',
	Epaper_296X128Bw = 'EPAPER_296X128_BW',
	Epaper_296X128R = 'EPAPER_296X128_R',
	Epaper_296X128Ry = 'EPAPER_296X128_RY',
	Epaper_296X128RSplit = 'EPAPER_296X128_R_SPLIT',
	Epaper_296X128Y = 'EPAPER_296X128_Y',
	Epaper_400X300R = 'EPAPER_400X300_R',
	Epaper_400X300Ry = 'EPAPER_400X300_RY',
	Epaper_400X300Y = 'EPAPER_400X300_Y',
	Epaper_792x272Ry = 'EPAPER_792x272_RY',
	Epaper_800x480R = 'EPAPER_800x480_R',
	Epaper_800x480Ry = 'EPAPER_800x480_RY',
	Epaper_800x480RyRotated = 'EPAPER_800x480_RY_ROTATED',
	Epaper_800x480RRotated = 'EPAPER_800x480_R_ROTATED',
	Epaper_800x480S6 = 'EPAPER_800x480_S6',
	Epaper_800x480S6Rotated = 'EPAPER_800x480_S6_ROTATED',
	Epaper_1600x1200S6 = 'EPAPER_1600x1200_S6',
	Epaper_1600x1200S6Rotated = 'EPAPER_1600x1200_S6_ROTATED',
	Epaper_2560x1440S6 = 'EPAPER_2560x1440_S6',
	Epaper_2560x1440S6Rotated = 'EPAPER_2560x1440_S6_ROTATED',
	EpaperNone = 'EPAPER_NONE',
	Lcd_1920X158 = 'LCD_1920X158',
	Lcd_1920X1080 = 'LCD_1920X1080',
	Lcd_2180X180 = 'LCD_2180X180',
}

export type TemplateVariant = {
	__typename?: 'TemplateVariant'
	id: Scalars['Int']
	inUse?: Maybe<Scalars['Boolean']>
	isActive: Scalars['Boolean']
	isDefault: Scalars['Boolean']
	key: Scalars['String']
	marketIDs?: Maybe<Array<Scalars['Int']>>
	name?: Maybe<Scalars['String']>
	orbisType?: Maybe<OrbisType>
	supportsRotated?: Maybe<Scalars['Boolean']>
	supportsSplit?: Maybe<Scalars['Boolean']>
	templates?: Maybe<Array<Template>>
}

export type TemplateVariantSupportsRotatedArgs = {
	deviceSize?: InputMaybe<DeviceSize>
}

export type TemplateVariantSupportsSplitArgs = {
	deviceSize?: InputMaybe<DeviceSize>
}

export type TemplateVariantInput = {
	isActive?: InputMaybe<Scalars['Boolean']>
	isDefault: Scalars['Boolean']
	key: Scalars['String']
	marketIDs?: InputMaybe<Array<Scalars['Int']>>
	name?: InputMaybe<Scalars['String']>
	orbisType?: InputMaybe<OrbisType>
}

export type TemplateVariantResponse = {
	__typename?: 'TemplateVariantResponse'
	errors?: Maybe<Array<Error>>
	templateVariant?: Maybe<TemplateVariant>
}

export type TemplateVariantsFilter = {
	any?: InputMaybe<Scalars['String']>
	deviceSize?: InputMaybe<TemplateType>
	deviceSizes?: InputMaybe<Array<TemplateType>>
	inUse?: InputMaybe<Scalars['Boolean']>
	includeInactive?: InputMaybe<Scalars['Boolean']>
	isActive?: InputMaybe<Scalars['Boolean']>
	isOrbis?: InputMaybe<Scalars['Boolean']>
	key?: InputMaybe<Scalars['String']>
	marketId?: InputMaybe<Scalars['Int']>
	name?: InputMaybe<Scalars['String']>
	split?: InputMaybe<Scalars['Boolean']>
	supportsOrbisTypes?: InputMaybe<Array<OrbisType>>
}

export type TemplateVariantsPagination = {
	__typename?: 'TemplateVariantsPagination'
	nodes?: Maybe<Array<TemplateVariant>>
	totalCount: Scalars['Int']
}

export type TemplatesFilter = {
	name?: InputMaybe<Scalars['String']>
	rootId?: InputMaybe<Scalars['Int']>
}

export type TemplatesPagination = {
	__typename?: 'TemplatesPagination'
	nodes?: Maybe<Array<Template>>
	totalCount: Scalars['Int']
}

export type Tenant = {
	__typename?: 'Tenant'
	address: Scalars['String']
	addressNumber?: Maybe<Scalars['String']>
	city: Scalars['String']
	companyName: Scalars['String']
	contractLength?: Maybe<ContractLength>
	contractorName?: Maybe<Scalars['String']>
	contractorsMail?: Maybe<Scalars['String']>
	country?: Maybe<Country>
	created: Scalars['DateTime']
	id: Scalars['Int']
	isActive?: Maybe<Scalars['Boolean']>
	loginLogo?: Maybe<Scalars['String']>
	logo?: Maybe<Scalars['String']>
	maxRoots: Scalars['Int']
	maxUsers: Scalars['Int']
	name: Scalars['String']
	numOfDevices?: Maybe<Scalars['Int']>
	numOfRoots?: Maybe<Scalars['Int']>
	numOfRouterProvisions?: Maybe<Scalars['Int']>
	numOfRouters?: Maybe<Scalars['Int']>
	numOfScales?: Maybe<Scalars['Int']>
	numOfSmartLabels?: Maybe<Scalars['Int']>
	numOfUsers?: Maybe<Scalars['Int']>
	postCode: Scalars['String']
	primaryColor?: Maybe<Scalars['String']>
	purchasedModules?: Maybe<Array<PurchasedModules>>
	startDate?: Maybe<Scalars['DateTime']>
	textColor?: Maybe<Scalars['String']>
	updated: Scalars['DateTime']
	usesDeviceName?: Maybe<Scalars['Boolean']>
	usesDualProduct?: Maybe<Scalars['Boolean']>
	usesMarkets?: Maybe<Scalars['Boolean']>
	usesPlanogram?: Maybe<Scalars['Boolean']>
	usesRootProducts?: Maybe<Scalars['Boolean']>
	vat: Scalars['String']
}

export type TenantInfo = {
	__typename?: 'TenantInfo'
	devicesError?: Maybe<Scalars['Int']>
	numOfRoots?: Maybe<Scalars['Int']>
	numOfScales?: Maybe<Scalars['Int']>
	numOfSensors?: Maybe<Scalars['Int']>
	numOfSmartLabels?: Maybe<Scalars['Int']>
	numOfUsers?: Maybe<Scalars['Int']>
	tenant: Tenant
}

export type TenantResponse = {
	__typename?: 'TenantResponse'
	adminUser?: Maybe<User>
	errors?: Maybe<Array<Error>>
	tenant?: Maybe<Tenant>
}

export type TenantsPaginations = {
	__typename?: 'TenantsPaginations'
	nodes: Array<Tenant>
	totalCount: Scalars['Int']
}

export type Transaction = {
	__typename?: 'Transaction'
	burnInPrevention?: Maybe<Scalars['Boolean']>
	cached?: Maybe<Scalars['Boolean']>
	clear?: Maybe<Scalars['Boolean']>
	device?: Maybe<Device>
	deviceserialnumber?: Maybe<Scalars['String']>
	duration?: Maybe<Scalars['Int']>
	error?: Maybe<Scalars['Int']>
	flipped?: Maybe<Scalars['Boolean']>
	productName?: Maybe<Scalars['String']>
	reset?: Maybe<Scalars['Boolean']>
	stage?: Maybe<TransactionStage>
	template?: Maybe<Template>
	templateid?: Maybe<Scalars['Int']>
	transactionid?: Maybe<Scalars['String']>
	ts?: Maybe<Scalars['String']>
}

export type TransactionResponse = {
	__typename?: 'TransactionResponse'
	errors?: Maybe<Array<Error>>
	totalCount?: Maybe<Scalars['Int']>
	transactions?: Maybe<Array<Transaction>>
}

export enum TransactionStage {
	Complete = 'COMPLETE',
	Error = 'ERROR',
	Processing = 'PROCESSING',
	Superseded = 'SUPERSEDED',
}

export type TriggerDeviceLedInput = {
	blinkSpeed: BlinkSpeed
	blinkTime: BlinkTime
	color: LedColor
	deviceId: Scalars['Int']
}

export type TriggerSyncInput = {
	integrationId: Scalars['Int']
}

export type UniqueColumn = {
	__typename?: 'UniqueColumn'
	name?: Maybe<Scalars['String']>
}

export type UniqueValueEntityColumnsResponse = {
	__typename?: 'UniqueValueEntityColumnsResponse'
	nodes: Array<Maybe<UniqueColumn>>
}

export type UpdateDevicesInput = {
	deviceIds: Array<Scalars['Int']>
	version?: InputMaybe<Scalars['String']>
}

export type UploadProductImageResponse = {
	__typename?: 'UploadProductImageResponse'
	file: File
	productImage?: Maybe<ProductImage>
}

export type UploadedFileResponse = {
	__typename?: 'UploadedFileResponse'
	encoding: Scalars['String']
	filename: Scalars['String']
	mimetype: Scalars['String']
	url: Scalars['String']
}

export type UrlAnalytics = {
	__typename?: 'UrlAnalytics'
	accessTime?: Maybe<Scalars['DateTime']>
	count?: Maybe<Scalars['Int']>
	customer?: Maybe<Scalars['String']>
	deviceSerialNumber?: Maybe<Scalars['String']>
	ipAddress?: Maybe<Scalars['String']>
	product?: Maybe<UrlAnalyticsProduct>
	productId?: Maybe<Scalars['Int']>
	root?: Maybe<UrlAnalyticsRoot>
	rootId?: Maybe<Scalars['Int']>
	userAgent?: Maybe<Scalars['String']>
}

export type UrlAnalyticsChartFilter = {
	from?: InputMaybe<Scalars['DateTime']>
	rootId?: InputMaybe<Scalars['Int']>
	to?: InputMaybe<Scalars['DateTime']>
}

export type UrlAnalyticsChartNode = {
	__typename?: 'UrlAnalyticsChartNode'
	count?: Maybe<Scalars['Int']>
	date?: Maybe<Scalars['String']>
}

export type UrlAnalyticsChartResponse = {
	__typename?: 'UrlAnalyticsChartResponse'
	errors?: Maybe<Array<Maybe<Error>>>
	nodes: Array<Maybe<UrlAnalyticsChartNode>>
}

export type UrlAnalyticsFilter = {
	deviceSerialNumber?: InputMaybe<Scalars['String']>
	from?: InputMaybe<Scalars['DateTime']>
	productId?: InputMaybe<Scalars['Int']>
	rootId?: InputMaybe<Scalars['Int']>
	to?: InputMaybe<Scalars['DateTime']>
}

export enum UrlAnalyticsGroupByEnum {
	Device = 'DEVICE',
	Location = 'LOCATION',
	Product = 'PRODUCT',
}

export type UrlAnalyticsGroupByFilter = {
	from?: InputMaybe<Scalars['DateTime']>
	groupBy: UrlAnalyticsGroupByEnum
	rootId?: InputMaybe<Scalars['Int']>
	to?: InputMaybe<Scalars['DateTime']>
}

export type UrlAnalyticsGroupByNode = {
	__typename?: 'UrlAnalyticsGroupByNode'
	count: Scalars['Int']
	groupedField: Scalars['String']
	product?: Maybe<UrlAnalyticsProduct>
	root?: Maybe<UrlAnalyticsRoot>
}

export type UrlAnalyticsGroupByPagination = {
	__typename?: 'UrlAnalyticsGroupByPagination'
	nodes: Array<Maybe<UrlAnalyticsGroupByNode>>
	totalCount: Scalars['Int']
}

export type UrlAnalyticsInfoResponse = {
	__typename?: 'UrlAnalyticsInfoResponse'
	activeDevicesCount: Scalars['Int']
	activeLocationsCount: Scalars['Int']
	scannedProductsCount: Scalars['Int']
	uniqueScannedProducts: Scalars['Int']
}

export type UrlAnalyticsPagination = {
	__typename?: 'UrlAnalyticsPagination'
	nodes: Array<Maybe<UrlAnalytics>>
	totalCount: Scalars['Int']
}

export type UrlAnalyticsProduct = {
	__typename?: 'UrlAnalyticsProduct'
	internalId?: Maybe<Scalars['String']>
	name?: Maybe<Scalars['String']>
}

export type UrlAnalyticsRoot = {
	__typename?: 'UrlAnalyticsRoot'
	name?: Maybe<Scalars['String']>
}

export type User = {
	__typename?: 'User'
	allowedIPs?: Maybe<Array<Scalars['IPv4']>>
	color?: Maybe<Scalars['String']>
	email?: Maybe<Scalars['String']>
	firstName?: Maybe<Scalars['String']>
	id: Scalars['Int']
	isRootRestricted?: Maybe<Scalars['Boolean']>
	isTwoFactorEnabled: Scalars['Boolean']
	lastName?: Maybe<Scalars['String']>
	ledConfig?: Maybe<LedConfig>
	ledConfigId?: Maybe<Scalars['Int']>
	locationRestrictions?: Maybe<Array<Root>>
	marketIDs?: Maybe<Array<Scalars['Int']>>
	marketRestrictions?: Maybe<Array<Market>>
	microsoftAuth?: Maybe<MicrosoftAuth>
	roles?: Maybe<Array<Role>>
	rootIDs?: Maybe<Array<Scalars['Int']>>
	username?: Maybe<Scalars['String']>
	verifiedEmail?: Maybe<Scalars['Boolean']>
}

export type UserResponse = {
	__typename?: 'UserResponse'
	errors?: Maybe<Array<Error>>
	user?: Maybe<User>
}

export type UsersFilter = {
	any?: InputMaybe<Scalars['String']>
	email?: InputMaybe<Scalars['String']>
}

export type UsersInfoResponse = {
	__typename?: 'UsersInfoResponse'
	maxUsers?: Maybe<Scalars['Int']>
	numOfUsers?: Maybe<Scalars['Int']>
}

export type UsersPaginations = {
	__typename?: 'UsersPaginations'
	nodes: Array<User>
	totalCount: Scalars['Int']
}

export type Value = {
	__typename?: 'Value'
	id: Scalars['Int']
	/** value name (only for display purposes) */
	name?: Maybe<Scalars['String']>
	root?: Maybe<Root>
	/** value can be assigned to a single root (e.g. the same product can have a different price in a specific root)) */
	rootId?: Maybe<Scalars['Int']>
	/** placeholder replaced with value in template (e.g. {{PRICE}}) */
	templateKey: Scalars['String']
	/** value type (formats value) */
	type?: Maybe<DeviceValueType>
	/** product value */
	value: Scalars['String']
}

export type ValueEntitiesFilter = {
	templateKey: Scalars['String']
	value: Scalars['String']
}

export type VirtualCategoryPoint = {
	__typename?: 'VirtualCategoryPoint'
	id: Scalars['Int']
	name?: Maybe<Scalars['String']>
	virtualCategoryPointId?: Maybe<Scalars['Int']>
	virtualRacks?: Maybe<Array<Maybe<VirtualRack>>>
}

export type VirtualCategoryPointPosition = {
	__typename?: 'VirtualCategoryPointPosition'
	id: Scalars['Int']
	virtualCategoryPoint?: Maybe<VirtualCategoryPoint>
	virtualCategoryPointId?: Maybe<Scalars['Int']>
	x: Scalars['Int']
	y: Scalars['Int']
}

export type VirtualCategoryPointResponse = {
	__typename?: 'VirtualCategoryPointResponse'
	errors?: Maybe<Array<Maybe<Error>>>
	virtualCategoryPoint?: Maybe<VirtualCategoryPoint>
}

export type VirtualCategoryPointsFilter = {
	name?: InputMaybe<Scalars['String']>
}

export type VirtualCategoryPointsPagination = {
	__typename?: 'VirtualCategoryPointsPagination'
	nodes?: Maybe<Array<VirtualCategoryPoint>>
	totalCount: Scalars['Int']
}

export type VirtualCategoryScreen = {
	__typename?: 'VirtualCategoryScreen'
	backgroundFile?: Maybe<File>
	backgroundFileId?: Maybe<Scalars['Int']>
	catalogMode?: Maybe<Scalars['Boolean']>
	channel?: Maybe<Channel>
	channelId?: Maybe<Scalars['Int']>
	file?: Maybe<File>
	fileId?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	name?: Maybe<Scalars['String']>
	timeout?: Maybe<Scalars['Int']>
	virtualCategoryPointPositions?: Maybe<
		Array<Maybe<VirtualCategoryPointPosition>>
	>
}

export type VirtualCategoryScreenResponse = {
	__typename?: 'VirtualCategoryScreenResponse'
	errors?: Maybe<Array<Maybe<Error>>>
	virtualCategoryScreen?: Maybe<VirtualCategoryScreen>
}

export type VirtualCategoryScreensFilter = {
	name?: InputMaybe<Scalars['String']>
}

export type VirtualDeviceInput = {
	barId?: InputMaybe<Scalars['Int']>
	groupId?: InputMaybe<Scalars['Int']>
	internalId?: InputMaybe<Scalars['String']>
	name?: InputMaybe<Scalars['String']>
	positionId?: InputMaybe<Scalars['Int']>
	rootId: Scalars['Int']
	templateVariantId?: InputMaybe<Scalars['Int']>
}

export type VirtualMultiScreen = {
	__typename?: 'VirtualMultiScreen'
	id: Scalars['Int']
	name?: Maybe<Scalars['String']>
	virtualMultiScreenPositions?: Maybe<
		Array<Maybe<VirtualMultiScreenPosition>>
	>
}

export type VirtualMultiScreenPosition = {
	__typename?: 'VirtualMultiScreenPosition'
	channel?: Maybe<Channel>
	channelId?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	sequence: Scalars['Int']
	virtualCategoryPoint?: Maybe<VirtualCategoryPoint>
	virtualCategoryPointId?: Maybe<Scalars['Int']>
	virtualRack?: Maybe<VirtualRack>
	virtualRackId?: Maybe<Scalars['Int']>
}

export type VirtualMultiScreenResponse = {
	__typename?: 'VirtualMultiScreenResponse'
	errors?: Maybe<Array<Maybe<Error>>>
	virtualMultiScreen?: Maybe<VirtualMultiScreen>
}

export type VirtualMultiScreensFilter = {
	name?: InputMaybe<Scalars['String']>
}

export type VirtualProductPosition = {
	__typename?: 'VirtualProductPosition'
	id: Scalars['Int']
	itemCount?: Maybe<Scalars['Int']>
	product?: Maybe<Product>
	productId?: Maybe<Scalars['Int']>
	rotation?: Maybe<Scalars['Int']>
	sequence: Scalars['Int']
	virtualShelf?: Maybe<VirtualShelf>
	virtualShelfId?: Maybe<Scalars['Int']>
	zoom?: Maybe<Scalars['Int']>
}

export type VirtualRack = {
	__typename?: 'VirtualRack'
	file?: Maybe<File>
	fileId?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	name?: Maybe<Scalars['String']>
	removePadding?: Maybe<Scalars['Boolean']>
	virtualShelfPositions?: Maybe<Array<VirtualShelfPosition>>
	virtualStoreDevices?: Maybe<Array<VirtualStoreDevice>>
}

export type VirtualRackResponse = {
	__typename?: 'VirtualRackResponse'
	errors?: Maybe<Array<Maybe<Error>>>
	virtualRack?: Maybe<VirtualRack>
}

export type VirtualRacksFilter = {
	name?: InputMaybe<Scalars['String']>
}

export type VirtualRacksPagination = {
	__typename?: 'VirtualRacksPagination'
	nodes?: Maybe<Array<VirtualRack>>
	totalCount: Scalars['Int']
}

export type VirtualShelf = {
	__typename?: 'VirtualShelf'
	file?: Maybe<File>
	fileId?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	name?: Maybe<Scalars['String']>
	spacing?: Maybe<Scalars['Float']>
	variant: VirtualShelfVariant
	virtualProductPositions?: Maybe<Array<Maybe<VirtualProductPosition>>>
}

export type VirtualShelfPosition = {
	__typename?: 'VirtualShelfPosition'
	id: Scalars['Int']
	sequence: Scalars['Int']
	virtualShelf?: Maybe<VirtualShelf>
	virtualShelfId?: Maybe<Scalars['Int']>
}

export type VirtualShelfResponse = {
	__typename?: 'VirtualShelfResponse'
	errors?: Maybe<Array<Maybe<Error>>>
	virtualShelf?: Maybe<VirtualShelf>
}

export enum VirtualShelfVariant {
	Agitron = 'AGITRON',
	GlassCenter = 'GLASS_CENTER',
	GlassFull = 'GLASS_FULL',
	GlassLeft = 'GLASS_LEFT',
	GlassRight = 'GLASS_RIGHT',
	GrayCenter = 'GRAY_CENTER',
	GrayFull = 'GRAY_FULL',
	GrayLeft = 'GRAY_LEFT',
	GrayRight = 'GRAY_RIGHT',
	Normal = 'NORMAL',
	WhiteCenter = 'WHITE_CENTER',
	WhiteFull = 'WHITE_FULL',
	WhiteLeft = 'WHITE_LEFT',
	WhiteRight = 'WHITE_RIGHT',
	WoodCenter = 'WOOD_CENTER',
	WoodFull = 'WOOD_FULL',
	WoodLeft = 'WOOD_LEFT',
	WoodRight = 'WOOD_RIGHT',
	WoodWhiteCenter = 'WOOD_WHITE_CENTER',
	WoodWhiteFull = 'WOOD_WHITE_FULL',
	WoodWhiteLeft = 'WOOD_WHITE_LEFT',
	WoodWhiteRight = 'WOOD_WHITE_RIGHT',
}

export type VirtualShelvesFilter = {
	name?: InputMaybe<Scalars['String']>
}

export type VirtualShelvesPagination = {
	__typename?: 'VirtualShelvesPagination'
	nodes?: Maybe<Array<VirtualShelf>>
	totalCount: Scalars['Int']
}

export type VirtualStoreDevice = {
	__typename?: 'VirtualStoreDevice'
	active?: Maybe<Scalars['Boolean']>
	channel?: Maybe<Channel>
	channelId?: Maybe<Scalars['Int']>
	height?: Maybe<Scalars['Int']>
	id: Scalars['Int']
	ip?: Maybe<Scalars['IPv4']>
	messageReceived?: Maybe<Scalars['Boolean']>
	name?: Maybe<Scalars['String']>
	note?: Maybe<Scalars['String']>
	powerWindows?: Maybe<Array<DevicePowerWindow>>
	root?: Maybe<Root>
	rootId?: Maybe<Scalars['Int']>
	signageButtons?: Maybe<Array<SignageButton>>
	tags?: Maybe<Array<Maybe<Scalars['String']>>>
	token?: Maybe<Scalars['String']>
	type?: Maybe<SignageDeviceType>
	version?: Maybe<Scalars['String']>
	virtualCategoryPoint?: Maybe<VirtualCategoryPoint>
	virtualCategoryPointId?: Maybe<Scalars['Int']>
	virtualCategoryScreen?: Maybe<VirtualCategoryScreen>
	virtualCategoryScreenId?: Maybe<Scalars['Int']>
	virtualMultiScreen?: Maybe<VirtualMultiScreen>
	virtualMultiScreenId?: Maybe<Scalars['Int']>
	width?: Maybe<Scalars['Int']>
}

export type VirtualStoreDeviceResponse = {
	__typename?: 'VirtualStoreDeviceResponse'
	errors?: Maybe<Array<Maybe<Error>>>
	virtualStoreDevice?: Maybe<VirtualStoreDevice>
}

export type VirtualStoreDevicesFilter = {
	active?: InputMaybe<Scalars['Boolean']>
	channelId?: InputMaybe<Scalars['Int']>
	messageReceived?: InputMaybe<Scalars['Boolean']>
	name?: InputMaybe<Scalars['String']>
	rootId?: InputMaybe<Scalars['Int']>
	tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type VirtualStoreDevicesPagination = {
	__typename?: 'VirtualStoreDevicesPagination'
	nodes?: Maybe<Array<VirtualStoreDevice>>
	totalCount: Scalars['Int']
}

export type VirutalCategoryScreensPagination = {
	__typename?: 'VirutalCategoryScreensPagination'
	nodes?: Maybe<Array<VirtualCategoryScreen>>
	totalCount: Scalars['Int']
}

export type VirutalMultiScreensPagination = {
	__typename?: 'VirutalMultiScreensPagination'
	nodes?: Maybe<Array<VirtualMultiScreen>>
	totalCount: Scalars['Int']
}

export type WarehouseAlarmsCountResponse = {
	__typename?: 'WarehouseAlarmsCountResponse'
	expiration?: Maybe<Scalars['Int']>
	express?: Maybe<Scalars['Int']>
	normal?: Maybe<Scalars['Int']>
}

export type WarehouseOrderCount = {
	__typename?: 'WarehouseOrderCount'
	date: Scalars['DateTime']
	expressCount: Scalars['Int']
	normalCount: Scalars['Int']
	total: Scalars['Int']
}

export type WarehouseOrderReport = {
	__typename?: 'WarehouseOrderReport'
	allOrders: Array<WarehouseOrderCount>
	stockValue: Array<WarehouseStockValue>
}

export type WarehouseOrderReportInput = {
	aisleId?: InputMaybe<Scalars['Int']>
	bayId?: InputMaybe<Scalars['Int']>
	dateFrom: Scalars['DateTime']
	dateTo?: InputMaybe<Scalars['DateTime']>
	rootId?: InputMaybe<Scalars['Int']>
	shelfId?: InputMaybe<Scalars['Int']>
	supplierId?: InputMaybe<Scalars['Int']>
}

export type WarehouseParentsWithChildrenFilter = {
	aisleId?: InputMaybe<Scalars['Int']>
	alarmType?: InputMaybe<AlarmType>
	any?: InputMaybe<Scalars['String']>
	bayId?: InputMaybe<Scalars['Int']>
	rootId?: InputMaybe<Scalars['Int']>
	shelfId?: InputMaybe<Scalars['Int']>
	supplierId?: InputMaybe<Scalars['Int']>
}

export type WarehouseProduct = {
	__typename?: 'WarehouseProduct'
	lastChange: Scalars['DateTime']
	mode: ModeEnum
	product: Product
	quantity: Scalars['Int']
}

export type WarehouseProductValueReport = {
	__typename?: 'WarehouseProductValueReport'
	CHF: Scalars['Float']
	EUR: Scalars['Float']
	GBP: Scalars['Float']
	USD: Scalars['Float']
	date: Scalars['DateTime']
	month: Scalars['String']
}

export type WarehouseProductValueReportFilter = {
	aisleId?: InputMaybe<Scalars['Int']>
	bayId?: InputMaybe<Scalars['Int']>
	rootId?: InputMaybe<Scalars['Int']>
	shelfId?: InputMaybe<Scalars['Int']>
	startDate?: InputMaybe<Scalars['DateTime']>
	supplierId?: InputMaybe<Scalars['Int']>
}

export type WarehouseProductValueReports = {
	__typename?: 'WarehouseProductValueReports'
	reports: Array<WarehouseProductValueReport>
}

export type WarehouseStockValue = {
	__typename?: 'WarehouseStockValue'
	CHF: Scalars['Float']
	EUR: Scalars['Float']
	GBP: Scalars['Float']
	USD: Scalars['Float']
	date: Scalars['DateTime']
}

export enum WeekDay {
	Friday = 'FRIDAY',
	Monday = 'MONDAY',
	Saturday = 'SATURDAY',
	Sunday = 'SUNDAY',
	Thursday = 'THURSDAY',
	Tuesday = 'TUESDAY',
	Wednesday = 'WEDNESDAY',
}

export enum WifiMode {
	GHz_2_4 = 'GHz_2_4',
	GHz_5 = 'GHz_5',
}

export type AddEditProductsResponse = {
	__typename?: 'addEditProductsResponse'
	/** list of products added by the mutation */
	addedProducts?: Maybe<Array<Product>>
	/** UUID for status check of updated devices */
	batchUUID: Scalars['String']
	errors?: Maybe<Array<Error>>
	isAssignedToShelves?: Maybe<Scalars['Boolean']>
	success?: Maybe<Scalars['Boolean']>
}

export type BaysFilter = {
	aisleId?: InputMaybe<Scalars['Int']>
	key?: InputMaybe<Scalars['String']>
	rootId?: InputMaybe<Scalars['Int']>
}

export type BaysPaginations = {
	__typename?: 'baysPaginations'
	nodes: Array<Bay>
	totalCount: Scalars['Int']
}

export type ShelvesFilter = {
	aisleKey?: InputMaybe<Scalars['String']>
	bayId?: InputMaybe<Scalars['Int']>
	bayKey?: InputMaybe<Scalars['String']>
	key?: InputMaybe<Scalars['String']>
	rootId?: InputMaybe<Scalars['Int']>
}

export type ShelvesPaginations = {
	__typename?: 'shelvesPaginations'
	nodes: Array<Shelf>
	totalCount: Scalars['Int']
}

export type AddRootMutationVariables = Exact<{
	input: AddRootInput
}>

export type AddRootMutation = {
	__typename?: 'Mutation'
	addRoot: {
		__typename?: 'RootResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		} | null> | null
	}
}

export type AutofillCoordinatesMutationVariables = Exact<{
	[key: string]: never
}>

export type AutofillCoordinatesMutation = {
	__typename?: 'Mutation'
	autofillCoordinates: {
		__typename?: 'AutofillCoordinatesResponse'
		success: boolean
		eligibleCount: number
		errorCount: number
		successCount: number
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type DeleteRootMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteRootMutation = {
	__typename?: 'Mutation'
	deleteRoot: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditRootMutationVariables = Exact<{
	id: Scalars['Int']
	input: EditRootInput
}>

export type EditRootMutation = {
	__typename?: 'Mutation'
	editRoot: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type LocationDashboardQueryVariables = Exact<{
	rootId: Scalars['Int']
}>

export type LocationDashboardQuery = {
	__typename?: 'Query'
	root: {
		__typename?: 'RootResponse'
		root?: {
			__typename?: 'Root'
			id: number
			deviceCount?: number | null
			routerCount?: number | null
			batteryUnderCount?: number | null
			deviceErrCount?: number | null
			deviceProcessingCount?: number | null
			routerOffline?: number | null
			market?: {
				__typename?: 'Market'
				id: number
				name?: string | null
			} | null
		} | null
	}
}

export type LocationsQueryVariables = Exact<{
	where?: InputMaybe<RootsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type LocationsQuery = {
	__typename?: 'Query'
	roots?: {
		__typename?: 'RootsPaginations'
		totalCount: number
		nodes: Array<{
			__typename: 'Root'
			id: number
			name?: string | null
			latitude?: number | null
			longitude?: number | null
			deviceCount?: number | null
			routerCount?: number | null
			market?: { __typename?: 'Market'; name?: string | null } | null
		}>
	} | null
}

export type LocationsDashboardQueryVariables = Exact<{
	where?: InputMaybe<RootsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type LocationsDashboardQuery = {
	__typename?: 'Query'
	roots?: {
		__typename?: 'RootsPaginations'
		nodes: Array<{
			__typename?: 'Root'
			id: number
			name?: string | null
			latitude?: number | null
			longitude?: number | null
		}>
	} | null
}

export type LocationsSelectQueryVariables = Exact<{
	where?: InputMaybe<RootsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type LocationsSelectQuery = {
	__typename?: 'Query'
	roots?: {
		__typename?: 'RootsPaginations'
		totalCount: number
		nodes: Array<{
			__typename: 'Root'
			id: number
			key?: string | null
			name?: string | null
		}>
	} | null
}

export type LocationsSelectRoutersQueryVariables = Exact<{
	where?: InputMaybe<RootsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type LocationsSelectRoutersQuery = {
	__typename?: 'Query'
	roots?: {
		__typename?: 'RootsPaginations'
		totalCount: number
		nodes: Array<{
			__typename: 'Root'
			id: number
			key?: string | null
			name?: string | null
			routers?: Array<{ __typename?: 'Router'; id: number }> | null
		}>
	} | null
}

export type RootQueryVariables = Exact<{
	rootId: Scalars['Int']
}>

export type RootQuery = {
	__typename?: 'Query'
	root: {
		__typename?: 'RootResponse'
		root?: {
			__typename?: 'Root'
			id: number
			key?: string | null
			name?: string | null
			latitude?: number | null
			longitude?: number | null
			mode?: RootMode | null
			marketId?: number | null
			burninPrevention?: boolean | null
			timezone?: string | null
			address?: string | null
			tags?: Array<string> | null
			market?: {
				__typename?: 'Market'
				id: number
				name?: string | null
			} | null
		} | null
	}
}

export type RootNameQueryVariables = Exact<{
	rootId: Scalars['Int']
}>

export type RootNameQuery = {
	__typename?: 'Query'
	root: {
		__typename?: 'RootResponse'
		root?: { __typename?: 'Root'; id: number; name?: string | null } | null
	}
}

export type RootsQueryVariables = Exact<{
	where?: InputMaybe<RootsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type RootsQuery = {
	__typename?: 'Query'
	roots?: {
		__typename?: 'RootsPaginations'
		nodes: Array<{
			__typename?: 'Root'
			id: number
			name?: string | null
			tags?: Array<string> | null
		}>
	} | null
}

export type TimezoneLookupQueryVariables = Exact<{
	latitude: Scalars['Float']
	longitude: Scalars['Float']
}>

export type TimezoneLookupQuery = {
	__typename?: 'Query'
	timezoneLookup?: string | null
}

export type AddMarketMutationVariables = Exact<{
	input: AddMarketInput
}>

export type AddMarketMutation = {
	__typename?: 'Mutation'
	addMarket: {
		__typename?: 'MarketResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		} | null> | null
	}
}

export type DeleteMarketMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteMarketMutation = {
	__typename?: 'Mutation'
	deleteMarket: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditMarketMutationVariables = Exact<{
	id: Scalars['Int']
	input: EditMarketInput
}>

export type EditMarketMutation = {
	__typename?: 'Mutation'
	editMarket: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type MarketQueryVariables = Exact<{
	id: Scalars['Int']
}>

export type MarketQuery = {
	__typename?: 'Query'
	market: {
		__typename?: 'MarketResponse'
		market?: {
			__typename?: 'Market'
			id: number
			name?: string | null
			key?: string | null
		} | null
	}
}

export type MarketsQueryVariables = Exact<{
	where?: InputMaybe<MarketsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type MarketsQuery = {
	__typename?: 'Query'
	markets?: {
		__typename?: 'MarketsPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'Market'
			id: number
			key?: string | null
			name?: string | null
			rootsCount?: number | null
		}>
	} | null
}

export type AddRouterMutationVariables = Exact<{
	input: AddRouterInput
}>

export type AddRouterMutation = {
	__typename?: 'Mutation'
	addRouter?: {
		__typename?: 'AddRouterResponse'
		router?: { __typename?: 'Router'; id: number } | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	} | null
}

export type DeleteRouterMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteRouterMutation = {
	__typename?: 'Mutation'
	deleteRouter: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditRouterMutationVariables = Exact<{
	id: Scalars['Int']
	input: EditRouterInput
}>

export type EditRouterMutation = {
	__typename?: 'Mutation'
	editRouter: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type RouterDetailsQueryVariables = Exact<{
	uuid?: InputMaybe<Scalars['String']>
	id?: InputMaybe<Scalars['Int']>
}>

export type RouterDetailsQuery = {
	__typename?: 'Query'
	routerDetails: {
		__typename?: 'RouterDetailsResponse'
		routerDetails?: {
			__typename?: 'RouterDetails'
			cpu_temp?: number | null
			cpu_usage?: number | null
			memory_usage?: number | null
			memory_total?: number | null
			is_online?: boolean | null
			is_connected_to_vpn?: boolean | null
			ip_address?: string | null
			mac_address?: string | null
			storage_usage?: number | null
			storage_total?: number | null
			is_undervolted?: boolean | null
			last_seen?: any | null
			router?: {
				__typename?: 'Router'
				id: number
				name?: string | null
				dhcp?: boolean | null
				token?: string | null
				macAddress?: any | null
				uuid?: string | null
				type?: RouterType | null
				version?: string | null
				online?: boolean | null
				root?: {
					__typename?: 'Root'
					id: number
					name?: string | null
				} | null
				routerNetwork?: {
					__typename?: 'RouterNetwork'
					ip?: any | null
					subnet?: any | null
					gateway?: any | null
					dns1?: any | null
					dns2?: any | null
					wifichannel?: number | null
					wifimode?: WifiMode | null
				} | null
			} | null
		} | null
	}
}

export type RoutersQueryVariables = Exact<{
	offset: Scalars['Int']
	limit: Scalars['Int']
	where?: InputMaybe<RoutersFilter>
}>

export type RoutersQuery = {
	__typename?: 'Query'
	routers: {
		__typename?: 'RoutersPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'Router'
			id: number
			name?: string | null
			macAddress?: any | null
			uuid?: string | null
			type?: RouterType | null
			version?: string | null
			online?: boolean | null
			deviceCount?: number | null
			root?: {
				__typename?: 'Root'
				id: number
				name?: string | null
				market?: {
					__typename?: 'Market'
					id: number
					name?: string | null
				} | null
			} | null
		}>
	}
}

export type RoutersSelectQueryVariables = Exact<{
	offset: Scalars['Int']
	limit: Scalars['Int']
	where?: InputMaybe<RoutersFilter>
}>

export type RoutersSelectQuery = {
	__typename?: 'Query'
	routers: {
		__typename?: 'RoutersPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'Router'
			id: number
			name?: string | null
			macAddress?: any | null
			uuid?: string | null
		}>
	}
}

export type CheckAuthQueryVariables = Exact<{ [key: string]: never }>

export type CheckAuthQuery = { __typename?: 'Query'; checkAuth: boolean }

export type LoginMutationVariables = Exact<{
	username: Scalars['String']
	password: Scalars['String']
	otp: Scalars['String']
}>

export type LoginMutation = {
	__typename?: 'Mutation'
	login: {
		__typename?: 'LoginResponse'
		tokens?: any | null
		needOTP?: boolean | null
		delta?: number | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type LogoutMutationVariables = Exact<{ [key: string]: never }>

export type LogoutMutation = {
	__typename?: 'Mutation'
	logout?: boolean | null
}

export type UrlAnalyticsQueryVariables = Exact<{
	where?: InputMaybe<UrlAnalyticsFilter>
	offset?: InputMaybe<Scalars['Int']>
	limit?: InputMaybe<Scalars['Int']>
}>

export type UrlAnalyticsQuery = {
	__typename?: 'Query'
	urlAnalytics: {
		__typename?: 'UrlAnalyticsPagination'
		totalCount: number
		nodes: Array<{
			__typename?: 'UrlAnalytics'
			accessTime?: any | null
			deviceSerialNumber?: string | null
			userAgent?: string | null
			productId?: number | null
			rootId?: number | null
			product?: {
				__typename?: 'UrlAnalyticsProduct'
				name?: string | null
				internalId?: string | null
			} | null
			root?: {
				__typename?: 'UrlAnalyticsRoot'
				name?: string | null
			} | null
		} | null>
	}
}

export type UrlAnalyticsChartQueryVariables = Exact<{
	where?: InputMaybe<UrlAnalyticsChartFilter>
}>

export type UrlAnalyticsChartQuery = {
	__typename?: 'Query'
	urlAnalyticsChart: {
		__typename?: 'UrlAnalyticsChartResponse'
		nodes: Array<{
			__typename?: 'UrlAnalyticsChartNode'
			date?: string | null
			count?: number | null
		} | null>
	}
}

export type UrlAnalyticsGroupByQueryVariables = Exact<{
	where?: InputMaybe<UrlAnalyticsGroupByFilter>
	offset?: InputMaybe<Scalars['Int']>
	limit?: InputMaybe<Scalars['Int']>
}>

export type UrlAnalyticsGroupByQuery = {
	__typename?: 'Query'
	urlAnalyticsGroupBy: {
		__typename?: 'UrlAnalyticsGroupByPagination'
		totalCount: number
		nodes: Array<{
			__typename?: 'UrlAnalyticsGroupByNode'
			groupedField: string
			count: number
			product?: {
				__typename?: 'UrlAnalyticsProduct'
				name?: string | null
				internalId?: string | null
			} | null
			root?: {
				__typename?: 'UrlAnalyticsRoot'
				name?: string | null
			} | null
		} | null>
	}
}

export type UrlAnalyticsInfoQueryVariables = Exact<{ [key: string]: never }>

export type UrlAnalyticsInfoQuery = {
	__typename?: 'Query'
	urlAnalyticsInfo: {
		__typename?: 'UrlAnalyticsInfoResponse'
		scannedProductsCount: number
		activeDevicesCount: number
		activeLocationsCount: number
		uniqueScannedProducts: number
	}
}

export type CreateApiClientMutationVariables = Exact<{
	name: Scalars['String']
	roleIDs: Array<Scalars['Int']> | Scalars['Int']
	rootIDs?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>
	expiresAt?: InputMaybe<Scalars['String']>
}>

export type CreateApiClientMutation = {
	__typename?: 'Mutation'
	createApiClient: {
		__typename?: 'CreateApiClientResponse'
		id: string
		name: string
		clientKey: string
		clientSecret: string
	}
}

export type GetApiClientsQueryVariables = Exact<{ [key: string]: never }>

export type GetApiClientsQuery = {
	__typename?: 'Query'
	apiClients: Array<{
		__typename?: 'ApiClientInfo'
		id: string
		name: string
		clientKey: string
		roleIDs: Array<number>
		rootIDs?: Array<number> | null
		isActive: boolean
		createdAt: string
		expiresAt?: string | null
		lastUsed?: string | null
	}>
}

export type RevokeApiClientMutationVariables = Exact<{
	id: Scalars['ID']
}>

export type RevokeApiClientMutation = {
	__typename?: 'Mutation'
	revokeApiClient: boolean
}

export type RotateApiClientSecretMutationVariables = Exact<{
	id: Scalars['ID']
}>

export type RotateApiClientSecretMutation = {
	__typename?: 'Mutation'
	rotateApiClientSecret: {
		__typename?: 'CreateApiClientResponse'
		id: string
		name: string
		clientKey: string
		clientSecret: string
	}
}

export type AssetDownloadQueryVariables = Exact<{
	fileId: Scalars['Int']
}>

export type AssetDownloadQuery = {
	__typename?: 'Query'
	getAsset?: { __typename?: 'AssetDownload'; url?: string | null } | null
}

export type CreateFolderMutationVariables = Exact<{
	input: FolderInput
}>

export type CreateFolderMutation = {
	__typename?: 'Mutation'
	createFolder: {
		__typename?: 'CreateFolderResponse'
		success: boolean
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		folder?: { __typename?: 'File'; id: number } | null
	}
}

export type DeleteFileMutationVariables = Exact<{
	fileId: Scalars['Int']
}>

export type DeleteFileMutation = {
	__typename?: 'Mutation'
	deleteFile: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditFileMutationVariables = Exact<{
	fileId: Scalars['Int']
	input: EditFileInput
}>

export type EditFileMutation = {
	__typename?: 'Mutation'
	editFile: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type FileStructureQueryVariables = Exact<{
	where?: InputMaybe<FileStructureFilter>
	limit?: InputMaybe<Scalars['Int']>
	offset?: InputMaybe<Scalars['Int']>
}>

export type FileStructureQuery = {
	__typename?: 'Query'
	getFileStructure?: {
		__typename?: 'FileStructureResponse'
		totalCount: number
		nodes: Array<{
			__typename?: 'File'
			id: number
			width?: number | null
			height?: number | null
			duration?: number | null
			originalname?: string | null
			filename?: string | null
			mimetype?: string | null
			isFolder: boolean
			thumbnail?: string | null
		}>
	} | null
}

export type FilesQueryVariables = Exact<{
	where?: InputMaybe<FilesFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type FilesQuery = {
	__typename?: 'Query'
	files?: {
		__typename?: 'FilesResponsePagination'
		totalCount: number
		nodes: Array<{
			__typename?: 'File'
			id: number
			duration?: number | null
			isFolder: boolean
			originalname?: string | null
			filename?: string | null
			mimetype?: string | null
			thumbnail?: string | null
			width?: number | null
			height?: number | null
		}>
	} | null
}

export type GetFileQueryVariables = Exact<{
	where?: InputMaybe<FileFilter>
}>

export type GetFileQuery = {
	__typename?: 'Query'
	getFile?: {
		__typename?: 'File'
		id: number
		duration?: number | null
		isFolder: boolean
		originalname?: string | null
		filename?: string | null
		mimetype?: string | null
		thumbnail?: string | null
		width?: number | null
		height?: number | null
	} | null
}

export type GetFileChainQueryVariables = Exact<{
	where: FileChainFilter
}>

export type GetFileChainQuery = {
	__typename?: 'Query'
	getFileChain: Array<{
		__typename?: 'FileChainNode'
		id: number
		filename?: string | null
		originalname?: string | null
		type?: FolderType | null
	}>
}

export type GetFileIdQueryVariables = Exact<{
	where?: InputMaybe<FileFilter>
}>

export type GetFileIdQuery = {
	__typename?: 'Query'
	getFile?: { __typename?: 'File'; id: number } | null
}

export type MultiUploadMutationVariables = Exact<{
	files: Array<Scalars['Upload']> | Scalars['Upload']
	parentFolderId?: InputMaybe<Scalars['Int']>
	productAssign?: InputMaybe<Scalars['Boolean']>
}>

export type MultiUploadMutation = {
	__typename?: 'Mutation'
	multiUpload?: Array<{
		__typename?: 'MultiUploadResponse'
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		file?: {
			__typename?: 'File'
			id: number
			originalname?: string | null
			filename?: string | null
			mimetype?: string | null
			encoding?: string | null
			url?: string | null
			isFolder: boolean
			thumbnail?: string | null
		} | null
	}> | null
}

export type AddChannelMutationVariables = Exact<{
	input: AddChannelInput
}>

export type AddChannelMutation = {
	__typename?: 'Mutation'
	addChannel: {
		__typename?: 'ChannelResponse'
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		channel?: { __typename?: 'Channel'; id: number } | null
	}
}

export type ChannelQueryVariables = Exact<{
	channelId: Scalars['Int']
}>

export type ChannelQuery = {
	__typename?: 'Query'
	channel: {
		__typename?: 'ChannelResponse'
		channel?: {
			__typename?: 'Channel'
			id: number
			name?: string | null
			tags?: Array<string> | null
			type: SignageDeviceType
			orientation?: ChannelOrientation | null
			marketId?: number | null
			market?: {
				__typename?: 'Market'
				id: number
				name?: string | null
			} | null
			channelItems?: Array<{
				__typename?: 'ChannelItem'
				id: number
				priority?: boolean | null
				duration?: number | null
				sequence: number
				display?: { __typename?: 'Display'; id: number } | null
				file?: {
					__typename?: 'File'
					id: number
					duration?: number | null
					encoding?: string | null
					isFolder: boolean
					filename?: string | null
					originalname?: string | null
					mimetype?: string | null
					thumbnail?: string | null
				} | null
				playlist?: {
					__typename?: 'Playlist'
					id: number
					name: string
					playlistItems: Array<{
						__typename?: 'PlaylistItem'
						duration: number
						file?: {
							__typename?: 'File'
							id: number
							encoding?: string | null
							isFolder: boolean
							filename?: string | null
							originalname?: string | null
							mimetype?: string | null
							thumbnail?: string | null
						} | null
					}>
				} | null
				schedule: {
					__typename?: 'Schedule'
					dateRange?: Array<any | null> | null
					weekdays: Array<WeekDay>
					id: number
					timeFrames?: Array<string | null> | null
				}
			}> | null
			displays?: Array<{
				__typename?: 'Display'
				id: number
				name?: string | null
				height: number
				width: number
				type: DisplayType
			}> | null
		} | null
	}
}

export type ChannelsQueryVariables = Exact<{
	where?: InputMaybe<ChannelsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type ChannelsQuery = {
	__typename?: 'Query'
	channels: {
		__typename?: 'ChannelsPagination'
		totalCount: number
		nodes?: Array<{
			__typename?: 'Channel'
			id: number
			name?: string | null
			tags?: Array<string> | null
			type: SignageDeviceType
			displays?: Array<{
				__typename?: 'Display'
				id: number
				type: DisplayType
			}> | null
			channelItems?: Array<{
				__typename?: 'ChannelItem'
				id: number
				schedule: {
					__typename?: 'Schedule'
					id: number
					weekdays: Array<WeekDay>
					timeFrames?: Array<string | null> | null
					dateRange?: Array<any | null> | null
				}
			}> | null
			tvDevices?: Array<{
				__typename?: 'TVDevice'
				id: number
			} | null> | null
			scales?: Array<{ __typename?: 'Scale'; id: number } | null> | null
			devices?: Array<{ __typename?: 'Device'; id: number } | null> | null
		}> | null
	}
}

export type ChannelsSelectQueryVariables = Exact<{
	where?: InputMaybe<ChannelsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type ChannelsSelectQuery = {
	__typename?: 'Query'
	channels: {
		__typename?: 'ChannelsPagination'
		nodes?: Array<{
			__typename?: 'Channel'
			id: number
			name?: string | null
		}> | null
	}
}

export type DeleteChannelMutationVariables = Exact<{
	channelId: Scalars['Int']
}>

export type DeleteChannelMutation = {
	__typename?: 'Mutation'
	deleteChannel: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			message: string
			path: string
		}> | null
	}
}

export type EditPlaylistMutationVariables = Exact<{
	playlistId: Scalars['Int']
	input: EditPlaylistInput
}>

export type EditPlaylistMutation = {
	__typename?: 'Mutation'
	editPlaylist: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type TagsQueryVariables = Exact<{
	where?: InputMaybe<TagsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type TagsQuery = {
	__typename?: 'Query'
	tags: { __typename?: 'TagsPagination'; nodes?: Array<string> | null }
}

export type CustomerSettingsQueryVariables = Exact<{
	customer: Scalars['String']
}>

export type CustomerSettingsQuery = {
	__typename?: 'Query'
	customerSettings?: {
		__typename?: 'CustomerSettings'
		usesMarkets?: boolean | null
		usesDualProduct?: boolean | null
		usesDeviceName?: boolean | null
		usesRootProducts?: boolean | null
		usesPlanogram?: boolean | null
	} | null
}

export type LoginPageSettingsQueryVariables = Exact<{
	customer: Scalars['String']
}>

export type LoginPageSettingsQuery = {
	__typename?: 'Query'
	loginPageSettings?: {
		__typename?: 'LoginPageSettings'
		logo?: string | null
		loginLogo?: string | null
		primaryColor?: string | null
		textColor?: string | null
	} | null
}

export type AddTemplateMutationVariables = Exact<{
	input: TemplateInput
}>

export type AddTemplateMutation = {
	__typename?: 'Mutation'
	addTemplate: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type AddTemplateVariantMutationVariables = Exact<{
	input: TemplateVariantInput
}>

export type AddTemplateVariantMutation = {
	__typename?: 'Mutation'
	addTemplateVariant: {
		__typename?: 'TemplateVariantResponse'
		errors?: Array<{
			__typename?: 'Error'
			message: string
			path: string
		}> | null
		templateVariant?: { __typename?: 'TemplateVariant'; id: number } | null
	}
}

export type ComponentVarsQueryVariables = Exact<{
	offset: Scalars['Int']
	limit: Scalars['Int']
	where?: InputMaybe<ComponentVarsFilter>
}>

export type ComponentVarsQuery = {
	__typename?: 'Query'
	componentVars: {
		__typename?: 'ComponentVarsPagination'
		nodes?: Array<{
			__typename?: 'ComponentVar'
			id: number
			name?: string | null
			templateKey?: string | null
			type?: DeviceValueType | null
		}> | null
	}
}

export type DeleteTemplateMutationVariables = Exact<{
	input: DeleteTemplateInput
}>

export type DeleteTemplateMutation = {
	__typename?: 'Mutation'
	deleteTemplate: {
		__typename?: 'DeleteResponse'
		affected?: number | null
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type DeleteTemplateVariantMutationVariables = Exact<{
	input: DeleteTemplateVariantInput
}>

export type DeleteTemplateVariantMutation = {
	__typename?: 'Mutation'
	deleteTemplateVariant: {
		__typename?: 'DeleteResponse'
		affected?: number | null
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type DeleteTemplatesMutationVariables = Exact<{
	input: DeleteTemplatesInput
}>

export type DeleteTemplatesMutation = {
	__typename?: 'Mutation'
	deleteTemplates: {
		__typename?: 'DeleteResponse'
		affected?: number | null
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type DisplayTemplateQueryVariables = Exact<{
	id: Scalars['Int']
}>

export type DisplayTemplateQuery = {
	__typename?: 'Query'
	template: {
		__typename?: 'TemplateResponse'
		template?: {
			__typename?: 'Template'
			id: number
			deviceSize?: TemplateType | null
			isCustom?: boolean | null
			name?: string | null
			width?: number | null
			height?: number | null
			templateVariant?: {
				__typename?: 'TemplateVariant'
				id: number
				key: string
				name?: string | null
				isDefault: boolean
			} | null
			landingTemplate?: {
				__typename?: 'LandingTemplate'
				id: number
				key: string
				name: string
			} | null
			components?: Array<{
				__typename?: 'Component'
				id: number
				name?: string | null
				w?: number | null
				h?: number | null
				x?: number | null
				y?: number | null
				htmlContent?: string | null
				type?: ComponentType | null
			}> | null
			templateVariables?: Array<{
				__typename?: 'ComponentVar'
				id: number
				name?: string | null
				maxLength?: number | null
				templateKey?: string | null
			}> | null
		} | null
	}
}

export type DisplayTemplatesQueryVariables = Exact<{
	offset: Scalars['Int']
	limit: Scalars['Int']
	where?: InputMaybe<TemplatesFilter>
}>

export type DisplayTemplatesQuery = {
	__typename?: 'Query'
	templates: {
		__typename?: 'TemplatesPagination'
		totalCount: number
		nodes?: Array<{
			__typename?: 'Template'
			id: number
			deviceSize?: TemplateType | null
			name?: string | null
			height?: number | null
			width?: number | null
			templateVariant?: {
				__typename?: 'TemplateVariant'
				id: number
				key: string
				name?: string | null
			} | null
		}> | null
	}
}

export type EditTemplateMutationVariables = Exact<{
	templateId: Scalars['Int']
	input: EditTemplateInput
}>

export type EditTemplateMutation = {
	__typename?: 'Mutation'
	editTemplate: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditTemplateVariantMutationVariables = Exact<{
	templateVariantId: Scalars['Int']
	input: EditTemplateVariantInput
}>

export type EditTemplateVariantMutation = {
	__typename?: 'Mutation'
	editTemplateVariant: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type ParseTemplateQueryVariables = Exact<{
	templateId: Scalars['Int']
	productId: Scalars['Int']
}>

export type ParseTemplateQuery = {
	__typename?: 'Query'
	parseTemplate: {
		__typename?: 'ParseTemplateResponse'
		template?: string | null
		errors?: Array<{
			__typename?: 'Error'
			message: string
			path: string
		}> | null
	}
}

export type TemplateVariantQueryVariables = Exact<{
	id: Scalars['Int']
}>

export type TemplateVariantQuery = {
	__typename?: 'Query'
	templateVariant: {
		__typename?: 'TemplateVariantResponse'
		templateVariant?: {
			__typename?: 'TemplateVariant'
			id: number
			name?: string | null
			key: string
			isActive: boolean
			orbisType?: OrbisType | null
			marketIDs?: Array<number> | null
		} | null
	}
}

export type TemplateVariantSupportsRotatedQueryVariables = Exact<{
	templateVariantId: Scalars['Int']
	deviceSize: DeviceSize
}>

export type TemplateVariantSupportsRotatedQuery = {
	__typename?: 'Query'
	templateVariantSupportsRotated?: boolean | null
}

export type TemplateVariantSupportsSplitQueryVariables = Exact<{
	templateVariantId: Scalars['Int']
	deviceSize: DeviceSize
}>

export type TemplateVariantSupportsSplitQuery = {
	__typename?: 'Query'
	templateVariantSupportsSplit?: boolean | null
}

export type TemplateVariantTemplateTypesQueryVariables = Exact<{
	templateVariantId: Scalars['Int']
}>

export type TemplateVariantTemplateTypesQuery = {
	__typename?: 'Query'
	templateVariantTemplateTypes?: Array<TemplateType> | null
}

export type TemplateVariantsQueryVariables = Exact<{
	where?: InputMaybe<TemplateVariantsFilter>
	limit: Scalars['Int']
	offset: Scalars['Int']
}>

export type TemplateVariantsQuery = {
	__typename?: 'Query'
	templateVariants: {
		__typename?: 'TemplateVariantsPagination'
		totalCount: number
		nodes?: Array<{
			__typename?: 'TemplateVariant'
			id: number
			name?: string | null
			key: string
			orbisType?: OrbisType | null
			isDefault: boolean
			inUse?: boolean | null
			isActive: boolean
			marketIDs?: Array<number> | null
			templates?: Array<{
				__typename?: 'Template'
				id: number
				deviceSize?: TemplateType | null
				name?: string | null
				height?: number | null
				width?: number | null
				isCustom?: boolean | null
			}> | null
		}> | null
	}
}

export type AddFlowMutationVariables = Exact<{
	input: AddFlowInput
}>

export type AddFlowMutation = {
	__typename?: 'Mutation'
	addFlow: {
		__typename?: 'AddFlowResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		flow?: { __typename?: 'Flow'; id: number; name?: string | null } | null
	}
}

export type DeleteFlowMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteFlowMutation = {
	__typename?: 'Mutation'
	deleteFlow: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditFlowMutationVariables = Exact<{
	id: Scalars['Int']
	input: EditFlowInput
}>

export type EditFlowMutation = {
	__typename?: 'Mutation'
	editFlow: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type FlowQueryVariables = Exact<{
	flowId: Scalars['Int']
}>

export type FlowQuery = {
	__typename?: 'Query'
	flow: {
		__typename?: 'FlowResponse'
		flow?: {
			__typename?: 'Flow'
			id: number
			name?: string | null
			validFrom?: any | null
			validTo?: any | null
			isDone: boolean
			flowStatements?: Array<{
				__typename?: 'FlowStatement'
				id: number
				type: FlowStatementType
				flowComponents?: Array<{
					__typename?: 'FlowComponent'
					type: FlowComponentType
					value?: string | null
				}> | null
				products?: Array<{
					__typename?: 'FlowProduct'
					id: number
					product?: {
						__typename?: 'Product'
						name?: string | null
						internalId: string
						marketId?: number | null
						valueEntities?: Array<{
							__typename?: 'Value'
							templateKey: string
							value: string
							rootId?: number | null
							root?: {
								__typename?: 'Root'
								name?: string | null
							} | null
						}> | null
					} | null
					valueEntities?: Array<{
						__typename?: 'FlowValueEntity'
						templateKey: string
						initialValue: string
						value: string
						rootId?: number | null
						root?: {
							__typename?: 'Root'
							name?: string | null
						} | null
					}> | null
				}> | null
			}> | null
		} | null
	}
}

export type FlowsQueryVariables = Exact<{
	where?: InputMaybe<FlowsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type FlowsQuery = {
	__typename?: 'Query'
	flows: {
		__typename?: 'FlowsPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'Flow'
			id: number
			name?: string | null
			validFrom?: any | null
			validTo?: any | null
			flowStatements?: Array<{
				__typename?: 'FlowStatement'
				id: number
				type: FlowStatementType
				flowComponents?: Array<{
					__typename?: 'FlowComponent'
					type: FlowComponentType
					value?: string | null
				}> | null
			}> | null
		}>
	}
}

export type HasFlowsQueryVariables = Exact<{
	productId: Scalars['Int']
}>

export type HasFlowsQuery = { __typename?: 'Query'; hasFlows: Array<number> }

export type InfoQueryVariables = Exact<{ [key: string]: never }>

export type InfoQuery = {
	__typename?: 'Query'
	info?: {
		__typename?: 'InfoResponse'
		tenant: string
		smartLabelCount?: number | null
		orbisLabelCount?: number | null
		sensorLabelCount?: number | null
		shelfBarCount?: number | null
		signageDeviceCount?: number | null
		industrialScaleCount?: number | null
		rootCount?: number | null
		routerCount?: number | null
		hasLocationCoordinates?: boolean | null
	} | null
}

export type InfoAttentionQueryVariables = Exact<{ [key: string]: never }>

export type InfoAttentionQuery = {
	__typename?: 'Query'
	info?: {
		__typename?: 'InfoResponse'
		batteryUnderCount?: number | null
		deviceProcessingCount?: number | null
		deviceErrCount?: number | null
	} | null
}

export type InfoAttentionInfrastructureQueryVariables = Exact<{
	[key: string]: never
}>

export type InfoAttentionInfrastructureQuery = {
	__typename?: 'Query'
	info?: { __typename?: 'InfoResponse'; routerOffline?: number | null } | null
}

export type InfoAttentionOrbisQueryVariables = Exact<{ [key: string]: never }>

export type InfoAttentionOrbisQuery = {
	__typename?: 'Query'
	info?: {
		__typename?: 'InfoResponse'
		orbisBatteryUnderCount?: number | null
		orbisDeviceProcessingCount?: number | null
		orbisDeviceErrCount?: number | null
	} | null
}

export type InfoAttentionScalesQueryVariables = Exact<{ [key: string]: never }>

export type InfoAttentionScalesQuery = {
	__typename?: 'Query'
	info?: {
		__typename?: 'InfoResponse'
		scaleBatteryUnderCount?: number | null
		scaleDeviceProcessingCount?: number | null
		scaleDeviceErrCount?: number | null
	} | null
}

export type AddIntegrationMutationVariables = Exact<{
	input: AddIntegrationInput
}>

export type AddIntegrationMutation = {
	__typename?: 'Mutation'
	addIntegration: {
		__typename?: 'AddIntegrationResponse'
		integration?: { __typename?: 'Integration'; id: number } | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		} | null> | null
	}
}

export type DeleteIntegrationMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteIntegrationMutation = {
	__typename?: 'Mutation'
	deleteIntegration: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditIntegrationMutationVariables = Exact<{
	input: EditIntegrationInput
}>

export type EditIntegrationMutation = {
	__typename?: 'Mutation'
	editIntegration: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type IntegrationQueryVariables = Exact<{
	id?: InputMaybe<Scalars['Int']>
	token?: InputMaybe<Scalars['String']>
}>

export type IntegrationQuery = {
	__typename?: 'Query'
	integration: {
		__typename?: 'IntegrationResponse'
		integration?: {
			__typename?: 'Integration'
			id: number
			name?: string | null
			token: string
			syncTime?: string | null
			weekDays?: Array<WeekDay> | null
			triggerUrl?: string | null
			cronUpdateUrl?: string | null
			preset?: CronPreset | null
			cron?: string | null
		} | null
	}
}

export type IntegrationsQueryVariables = Exact<{
	where?: InputMaybe<IntegrationsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type IntegrationsQuery = {
	__typename?: 'Query'
	integrations: {
		__typename?: 'IntegrationsPagination'
		nodes?: Array<{
			__typename?: 'Integration'
			id: number
			name?: string | null
		}> | null
	}
}

export type SynchronizationsQueryVariables = Exact<{
	where?: InputMaybe<SynchronizationsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type SynchronizationsQuery = {
	__typename?: 'Query'
	synchronizations: {
		__typename?: 'SynchronizationsPagination'
		totalCount: number
		nodes?: Array<{
			__typename?: 'Synchronization'
			id: number
			status: SynchronizationStatus
			time: any
			note?: string | null
			updatedProducts: Array<string>
		}> | null
	}
}

export type TriggerSyncMutationVariables = Exact<{
	input: TriggerSyncInput
}>

export type TriggerSyncMutation = {
	__typename?: 'Mutation'
	triggerSync: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type AddLandingTemplateMutationVariables = Exact<{
	input: LandingTemplateInput
}>

export type AddLandingTemplateMutation = {
	__typename?: 'Mutation'
	addLandingTemplate: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type DeleteLandingTemplateMutationVariables = Exact<{
	input: DeleteLandingTemplateInput
}>

export type DeleteLandingTemplateMutation = {
	__typename?: 'Mutation'
	deleteLandingTemplate: {
		__typename?: 'DeleteResponse'
		affected?: number | null
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditLandingTemplateMutationVariables = Exact<{
	landingTemplateId: Scalars['Int']
	input: EditLandingTemplateInput
}>

export type EditLandingTemplateMutation = {
	__typename?: 'Mutation'
	editLandingTemplate: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type LandingTemplateQueryVariables = Exact<{
	id: Scalars['Int']
}>

export type LandingTemplateQuery = {
	__typename?: 'Query'
	landingTemplate: {
		__typename?: 'LandingTemplateResponse'
		landingTemplate?: {
			__typename?: 'LandingTemplate'
			id: number
			name: string
			key: string
			isCustom?: boolean | null
			width?: number | null
			height?: number | null
			components?: Array<{
				__typename?: 'Component'
				id: number
				name?: string | null
				w?: number | null
				h?: number | null
				x?: number | null
				y?: number | null
				htmlContent?: string | null
				type?: ComponentType | null
			}> | null
		} | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type LandingTemplatesQueryVariables = Exact<{
	offset: Scalars['Int']
	limit: Scalars['Int']
	where?: InputMaybe<LandingTemplatesFilter>
}>

export type LandingTemplatesQuery = {
	__typename?: 'Query'
	landingTemplates: {
		__typename?: 'LandingTemplatesPagination'
		totalCount: number
		nodes?: Array<{
			__typename?: 'LandingTemplate'
			id: number
			name: string
			key: string
			height?: number | null
			width?: number | null
			inUse?: boolean | null
			isCustom?: boolean | null
		}> | null
	}
}

export type AuditLogsQueryVariables = Exact<{
	where?: InputMaybe<AuditLogsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type AuditLogsQuery = {
	__typename?: 'Query'
	auditLogs: {
		__typename?: 'AuditLogsPagination'
		totalCount: number
		nodes: Array<{
			__typename?: 'AuditLog'
			id: number
			createdAt: any
			authorId?: number | null
			authorType: string
			event: string
			entityId: string
			entityType: string
			entityBefore?: string | null
			entityAfter?: string | null
			author?: {
				__typename?: 'User'
				id: number
				email?: string | null
				firstName?: string | null
				lastName?: string | null
				username?: string | null
			} | null
		}>
	}
}

export type EditDemoScreenMutationVariables = Exact<{
	input: EditDemoScreenInput
}>

export type EditDemoScreenMutation = {
	__typename?: 'Mutation'
	editDemoScreen: {
		__typename?: 'DemoScreenResponse'
		success: boolean
		filename?: string | null
	}
}

export type AddCalendarMutationVariables = Exact<{
	input: AddCalendarInput
}>

export type AddCalendarMutation = {
	__typename?: 'Mutation'
	addCalendar: {
		__typename?: 'AddCalendarResponse'
		success: boolean
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		calendar?: { __typename?: 'Calendar'; id: number } | null
	}
}

export type CalendarQueryVariables = Exact<{
	id: Scalars['Int']
}>

export type CalendarQuery = {
	__typename?: 'Query'
	calendar: {
		__typename?: 'CalendarResponse'
		calendar?: {
			__typename?: 'Calendar'
			id: number
			calendarName?: string | null
			userUuid?: string | null
			calendarId?: string | null
			email: string
			calendarType: CalendarType
			calendarProvider: CalendarProvider
			taskListName?: string | null
			taskListId?: string | null
			templateVariantId?: number | null
			templateVariant?: {
				__typename?: 'TemplateVariant'
				id: number
				key: string
				name?: string | null
			} | null
			product: {
				__typename?: 'Product'
				id: number
				name?: string | null
				valueEntities?: Array<{
					__typename?: 'Value'
					id: number
					templateKey: string
					type?: DeviceValueType | null
					value: string
					rootId?: number | null
				}> | null
				devices?: Array<{
					__typename?: 'Device'
					id: number
					serialNumber: string
					name?: string | null
					size?: DeviceSize | null
					deviceType?: DeviceType | null
					lastTransactionStatus?: TransactionStage | null
					lastSeen?: any | null
					deviceMode?: DeviceMode | null
					firmwareVersion?: string | null
					softwareVersion?: string | null
					screenType?: string | null
					rotated?: boolean | null
					routerId?: number | null
					batteryLevel?: number | null
					batteryCharging?: boolean | null
					batteryError?: boolean | null
					active?: boolean | null
					rssi?: number | null
					lastSync?: string | null
					router?: {
						__typename?: 'Router'
						id: number
						name?: string | null
					} | null
					root?: {
						__typename?: 'Root'
						id: number
						name?: string | null
						routers?: Array<{
							__typename?: 'Router'
							id: number
							name?: string | null
						}> | null
					} | null
					config?: {
						__typename?: 'DeviceConfig'
						id: number
						sleepTime?: number | null
						awakeTime?: number | null
						highPowerMode: boolean
					} | null
					lastConfigTransaction?: {
						__typename?: 'Transaction'
						stage?: TransactionStage | null
						ts?: string | null
					} | null
					product?: {
						__typename?: 'Product'
						name?: string | null
						internalId: string
						parentProduct?: {
							__typename?: 'Product'
							name?: string | null
						} | null
					} | null
					product2nd?: {
						__typename?: 'Product'
						name?: string | null
						internalId: string
						parentProduct?: {
							__typename?: 'Product'
							name?: string | null
						} | null
					} | null
				}> | null
			}
		} | null
	}
}

export type CalendarsQueryVariables = Exact<{
	where?: InputMaybe<CalendarsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type CalendarsQuery = {
	__typename?: 'Query'
	calendars: {
		__typename?: 'CalendarsPaginations'
		nodes: Array<{
			__typename?: 'Calendar'
			id: number
			userUuid?: string | null
			calendarId?: string | null
			email: string
			calendarType: CalendarType
			calendarProvider: CalendarProvider
			product: {
				__typename?: 'Product'
				id: number
				name?: string | null
				valueEntities?: Array<{
					__typename?: 'Value'
					id: number
					templateKey: string
					type?: DeviceValueType | null
					value: string
					rootId?: number | null
				}> | null
				devices?: Array<{
					__typename?: 'Device'
					id: number
					serialNumber: string
					active?: boolean | null
					lastTransactionStatus?: TransactionStage | null
				}> | null
			}
		}>
	}
}

export type DeleteOrbisDeviceMutationVariables = Exact<{
	deviceId: Scalars['Int']
}>

export type DeleteOrbisDeviceMutation = {
	__typename?: 'Mutation'
	deleteOrbisDevice: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type DeleteCalendarMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteCalendarMutation = {
	__typename?: 'Mutation'
	deleteCalendar: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			message: string
			path: string
		}> | null
	}
}

export type EditCalendarMutationVariables = Exact<{
	input: EditCalendarInput
}>

export type EditCalendarMutation = {
	__typename?: 'Mutation'
	editCalendar: {
		__typename?: 'EditCalendarResponse'
		success: boolean
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type OrbisProductsQueryVariables = Exact<{
	where?: InputMaybe<ProductsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type OrbisProductsQuery = {
	__typename?: 'Query'
	products: {
		__typename?: 'ProductsPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'Product'
			id: number
			name?: string | null
			internalId: string
			valueEntities?: Array<{
				__typename?: 'Value'
				templateKey: string
				value: string
			}> | null
			products?: Array<{
				__typename?: 'Product'
				id: number
				internalId: string
				name?: string | null
				valueEntities?: Array<{
					__typename?: 'Value'
					templateKey: string
					value: string
				}> | null
				root?: {
					__typename?: 'Root'
					id: number
					name?: string | null
				} | null
				supplier?: {
					__typename?: 'Supplier'
					id: number
					companyName: string
					supplierId?: string | null
				} | null
				positions?: Array<{
					__typename?: 'Position'
					id: number
					sequence?: number | null
					shelf?: {
						__typename?: 'Shelf'
						key: string
						bay?: {
							__typename?: 'Bay'
							key: string
							aisle?: { __typename?: 'Aisle'; key: string } | null
						} | null
					} | null
				} | null> | null
			}> | null
			productImages?: Array<{
				__typename?: 'ProductImage'
				id: number
				file: { __typename?: 'File'; thumbnail?: string | null }
			} | null> | null
		}>
	}
}

export type AddAisleMutationVariables = Exact<{
	input: IsleInput
}>

export type AddAisleMutation = {
	__typename?: 'Mutation'
	addAisle: {
		__typename?: 'AisleResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		} | null> | null
	}
}

export type AisleQueryVariables = Exact<{
	aisleId: Scalars['Int']
}>

export type AisleQuery = {
	__typename?: 'Query'
	aisle: {
		__typename?: 'AisleResponse'
		aisle?: {
			__typename?: 'Aisle'
			id: number
			key: string
			root?: { __typename?: 'Root'; id: number } | null
		} | null
	}
}

export type AisleVisualQueryVariables = Exact<{
	aisleId: Scalars['Int']
}>

export type AisleVisualQuery = {
	__typename?: 'Query'
	aisle: {
		__typename?: 'AisleResponse'
		aisle?: {
			__typename?: 'Aisle'
			id: number
			key: string
			height?: number | null
			bays?: Array<{
				__typename?: 'Bay'
				id: number
				key: string
				width?: number | null
				sequence?: number | null
				shelves?: Array<{
					__typename?: 'Shelf'
					id: number
					key: string
					sequence?: number | null
					positions?: Array<{
						__typename?: 'Position'
						id: number
						key?: string | null
						sequence?: number | null
					}> | null
				}> | null
			}> | null
		} | null
	}
}

export type AislesQueryVariables = Exact<{
	where?: InputMaybe<IslesFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type AislesQuery = {
	__typename?: 'Query'
	aisles: {
		__typename?: 'IslesPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'Aisle'
			id: number
			key: string
			bays?: Array<{
				__typename?: 'Bay'
				id: number
				key: string
				shelves?: Array<{
					__typename?: 'Shelf'
					id: number
					key: string
					positions?: Array<{
						__typename?: 'Position'
						id: number
					}> | null
				}> | null
			}> | null
		}>
	}
}

export type AislesVisualQueryVariables = Exact<{
	where?: InputMaybe<IslesFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type AislesVisualQuery = {
	__typename?: 'Query'
	aisles: {
		__typename?: 'IslesPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'Aisle'
			id: number
			key: string
			width?: number | null
			height?: number | null
			depth?: number | null
			x?: number | null
			y?: number | null
			bays?: Array<{
				__typename?: 'Bay'
				id: number
				key: string
				width?: number | null
				sequence?: number | null
			}> | null
		}>
	}
}

export type DeleteAisleMutationVariables = Exact<{
	input: DeleteAisleInput
}>

export type DeleteAisleMutation = {
	__typename?: 'Mutation'
	deleteAisle: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditAisleMutationVariables = Exact<{
	aisleId: Scalars['Int']
	input: EditAisleInput
}>

export type EditAisleMutation = {
	__typename?: 'Mutation'
	editAisle: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type AddBayMutationVariables = Exact<{
	input: BayInput
}>

export type AddBayMutation = {
	__typename?: 'Mutation'
	addBay: {
		__typename?: 'BayResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		} | null> | null
	}
}

export type BayQueryVariables = Exact<{
	bayId: Scalars['Int']
}>

export type BayQuery = {
	__typename?: 'Query'
	bay: {
		__typename?: 'BayResponse'
		bay?: {
			__typename?: 'Bay'
			id: number
			key: string
			aisle?: { __typename?: 'Aisle'; id: number; key: string } | null
		} | null
	}
}

export type BaysQueryVariables = Exact<{
	where?: InputMaybe<BaysFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type BaysQuery = {
	__typename?: 'Query'
	bays: {
		__typename?: 'baysPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'Bay'
			id: number
			key: string
			aisle?: { __typename?: 'Aisle'; id: number; key: string } | null
		}>
	}
}

export type DeleteBayMutationVariables = Exact<{
	input: DeleteBayInput
}>

export type DeleteBayMutation = {
	__typename?: 'Mutation'
	deleteBay: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditBayMutationVariables = Exact<{
	bayId: Scalars['Int']
	input: EditBayInput
}>

export type EditBayMutation = {
	__typename?: 'Mutation'
	editBay: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type PlanogramRootQueryVariables = Exact<{
	rootId: Scalars['Int']
}>

export type PlanogramRootQuery = {
	__typename?: 'Query'
	root: {
		__typename?: 'RootResponse'
		root?: { __typename?: 'Root'; name?: string | null } | null
	}
}

export type AddPositionMutationVariables = Exact<{
	input: PositionInput
}>

export type AddPositionMutation = {
	__typename?: 'Mutation'
	addPosition: {
		__typename?: 'PositionResponse'
		success?: boolean | null
		errors?: Array<{ __typename?: 'Error'; message: string } | null> | null
	}
}

export type DeletePositionMutationVariables = Exact<{
	positionId: Scalars['Int']
}>

export type DeletePositionMutation = {
	__typename?: 'Mutation'
	deletePosition: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{ __typename?: 'Error'; message: string }> | null
	}
}

export type DeletePositionAndUntieDeviceMutationVariables = Exact<{
	positionId: Scalars['Int']
}>

export type DeletePositionAndUntieDeviceMutation = {
	__typename?: 'Mutation'
	deletePositionAndUntieDevice: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{ __typename?: 'Error'; message: string }> | null
	}
}

export type EditPositionMutationVariables = Exact<{
	positionId: Scalars['Int']
	input: EditPositionInput
}>

export type EditPositionMutation = {
	__typename?: 'Mutation'
	editPosition: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			message: string
			path: string
		}> | null
	}
}

export type EditPositionOldPositionMutationVariables = Exact<{
	positionId: Scalars['Int']
	positionInput: EditPositionInput
	oldPositionId: Scalars['Int']
	oldPositionInput: EditPositionInput
}>

export type EditPositionOldPositionMutation = {
	__typename?: 'Mutation'
	A: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			message: string
			path: string
		}> | null
	}
	B: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			message: string
			path: string
		}> | null
	}
}

export type PlanogramPositionQueryVariables = Exact<{
	positionId: Scalars['Int']
}>

export type PlanogramPositionQuery = {
	__typename?: 'Query'
	position: {
		__typename?: 'PositionResponse'
		position?: {
			__typename?: 'Position'
			id: number
			key?: string | null
			sequence?: number | null
			x?: number | null
			y?: number | null
			z?: number | null
			shelf?: {
				__typename?: 'Shelf'
				id: number
				key: string
				bay?: {
					__typename?: 'Bay'
					key: string
					aisle?: { __typename?: 'Aisle'; key: string } | null
				} | null
			} | null
			product?: {
				__typename?: 'Product'
				id: number
				internalId: string
				name?: string | null
				parentProduct?: {
					__typename?: 'Product'
					name?: string | null
				} | null
			} | null
			root?: {
				__typename?: 'Root'
				id: number
				market?: { __typename?: 'Market'; id: number } | null
			} | null
			device?: {
				__typename?: 'Device'
				id: number
				serialNumber: string
				size?: DeviceSize | null
				product?: {
					__typename?: 'Product'
					id: number
					internalId: string
					name?: string | null
					parentProduct?: {
						__typename?: 'Product'
						name?: string | null
					} | null
				} | null
			} | null
			templateVariant?: {
				__typename?: 'TemplateVariant'
				id: number
			} | null
		} | null
	}
}

export type PlanogramPositionsQueryVariables = Exact<{
	where?: InputMaybe<PositionsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type PlanogramPositionsQuery = {
	__typename?: 'Query'
	positions: {
		__typename?: 'PositionsPaginations'
		nodes: Array<{
			__typename?: 'Position'
			id: number
			key?: string | null
			sequence?: number | null
			shelf?: {
				__typename?: 'Shelf'
				key: string
				bay?: {
					__typename?: 'Bay'
					key: string
					aisle?: { __typename?: 'Aisle'; key: string } | null
				} | null
			} | null
			device?: {
				__typename?: 'Device'
				id: number
				serialNumber: string
			} | null
			templateVariant?: {
				__typename?: 'TemplateVariant'
				id: number
				key: string
			} | null
			product?: {
				__typename?: 'Product'
				id: number
				internalId: string
				name?: string | null
				parentProduct?: {
					__typename?: 'Product'
					id: number
					name?: string | null
				} | null
			} | null
		}>
	}
}

export type AddShelfMutationVariables = Exact<{
	input: ShelfInput
}>

export type AddShelfMutation = {
	__typename?: 'Mutation'
	addShelf: {
		__typename?: 'ShelfResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		} | null> | null
	}
}

export type AddShelfStructMutationVariables = Exact<{
	input: ShelfStructInput
}>

export type AddShelfStructMutation = {
	__typename?: 'Mutation'
	addShelfStruct: {
		__typename?: 'ShelfStructResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type DeleteShelfMutationVariables = Exact<{
	input: DeleteShelfInput
}>

export type DeleteShelfMutation = {
	__typename?: 'Mutation'
	deleteShelf: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditShelfMutationVariables = Exact<{
	shelfId: Scalars['Int']
	input: EditShelfInput
}>

export type EditShelfMutation = {
	__typename?: 'Mutation'
	editShelf: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type ShelfQueryVariables = Exact<{
	shelfId: Scalars['Int']
}>

export type ShelfQuery = {
	__typename?: 'Query'
	shelf: {
		__typename?: 'ShelfResponse'
		shelf?: {
			__typename?: 'Shelf'
			id: number
			key: string
			bay?: {
				__typename?: 'Bay'
				id: number
				key: string
				aisle?: { __typename?: 'Aisle'; id: number; key: string } | null
			} | null
			root?: { __typename?: 'Root'; id: number } | null
			positions?: Array<{
				__typename?: 'Position'
				id: number
				name?: string | null
				sequence?: number | null
				product?: {
					__typename?: 'Product'
					id: number
					internalId: string
					name?: string | null
					parentProduct?: {
						__typename?: 'Product'
						name?: string | null
					} | null
				} | null
				device?: {
					__typename?: 'Device'
					id: number
					serialNumber: string
				} | null
				root?: { __typename?: 'Root'; id: number } | null
			}> | null
		} | null
	}
}

export type ShelvesQueryVariables = Exact<{
	where?: InputMaybe<ShelvesFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type ShelvesQuery = {
	__typename?: 'Query'
	shelves: {
		__typename?: 'shelvesPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'Shelf'
			id: number
			key: string
			bay?: {
				__typename?: 'Bay'
				key: string
				aisle?: { __typename?: 'Aisle'; key: string } | null
			} | null
		}>
	}
}

export type StockPlanogramPositionsQueryVariables = Exact<{
	where?: InputMaybe<PositionsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type StockPlanogramPositionsQuery = {
	__typename?: 'Query'
	positions: {
		__typename?: 'PositionsPaginations'
		nodes: Array<{
			__typename?: 'Position'
			id: number
			key?: string | null
			sequence?: number | null
			device?: {
				__typename?: 'Device'
				id: number
				serialNumber: string
			} | null
			templateVariant?: {
				__typename?: 'TemplateVariant'
				id: number
				key: string
			} | null
			product?: {
				__typename?: 'Product'
				id: number
				internalId: string
				parentProduct?: {
					__typename?: 'Product'
					id: number
					name?: string | null
				} | null
			} | null
		}>
	}
}

export type AddPlaylistMutationVariables = Exact<{
	input: AddPlaylistInput
}>

export type AddPlaylistMutation = {
	__typename?: 'Mutation'
	addPlaylist: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type DeletePlaylistMutationVariables = Exact<{
	playlistId: Scalars['Int']
}>

export type DeletePlaylistMutation = {
	__typename?: 'Mutation'
	deletePlaylist: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditChannelMutationVariables = Exact<{
	channelId: Scalars['Int']
	input: EditChannelInput
}>

export type EditChannelMutation = {
	__typename?: 'Mutation'
	editChannel: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type PlaylistQueryVariables = Exact<{
	playlistId: Scalars['Int']
}>

export type PlaylistQuery = {
	__typename?: 'Query'
	playlist: {
		__typename?: 'PlaylistResponse'
		playlist?: {
			__typename?: 'Playlist'
			id: number
			name: string
			playlistItems: Array<{
				__typename?: 'PlaylistItem'
				id: number
				duration: number
				sequence?: number | null
				file?: {
					__typename?: 'File'
					id: number
					duration?: number | null
					encoding?: string | null
					mimetype?: string | null
					filename?: string | null
					originalname?: string | null
					thumbnail?: string | null
				} | null
			}>
		} | null
	}
}

export type PlaylistsQueryVariables = Exact<{
	where?: InputMaybe<PlaylistsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type PlaylistsQuery = {
	__typename?: 'Query'
	playlists: {
		__typename?: 'PlaylistsPagination'
		totalCount: number
		nodes?: Array<{
			__typename?: 'Playlist'
			id: number
			name: string
		}> | null
	}
}

export type PlaylistsWithItemsQueryVariables = Exact<{
	where?: InputMaybe<PlaylistsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type PlaylistsWithItemsQuery = {
	__typename?: 'Query'
	playlists: {
		__typename?: 'PlaylistsPagination'
		totalCount: number
		nodes?: Array<{
			__typename?: 'Playlist'
			id: number
			name: string
			playlistItems: Array<{
				__typename?: 'PlaylistItem'
				duration: number
				file?: {
					__typename?: 'File'
					mimetype?: string | null
					filename?: string | null
					thumbnail?: string | null
				} | null
			}>
		}> | null
	}
}

export type AddEditProductsMutationVariables = Exact<{
	input: Array<ProductInput> | ProductInput
}>

export type AddEditProductsMutation = {
	__typename?: 'Mutation'
	addEditProducts: {
		__typename?: 'addEditProductsResponse'
		success?: boolean | null
		isAssignedToShelves?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		addedProducts?: Array<{
			__typename?: 'Product'
			id: number
			internalId: string
			name?: string | null
			eanCodes?: Array<string> | null
			valueEntities?: Array<{
				__typename?: 'Value'
				id: number
				name?: string | null
				templateKey: string
				type?: DeviceValueType | null
				value: string
			}> | null
			productImages?: Array<{
				__typename?: 'ProductImage'
				id: number
				primary: boolean
				file: {
					__typename?: 'File'
					id: number
					originalname?: string | null
					filename?: string | null
					mimetype?: string | null
					encoding?: string | null
					url?: string | null
					isFolder: boolean
					width?: number | null
					height?: number | null
					thumbnail?: string | null
				}
			} | null> | null
		}> | null
	}
}

export type AddProductMutationVariables = Exact<{
	input: ProductInput
}>

export type AddProductMutation = {
	__typename?: 'Mutation'
	addProduct: {
		__typename?: 'AddProductResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		product?: { __typename?: 'Product'; id: number } | null
	}
}

export type DeleteProductMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteProductMutation = {
	__typename?: 'Mutation'
	deleteProduct: {
		__typename?: 'DeleteProductResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			message: string
			path: string
		}> | null
	}
}

export type DeleteProductsMutationVariables = Exact<{
	input: DeleteProductInput
}>

export type DeleteProductsMutation = {
	__typename?: 'Mutation'
	deleteProducts: {
		__typename?: 'DeleteResponse'
		affected?: number | null
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			message: string
			path: string
		}> | null
	}
}

export type DeleteValueEntitiesMutationVariables = Exact<{
	ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>
}>

export type DeleteValueEntitiesMutation = {
	__typename?: 'Mutation'
	deleteValueEntities: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			message: string
			path: string
		}> | null
	}
}

export type EditProductMutationVariables = Exact<{
	input: EditProductInput
}>

export type EditProductMutation = {
	__typename?: 'Mutation'
	editProduct: {
		__typename?: 'EditProductResponse'
		success?: boolean | null
		isAssignedToShelves?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type ProductDetailsQueryVariables = Exact<{
	id: Scalars['Int']
}>

export type ProductDetailsQuery = {
	__typename?: 'Query'
	product: {
		__typename?: 'ProductResponse'
		product?: {
			__typename?: 'Product'
			id: number
			internalId: string
			name?: string | null
			valueEntities?: Array<{
				__typename?: 'Value'
				id: number
				templateKey: string
				type?: DeviceValueType | null
				value: string
				rootId?: number | null
			}> | null
			parentProduct?: {
				__typename?: 'Product'
				id: number
				internalId: string
			} | null
			products?: Array<{
				__typename?: 'Product'
				id: number
				internalId: string
			}> | null
			market?: {
				__typename?: 'Market'
				id: number
				name?: string | null
			} | null
		} | null
	}
}

export type ProductDetailsListQueryVariables = Exact<{
	where?: InputMaybe<ProductsFilter>
}>

export type ProductDetailsListQuery = {
	__typename?: 'Query'
	products: {
		__typename?: 'ProductsPaginations'
		nodes: Array<{
			__typename?: 'Product'
			id: number
			internalId: string
			name?: string | null
			valueEntities?: Array<{
				__typename?: 'Value'
				name?: string | null
				templateKey: string
				type?: DeviceValueType | null
				value: string
			}> | null
			parentProduct?: {
				__typename?: 'Product'
				id: number
				internalId: string
			} | null
			products?: Array<{
				__typename?: 'Product'
				id: number
				internalId: string
			}> | null
		}>
	}
}

export type ProductExistsQueryVariables = Exact<{
	internalId: Scalars['String']
}>

export type ProductExistsQuery = {
	__typename?: 'Query'
	product: {
		__typename?: 'ProductResponse'
		product?: {
			__typename?: 'Product'
			id: number
			internalId: string
			name?: string | null
		} | null
	}
}

export type ProductMarketQueryVariables = Exact<{
	id: Scalars['Int']
}>

export type ProductMarketQuery = {
	__typename?: 'Query'
	product: {
		__typename?: 'ProductResponse'
		product?: {
			__typename?: 'Product'
			market?: {
				__typename?: 'Market'
				id: number
				name?: string | null
			} | null
		} | null
	}
}

export type ProductUsageReportQueryVariables = Exact<{
	where?: InputMaybe<ProductUsageReportFilter>
	offset?: InputMaybe<Scalars['Int']>
	limit?: InputMaybe<Scalars['Int']>
	withValues?: InputMaybe<Scalars['Boolean']>
}>

export type ProductUsageReportQuery = {
	__typename?: 'Query'
	productUsageReport: {
		__typename?: 'ProductUsageReportResponse'
		totalCount: number
		nodes?: Array<{
			__typename?: 'ProductUsageReportItem'
			serialNumber: string
			productName: string
			internalId: string
			locationName: string
			valueEntities?: Array<{
				__typename?: 'Value'
				id: number
				templateKey: string
				value: string
				rootId?: number | null
				root?: { __typename?: 'Root'; name?: string | null } | null
			}> | null
		}> | null
	}
}

export type ProductsQueryVariables = Exact<{
	where?: InputMaybe<ProductsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type ProductsQuery = {
	__typename?: 'Query'
	products: {
		__typename?: 'ProductsPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'Product'
			id: number
			eanCodes?: Array<string> | null
			internalId: string
			name?: string | null
			productType?: ProductType | null
			productImages?: Array<{
				__typename?: 'ProductImage'
				id: number
				file: {
					__typename?: 'File'
					id: number
					thumbnail?: string | null
				}
			} | null> | null
		}>
	}
}

export type ProductsFlowListQueryVariables = Exact<{
	where?: InputMaybe<ProductsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type ProductsFlowListQuery = {
	__typename?: 'Query'
	products: {
		__typename?: 'ProductsPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'Product'
			id: number
			eanCodes?: Array<string> | null
			internalId: string
			name?: string | null
			productType?: ProductType | null
			marketId?: number | null
			valueEntities?: Array<{
				__typename?: 'Value'
				templateKey: string
				value: string
				rootId?: number | null
				root?: {
					__typename?: 'Root'
					id: number
					name?: string | null
				} | null
			}> | null
		}>
	}
}

export type SearchProductsQueryVariables = Exact<{
	where?: InputMaybe<ProductsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type SearchProductsQuery = {
	__typename?: 'Query'
	products: {
		__typename?: 'ProductsPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'Product'
			id: number
			eanCodes?: Array<string> | null
			internalId: string
			name?: string | null
			parentProduct?: {
				__typename?: 'Product'
				name?: string | null
			} | null
		}>
	}
}

export type AddDeviceAlarmReportMutationVariables = Exact<{
	input: AddDeviceAlarmReportInput
}>

export type AddDeviceAlarmReportMutation = {
	__typename?: 'Mutation'
	addDeviceAlarmReport: {
		__typename?: 'AddDeviceAlarmReportResponse'
		success: boolean
		deviceAlarmReport?: {
			__typename?: 'DeviceAlarmReport'
			id: number
		} | null
	}
}

export type BatchTransactionsQueryVariables = Exact<{
	batchUUID: Scalars['String']
}>

export type BatchTransactionsQuery = {
	__typename?: 'Query'
	batchTransactions?: {
		__typename?: 'TransactionResponse'
		transactions?: Array<{
			__typename?: 'Transaction'
			stage?: TransactionStage | null
			transactionid?: string | null
			ts?: string | null
			device?: {
				__typename?: 'Device'
				size?: DeviceSize | null
				serialNumber: string
				product?: {
					__typename?: 'Product'
					name?: string | null
					internalId: string
				} | null
				template?: {
					__typename?: 'Template'
					templateVariant?: {
						__typename?: 'TemplateVariant'
						key: string
					} | null
				} | null
				root?: { __typename?: 'Root'; name?: string | null } | null
				position?: {
					__typename?: 'Position'
					id: number
					name?: string | null
					key?: string | null
					sequence?: number | null
					shelf?: {
						__typename?: 'Shelf'
						id: number
						key: string
						bay?: {
							__typename?: 'Bay'
							id: number
							key: string
							aisle?: {
								__typename?: 'Aisle'
								id: number
								key: string
							} | null
						} | null
					} | null
				} | null
			} | null
		}> | null
	} | null
}

export type DeleteDeviceAlarmReportMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteDeviceAlarmReportMutation = {
	__typename?: 'Mutation'
	deleteDeviceAlarmReport: {
		__typename?: 'StandardResponse'
		success?: boolean | null
	}
}

export type DeviceAlarmReportQueryVariables = Exact<{
	id: Scalars['Int']
}>

export type DeviceAlarmReportQuery = {
	__typename?: 'Query'
	deviceAlarmReport: {
		__typename?: 'DeviceAlarmReportResponse'
		deviceAlarmReport?: {
			__typename?: 'DeviceAlarmReport'
			id: number
			created: any
			updated: any
			name: string
			days?: Array<DayEnum> | null
			time?: any | null
			batteryPercentage?: number | null
			batteryUnderCount?: boolean | null
			deviceErrCount?: boolean | null
			deviceOffline?: boolean | null
			routerOffline?: boolean | null
			includeAllLocations?: boolean | null
			roots?: Array<{
				__typename?: 'Root'
				id: number
				name?: string | null
			}> | null
			users?: Array<{
				__typename?: 'User'
				id: number
				username?: string | null
			}> | null
		} | null
	}
}

export type DeviceAlarmReportsQueryVariables = Exact<{
	where?: InputMaybe<DeviceAlarmReportsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type DeviceAlarmReportsQuery = {
	__typename?: 'Query'
	deviceAlarmReports: {
		__typename?: 'DeviceAlarmReportsPagination'
		totalCount: number
		nodes: Array<{
			__typename?: 'DeviceAlarmReport'
			id: number
			name: string
			days?: Array<DayEnum> | null
			includeAllLocations?: boolean | null
			batteryPercentage?: number | null
			users?: Array<{
				__typename?: 'User'
				id: number
				username?: string | null
			}> | null
			roots?: Array<{
				__typename?: 'Root'
				id: number
				name?: string | null
			}> | null
		}>
	}
}

export type EditDeviceAlarmReportMutationVariables = Exact<{
	input: EditDeviceAlarmReportInput
}>

export type EditDeviceAlarmReportMutation = {
	__typename?: 'Mutation'
	editDeviceAlarmReport: {
		__typename?: 'EditDeviceAlarmReportResponse'
		success: boolean
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type AddRoleMutationVariables = Exact<{
	input: AddRoleInput
}>

export type AddRoleMutation = {
	__typename?: 'Mutation'
	addRole: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditRolezMutationVariables = Exact<{
	roleId: Scalars['Int']
	input: EditRoleInput
}>

export type EditRolezMutation = {
	__typename?: 'Mutation'
	editRole: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type DeleteRoleMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteRoleMutation = {
	__typename?: 'Mutation'
	deleteRole: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditRoleMutationVariables = Exact<{
	roleId: Scalars['Int']
	input: EditRoleInput
}>

export type EditRoleMutation = {
	__typename?: 'Mutation'
	editRole: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type RoleQueryVariables = Exact<{
	roleId: Scalars['Int']
}>

export type RoleQuery = {
	__typename?: 'Query'
	role: {
		__typename?: 'RoleResponse'
		role?: {
			__typename?: 'Role'
			id: number
			value?: string | null
			permissions: Array<string>
		} | null
	}
}

export type RolesQueryVariables = Exact<{
	where?: InputMaybe<RolesFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type RolesQuery = {
	__typename?: 'Query'
	roles: {
		__typename?: 'RolesPaginations'
		nodes: Array<{ __typename?: 'Role'; id: number; value?: string | null }>
	}
}

export type AddSmartButtonMutationVariables = Exact<{
	input: AddButton
}>

export type AddSmartButtonMutation = {
	__typename?: 'Mutation'
	addButton: {
		__typename?: 'AddButtonResponse'
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		button?: { __typename?: 'Button'; id: number } | null
	}
}

export type DeleteSmartButtonMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteSmartButtonMutation = {
	__typename?: 'Mutation'
	deleteButton: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type DeviceSizesQueryVariables = Exact<{ [key: string]: never }>

export type DeviceSizesQuery = {
	__typename?: 'Query'
	deviceSizes: Array<DeviceSize>
}

export type EditSmartButtonMutationVariables = Exact<{
	input: EditButton
}>

export type EditSmartButtonMutation = {
	__typename?: 'Mutation'
	editButton: {
		__typename?: 'EditButtonResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type AddSignageButtonMutationVariables = Exact<{
	input: AddSignageButton
}>

export type AddSignageButtonMutation = {
	__typename?: 'Mutation'
	addSignageButton: {
		__typename?: 'AddSignageButtonResponse'
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		signageButton?: { __typename?: 'SignageButton'; id: number } | null
	}
}

export type DeleteSignageButtonMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteSignageButtonMutation = {
	__typename?: 'Mutation'
	deleteSignageButton: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditSignageButtonMutationVariables = Exact<{
	input: EditSignageButton
}>

export type EditSignageButtonMutation = {
	__typename?: 'Mutation'
	editSignageButton: {
		__typename?: 'EditSignageButtonResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type SmartButtonQueryVariables = Exact<{
	id: Scalars['Int']
}>

export type SmartButtonQuery = {
	__typename?: 'Query'
	button: {
		__typename?: 'ButtonResponse'
		button?: {
			__typename?: 'Button'
			id: number
			serialNumber: string
			name?: string | null
			rootId: number
			routerId?: number | null
			batteryLevel?: number | null
			active?: boolean | null
			rssi?: number | null
			router?: {
				__typename?: 'Router'
				id: number
				name?: string | null
			} | null
			root: {
				__typename?: 'Root'
				id: number
				name?: string | null
				routers?: Array<{ __typename?: 'Router'; id: number }> | null
			}
		} | null
	}
}

export type SmartButtonsQueryVariables = Exact<{
	where?: InputMaybe<ButtonsFilter>
	limit: Scalars['Int']
	offset: Scalars['Int']
}>

export type SmartButtonsQuery = {
	__typename?: 'Query'
	buttons: {
		__typename?: 'ButtonsPagination'
		totalCount: number
		nodes?: Array<{
			__typename?: 'Button'
			id: number
			serialNumber: string
			name?: string | null
			batteryLevel?: number | null
			active?: boolean | null
			root: { __typename?: 'Root'; name?: string | null }
		}> | null
	}
}

export type ClearDeviceMutationVariables = Exact<{
	deviceId: Scalars['Int']
}>

export type ClearDeviceMutation = {
	__typename?: 'Mutation'
	clearDevice: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type DeleteDeviceMutationVariables = Exact<{
	deviceId: Scalars['Int']
}>

export type DeleteDeviceMutation = {
	__typename?: 'Mutation'
	deleteDevice: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type DeviceQueryVariables = Exact<{
	deviceSerialNumber: Scalars['String']
	deviceSize?: InputMaybe<DeviceSize>
}>

export type DeviceQuery = {
	__typename?: 'Query'
	device: {
		__typename?: 'DeviceResponse'
		device?: {
			__typename?: 'Device'
			id: number
			serialNumber: string
			name?: string | null
			size?: DeviceSize | null
			firmwareVersion?: string | null
			softwareVersion?: string | null
			deviceMode?: DeviceMode | null
			lastSeen?: any | null
			lastTransactionStatus?: TransactionStage | null
			lastSync?: string | null
			batteryLevel?: number | null
			batteryCharging?: boolean | null
			batteryError?: boolean | null
			active?: boolean | null
			rssi?: number | null
			shortPressAction?: ButtonActions | null
			longPressAction?: ButtonActions | null
			shortPressEnabled: boolean
			longPressEnabled: boolean
			deviceType?: DeviceType | null
			rotated?: boolean | null
			routerId?: number | null
			screenType?: string | null
			flipped?: boolean | null
			channelId?: number | null
			config?: {
				__typename?: 'DeviceConfig'
				id: number
				sleepTime?: number | null
				awakeTime?: number | null
				highPowerMode: boolean
				version?: string | null
			} | null
			root?: {
				__typename?: 'Root'
				id: number
				name?: string | null
				routers?: Array<{ __typename?: 'Router'; id: number }> | null
				market?: {
					__typename?: 'Market'
					id: number
					name?: string | null
				} | null
			} | null
			template?: {
				__typename?: 'Template'
				id: number
				name?: string | null
				width?: number | null
				templateVariant?: {
					__typename?: 'TemplateVariant'
					id: number
					key: string
					name?: string | null
				} | null
			} | null
			position?: {
				__typename?: 'Position'
				id: number
				name?: string | null
				key?: string | null
				sequence?: number | null
				templateVariant?: {
					__typename?: 'TemplateVariant'
					id: number
					key: string
					name?: string | null
					supportsSplit?: boolean | null
					supportsRotated?: boolean | null
				} | null
				shelf?: {
					__typename?: 'Shelf'
					id: number
					key: string
					bay?: {
						__typename?: 'Bay'
						id: number
						key: string
						aisle?: {
							__typename?: 'Aisle'
							id: number
							key: string
						} | null
					} | null
				} | null
			} | null
			product?: {
				__typename?: 'Product'
				id: number
				name?: string | null
				internalId: string
				parentProduct?: {
					__typename?: 'Product'
					name?: string | null
				} | null
			} | null
			product2nd?: {
				__typename?: 'Product'
				id: number
				name?: string | null
				internalId: string
				parentProduct?: {
					__typename?: 'Product'
					name?: string | null
				} | null
			} | null
			lastConfigTransaction?: {
				__typename?: 'Transaction'
				stage?: TransactionStage | null
				ts?: string | null
			} | null
			shelf?: {
				__typename?: 'Shelf'
				id: number
				key: string
				bay?: {
					__typename?: 'Bay'
					id: number
					key: string
					aisle?: {
						__typename?: 'Aisle'
						id: number
						key: string
					} | null
				} | null
			} | null
			router?: {
				__typename?: 'Router'
				id: number
				name?: string | null
			} | null
			channel?: {
				__typename?: 'Channel'
				id: number
				name?: string | null
			} | null
		} | null
	}
}

export type AddDeviceConfigMutationVariables = Exact<{
	input: DeviceConfigInput
}>

export type AddDeviceConfigMutation = {
	__typename?: 'Mutation'
	addDeviceConfig: {
		__typename?: 'DeviceConfigResponse'
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		deviceConfig?: { __typename?: 'DeviceConfig'; id: number } | null
	}
}

export type EditDeviceConfigMutationVariables = Exact<{
	input: EditDeviceConfigInput
}>

export type EditDeviceConfigMutation = {
	__typename?: 'Mutation'
	editDeviceConfig: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type DeviceIdsQueryVariables = Exact<{
	where?: InputMaybe<DevicesFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
	order?: InputMaybe<DeviceOrder>
}>

export type DeviceIdsQuery = {
	__typename?: 'Query'
	devices: {
		__typename?: 'DevicesPagination'
		totalCount: number
		nodes?: Array<{ __typename?: 'Device'; id: number }> | null
	}
}

export type DevicePositionsQueryVariables = Exact<{
	where?: InputMaybe<PositionsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type DevicePositionsQuery = {
	__typename?: 'Query'
	positions: {
		__typename?: 'PositionsPaginations'
		nodes: Array<{
			__typename?: 'Position'
			id: number
			key?: string | null
			device?: { __typename?: 'Device'; id: number } | null
		}>
	}
}

export type DevicePreviewQueryVariables = Exact<{
	deviceSerialNumber: Scalars['String']
}>

export type DevicePreviewQuery = {
	__typename?: 'Query'
	devicePreview: {
		__typename?: 'DevicePreviewResponse'
		currentData?: {
			__typename?: 'DevicePreviewData'
			image?: string | null
			flipped?: boolean | null
		} | null
		previewData?: {
			__typename?: 'DevicePreviewData'
			image?: string | null
			flipped?: boolean | null
		} | null
	}
}

export type DeviceSocHistoryQueryVariables = Exact<{
	deviceSerialNumber: Scalars['String']
	from: Scalars['DateTime']
	to?: InputMaybe<Scalars['DateTime']>
}>

export type DeviceSocHistoryQuery = {
	__typename?: 'Query'
	deviceSocHistory: Array<{
		__typename?: 'DeviceSocData'
		timestamp: any
		soc: number
		voltage?: number | null
		charging: boolean
		rssi?: number | null
		routerName?: string | null
	}>
}

export type DeviceTempHistoryQueryVariables = Exact<{
	deviceSerialNumber: Scalars['String']
	from: Scalars['DateTime']
	to?: InputMaybe<Scalars['DateTime']>
}>

export type DeviceTempHistoryQuery = {
	__typename?: 'Query'
	deviceTempHistory: Array<{
		__typename?: 'DeviceTempData'
		timestamp: any
		panelTemp?: number | null
	}>
}

export type DeviceTransactionsQueryVariables = Exact<{
	deviceId: Scalars['Int']
	limit: Scalars['Int']
	offset: Scalars['Int']
}>

export type DeviceTransactionsQuery = {
	__typename?: 'Query'
	deviceTransactions?: {
		__typename?: 'TransactionResponse'
		totalCount?: number | null
		transactions?: Array<{
			__typename?: 'Transaction'
			transactionid?: string | null
			ts?: string | null
			stage?: TransactionStage | null
			duration?: number | null
			cached?: boolean | null
			reset?: boolean | null
			clear?: boolean | null
			burnInPrevention?: boolean | null
			productName?: string | null
			template?: {
				__typename?: 'Template'
				id: number
				templateVariant?: {
					__typename?: 'TemplateVariant'
					id: number
					key: string
					name?: string | null
					isDefault: boolean
					isActive: boolean
				} | null
			} | null
		}> | null
	} | null
}

export type DevicesQueryVariables = Exact<{
	where?: InputMaybe<DevicesFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
	order?: InputMaybe<DeviceOrder>
}>

export type DevicesQuery = {
	__typename?: 'Query'
	devices: {
		__typename?: 'DevicesPagination'
		totalCount: number
		nodes?: Array<{
			__typename?: 'Device'
			id: number
			serialNumber: string
			name?: string | null
			size?: DeviceSize | null
			deviceType?: DeviceType | null
			lastTransactionStatus?: TransactionStage | null
			lastSync?: string | null
			batteryLevel?: number | null
			batteryCharging?: boolean | null
			batteryError?: boolean | null
			active?: boolean | null
			rssi?: number | null
			screenType?: string | null
			deviceMode?: DeviceMode | null
			channelId?: number | null
			position?: {
				__typename?: 'Position'
				key?: string | null
				sequence?: number | null
				shelf?: {
					__typename?: 'Shelf'
					key: string
					bay?: {
						__typename?: 'Bay'
						key: string
						aisle?: { __typename?: 'Aisle'; key: string } | null
					} | null
				} | null
			} | null
			root?: {
				__typename?: 'Root'
				id: number
				name?: string | null
			} | null
			product?: {
				__typename?: 'Product'
				name?: string | null
				internalId: string
				parentProduct?: {
					__typename?: 'Product'
					name?: string | null
				} | null
			} | null
			product2nd?: {
				__typename?: 'Product'
				name?: string | null
				internalId: string
				parentProduct?: {
					__typename?: 'Product'
					name?: string | null
				} | null
			} | null
			template?: {
				__typename?: 'Template'
				id: number
				width?: number | null
				deviceSize?: TemplateType | null
				templateVariant?: {
					__typename?: 'TemplateVariant'
					key: string
					name?: string | null
				} | null
			} | null
			shelf?: {
				__typename?: 'Shelf'
				key: string
				bay?: {
					__typename?: 'Bay'
					key: string
					aisle?: { __typename?: 'Aisle'; key: string } | null
				} | null
			} | null
			channel?: {
				__typename?: 'Channel'
				id: number
				name?: string | null
			} | null
		}> | null
	}
}

export type EditDeviceMutationVariables = Exact<{
	deviceId: Scalars['Int']
	input: EditDeviceInput
}>

export type EditDeviceMutation = {
	__typename?: 'Mutation'
	editDevice: {
		__typename?: 'EditDeviceResponse'
		success: boolean
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditDeviceNameMutationVariables = Exact<{
	deviceId: Scalars['Int']
	name: Scalars['String']
}>

export type EditDeviceNameMutation = {
	__typename?: 'Mutation'
	editDeviceName: {
		__typename?: 'EditDeviceResponse'
		success: boolean
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditDeviceTemplatesMutationVariables = Exact<{
	deviceIds: Array<Scalars['Int']> | Scalars['Int']
	templateVariantId: Scalars['Int']
}>

export type EditDeviceTemplatesMutation = {
	__typename?: 'Mutation'
	editDeviceTemplates: {
		__typename?: 'EditDeviceTemplatesResponse'
		success: boolean
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		failedDevices?: Array<{
			__typename?: 'FailedDevice'
			device: { __typename?: 'Device'; id: number; serialNumber: string }
			errors?: Array<{
				__typename?: 'Error'
				path: string
				message: string
			}> | null
		}> | null
	}
}

export type ExportDevicesQueryVariables = Exact<{
	where?: InputMaybe<DevicesFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
	order?: InputMaybe<DeviceOrder>
}>

export type ExportDevicesQuery = {
	__typename?: 'Query'
	devices: {
		__typename?: 'DevicesPagination'
		totalCount: number
		nodes?: Array<{
			__typename?: 'Device'
			id: number
			name?: string | null
			serialNumber: string
			screenType?: string | null
			batteryLevel?: number | null
			batteryCharging?: boolean | null
			batteryError?: boolean | null
			rssi?: number | null
			firmwareVersion?: string | null
			product?: {
				__typename?: 'Product'
				name?: string | null
				internalId: string
				parentProduct?: {
					__typename?: 'Product'
					name?: string | null
				} | null
			} | null
			product2nd?: {
				__typename?: 'Product'
				name?: string | null
				internalId: string
				parentProduct?: {
					__typename?: 'Product'
					name?: string | null
				} | null
			} | null
			position?: {
				__typename?: 'Position'
				key?: string | null
				sequence?: number | null
				product?: {
					__typename?: 'Product'
					name?: string | null
					internalId: string
					parentProduct?: {
						__typename?: 'Product'
						name?: string | null
					} | null
				} | null
			} | null
			root?: {
				__typename?: 'Root'
				id: number
				name?: string | null
			} | null
			template?: {
				__typename?: 'Template'
				id: number
				templateVariant?: {
					__typename?: 'TemplateVariant'
					key: string
					name?: string | null
				} | null
			} | null
		}> | null
	}
}

export type ForceRefreshDeviceMutationVariables = Exact<{
	deviceId: Scalars['Int']
}>

export type ForceRefreshDeviceMutation = {
	__typename?: 'Mutation'
	forceRefreshDevice: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type ForceRefreshDevicesMutationVariables = Exact<{
	deviceIds: Array<Scalars['Int']> | Scalars['Int']
}>

export type ForceRefreshDevicesMutation = {
	__typename?: 'Mutation'
	forceRefreshDevices: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type GroupsQueryVariables = Exact<{
	where?: InputMaybe<GroupsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type GroupsQuery = {
	__typename?: 'Query'
	groups: {
		__typename?: 'GroupsPaginations'
		nodes: Array<{
			__typename?: 'Group'
			id: number
			name?: string | null
			level?: number | null
		}>
	}
}

export type RefreshDevicesMutationVariables = Exact<{
	deviceIds: Array<Scalars['Int']> | Scalars['Int']
}>

export type RefreshDevicesMutation = {
	__typename?: 'Mutation'
	refreshDevices: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type RegisterDeviceMutationVariables = Exact<{
	input: DeviceRegisterInput
}>

export type RegisterDeviceMutation = {
	__typename?: 'Mutation'
	registerDevice: {
		__typename?: 'DeviceResponse'
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		device?: {
			__typename?: 'Device'
			id: number
			name?: string | null
			serialNumber: string
			health?: number | null
			batteryLevel?: number | null
			batteryError?: boolean | null
			active?: boolean | null
			rssi?: number | null
			size?: DeviceSize | null
			rotated?: boolean | null
			template?: {
				__typename?: 'Template'
				id: number
				name?: string | null
				templateVariant?: {
					__typename?: 'TemplateVariant'
					id: number
					key: string
				} | null
			} | null
			product?: {
				__typename?: 'Product'
				id: number
				internalId: string
				name?: string | null
				parentProduct?: {
					__typename?: 'Product'
					name?: string | null
				} | null
			} | null
			root?: {
				__typename?: 'Root'
				id: number
				name?: string | null
			} | null
			position?: {
				__typename?: 'Position'
				id: number
				sequence?: number | null
				shelf?: {
					__typename?: 'Shelf'
					id: number
					key: string
					bay?: {
						__typename?: 'Bay'
						key: string
						aisle?: { __typename?: 'Aisle'; key: string } | null
					} | null
				} | null
			} | null
		} | null
	}
}

export type SwapDeviceProductsMutationVariables = Exact<{
	deviceIds: Array<Scalars['Int']> | Scalars['Int']
	fromProductId: Scalars['Int']
	toProductId: Scalars['Int']
}>

export type SwapDeviceProductsMutation = {
	__typename?: 'Mutation'
	swapDeviceProducts: {
		__typename?: 'EditDeviceTemplatesResponse'
		success: boolean
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type TemplatesQueryVariables = Exact<{
	where?: InputMaybe<TemplatesFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type TemplatesQuery = {
	__typename?: 'Query'
	templates: {
		__typename?: 'TemplatesPagination'
		nodes?: Array<{
			__typename?: 'Template'
			id: number
			name?: string | null
			width?: number | null
		}> | null
	}
}

export type UnassignDeviceProductMutationVariables = Exact<{
	deviceIds: Array<Scalars['Int']> | Scalars['Int']
	productId: Scalars['Int']
}>

export type UnassignDeviceProductMutation = {
	__typename?: 'Mutation'
	unassignDeviceProduct: {
		__typename?: 'EditDeviceTemplatesResponse'
		success: boolean
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		failedDevices?: Array<{
			__typename?: 'FailedDevice'
			device: { __typename?: 'Device'; id: number; serialNumber: string }
			errors?: Array<{
				__typename?: 'Error'
				path: string
				message: string
			}> | null
		}> | null
	}
}

export type UpdateDevicesMutationVariables = Exact<{
	input: UpdateDevicesInput
}>

export type UpdateDevicesMutation = {
	__typename?: 'Mutation'
	updateDevices: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type AddSmartSensorLabelMutationVariables = Exact<{
	input: AddSensorInput
}>

export type AddSmartSensorLabelMutation = {
	__typename?: 'Mutation'
	addSensor: {
		__typename?: 'SensorResponse'
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		sensor?: { __typename?: 'Sensor'; id: number } | null
	}
}

export type EditSmartSensorLabelMutationVariables = Exact<{
	id: Scalars['Int']
	input: EditSensorInput
}>

export type EditSmartSensorLabelMutation = {
	__typename?: 'Mutation'
	editSensor: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type SmartSensorLabelQueryVariables = Exact<{
	serialNumber: Scalars['String']
}>

export type SmartSensorLabelQuery = {
	__typename?: 'Query'
	sensor: {
		__typename?: 'SensorExtendedResponse'
		sensor?: {
			__typename?: 'SensorExtended'
			id: number
			battery?: number | null
			serialNumber: any
			name?: string | null
			tags?: Array<string | null> | null
			sensorType?: SensorType | null
			root?: {
				__typename?: 'Root'
				id: number
				name?: string | null
			} | null
		} | null
	}
}

export type SmartSensorLabelMeasurementHistoryQueryVariables = Exact<{
	serialNumber: Scalars['String']
	from: Scalars['DateTime']
	to?: InputMaybe<Scalars['DateTime']>
}>

export type SmartSensorLabelMeasurementHistoryQuery = {
	__typename?: 'Query'
	sensorMeasurementHistory: Array<{
		__typename?: 'SensorDataPoint'
		time: any
		airQualityIndex?: number | null
		eco2?: number | null
		accuracy?: number | null
	}>
}

export type SmartSensorLabelMeasurementsQueryVariables = Exact<{
	serialNumber: Scalars['String']
	measurementType: MeasurementType
	from: Scalars['DateTime']
	to?: InputMaybe<Scalars['DateTime']>
}>

export type SmartSensorLabelMeasurementsQuery = {
	__typename?: 'Query'
	sensor: {
		__typename?: 'SensorExtendedResponse'
		sensor?: {
			__typename?: 'SensorExtended'
			measurement?: Array<{
				__typename?: 'Measurement'
				_time?: any | null
				_value?: number | null
			} | null> | null
		} | null
	}
}

export type SmartSensorLabelsQueryVariables = Exact<{
	where?: InputMaybe<SensorsFilter>
	limit: Scalars['Int']
	offset: Scalars['Int']
}>

export type SmartSensorLabelsQuery = {
	__typename?: 'Query'
	sensors: {
		__typename?: 'SensorsPagination'
		nodes: Array<{
			__typename?: 'SensorExtended'
			id: number
			battery?: number | null
			serialNumber: any
			name?: string | null
			tags?: Array<string | null> | null
			active?: boolean | null
			sensorType?: SensorType | null
			root?: { __typename?: 'Root'; name?: string | null } | null
		} | null>
	}
}

export type EditSmartShelfBarMutationVariables = Exact<{
	barId: Scalars['Int']
	input: EditBarInput
}>

export type EditSmartShelfBarMutation = {
	__typename?: 'Mutation'
	editBar: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type SmartShelfBarQueryVariables = Exact<{
	barId?: InputMaybe<Scalars['Int']>
}>

export type SmartShelfBarQuery = {
	__typename?: 'Query'
	bar: {
		__typename?: 'BarResponse'
		bar?: {
			__typename?: 'Bar'
			id: number
			macAddress?: any | null
			name?: string | null
			size: DeviceSize
			x?: number | null
			backgroundFile?: {
				__typename?: 'File'
				id: number
				filename?: string | null
				mimetype?: string | null
			} | null
			group?: {
				__typename?: 'Group'
				id: number
				name?: string | null
			} | null
			devices?: Array<{
				__typename?: 'Device'
				id: number
				serialNumber: string
				x?: number | null
				y?: number | null
				z?: number | null
				product?: {
					__typename?: 'Product'
					id: number
					name?: string | null
					internalId: string
				} | null
				template?: {
					__typename?: 'Template'
					width?: number | null
					templateVariant?: {
						__typename?: 'TemplateVariant'
						id: number
					} | null
				} | null
				position?: {
					__typename?: 'Position'
					x?: number | null
					sequence?: number | null
					product?: { __typename?: 'Product'; id: number } | null
					templateVariant?: {
						__typename?: 'TemplateVariant'
						id: number
					} | null
				} | null
			}> | null
			shelf?: { __typename?: 'Shelf'; id: number } | null
			root?: {
				__typename?: 'Root'
				id: number
				market?: { __typename?: 'Market'; id: number } | null
			} | null
		} | null
	}
}

export type SmartShelfBarsQueryVariables = Exact<{
	where?: InputMaybe<BarsFilter>
	limit: Scalars['Int']
	offset: Scalars['Int']
}>

export type SmartShelfBarsQuery = {
	__typename?: 'Query'
	bars: {
		__typename?: 'BarsPagination'
		nodes: Array<{
			__typename?: 'Bar'
			id: number
			macAddress?: any | null
			name?: string | null
			size: DeviceSize
			root?: { __typename?: 'Root'; name?: string | null } | null
			shelf?: {
				__typename?: 'Shelf'
				key: string
				bay?: {
					__typename?: 'Bay'
					key: string
					aisle?: { __typename?: 'Aisle'; key: string } | null
				} | null
			} | null
		} | null>
	}
}

export type EditScaleMutationVariables = Exact<{
	scaleId: Scalars['Int']
	input: EditScaleInput
}>

export type EditScaleMutation = {
	__typename?: 'Mutation'
	editScale: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditTvDeviceMutationVariables = Exact<{
	tvDeviceId: Scalars['Int']
	input: EditTvDeviceInput
}>

export type EditTvDeviceMutation = {
	__typename?: 'Mutation'
	editTvDevice: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type RegisterScaleMutationVariables = Exact<{
	input: ScaleRegisterInput
}>

export type RegisterScaleMutation = {
	__typename?: 'Mutation'
	registerScale: {
		__typename?: 'ScaleResponse'
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		scale?: { __typename?: 'Scale'; id: number } | null
	}
}

export type ScaleQueryVariables = Exact<{
	scaleId: Scalars['Int']
}>

export type ScaleQuery = {
	__typename?: 'Query'
	scale: {
		__typename?: 'ScaleResponse'
		scale?: {
			__typename?: 'Scale'
			id: number
			name?: string | null
			username: string
			ip: any
			tags?: Array<string> | null
			type: DisplayType
			root?: { __typename?: 'Root'; id: number } | null
			channel?: { __typename?: 'Channel'; id: number } | null
		} | null
	}
}

export type ScalesQueryVariables = Exact<{
	offset: Scalars['Int']
	limit: Scalars['Int']
	where?: InputMaybe<ScalesFilter>
}>

export type ScalesQuery = {
	__typename?: 'Query'
	scales: {
		__typename?: 'ScalesPagination'
		totalCount: number
		nodes: Array<{
			__typename?: 'Scale'
			id: number
			name?: string | null
			ip: any
			tags?: Array<string> | null
			type: DisplayType
			root?: {
				__typename?: 'Root'
				name?: string | null
				marketId?: number | null
			} | null
			channel?: {
				__typename?: 'Channel'
				id: number
				name?: string | null
			} | null
		} | null>
	}
}

export type TvDevicesQueryVariables = Exact<{
	offset: Scalars['Int']
	limit: Scalars['Int']
	where?: InputMaybe<TvDevicesFilter>
}>

export type TvDevicesQuery = {
	__typename?: 'Query'
	tvDevices: {
		__typename?: 'TVDevicesPagination'
		totalCount: number
		nodes: Array<{
			__typename?: 'TVDevice'
			id: number
			token?: string | null
			uuid?: string | null
			name?: string | null
			width?: number | null
			height?: number | null
			tags?: Array<string | null> | null
			root?: {
				__typename?: 'Root'
				name?: string | null
				marketId?: number | null
			} | null
			channel?: {
				__typename?: 'Channel'
				id: number
				name?: string | null
			} | null
		} | null>
	}
}

export type AddUserMutationVariables = Exact<{
	input: AddUserInput
}>

export type AddUserMutation = {
	__typename?: 'Mutation'
	addUser: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type AdminDisable2FaMutationVariables = Exact<{
	userId: Scalars['Int']
}>

export type AdminDisable2FaMutation = {
	__typename?: 'Mutation'
	adminDisable2FA: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type CustomerInfoQueryVariables = Exact<{ [key: string]: never }>

export type CustomerInfoQuery = {
	__typename?: 'Query'
	customerInfo: {
		__typename?: 'CustomerInfoResponse'
		purchasedModules?: Array<PurchasedModules> | null
	}
}

export type DeleteUserMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteUserMutation = {
	__typename?: 'Mutation'
	deleteUser: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type Disable2FaMutationVariables = Exact<{
	code: Scalars['String']
}>

export type Disable2FaMutation = {
	__typename?: 'Mutation'
	disable2FA: {
		__typename?: 'Disable2FAResponse'
		success: boolean
		delta?: number | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditUserMutationVariables = Exact<{
	userId: Scalars['Int']
	input: EditUserInput
}>

export type EditUserMutation = {
	__typename?: 'Mutation'
	editUser: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type Enable2FaMutationVariables = Exact<{
	code: Scalars['String']
}>

export type Enable2FaMutation = {
	__typename?: 'Mutation'
	enable2FA: {
		__typename?: 'Enable2FAResponse'
		success: boolean
		delta?: number | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type Generate2FaSecretMutationVariables = Exact<{ [key: string]: never }>

export type Generate2FaSecretMutation = {
	__typename?: 'Mutation'
	generate2FASecret: {
		__typename?: 'Generate2FASecretResponse'
		secret: string
		uri: string
	}
}

export type GetGoogleAuthMutationVariables = Exact<{
	code: Scalars['String']
	redirectUri: Scalars['String']
}>

export type GetGoogleAuthMutation = {
	__typename?: 'Mutation'
	getGoogleAuth: {
		__typename?: 'GoogleAuthResponse'
		success: boolean
		googleAuth?: {
			__typename?: 'GoogleAuth'
			name?: string | null
			email?: string | null
			accessToken?: string | null
			expiresAt?: any | null
		} | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type MeQueryVariables = Exact<{ [key: string]: never }>

export type MeQuery = {
	__typename?: 'Query'
	me?: {
		__typename?: 'MeResponse'
		id: number
		email?: string | null
		fullName?: string | null
		allowedIPs?: Array<any | null> | null
		rootIDs?: Array<number> | null
		permissions?: Array<string> | null
		roles?: Array<{
			__typename?: 'Role'
			id: number
			value?: string | null
		}> | null
		microsoftAuth?: {
			__typename?: 'MicrosoftAuth'
			uuid?: string | null
			name?: string | null
			email?: string | null
			tenantId?: string | null
			accessToken?: string | null
			expiresAt?: any | null
			scopes?: Array<string> | null
		} | null
		googleAuth?: {
			__typename?: 'GoogleAuth'
			name?: string | null
			email?: string | null
			accessToken?: string | null
			refreshToken?: string | null
			expiresAt?: any | null
		} | null
		ledConfig?: {
			__typename?: 'LedConfig'
			blinkSpeed?: BlinkSpeed | null
			blinkTime?: BlinkTime | null
			color?: LedColor | null
		} | null
	} | null
}

export type UserQueryVariables = Exact<{
	userId: Scalars['Int']
}>

export type UserQuery = {
	__typename?: 'Query'
	user: {
		__typename?: 'UserResponse'
		user?: {
			__typename?: 'User'
			id: number
			email?: string | null
			firstName?: string | null
			lastName?: string | null
			username?: string | null
			rootIDs?: Array<number> | null
			marketIDs?: Array<number> | null
			isRootRestricted?: boolean | null
			isTwoFactorEnabled: boolean
			verifiedEmail?: boolean | null
			roles?: Array<{
				__typename?: 'Role'
				value?: string | null
				id: number
				rank?: number | null
				permissions: Array<string>
			}> | null
			locationRestrictions?: Array<{
				__typename?: 'Root'
				name?: string | null
			}> | null
			marketRestrictions?: Array<{
				__typename?: 'Market'
				name?: string | null
			}> | null
		} | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type UsersQueryVariables = Exact<{
	where?: InputMaybe<UsersFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type UsersQuery = {
	__typename?: 'Query'
	users: {
		__typename?: 'UsersPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'User'
			id: number
			username?: string | null
			email?: string | null
			firstName?: string | null
			lastName?: string | null
			roles?: Array<{ __typename?: 'Role'; value?: string | null }> | null
		}>
	}
}

export type UsersInfoQueryVariables = Exact<{ [key: string]: never }>

export type UsersInfoQuery = {
	__typename?: 'Query'
	usersInfo: {
		__typename?: 'UsersInfoResponse'
		numOfUsers?: number | null
		maxUsers?: number | null
	}
}

export type VerifyEmailMutationVariables = Exact<{
	token: Scalars['String']
}>

export type VerifyEmailMutation = {
	__typename?: 'Mutation'
	verifyEmail: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type UniqueValueEntityColumnsQueryVariables = Exact<{
	templateKey: Scalars['String']
}>

export type UniqueValueEntityColumnsQuery = {
	__typename?: 'Query'
	uniqueValueEntityColumns: {
		__typename?: 'UniqueValueEntityColumnsResponse'
		nodes: Array<{
			__typename?: 'UniqueColumn'
			name?: string | null
		} | null>
	}
}

export type AddVirtualMultiScreenMutationVariables = Exact<{
	input: AddVirtualMultiScreenInput
}>

export type AddVirtualMultiScreenMutation = {
	__typename?: 'Mutation'
	addVirtualMultiScreen: {
		__typename?: 'VirtualMultiScreenResponse'
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		} | null> | null
		virtualMultiScreen?: {
			__typename?: 'VirtualMultiScreen'
			id: number
		} | null
	}
}

export type DeleteVirtualMultiScreenMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteVirtualMultiScreenMutation = {
	__typename?: 'Mutation'
	deleteVirtualMultiScreen: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditVirtualMultiScreenMutationVariables = Exact<{
	input: EditVirtualMultiScreenInput
}>

export type EditVirtualMultiScreenMutation = {
	__typename?: 'Mutation'
	editVirtualMultiScreen: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type VirtualMultiScreenQueryVariables = Exact<{
	virtualMultiScreenId: Scalars['Int']
}>

export type VirtualMultiScreenQuery = {
	__typename?: 'Query'
	virtualMultiScreen: {
		__typename?: 'VirtualMultiScreenResponse'
		virtualMultiScreen?: {
			__typename?: 'VirtualMultiScreen'
			id: number
			name?: string | null
			virtualMultiScreenPositions?: Array<{
				__typename?: 'VirtualMultiScreenPosition'
				id: number
				sequence: number
				channel?: {
					__typename?: 'Channel'
					id: number
					name?: string | null
				} | null
				virtualCategoryPoint?: {
					__typename?: 'VirtualCategoryPoint'
					id: number
					name?: string | null
				} | null
				virtualRack?: {
					__typename?: 'VirtualRack'
					id: number
					name?: string | null
					virtualShelfPositions?: Array<{
						__typename?: 'VirtualShelfPosition'
						id: number
						virtualShelf?: {
							__typename?: 'VirtualShelf'
							id: number
							spacing?: number | null
							virtualProductPositions?: Array<{
								__typename?: 'VirtualProductPosition'
								id: number
								zoom?: number | null
								rotation?: number | null
								itemCount?: number | null
								product?: {
									__typename?: 'Product'
									id: number
									name?: string | null
									productImages?: Array<{
										__typename?: 'ProductImage'
										id: number
										file: {
											__typename?: 'File'
											id: number
											thumbnail?: string | null
											filename?: string | null
											width?: number | null
											height?: number | null
										}
									} | null> | null
								} | null
							} | null> | null
						} | null
					}> | null
				} | null
			} | null> | null
		} | null
	}
}

export type VirtualMultiScreensQueryVariables = Exact<{
	offset: Scalars['Int']
	limit: Scalars['Int']
	where?: InputMaybe<VirtualMultiScreensFilter>
}>

export type VirtualMultiScreensQuery = {
	__typename?: 'Query'
	virtualMultiScreens: {
		__typename?: 'VirutalMultiScreensPagination'
		totalCount: number
		nodes?: Array<{
			__typename?: 'VirtualMultiScreen'
			id: number
			name?: string | null
		}> | null
	}
}

export type EditOrderMutationVariables = Exact<{
	input: EditOrderInput
}>

export type EditOrderMutation = {
	__typename?: 'Mutation'
	editOrder: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditOrderItemMutationVariables = Exact<{
	id: Scalars['Int']
	input: EditOrderItemInput
}>

export type EditOrderItemMutation = {
	__typename?: 'Mutation'
	editOrderItem: {
		__typename?: 'EditOrderItemResponse'
		success?: boolean | null
		archivedOrder?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type OrderQueryVariables = Exact<{
	id: Scalars['Int']
}>

export type OrderQuery = {
	__typename?: 'Query'
	order: {
		__typename?: 'OrderResponse'
		order?: {
			__typename?: 'Order'
			id: number
			created?: any | null
			orderNumber?: string | null
			mode?: OrderMode | null
			costumerId?: number | null
			rootId?: number | null
			supplier?: {
				__typename?: 'Supplier'
				id: number
				companyName: string
			} | null
			orderItems?: Array<{
				__typename?: 'OrderItem'
				id: number
				quantity?: number | null
				status?: OrderStatus | null
				deliveryDate?: any | null
				productName?: string | null
				internalId?: string | null
				partnerId?: string | null
				product?: {
					__typename?: 'Product'
					id: number
					internalId: string
					eanCodes?: Array<string> | null
					parentProduct?: {
						__typename?: 'Product'
						name?: string | null
					} | null
					valueEntities?: Array<{
						__typename?: 'Value'
						id: number
						name?: string | null
						templateKey: string
						type?: DeviceValueType | null
						value: string
					}> | null
				} | null
			}> | null
		} | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type OrderItemLogsQueryVariables = Exact<{
	offset: Scalars['Int']
	limit: Scalars['Int']
	where?: InputMaybe<OrderItemLogsFilter>
}>

export type OrderItemLogsQuery = {
	__typename?: 'Query'
	orderItemLogs: {
		__typename?: 'OrderItemLogsPagination'
		totalCount: number
		nodes: Array<{
			__typename?: 'OrderItemLog'
			id: number
			time?: any | null
			type?: LogType | null
			quantity?: number | null
			status?: OrderStatus | null
			deliveryDate?: any | null
			user?: {
				__typename?: 'User'
				firstName?: string | null
				lastName?: string | null
			} | null
		} | null>
	}
}

export type OrdersQueryVariables = Exact<{
	offset: Scalars['Int']
	limit: Scalars['Int']
	where?: InputMaybe<OrderFilter>
}>

export type OrdersQuery = {
	__typename?: 'Query'
	orders: {
		__typename?: 'OrdersPagination'
		totalCount: number
		nodes: Array<{
			__typename?: 'Order'
			id: number
			created?: any | null
			orderNumber?: string | null
			mode?: OrderMode | null
			costumerId?: number | null
			rootId?: number | null
			orderItems?: Array<{
				__typename?: 'OrderItem'
				id: number
				quantity?: number | null
				status?: OrderStatus | null
				deliveryDate?: any | null
				product?: {
					__typename?: 'Product'
					id: number
					name?: string | null
					internalId: string
				} | null
			}> | null
			supplier?: {
				__typename?: 'Supplier'
				id: number
				companyName: string
				supplierId?: string | null
			} | null
		} | null>
	}
}

export type DeleteProductImageMutationVariables = Exact<{
	productImageId: Scalars['Int']
}>

export type DeleteProductImageMutation = {
	__typename?: 'Mutation'
	deleteProductImage: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type ProductEditDetailsQueryVariables = Exact<{
	internalId?: InputMaybe<Scalars['String']>
	id?: InputMaybe<Scalars['Int']>
}>

export type ProductEditDetailsQuery = {
	__typename?: 'Query'
	product: {
		__typename?: 'ProductResponse'
		product?: {
			__typename?: 'Product'
			id: number
			internalId: string
			name?: string | null
			eanCodes?: Array<string> | null
			active?: boolean | null
			virtualProductPositions?: Array<{
				__typename?: 'VirtualProductPosition'
				virtualShelf?: {
					__typename?: 'VirtualShelf'
					id: number
					name?: string | null
				} | null
			}> | null
			productImages?: Array<{
				__typename?: 'ProductImage'
				id: number
				primary: boolean
				file: {
					__typename?: 'File'
					id: number
					originalname?: string | null
					filename?: string | null
					mimetype?: string | null
					encoding?: string | null
					url?: string | null
					isFolder: boolean
					width?: number | null
					height?: number | null
					thumbnail?: string | null
				}
			} | null> | null
			valueEntities?: Array<{
				__typename?: 'Value'
				id: number
				name?: string | null
				templateKey: string
				type?: DeviceValueType | null
				value: string
			}> | null
			products?: Array<{
				__typename?: 'Product'
				id: number
				internalId: string
				name?: string | null
				eanCodes?: Array<string> | null
				valueEntities?: Array<{
					__typename?: 'Value'
					id: number
					name?: string | null
					templateKey: string
					type?: DeviceValueType | null
					value: string
				}> | null
				productImages?: Array<{
					__typename?: 'ProductImage'
					id: number
					primary: boolean
					file: {
						__typename?: 'File'
						id: number
						originalname?: string | null
						filename?: string | null
						mimetype?: string | null
						encoding?: string | null
						url?: string | null
						isFolder: boolean
						width?: number | null
						height?: number | null
						thumbnail?: string | null
					}
				} | null> | null
			}> | null
		} | null
	}
}

export type UploadProductImageMutationVariables = Exact<{
	file: Scalars['Upload']
	internalId?: InputMaybe<Scalars['String']>
	primary?: InputMaybe<Scalars['Boolean']>
	productType?: InputMaybe<ProductType>
}>

export type UploadProductImageMutation = {
	__typename?: 'Mutation'
	uploadProductImage?: {
		__typename?: 'UploadProductImageResponse'
		file: {
			__typename?: 'File'
			id: number
			isFolder: boolean
			originalname?: string | null
			filename?: string | null
			mimetype?: string | null
			encoding?: string | null
			url?: string | null
			thumbnail?: string | null
		}
		productImage?: {
			__typename?: 'ProductImage'
			id: number
			primary: boolean
			file: {
				__typename?: 'File'
				id: number
				isFolder: boolean
				originalname?: string | null
				filename?: string | null
				mimetype?: string | null
				encoding?: string | null
				url?: string | null
				thumbnail?: string | null
			}
		} | null
	} | null
}

export type VirtualStoreProductsQueryVariables = Exact<{
	where?: InputMaybe<ProductsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type VirtualStoreProductsQuery = {
	__typename?: 'Query'
	products: {
		__typename?: 'ProductsPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'Product'
			id: number
			eanCodes?: Array<string> | null
			internalId: string
			name?: string | null
			productType?: ProductType | null
			active?: boolean | null
			productImages?: Array<{
				__typename?: 'ProductImage'
				id: number
				file: {
					__typename?: 'File'
					id: number
					thumbnail?: string | null
				}
			} | null> | null
			valueEntities?: Array<{
				__typename?: 'Value'
				id: number
				templateKey: string
				type?: DeviceValueType | null
				value: string
			}> | null
		}>
	}
}

export type AddVirtualCategoryPointMutationVariables = Exact<{
	input: AddVirtualCategoryPointInput
}>

export type AddVirtualCategoryPointMutation = {
	__typename?: 'Mutation'
	addVirtualCategoryPoint: {
		__typename?: 'VirtualCategoryPointResponse'
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		} | null> | null
		virtualCategoryPoint?: {
			__typename?: 'VirtualCategoryPoint'
			id: number
		} | null
	}
}

export type DeleteVirtualCategoryPointMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteVirtualCategoryPointMutation = {
	__typename?: 'Mutation'
	deleteVirtualCategoryPoint: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditVirtualCategoryPointMutationVariables = Exact<{
	input: EditVirtualCategoryPointInput
}>

export type EditVirtualCategoryPointMutation = {
	__typename?: 'Mutation'
	editVirtualCategoryPoint: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type VirtualCategoryPointQueryVariables = Exact<{
	virtualCategoryPointId: Scalars['Int']
}>

export type VirtualCategoryPointQuery = {
	__typename?: 'Query'
	virtualCategoryPoint: {
		__typename?: 'VirtualCategoryPointResponse'
		virtualCategoryPoint?: {
			__typename?: 'VirtualCategoryPoint'
			id: number
			name?: string | null
			virtualRacks?: Array<{
				__typename?: 'VirtualRack'
				id: number
				name?: string | null
				virtualShelfPositions?: Array<{
					__typename?: 'VirtualShelfPosition'
					virtualShelf?: {
						__typename?: 'VirtualShelf'
						id: number
						name?: string | null
						spacing?: number | null
						variant: VirtualShelfVariant
						virtualProductPositions?: Array<{
							__typename?: 'VirtualProductPosition'
							zoom?: number | null
							rotation?: number | null
							itemCount?: number | null
							product?: {
								__typename?: 'Product'
								id: number
								name?: string | null
								productImages?: Array<{
									__typename?: 'ProductImage'
									file: {
										__typename?: 'File'
										filename?: string | null
										thumbnail?: string | null
										width?: number | null
										height?: number | null
									}
								} | null> | null
							} | null
						} | null> | null
					} | null
				}> | null
			} | null> | null
		} | null
	}
}

export type VirtualCategoryPointsQueryVariables = Exact<{
	offset: Scalars['Int']
	limit: Scalars['Int']
	where?: InputMaybe<VirtualCategoryPointsFilter>
}>

export type VirtualCategoryPointsQuery = {
	__typename?: 'Query'
	virtualCategoryPoints: {
		__typename?: 'VirtualCategoryPointsPagination'
		totalCount: number
		nodes?: Array<{
			__typename?: 'VirtualCategoryPoint'
			id: number
			name?: string | null
			virtualRacks?: Array<{
				__typename?: 'VirtualRack'
				id: number
				name?: string | null
			} | null> | null
		}> | null
	}
}

export type AddVirtualCategoryScreenMutationVariables = Exact<{
	input: AddVirtualCategoryScreenInput
}>

export type AddVirtualCategoryScreenMutation = {
	__typename?: 'Mutation'
	addVirtualCategoryScreen: {
		__typename?: 'VirtualCategoryScreenResponse'
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		} | null> | null
		virtualCategoryScreen?: {
			__typename?: 'VirtualCategoryScreen'
			id: number
		} | null
	}
}

export type DeleteCategoryScreenImageMutationVariables = Exact<{
	categoryId: Scalars['Int']
}>

export type DeleteCategoryScreenImageMutation = {
	__typename?: 'Mutation'
	deleteVirtualCategoryScreenImage: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type DeleteVirtualCategoryScreenMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteVirtualCategoryScreenMutation = {
	__typename?: 'Mutation'
	deleteVirtualCategoryScreen: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditVirtualCategoryScreenMutationVariables = Exact<{
	input: EditVirtualCategoryScreenInput
}>

export type EditVirtualCategoryScreenMutation = {
	__typename?: 'Mutation'
	editVirtualCategoryScreen: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type UploadVirtualStoreScreenMutationVariables = Exact<{
	file: Scalars['Upload']
	virtualCategoryScreenId?: InputMaybe<Scalars['Int']>
}>

export type UploadVirtualStoreScreenMutation = {
	__typename?: 'Mutation'
	uploadVirtualStoreScreen?: {
		__typename?: 'File'
		id: number
		originalname?: string | null
		filename?: string | null
		mimetype?: string | null
		encoding?: string | null
		url?: string | null
		isFolder: boolean
		thumbnail?: string | null
		width?: number | null
		height?: number | null
	} | null
}

export type VirtualCategoryScreenQueryVariables = Exact<{
	virtualCategoryScreenId: Scalars['Int']
}>

export type VirtualCategoryScreenQuery = {
	__typename?: 'Query'
	virtualCategoryScreen: {
		__typename?: 'VirtualCategoryScreenResponse'
		virtualCategoryScreen?: {
			__typename?: 'VirtualCategoryScreen'
			id: number
			name?: string | null
			timeout?: number | null
			catalogMode?: boolean | null
			channel?: { __typename?: 'Channel'; id: number } | null
			file?: {
				__typename?: 'File'
				id: number
				originalname?: string | null
				filename?: string | null
				mimetype?: string | null
				encoding?: string | null
				url?: string | null
				isFolder: boolean
				width?: number | null
				height?: number | null
			} | null
			backgroundFile?: {
				__typename?: 'File'
				id: number
				originalname?: string | null
				filename?: string | null
				mimetype?: string | null
				encoding?: string | null
				url?: string | null
				isFolder: boolean
				width?: number | null
				height?: number | null
			} | null
			virtualCategoryPointPositions?: Array<{
				__typename?: 'VirtualCategoryPointPosition'
				id: number
				x: number
				y: number
				virtualCategoryPoint?: {
					__typename?: 'VirtualCategoryPoint'
					id: number
					name?: string | null
				} | null
			} | null> | null
		} | null
	}
}

export type VirtualCategoryScreensQueryVariables = Exact<{
	offset: Scalars['Int']
	limit: Scalars['Int']
	where?: InputMaybe<VirtualCategoryScreensFilter>
}>

export type VirtualCategoryScreensQuery = {
	__typename?: 'Query'
	virtualCategoryScreens: {
		__typename?: 'VirutalCategoryScreensPagination'
		totalCount: number
		nodes?: Array<{
			__typename?: 'VirtualCategoryScreen'
			id: number
			name?: string | null
			virtualCategoryPointPositions?: Array<{
				__typename?: 'VirtualCategoryPointPosition'
				id: number
				x: number
				y: number
				virtualCategoryPoint?: {
					__typename?: 'VirtualCategoryPoint'
					id: number
					name?: string | null
				} | null
			} | null> | null
		}> | null
	}
}

export type AddVirtualRackMutationVariables = Exact<{
	input: AddVirtualRackInput
}>

export type AddVirtualRackMutation = {
	__typename?: 'Mutation'
	addVirtualRack: {
		__typename?: 'VirtualRackResponse'
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		} | null> | null
		virtualRack?: { __typename?: 'VirtualRack'; id: number } | null
	}
}

export type DeleteVirtualRackMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteVirtualRackMutation = {
	__typename?: 'Mutation'
	deleteVirtualRack: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditVirtualRackMutationVariables = Exact<{
	input: EditVirtualRackInput
}>

export type EditVirtualRackMutation = {
	__typename?: 'Mutation'
	editVirtualRack: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type VirtualRackQueryVariables = Exact<{
	virtualRackId: Scalars['Int']
}>

export type VirtualRackQuery = {
	__typename?: 'Query'
	virtualRack: {
		__typename?: 'VirtualRackResponse'
		virtualRack?: {
			__typename?: 'VirtualRack'
			id: number
			name?: string | null
			removePadding?: boolean | null
			file?: {
				__typename?: 'File'
				id: number
				originalname?: string | null
			} | null
			virtualShelfPositions?: Array<{
				__typename?: 'VirtualShelfPosition'
				id: number
				virtualShelf?: {
					__typename?: 'VirtualShelf'
					id: number
					name?: string | null
					spacing?: number | null
					variant: VirtualShelfVariant
					virtualProductPositions?: Array<{
						__typename?: 'VirtualProductPosition'
						id: number
						zoom?: number | null
						rotation?: number | null
						itemCount?: number | null
						product?: {
							__typename?: 'Product'
							id: number
							name?: string | null
							valueEntities?: Array<{
								__typename?: 'Value'
								value: string
								templateKey: string
							}> | null
							productImages?: Array<{
								__typename?: 'ProductImage'
								id: number
								file: {
									__typename?: 'File'
									id: number
									thumbnail?: string | null
									filename?: string | null
									width?: number | null
									height?: number | null
								}
							} | null> | null
						} | null
					} | null> | null
				} | null
			}> | null
		} | null
	}
}

export type VirtualRacksQueryVariables = Exact<{
	offset: Scalars['Int']
	limit: Scalars['Int']
	where?: InputMaybe<VirtualRacksFilter>
}>

export type VirtualRacksQuery = {
	__typename?: 'Query'
	virtualRacks: {
		__typename?: 'VirtualRacksPagination'
		totalCount: number
		nodes?: Array<{
			__typename?: 'VirtualRack'
			id: number
			name?: string | null
			file?: {
				__typename?: 'File'
				id: number
				thumbnail?: string | null
				width?: number | null
				height?: number | null
			} | null
			virtualShelfPositions?: Array<{
				__typename?: 'VirtualShelfPosition'
				id: number
				virtualShelf?: {
					__typename?: 'VirtualShelf'
					variant: VirtualShelfVariant
					spacing?: number | null
					virtualProductPositions?: Array<{
						__typename?: 'VirtualProductPosition'
						zoom?: number | null
						rotation?: number | null
						itemCount?: number | null
						product?: {
							__typename?: 'Product'
							productImages?: Array<{
								__typename?: 'ProductImage'
								file: {
									__typename?: 'File'
									id: number
									thumbnail?: string | null
									width?: number | null
									height?: number | null
								}
							} | null> | null
						} | null
					} | null> | null
				} | null
			}> | null
		}> | null
	}
}

export type AddVirtualShelfMutationVariables = Exact<{
	input: AddVirtualShelfInput
}>

export type AddVirtualShelfMutation = {
	__typename?: 'Mutation'
	addVirtualShelf: {
		__typename?: 'VirtualShelfResponse'
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		} | null> | null
		virtualShelf?: { __typename?: 'VirtualShelf'; id: number } | null
	}
}

export type DeleteVirtualShelfMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteVirtualShelfMutation = {
	__typename?: 'Mutation'
	deleteVirtualShelf: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditVirtualShelfMutationVariables = Exact<{
	input: EditVirtualShelfInput
}>

export type EditVirtualShelfMutation = {
	__typename?: 'Mutation'
	editVirtualShelf: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type VirtualShelfQueryVariables = Exact<{
	virtualShelfId: Scalars['Int']
}>

export type VirtualShelfQuery = {
	__typename?: 'Query'
	virtualShelf: {
		__typename?: 'VirtualShelfResponse'
		virtualShelf?: {
			__typename?: 'VirtualShelf'
			id: number
			name?: string | null
			spacing?: number | null
			variant: VirtualShelfVariant
			virtualProductPositions?: Array<{
				__typename?: 'VirtualProductPosition'
				id: number
				zoom?: number | null
				rotation?: number | null
				itemCount?: number | null
				product?: {
					__typename?: 'Product'
					id: number
					name?: string | null
					internalId: string
					valueEntities?: Array<{
						__typename?: 'Value'
						templateKey: string
						value: string
					}> | null
					productImages?: Array<{
						__typename?: 'ProductImage'
						id: number
						file: {
							__typename?: 'File'
							thumbnail?: string | null
							filename?: string | null
							width?: number | null
							height?: number | null
						}
					} | null> | null
				} | null
			} | null> | null
		} | null
	}
}

export type VirtualShelfProductsQueryVariables = Exact<{
	where?: InputMaybe<ProductsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type VirtualShelfProductsQuery = {
	__typename?: 'Query'
	products: {
		__typename?: 'ProductsPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'Product'
			id: number
			name?: string | null
			internalId: string
			valueEntities?: Array<{
				__typename?: 'Value'
				templateKey: string
				value: string
				type?: DeviceValueType | null
			}> | null
			productImages?: Array<{
				__typename?: 'ProductImage'
				id: number
				file: {
					__typename?: 'File'
					id: number
					thumbnail?: string | null
					width?: number | null
					height?: number | null
				}
			} | null> | null
		}>
	}
}

export type VirtualShelvesQueryVariables = Exact<{
	offset: Scalars['Int']
	limit: Scalars['Int']
	where?: InputMaybe<VirtualShelvesFilter>
}>

export type VirtualShelvesQuery = {
	__typename?: 'Query'
	virtualShelves: {
		__typename?: 'VirtualShelvesPagination'
		totalCount: number
		nodes?: Array<{
			__typename?: 'VirtualShelf'
			id: number
			name?: string | null
			spacing?: number | null
			variant: VirtualShelfVariant
			virtualProductPositions?: Array<{
				__typename?: 'VirtualProductPosition'
				id: number
				zoom?: number | null
				rotation?: number | null
				itemCount?: number | null
				product?: {
					__typename?: 'Product'
					id: number
					productImages?: Array<{
						__typename?: 'ProductImage'
						file: {
							__typename?: 'File'
							id: number
							thumbnail?: string | null
							width?: number | null
							height?: number | null
						}
					} | null> | null
				} | null
			} | null> | null
		}> | null
	}
}

export type AddVirtualStoreDeviceMutationVariables = Exact<{
	input: AddVirtualStoreDeviceInput
}>

export type AddVirtualStoreDeviceMutation = {
	__typename?: 'Mutation'
	addVirtualStoreDevice: {
		__typename?: 'VirtualStoreDeviceResponse'
		virtualStoreDevice?: {
			__typename?: 'VirtualStoreDevice'
			id: number
		} | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		} | null> | null
	}
}

export type DeleteVirtualStoreDeviceMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteVirtualStoreDeviceMutation = {
	__typename?: 'Mutation'
	deleteVirtualStoreDevice: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditVirtualStoreDeviceMutationVariables = Exact<{
	input: EditVirtualStoreDeviceInput
}>

export type EditVirtualStoreDeviceMutation = {
	__typename?: 'Mutation'
	editVirtualStoreDevice: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type VirtualStoreDeviceQueryVariables = Exact<{
	virtualStoreDeviceId: Scalars['Int']
}>

export type VirtualStoreDeviceQuery = {
	__typename?: 'Query'
	virtualStoreDevice: {
		__typename?: 'VirtualStoreDeviceResponse'
		virtualStoreDevice?: {
			__typename?: 'VirtualStoreDevice'
			id: number
			name?: string | null
			tags?: Array<string | null> | null
			token?: string | null
			note?: string | null
			powerWindows?: Array<{
				__typename?: 'DevicePowerWindow'
				weekday: WeekDay
				from: string
				to: string
			}> | null
			root?: {
				__typename?: 'Root'
				id: number
				name?: string | null
			} | null
			virtualCategoryScreen?: {
				__typename?: 'VirtualCategoryScreen'
				id: number
				name?: string | null
			} | null
			channel?: {
				__typename?: 'Channel'
				id: number
				name?: string | null
			} | null
			virtualMultiScreen?: {
				__typename?: 'VirtualMultiScreen'
				id: number
				name?: string | null
			} | null
			signageButtons?: Array<{
				__typename?: 'SignageButton'
				id: number
				virtualStoreDeviceId: number
				durationSeconds?: number | null
				button: {
					__typename?: 'Button'
					id: number
					name?: string | null
				}
				channel: {
					__typename?: 'Channel'
					id: number
					name?: string | null
				}
			}> | null
		} | null
	}
}

export type VirtualStoreDevicesQueryVariables = Exact<{
	offset: Scalars['Int']
	limit: Scalars['Int']
	where?: InputMaybe<VirtualStoreDevicesFilter>
}>

export type VirtualStoreDevicesQuery = {
	__typename?: 'Query'
	virtualStoreDevices: {
		__typename?: 'VirtualStoreDevicesPagination'
		totalCount: number
		nodes?: Array<{
			__typename?: 'VirtualStoreDevice'
			id: number
			name?: string | null
			tags?: Array<string | null> | null
			active?: boolean | null
			width?: number | null
			height?: number | null
			version?: string | null
			messageReceived?: boolean | null
			root?: {
				__typename?: 'Root'
				id: number
				name?: string | null
				marketId?: number | null
			} | null
			channel?: {
				__typename?: 'Channel'
				id: number
				name?: string | null
			} | null
			virtualCategoryScreen?: {
				__typename?: 'VirtualCategoryScreen'
				id: number
				name?: string | null
			} | null
			virtualMultiScreen?: {
				__typename?: 'VirtualMultiScreen'
				id: number
				name?: string | null
			} | null
			virtualCategoryPoint?: {
				__typename?: 'VirtualCategoryPoint'
				id: number
				name?: string | null
			} | null
		}> | null
	}
}

export type WarehouseParentsWithChildrenQueryVariables = Exact<{
	any?: InputMaybe<Scalars['String']>
	rootId?: InputMaybe<Scalars['Int']>
	supplierId?: InputMaybe<Scalars['Int']>
	alarmType?: InputMaybe<AlarmType>
	offset: Scalars['Int']
	limit: Scalars['Int']
	shelfId?: InputMaybe<Scalars['Int']>
	bayId?: InputMaybe<Scalars['Int']>
	aisleId?: InputMaybe<Scalars['Int']>
}>

export type WarehouseParentsWithChildrenQuery = {
	__typename?: 'Query'
	warehouseParentsWithChildren: {
		__typename?: 'ProductsPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'Product'
			id: number
			name?: string | null
			internalId: string
			valueEntities?: Array<{
				__typename?: 'Value'
				templateKey: string
				value: string
			}> | null
			products?: Array<{
				__typename?: 'Product'
				id: number
				internalId: string
				expirationDate?: any | null
				valueEntities?: Array<{
					__typename?: 'Value'
					templateKey: string
					value: string
				}> | null
				root?: {
					__typename?: 'Root'
					id: number
					name?: string | null
				} | null
				supplier?: {
					__typename?: 'Supplier'
					id: number
					companyName: string
					supplierId?: string | null
				} | null
				positions?: Array<{
					__typename?: 'Position'
					sequence?: number | null
					shelf?: {
						__typename?: 'Shelf'
						key: string
						bay?: {
							__typename?: 'Bay'
							key: string
							aisle?: { __typename?: 'Aisle'; key: string } | null
						} | null
					} | null
				} | null> | null
			}> | null
		}>
	}
}

export type DownloadPricesQueryVariables = Exact<{
	productType: ProductType
	rootId?: InputMaybe<Scalars['Int']>
	supplierId?: InputMaybe<Scalars['Int']>
}>

export type DownloadPricesQuery = {
	__typename?: 'Query'
	downloadPrices: {
		__typename?: 'DownloadPricesResponse'
		nodes: Array<{
			__typename?: 'DownloadPrice'
			internalId: string
			price: number
		}>
	}
}

export type OrderReportInfoQueryVariables = Exact<{ [key: string]: never }>

export type OrderReportInfoQuery = {
	__typename?: 'Query'
	info?: {
		__typename?: 'InfoResponse'
		rootCount?: number | null
		warehouseProductCount?: number | null
		totalWarehouseOrderCount?: number | null
		openWarehouseOrderCount?: number | null
	} | null
}

export type PredictOrderQuantityQueryVariables = Exact<{
	productId: Scalars['Int']
	startDate: Scalars['DateTime']
	endDate: Scalars['DateTime']
	deliveryTime: Scalars['Int']
}>

export type PredictOrderQuantityQuery = {
	__typename?: 'Query'
	predictOrderQuantity: {
		__typename?: 'PredictOrderQuantityResponse'
		quantity: number
		deliveryTimeDays?: number | null
		avgDailyConsumption?: number | null
		cleanedDataPoints?: number | null
		detectedDeliveries?: number | null
		regressionSlope?: number | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type ProductQuantityHistoryQueryVariables = Exact<{
	productId: Scalars['Int']
	where?: InputMaybe<QuantityHistoryFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type ProductQuantityHistoryQuery = {
	__typename?: 'Query'
	quantityHistory: {
		__typename?: 'QuantityHistoryResponse'
		totalCount: number
		nodes: Array<{
			__typename?: 'QuantityHistory'
			id: number
			created: any
			quantity?: number | null
			quantityChange?: number | null
			mode: ModeEnum
		} | null>
	}
}

export type QuantityUsageHistoryQueryVariables = Exact<{
	productId: Scalars['Int']
	where: QuantityUsageFilter
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type QuantityUsageHistoryQuery = {
	__typename?: 'Query'
	quantityUsage: {
		__typename?: 'QuantityUsageResponse'
		usage: Array<{
			__typename?: 'DailyQuantityData'
			date: any
			quantity: number
		}>
		quantity: Array<{
			__typename?: 'DailyQuantityData'
			date: any
			quantity: number
		}>
		deliveries: Array<{
			__typename?: 'DailyQuantityData'
			date: any
			quantity: number
			isKnown?: boolean | null
		}>
	}
}

export type SearchChildProductsQueryVariables = Exact<{
	where?: InputMaybe<ProductsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type SearchChildProductsQuery = {
	__typename?: 'Query'
	warehouseChildren: {
		__typename?: 'ProductsPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'Product'
			id: number
			internalId: string
			name?: string | null
			parentProduct?: {
				__typename?: 'Product'
				id: number
				name?: string | null
				internalId: string
			} | null
			devices?: Array<{ __typename?: 'Device'; id: number }> | null
			positions?: Array<{
				__typename?: 'Position'
				id: number
			} | null> | null
		}>
	}
}

export type WarehouseProductValueReportQueryVariables = Exact<{
	startDate: Scalars['DateTime']
	rootId?: InputMaybe<Scalars['Int']>
	supplierId?: InputMaybe<Scalars['Int']>
	shelfId?: InputMaybe<Scalars['Int']>
	bayId?: InputMaybe<Scalars['Int']>
	aisleId?: InputMaybe<Scalars['Int']>
}>

export type WarehouseProductValueReportQuery = {
	__typename?: 'Query'
	warehouseProductValueReport: {
		__typename?: 'WarehouseProductValueReports'
		reports: Array<{
			__typename?: 'WarehouseProductValueReport'
			month: string
			EUR: number
			USD: number
			GBP: number
			CHF: number
			date: any
		}>
	}
}

export type AddSupplierMutationVariables = Exact<{
	input: AddSupplier
}>

export type AddSupplierMutation = {
	__typename?: 'Mutation'
	addSupplier: {
		__typename?: 'AddSupplierResponse'
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		supplier?: { __typename?: 'Supplier'; id: number } | null
	}
}

export type DeleteSupplierMutationVariables = Exact<{
	id: Scalars['Int']
}>

export type DeleteSupplierMutation = {
	__typename?: 'Mutation'
	deleteSupplier: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type EditSupplierMutationVariables = Exact<{
	input: EditSupplier
}>

export type EditSupplierMutation = {
	__typename?: 'Mutation'
	editSupplier: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type SupplierQueryVariables = Exact<{
	id: Scalars['Int']
}>

export type SupplierQuery = {
	__typename?: 'Query'
	supplier: {
		__typename?: 'SupplierResponse'
		supplier?: {
			__typename?: 'Supplier'
			id: number
			companyName: string
			email?: string | null
			supplierId?: string | null
			address?: string | null
			addressNumber?: string | null
			country?: Country | null
			postCode?: string | null
			city?: string | null
			vat?: string | null
			verifiedEmail?: boolean | null
			supplierRootSettings?: Array<{
				__typename?: 'SupplierRootSettings'
				id: number
				rootId: number
				supplierId: number
				deliveryTime: number
				root: { __typename?: 'Root'; id: number; name?: string | null }
			}> | null
		} | null
	}
}

export type SuppliersQueryVariables = Exact<{
	where?: InputMaybe<SuppliersFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type SuppliersQuery = {
	__typename?: 'Query'
	suppliers: {
		__typename?: 'SuppliersPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'Supplier'
			id: number
			companyName: string
			supplierId?: string | null
			country?: Country | null
			address?: string | null
			postCode?: string | null
			city?: string | null
		} | null>
	}
}

export type TriggerDeviceLedMutationVariables = Exact<{
	input: TriggerDeviceLedInput
}>

export type TriggerDeviceLedMutation = {
	__typename?: 'Mutation'
	triggerDeviceLed: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
	}
}

export type WarehouseOrderReportQueryVariables = Exact<{
	input: WarehouseOrderReportInput
}>

export type WarehouseOrderReportQuery = {
	__typename?: 'Query'
	warehouseOrderReport: {
		__typename?: 'WarehouseOrderReport'
		allOrders: Array<{
			__typename?: 'WarehouseOrderCount'
			date: any
			normalCount: number
			expressCount: number
			total: number
		}>
		stockValue: Array<{
			__typename?: 'WarehouseStockValue'
			date: any
			EUR: number
			USD: number
			GBP: number
			CHF: number
		}>
	}
}

export type WarehouseParentProductQueryVariables = Exact<{
	id: Scalars['Int']
}>

export type WarehouseParentProductQuery = {
	__typename?: 'Query'
	product: {
		__typename?: 'ProductResponse'
		product?: {
			__typename?: 'Product'
			id: number
			internalId: string
			name?: string | null
			valueEntities?: Array<{
				__typename?: 'Value'
				templateKey: string
				value: string
			}> | null
			productImages?: Array<{
				__typename?: 'ProductImage'
				id: number
				primary: boolean
				file: {
					__typename?: 'File'
					id: number
					originalname?: string | null
					filename?: string | null
					mimetype?: string | null
					encoding?: string | null
					url?: string | null
					isFolder: boolean
					width?: number | null
					height?: number | null
					thumbnail?: string | null
				}
			} | null> | null
		} | null
	}
}

export type WarehouseParentProductsQueryVariables = Exact<{
	where?: InputMaybe<ProductsFilter>
	offset: Scalars['Int']
	limit: Scalars['Int']
}>

export type WarehouseParentProductsQuery = {
	__typename?: 'Query'
	products: {
		__typename?: 'ProductsPaginations'
		totalCount: number
		nodes: Array<{
			__typename?: 'Product'
			id: number
			name?: string | null
			internalId: string
			valueEntities?: Array<{
				__typename?: 'Value'
				templateKey: string
				value: string
			}> | null
			products?: Array<{
				__typename?: 'Product'
				id: number
				internalId: string
				name?: string | null
				valueEntities?: Array<{
					__typename?: 'Value'
					templateKey: string
					value: string
				}> | null
				root?: {
					__typename?: 'Root'
					id: number
					name?: string | null
				} | null
				supplier?: {
					__typename?: 'Supplier'
					id: number
					companyName: string
					supplierId?: string | null
				} | null
				positions?: Array<{
					__typename?: 'Position'
					id: number
					sequence?: number | null
					shelf?: {
						__typename?: 'Shelf'
						key: string
						bay?: {
							__typename?: 'Bay'
							key: string
							aisle?: { __typename?: 'Aisle'; key: string } | null
						} | null
					} | null
				} | null> | null
			}> | null
			productImages?: Array<{
				__typename?: 'ProductImage'
				id: number
				file: { __typename?: 'File'; thumbnail?: string | null }
			} | null> | null
		}>
	}
}

export type WarehouseProductQueryVariables = Exact<{
	id: Scalars['Int']
}>

export type WarehouseProductQuery = {
	__typename?: 'Query'
	product: {
		__typename?: 'ProductResponse'
		product?: {
			__typename?: 'Product'
			id: number
			internalId: string
			name?: string | null
			rootId?: number | null
			expirationDate?: any | null
			parentProduct?: {
				__typename?: 'Product'
				id: number
				name?: string | null
				internalId: string
				valueEntities?: Array<{
					__typename?: 'Value'
					templateKey: string
					value: string
				}> | null
				productImages?: Array<{
					__typename?: 'ProductImage'
					id: number
					primary: boolean
					file: {
						__typename?: 'File'
						id: number
						originalname?: string | null
						filename?: string | null
						mimetype?: string | null
						encoding?: string | null
						url?: string | null
						isFolder: boolean
						width?: number | null
						height?: number | null
						thumbnail?: string | null
					}
				} | null> | null
			} | null
			supplier?: {
				__typename?: 'Supplier'
				id: number
				supplierId?: string | null
				companyName: string
				supplierRootSettings?: Array<{
					__typename?: 'SupplierRootSettings'
					rootId: number
					deliveryTime: number
				}> | null
			} | null
			valueEntities?: Array<{
				__typename?: 'Value'
				templateKey: string
				value: string
			}> | null
			positions?: Array<{
				__typename?: 'Position'
				id: number
				sequence?: number | null
				device?: {
					__typename?: 'Device'
					id: number
					serialNumber: string
				} | null
				shelf?: {
					__typename?: 'Shelf'
					key: string
					bay?: {
						__typename?: 'Bay'
						key: string
						aisle?: { __typename?: 'Aisle'; key: string } | null
					} | null
				} | null
			} | null> | null
			devices?: Array<{
				__typename?: 'Device'
				id: number
				serialNumber: string
			}> | null
		} | null
	}
}

export type AddWarehouseProductsMutationVariables = Exact<{
	input: Array<ProductInput> | ProductInput
}>

export type AddWarehouseProductsMutation = {
	__typename?: 'Mutation'
	addEditProducts: {
		__typename?: 'addEditProductsResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		addedProducts?: Array<{
			__typename?: 'Product'
			id: number
			internalId: string
			name?: string | null
			rootId?: number | null
			valueEntities?: Array<{
				__typename?: 'Value'
				id: number
				name?: string | null
				templateKey: string
				type?: DeviceValueType | null
				value: string
			}> | null
		}> | null
	}
}

export type AddEditWarehouseProductsNewPositionMutationVariables = Exact<{
	input: Array<ProductInput> | ProductInput
	positionId: Scalars['Int']
	positionInput: EditPositionInput
}>

export type AddEditWarehouseProductsNewPositionMutation = {
	__typename?: 'Mutation'
	addEditProducts: {
		__typename?: 'addEditProductsResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		addedProducts?: Array<{
			__typename?: 'Product'
			id: number
			internalId: string
			name?: string | null
			rootId?: number | null
			valueEntities?: Array<{
				__typename?: 'Value'
				id: number
				name?: string | null
				templateKey: string
				type?: DeviceValueType | null
				value: string
			}> | null
		}> | null
	}
	editPosition: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			message: string
			path: string
		}> | null
	}
}

export type AddEditWarehouseProductsOldPositionMutationVariables = Exact<{
	input: Array<ProductInput> | ProductInput
	oldPositionId: Scalars['Int']
	oldPositionInput: EditPositionInput
}>

export type AddEditWarehouseProductsOldPositionMutation = {
	__typename?: 'Mutation'
	addEditProducts: {
		__typename?: 'addEditProductsResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		addedProducts?: Array<{
			__typename?: 'Product'
			id: number
			internalId: string
			name?: string | null
			rootId?: number | null
			valueEntities?: Array<{
				__typename?: 'Value'
				id: number
				name?: string | null
				templateKey: string
				type?: DeviceValueType | null
				value: string
			}> | null
		}> | null
	}
	editPosition: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			message: string
			path: string
		}> | null
	}
}

export type AddEditWarehouseProductsOldPositionNewPositionMutationVariables =
	Exact<{
		input: Array<ProductInput> | ProductInput
		positionId: Scalars['Int']
		positionInput: EditPositionInput
		oldPositionId: Scalars['Int']
		oldPositionInput: EditPositionInput
	}>

export type AddEditWarehouseProductsOldPositionNewPositionMutation = {
	__typename?: 'Mutation'
	addEditProducts: {
		__typename?: 'addEditProductsResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		addedProducts?: Array<{
			__typename?: 'Product'
			id: number
			internalId: string
			name?: string | null
			rootId?: number | null
			valueEntities?: Array<{
				__typename?: 'Value'
				id: number
				name?: string | null
				templateKey: string
				type?: DeviceValueType | null
				value: string
			}> | null
		}> | null
	}
	A: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			message: string
			path: string
		}> | null
	}
	B: {
		__typename?: 'StandardResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			message: string
			path: string
		}> | null
	}
}

export type AddWarehouseProductMutationVariables = Exact<{
	input: ProductInput
}>

export type AddWarehouseProductMutation = {
	__typename?: 'Mutation'
	addProduct: {
		__typename?: 'AddProductResponse'
		success?: boolean | null
		errors?: Array<{
			__typename?: 'Error'
			path: string
			message: string
		}> | null
		product?: { __typename?: 'Product'; id: number } | null
	}
}

export type WarehouseProductReportQueryVariables = Exact<{
	date: Scalars['DateTime']
	rootId?: InputMaybe<Scalars['Int']>
	supplierId?: InputMaybe<Scalars['Int']>
	shelfId?: InputMaybe<Scalars['Int']>
	bayId?: InputMaybe<Scalars['Int']>
	aisleId?: InputMaybe<Scalars['Int']>
}>

export type WarehouseProductReportQuery = {
	__typename?: 'Query'
	warehouseProductReport: Array<{
		__typename?: 'WarehouseProduct'
		quantity: number
		lastChange: any
		mode: ModeEnum
		product: {
			__typename?: 'Product'
			id: number
			internalId: string
			name?: string | null
			root?: { __typename?: 'Root'; name?: string | null } | null
			supplier?: { __typename?: 'Supplier'; companyName: string } | null
			valueEntities?: Array<{
				__typename?: 'Value'
				templateKey: string
				value: string
			}> | null
			parentProduct?: {
				__typename?: 'Product'
				name?: string | null
			} | null
			products?: Array<{
				__typename?: 'Product'
				id: number
				internalId: string
				name?: string | null
				valueEntities?: Array<{
					__typename?: 'Value'
					templateKey: string
					value: string
				}> | null
			}> | null
		}
	}>
}

export const AddRootDocument = gql`
	mutation addRoot($input: AddRootInput!) {
		addRoot(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type AddRootMutationFn = Apollo.MutationFunction<
	AddRootMutation,
	AddRootMutationVariables
>

/**
 * __useAddRootMutation__
 *
 * To run a mutation, you first call `useAddRootMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRootMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRootMutation, { data, loading, error }] = useAddRootMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRootMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddRootMutation,
		AddRootMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddRootMutation,
		AddRootMutationVariables
	>(AddRootDocument, options)
}
export type AddRootMutationHookResult = ReturnType<typeof useAddRootMutation>
export type AddRootMutationResult = Apollo.MutationResult<AddRootMutation>
export type AddRootMutationOptions = Apollo.BaseMutationOptions<
	AddRootMutation,
	AddRootMutationVariables
>
export const AutofillCoordinatesDocument = gql`
	mutation autofillCoordinates {
		autofillCoordinates {
			errors {
				path
				message
			}
			success
			eligibleCount
			errorCount
			successCount
		}
	}
`
export type AutofillCoordinatesMutationFn = Apollo.MutationFunction<
	AutofillCoordinatesMutation,
	AutofillCoordinatesMutationVariables
>

/**
 * __useAutofillCoordinatesMutation__
 *
 * To run a mutation, you first call `useAutofillCoordinatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutofillCoordinatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autofillCoordinatesMutation, { data, loading, error }] = useAutofillCoordinatesMutation({
 *   variables: {
 *   },
 * });
 */
export function useAutofillCoordinatesMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AutofillCoordinatesMutation,
		AutofillCoordinatesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AutofillCoordinatesMutation,
		AutofillCoordinatesMutationVariables
	>(AutofillCoordinatesDocument, options)
}
export type AutofillCoordinatesMutationHookResult = ReturnType<
	typeof useAutofillCoordinatesMutation
>
export type AutofillCoordinatesMutationResult =
	Apollo.MutationResult<AutofillCoordinatesMutation>
export type AutofillCoordinatesMutationOptions = Apollo.BaseMutationOptions<
	AutofillCoordinatesMutation,
	AutofillCoordinatesMutationVariables
>
export const DeleteRootDocument = gql`
	mutation deleteRoot($id: Int!) {
		deleteRoot(id: $id) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteRootMutationFn = Apollo.MutationFunction<
	DeleteRootMutation,
	DeleteRootMutationVariables
>

/**
 * __useDeleteRootMutation__
 *
 * To run a mutation, you first call `useDeleteRootMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRootMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRootMutation, { data, loading, error }] = useDeleteRootMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRootMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteRootMutation,
		DeleteRootMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteRootMutation,
		DeleteRootMutationVariables
	>(DeleteRootDocument, options)
}
export type DeleteRootMutationHookResult = ReturnType<
	typeof useDeleteRootMutation
>
export type DeleteRootMutationResult = Apollo.MutationResult<DeleteRootMutation>
export type DeleteRootMutationOptions = Apollo.BaseMutationOptions<
	DeleteRootMutation,
	DeleteRootMutationVariables
>
export const EditRootDocument = gql`
	mutation editRoot($id: Int!, $input: EditRootInput!) {
		editRoot(rootId: $id, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditRootMutationFn = Apollo.MutationFunction<
	EditRootMutation,
	EditRootMutationVariables
>

/**
 * __useEditRootMutation__
 *
 * To run a mutation, you first call `useEditRootMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRootMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRootMutation, { data, loading, error }] = useEditRootMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditRootMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditRootMutation,
		EditRootMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditRootMutation,
		EditRootMutationVariables
	>(EditRootDocument, options)
}
export type EditRootMutationHookResult = ReturnType<typeof useEditRootMutation>
export type EditRootMutationResult = Apollo.MutationResult<EditRootMutation>
export type EditRootMutationOptions = Apollo.BaseMutationOptions<
	EditRootMutation,
	EditRootMutationVariables
>
export const LocationDashboardDocument = gql`
	query locationDashboard($rootId: Int!) {
		root(rootId: $rootId) {
			root {
				id
				deviceCount
				routerCount
				batteryUnderCount
				deviceErrCount
				deviceProcessingCount
				routerOffline
				market {
					id
					name
				}
			}
		}
	}
`

/**
 * __useLocationDashboardQuery__
 *
 * To run a query within a React component, call `useLocationDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationDashboardQuery({
 *   variables: {
 *      rootId: // value for 'rootId'
 *   },
 * });
 */
export function useLocationDashboardQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		LocationDashboardQuery,
		LocationDashboardQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		LocationDashboardQuery,
		LocationDashboardQueryVariables
	>(LocationDashboardDocument, options)
}
export function useLocationDashboardLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		LocationDashboardQuery,
		LocationDashboardQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		LocationDashboardQuery,
		LocationDashboardQueryVariables
	>(LocationDashboardDocument, options)
}
export type LocationDashboardQueryHookResult = ReturnType<
	typeof useLocationDashboardQuery
>
export type LocationDashboardLazyQueryHookResult = ReturnType<
	typeof useLocationDashboardLazyQuery
>
export type LocationDashboardQueryResult = Apollo.QueryResult<
	LocationDashboardQuery,
	LocationDashboardQueryVariables
>
export const LocationsDocument = gql`
	query locations($where: RootsFilter, $offset: Int!, $limit: Int!) {
		roots(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				name
				latitude
				longitude
				deviceCount
				routerCount
				market {
					name
				}
				__typename
			}
			totalCount
		}
	}
`

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useLocationsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		LocationsQuery,
		LocationsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<LocationsQuery, LocationsQueryVariables>(
		LocationsDocument,
		options
	)
}
export function useLocationsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		LocationsQuery,
		LocationsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		LocationsQuery,
		LocationsQueryVariables
	>(LocationsDocument, options)
}
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>
export type LocationsLazyQueryHookResult = ReturnType<
	typeof useLocationsLazyQuery
>
export type LocationsQueryResult = Apollo.QueryResult<
	LocationsQuery,
	LocationsQueryVariables
>
export const LocationsDashboardDocument = gql`
	query locationsDashboard($where: RootsFilter, $offset: Int!, $limit: Int!) {
		roots(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				name
				latitude
				longitude
			}
		}
	}
`

/**
 * __useLocationsDashboardQuery__
 *
 * To run a query within a React component, call `useLocationsDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsDashboardQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useLocationsDashboardQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		LocationsDashboardQuery,
		LocationsDashboardQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		LocationsDashboardQuery,
		LocationsDashboardQueryVariables
	>(LocationsDashboardDocument, options)
}
export function useLocationsDashboardLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		LocationsDashboardQuery,
		LocationsDashboardQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		LocationsDashboardQuery,
		LocationsDashboardQueryVariables
	>(LocationsDashboardDocument, options)
}
export type LocationsDashboardQueryHookResult = ReturnType<
	typeof useLocationsDashboardQuery
>
export type LocationsDashboardLazyQueryHookResult = ReturnType<
	typeof useLocationsDashboardLazyQuery
>
export type LocationsDashboardQueryResult = Apollo.QueryResult<
	LocationsDashboardQuery,
	LocationsDashboardQueryVariables
>
export const LocationsSelectDocument = gql`
	query locationsSelect($where: RootsFilter, $offset: Int!, $limit: Int!) {
		roots(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				key
				name
				__typename
			}
			totalCount
		}
	}
`

/**
 * __useLocationsSelectQuery__
 *
 * To run a query within a React component, call `useLocationsSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsSelectQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useLocationsSelectQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		LocationsSelectQuery,
		LocationsSelectQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		LocationsSelectQuery,
		LocationsSelectQueryVariables
	>(LocationsSelectDocument, options)
}
export function useLocationsSelectLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		LocationsSelectQuery,
		LocationsSelectQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		LocationsSelectQuery,
		LocationsSelectQueryVariables
	>(LocationsSelectDocument, options)
}
export type LocationsSelectQueryHookResult = ReturnType<
	typeof useLocationsSelectQuery
>
export type LocationsSelectLazyQueryHookResult = ReturnType<
	typeof useLocationsSelectLazyQuery
>
export type LocationsSelectQueryResult = Apollo.QueryResult<
	LocationsSelectQuery,
	LocationsSelectQueryVariables
>
export const LocationsSelectRoutersDocument = gql`
	query locationsSelectRouters(
		$where: RootsFilter
		$offset: Int!
		$limit: Int!
	) {
		roots(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				key
				name
				routers {
					id
				}
				__typename
			}
			totalCount
		}
	}
`

/**
 * __useLocationsSelectRoutersQuery__
 *
 * To run a query within a React component, call `useLocationsSelectRoutersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsSelectRoutersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsSelectRoutersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useLocationsSelectRoutersQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		LocationsSelectRoutersQuery,
		LocationsSelectRoutersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		LocationsSelectRoutersQuery,
		LocationsSelectRoutersQueryVariables
	>(LocationsSelectRoutersDocument, options)
}
export function useLocationsSelectRoutersLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		LocationsSelectRoutersQuery,
		LocationsSelectRoutersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		LocationsSelectRoutersQuery,
		LocationsSelectRoutersQueryVariables
	>(LocationsSelectRoutersDocument, options)
}
export type LocationsSelectRoutersQueryHookResult = ReturnType<
	typeof useLocationsSelectRoutersQuery
>
export type LocationsSelectRoutersLazyQueryHookResult = ReturnType<
	typeof useLocationsSelectRoutersLazyQuery
>
export type LocationsSelectRoutersQueryResult = Apollo.QueryResult<
	LocationsSelectRoutersQuery,
	LocationsSelectRoutersQueryVariables
>
export const RootDocument = gql`
	query root($rootId: Int!) {
		root(rootId: $rootId) {
			root {
				id
				key
				name
				latitude
				longitude
				mode
				marketId
				burninPrevention
				market {
					id
					name
				}
				timezone
				address
				tags
			}
		}
	}
`

/**
 * __useRootQuery__
 *
 * To run a query within a React component, call `useRootQuery` and pass it any options that fit your needs.
 * When your component renders, `useRootQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRootQuery({
 *   variables: {
 *      rootId: // value for 'rootId'
 *   },
 * });
 */
export function useRootQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		RootQuery,
		RootQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<RootQuery, RootQueryVariables>(
		RootDocument,
		options
	)
}
export function useRootLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		RootQuery,
		RootQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<RootQuery, RootQueryVariables>(
		RootDocument,
		options
	)
}
export type RootQueryHookResult = ReturnType<typeof useRootQuery>
export type RootLazyQueryHookResult = ReturnType<typeof useRootLazyQuery>
export type RootQueryResult = Apollo.QueryResult<RootQuery, RootQueryVariables>
export const RootNameDocument = gql`
	query rootName($rootId: Int!) {
		root(rootId: $rootId) {
			root {
				id
				name
			}
		}
	}
`

/**
 * __useRootNameQuery__
 *
 * To run a query within a React component, call `useRootNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useRootNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRootNameQuery({
 *   variables: {
 *      rootId: // value for 'rootId'
 *   },
 * });
 */
export function useRootNameQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		RootNameQuery,
		RootNameQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<RootNameQuery, RootNameQueryVariables>(
		RootNameDocument,
		options
	)
}
export function useRootNameLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		RootNameQuery,
		RootNameQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<RootNameQuery, RootNameQueryVariables>(
		RootNameDocument,
		options
	)
}
export type RootNameQueryHookResult = ReturnType<typeof useRootNameQuery>
export type RootNameLazyQueryHookResult = ReturnType<
	typeof useRootNameLazyQuery
>
export type RootNameQueryResult = Apollo.QueryResult<
	RootNameQuery,
	RootNameQueryVariables
>
export const RootsDocument = gql`
	query roots($where: RootsFilter, $offset: Int!, $limit: Int!) {
		roots(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				name
				tags
			}
		}
	}
`

/**
 * __useRootsQuery__
 *
 * To run a query within a React component, call `useRootsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRootsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRootsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRootsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		RootsQuery,
		RootsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<RootsQuery, RootsQueryVariables>(
		RootsDocument,
		options
	)
}
export function useRootsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		RootsQuery,
		RootsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<RootsQuery, RootsQueryVariables>(
		RootsDocument,
		options
	)
}
export type RootsQueryHookResult = ReturnType<typeof useRootsQuery>
export type RootsLazyQueryHookResult = ReturnType<typeof useRootsLazyQuery>
export type RootsQueryResult = Apollo.QueryResult<
	RootsQuery,
	RootsQueryVariables
>
export const TimezoneLookupDocument = gql`
	query timezoneLookup($latitude: Float!, $longitude: Float!) {
		timezoneLookup(latitude: $latitude, longitude: $longitude)
	}
`

/**
 * __useTimezoneLookupQuery__
 *
 * To run a query within a React component, call `useTimezoneLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimezoneLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimezoneLookupQuery({
 *   variables: {
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *   },
 * });
 */
export function useTimezoneLookupQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		TimezoneLookupQuery,
		TimezoneLookupQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		TimezoneLookupQuery,
		TimezoneLookupQueryVariables
	>(TimezoneLookupDocument, options)
}
export function useTimezoneLookupLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		TimezoneLookupQuery,
		TimezoneLookupQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		TimezoneLookupQuery,
		TimezoneLookupQueryVariables
	>(TimezoneLookupDocument, options)
}
export type TimezoneLookupQueryHookResult = ReturnType<
	typeof useTimezoneLookupQuery
>
export type TimezoneLookupLazyQueryHookResult = ReturnType<
	typeof useTimezoneLookupLazyQuery
>
export type TimezoneLookupQueryResult = Apollo.QueryResult<
	TimezoneLookupQuery,
	TimezoneLookupQueryVariables
>
export const AddMarketDocument = gql`
	mutation addMarket($input: AddMarketInput!) {
		addMarket(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type AddMarketMutationFn = Apollo.MutationFunction<
	AddMarketMutation,
	AddMarketMutationVariables
>

/**
 * __useAddMarketMutation__
 *
 * To run a mutation, you first call `useAddMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMarketMutation, { data, loading, error }] = useAddMarketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMarketMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddMarketMutation,
		AddMarketMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddMarketMutation,
		AddMarketMutationVariables
	>(AddMarketDocument, options)
}
export type AddMarketMutationHookResult = ReturnType<
	typeof useAddMarketMutation
>
export type AddMarketMutationResult = Apollo.MutationResult<AddMarketMutation>
export type AddMarketMutationOptions = Apollo.BaseMutationOptions<
	AddMarketMutation,
	AddMarketMutationVariables
>
export const DeleteMarketDocument = gql`
	mutation deleteMarket($id: Int!) {
		deleteMarket(id: $id) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteMarketMutationFn = Apollo.MutationFunction<
	DeleteMarketMutation,
	DeleteMarketMutationVariables
>

/**
 * __useDeleteMarketMutation__
 *
 * To run a mutation, you first call `useDeleteMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMarketMutation, { data, loading, error }] = useDeleteMarketMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMarketMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteMarketMutation,
		DeleteMarketMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteMarketMutation,
		DeleteMarketMutationVariables
	>(DeleteMarketDocument, options)
}
export type DeleteMarketMutationHookResult = ReturnType<
	typeof useDeleteMarketMutation
>
export type DeleteMarketMutationResult =
	Apollo.MutationResult<DeleteMarketMutation>
export type DeleteMarketMutationOptions = Apollo.BaseMutationOptions<
	DeleteMarketMutation,
	DeleteMarketMutationVariables
>
export const EditMarketDocument = gql`
	mutation editMarket($id: Int!, $input: EditMarketInput!) {
		editMarket(marketId: $id, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditMarketMutationFn = Apollo.MutationFunction<
	EditMarketMutation,
	EditMarketMutationVariables
>

/**
 * __useEditMarketMutation__
 *
 * To run a mutation, you first call `useEditMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMarketMutation, { data, loading, error }] = useEditMarketMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMarketMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditMarketMutation,
		EditMarketMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditMarketMutation,
		EditMarketMutationVariables
	>(EditMarketDocument, options)
}
export type EditMarketMutationHookResult = ReturnType<
	typeof useEditMarketMutation
>
export type EditMarketMutationResult = Apollo.MutationResult<EditMarketMutation>
export type EditMarketMutationOptions = Apollo.BaseMutationOptions<
	EditMarketMutation,
	EditMarketMutationVariables
>
export const MarketDocument = gql`
	query market($id: Int!) {
		market(marketId: $id) {
			market {
				id
				name
				key
			}
		}
	}
`

/**
 * __useMarketQuery__
 *
 * To run a query within a React component, call `useMarketQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		MarketQuery,
		MarketQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<MarketQuery, MarketQueryVariables>(
		MarketDocument,
		options
	)
}
export function useMarketLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		MarketQuery,
		MarketQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<MarketQuery, MarketQueryVariables>(
		MarketDocument,
		options
	)
}
export type MarketQueryHookResult = ReturnType<typeof useMarketQuery>
export type MarketLazyQueryHookResult = ReturnType<typeof useMarketLazyQuery>
export type MarketQueryResult = Apollo.QueryResult<
	MarketQuery,
	MarketQueryVariables
>
export const MarketsDocument = gql`
	query markets($where: MarketsFilter, $offset: Int!, $limit: Int!) {
		markets(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				key
				name
				rootsCount
			}
			totalCount
		}
	}
`

/**
 * __useMarketsQuery__
 *
 * To run a query within a React component, call `useMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMarketsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		MarketsQuery,
		MarketsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<MarketsQuery, MarketsQueryVariables>(
		MarketsDocument,
		options
	)
}
export function useMarketsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		MarketsQuery,
		MarketsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<MarketsQuery, MarketsQueryVariables>(
		MarketsDocument,
		options
	)
}
export type MarketsQueryHookResult = ReturnType<typeof useMarketsQuery>
export type MarketsLazyQueryHookResult = ReturnType<typeof useMarketsLazyQuery>
export type MarketsQueryResult = Apollo.QueryResult<
	MarketsQuery,
	MarketsQueryVariables
>
export const AddRouterDocument = gql`
	mutation addRouter($input: AddRouterInput!) {
		addRouter(input: $input) {
			router {
				id
			}
			errors {
				path
				message
			}
		}
	}
`
export type AddRouterMutationFn = Apollo.MutationFunction<
	AddRouterMutation,
	AddRouterMutationVariables
>

/**
 * __useAddRouterMutation__
 *
 * To run a mutation, you first call `useAddRouterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRouterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRouterMutation, { data, loading, error }] = useAddRouterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRouterMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddRouterMutation,
		AddRouterMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddRouterMutation,
		AddRouterMutationVariables
	>(AddRouterDocument, options)
}
export type AddRouterMutationHookResult = ReturnType<
	typeof useAddRouterMutation
>
export type AddRouterMutationResult = Apollo.MutationResult<AddRouterMutation>
export type AddRouterMutationOptions = Apollo.BaseMutationOptions<
	AddRouterMutation,
	AddRouterMutationVariables
>
export const DeleteRouterDocument = gql`
	mutation deleteRouter($id: Int!) {
		deleteRouter(id: $id) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteRouterMutationFn = Apollo.MutationFunction<
	DeleteRouterMutation,
	DeleteRouterMutationVariables
>

/**
 * __useDeleteRouterMutation__
 *
 * To run a mutation, you first call `useDeleteRouterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRouterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRouterMutation, { data, loading, error }] = useDeleteRouterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRouterMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteRouterMutation,
		DeleteRouterMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteRouterMutation,
		DeleteRouterMutationVariables
	>(DeleteRouterDocument, options)
}
export type DeleteRouterMutationHookResult = ReturnType<
	typeof useDeleteRouterMutation
>
export type DeleteRouterMutationResult =
	Apollo.MutationResult<DeleteRouterMutation>
export type DeleteRouterMutationOptions = Apollo.BaseMutationOptions<
	DeleteRouterMutation,
	DeleteRouterMutationVariables
>
export const EditRouterDocument = gql`
	mutation editRouter($id: Int!, $input: EditRouterInput!) {
		editRouter(routerId: $id, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditRouterMutationFn = Apollo.MutationFunction<
	EditRouterMutation,
	EditRouterMutationVariables
>

/**
 * __useEditRouterMutation__
 *
 * To run a mutation, you first call `useEditRouterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRouterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRouterMutation, { data, loading, error }] = useEditRouterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditRouterMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditRouterMutation,
		EditRouterMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditRouterMutation,
		EditRouterMutationVariables
	>(EditRouterDocument, options)
}
export type EditRouterMutationHookResult = ReturnType<
	typeof useEditRouterMutation
>
export type EditRouterMutationResult = Apollo.MutationResult<EditRouterMutation>
export type EditRouterMutationOptions = Apollo.BaseMutationOptions<
	EditRouterMutation,
	EditRouterMutationVariables
>
export const RouterDetailsDocument = gql`
	query routerDetails($uuid: String, $id: Int) {
		routerDetails(uuid: $uuid, id: $id) {
			routerDetails {
				cpu_temp
				cpu_usage
				memory_usage
				memory_total
				is_online
				is_connected_to_vpn
				ip_address
				mac_address
				storage_usage
				storage_total
				is_undervolted
				last_seen
				router {
					id
					name
					dhcp
					token
					macAddress
					uuid
					type
					version
					online
					root {
						id
						name
					}
					routerNetwork {
						ip
						subnet
						gateway
						dns1
						dns2
						wifichannel
						wifimode
					}
				}
			}
		}
	}
`

/**
 * __useRouterDetailsQuery__
 *
 * To run a query within a React component, call `useRouterDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouterDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouterDetailsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRouterDetailsQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		RouterDetailsQuery,
		RouterDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		RouterDetailsQuery,
		RouterDetailsQueryVariables
	>(RouterDetailsDocument, options)
}
export function useRouterDetailsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		RouterDetailsQuery,
		RouterDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		RouterDetailsQuery,
		RouterDetailsQueryVariables
	>(RouterDetailsDocument, options)
}
export type RouterDetailsQueryHookResult = ReturnType<
	typeof useRouterDetailsQuery
>
export type RouterDetailsLazyQueryHookResult = ReturnType<
	typeof useRouterDetailsLazyQuery
>
export type RouterDetailsQueryResult = Apollo.QueryResult<
	RouterDetailsQuery,
	RouterDetailsQueryVariables
>
export const RoutersDocument = gql`
	query routers($offset: Int!, $limit: Int!, $where: RoutersFilter) {
		routers(offset: $offset, limit: $limit, where: $where) {
			nodes {
				id
				name
				macAddress
				root {
					id
					name
					market {
						id
						name
					}
				}
				uuid
				type
				version
				online
				deviceCount
			}
			totalCount
		}
	}
`

/**
 * __useRoutersQuery__
 *
 * To run a query within a React component, call `useRoutersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoutersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoutersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRoutersQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		RoutersQuery,
		RoutersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<RoutersQuery, RoutersQueryVariables>(
		RoutersDocument,
		options
	)
}
export function useRoutersLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		RoutersQuery,
		RoutersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<RoutersQuery, RoutersQueryVariables>(
		RoutersDocument,
		options
	)
}
export type RoutersQueryHookResult = ReturnType<typeof useRoutersQuery>
export type RoutersLazyQueryHookResult = ReturnType<typeof useRoutersLazyQuery>
export type RoutersQueryResult = Apollo.QueryResult<
	RoutersQuery,
	RoutersQueryVariables
>
export const RoutersSelectDocument = gql`
	query routersSelect($offset: Int!, $limit: Int!, $where: RoutersFilter) {
		routers(offset: $offset, limit: $limit, where: $where) {
			nodes {
				id
				name
				macAddress
				uuid
			}
			totalCount
		}
	}
`

/**
 * __useRoutersSelectQuery__
 *
 * To run a query within a React component, call `useRoutersSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoutersSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoutersSelectQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRoutersSelectQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		RoutersSelectQuery,
		RoutersSelectQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		RoutersSelectQuery,
		RoutersSelectQueryVariables
	>(RoutersSelectDocument, options)
}
export function useRoutersSelectLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		RoutersSelectQuery,
		RoutersSelectQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		RoutersSelectQuery,
		RoutersSelectQueryVariables
	>(RoutersSelectDocument, options)
}
export type RoutersSelectQueryHookResult = ReturnType<
	typeof useRoutersSelectQuery
>
export type RoutersSelectLazyQueryHookResult = ReturnType<
	typeof useRoutersSelectLazyQuery
>
export type RoutersSelectQueryResult = Apollo.QueryResult<
	RoutersSelectQuery,
	RoutersSelectQueryVariables
>
export const CheckAuthDocument = gql`
	query checkAuth {
		checkAuth
	}
`

/**
 * __useCheckAuthQuery__
 *
 * To run a query within a React component, call `useCheckAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckAuthQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckAuthQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		CheckAuthQuery,
		CheckAuthQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<CheckAuthQuery, CheckAuthQueryVariables>(
		CheckAuthDocument,
		options
	)
}
export function useCheckAuthLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		CheckAuthQuery,
		CheckAuthQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		CheckAuthQuery,
		CheckAuthQueryVariables
	>(CheckAuthDocument, options)
}
export type CheckAuthQueryHookResult = ReturnType<typeof useCheckAuthQuery>
export type CheckAuthLazyQueryHookResult = ReturnType<
	typeof useCheckAuthLazyQuery
>
export type CheckAuthQueryResult = Apollo.QueryResult<
	CheckAuthQuery,
	CheckAuthQueryVariables
>
export const LoginDocument = gql`
	mutation login($username: String!, $password: String!, $otp: String!) {
		login(username: $username, password: $password, otp: $otp) {
			errors {
				path
				message
			}
			tokens
			needOTP
			delta
		}
	}
`
export type LoginMutationFn = Apollo.MutationFunction<
	LoginMutation,
	LoginMutationVariables
>

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useLoginMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		LoginMutation,
		LoginMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<LoginMutation, LoginMutationVariables>(
		LoginDocument,
		options
	)
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>
export type LoginMutationOptions = Apollo.BaseMutationOptions<
	LoginMutation,
	LoginMutationVariables
>
export const LogoutDocument = gql`
	mutation logout {
		logout
	}
`
export type LogoutMutationFn = Apollo.MutationFunction<
	LogoutMutation,
	LogoutMutationVariables
>

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		LogoutMutation,
		LogoutMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		LogoutMutation,
		LogoutMutationVariables
	>(LogoutDocument, options)
}
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>
export type LogoutMutationOptions = Apollo.BaseMutationOptions<
	LogoutMutation,
	LogoutMutationVariables
>
export const UrlAnalyticsDocument = gql`
	query urlAnalytics($where: UrlAnalyticsFilter, $offset: Int, $limit: Int) {
		urlAnalytics(where: $where, offset: $offset, limit: $limit) {
			nodes {
				accessTime
				deviceSerialNumber
				userAgent
				productId
				rootId
				product {
					name
					internalId
				}
				root {
					name
				}
			}
			totalCount
		}
	}
`

/**
 * __useUrlAnalyticsQuery__
 *
 * To run a query within a React component, call `useUrlAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUrlAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUrlAnalyticsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUrlAnalyticsQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		UrlAnalyticsQuery,
		UrlAnalyticsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		UrlAnalyticsQuery,
		UrlAnalyticsQueryVariables
	>(UrlAnalyticsDocument, options)
}
export function useUrlAnalyticsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		UrlAnalyticsQuery,
		UrlAnalyticsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		UrlAnalyticsQuery,
		UrlAnalyticsQueryVariables
	>(UrlAnalyticsDocument, options)
}
export type UrlAnalyticsQueryHookResult = ReturnType<
	typeof useUrlAnalyticsQuery
>
export type UrlAnalyticsLazyQueryHookResult = ReturnType<
	typeof useUrlAnalyticsLazyQuery
>
export type UrlAnalyticsQueryResult = Apollo.QueryResult<
	UrlAnalyticsQuery,
	UrlAnalyticsQueryVariables
>
export const UrlAnalyticsChartDocument = gql`
	query urlAnalyticsChart($where: UrlAnalyticsChartFilter) {
		urlAnalyticsChart(where: $where) {
			nodes {
				date
				count
			}
		}
	}
`

/**
 * __useUrlAnalyticsChartQuery__
 *
 * To run a query within a React component, call `useUrlAnalyticsChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useUrlAnalyticsChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUrlAnalyticsChartQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUrlAnalyticsChartQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		UrlAnalyticsChartQuery,
		UrlAnalyticsChartQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		UrlAnalyticsChartQuery,
		UrlAnalyticsChartQueryVariables
	>(UrlAnalyticsChartDocument, options)
}
export function useUrlAnalyticsChartLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		UrlAnalyticsChartQuery,
		UrlAnalyticsChartQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		UrlAnalyticsChartQuery,
		UrlAnalyticsChartQueryVariables
	>(UrlAnalyticsChartDocument, options)
}
export type UrlAnalyticsChartQueryHookResult = ReturnType<
	typeof useUrlAnalyticsChartQuery
>
export type UrlAnalyticsChartLazyQueryHookResult = ReturnType<
	typeof useUrlAnalyticsChartLazyQuery
>
export type UrlAnalyticsChartQueryResult = Apollo.QueryResult<
	UrlAnalyticsChartQuery,
	UrlAnalyticsChartQueryVariables
>
export const UrlAnalyticsGroupByDocument = gql`
	query urlAnalyticsGroupBy(
		$where: UrlAnalyticsGroupByFilter
		$offset: Int
		$limit: Int
	) {
		urlAnalyticsGroupBy(where: $where, offset: $offset, limit: $limit) {
			nodes {
				groupedField
				count
				product {
					name
					internalId
				}
				root {
					name
				}
			}
			totalCount
		}
	}
`

/**
 * __useUrlAnalyticsGroupByQuery__
 *
 * To run a query within a React component, call `useUrlAnalyticsGroupByQuery` and pass it any options that fit your needs.
 * When your component renders, `useUrlAnalyticsGroupByQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUrlAnalyticsGroupByQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUrlAnalyticsGroupByQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		UrlAnalyticsGroupByQuery,
		UrlAnalyticsGroupByQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		UrlAnalyticsGroupByQuery,
		UrlAnalyticsGroupByQueryVariables
	>(UrlAnalyticsGroupByDocument, options)
}
export function useUrlAnalyticsGroupByLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		UrlAnalyticsGroupByQuery,
		UrlAnalyticsGroupByQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		UrlAnalyticsGroupByQuery,
		UrlAnalyticsGroupByQueryVariables
	>(UrlAnalyticsGroupByDocument, options)
}
export type UrlAnalyticsGroupByQueryHookResult = ReturnType<
	typeof useUrlAnalyticsGroupByQuery
>
export type UrlAnalyticsGroupByLazyQueryHookResult = ReturnType<
	typeof useUrlAnalyticsGroupByLazyQuery
>
export type UrlAnalyticsGroupByQueryResult = Apollo.QueryResult<
	UrlAnalyticsGroupByQuery,
	UrlAnalyticsGroupByQueryVariables
>
export const UrlAnalyticsInfoDocument = gql`
	query urlAnalyticsInfo {
		urlAnalyticsInfo {
			scannedProductsCount
			activeDevicesCount
			activeLocationsCount
			uniqueScannedProducts
		}
	}
`

/**
 * __useUrlAnalyticsInfoQuery__
 *
 * To run a query within a React component, call `useUrlAnalyticsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUrlAnalyticsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUrlAnalyticsInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useUrlAnalyticsInfoQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		UrlAnalyticsInfoQuery,
		UrlAnalyticsInfoQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		UrlAnalyticsInfoQuery,
		UrlAnalyticsInfoQueryVariables
	>(UrlAnalyticsInfoDocument, options)
}
export function useUrlAnalyticsInfoLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		UrlAnalyticsInfoQuery,
		UrlAnalyticsInfoQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		UrlAnalyticsInfoQuery,
		UrlAnalyticsInfoQueryVariables
	>(UrlAnalyticsInfoDocument, options)
}
export type UrlAnalyticsInfoQueryHookResult = ReturnType<
	typeof useUrlAnalyticsInfoQuery
>
export type UrlAnalyticsInfoLazyQueryHookResult = ReturnType<
	typeof useUrlAnalyticsInfoLazyQuery
>
export type UrlAnalyticsInfoQueryResult = Apollo.QueryResult<
	UrlAnalyticsInfoQuery,
	UrlAnalyticsInfoQueryVariables
>
export const CreateApiClientDocument = gql`
	mutation CreateApiClient(
		$name: String!
		$roleIDs: [Int!]!
		$rootIDs: [Int!]
		$expiresAt: String
	) {
		createApiClient(
			name: $name
			roleIDs: $roleIDs
			rootIDs: $rootIDs
			expiresAt: $expiresAt
		) {
			id
			name
			clientKey
			clientSecret
		}
	}
`
export type CreateApiClientMutationFn = Apollo.MutationFunction<
	CreateApiClientMutation,
	CreateApiClientMutationVariables
>

/**
 * __useCreateApiClientMutation__
 *
 * To run a mutation, you first call `useCreateApiClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiClientMutation, { data, loading, error }] = useCreateApiClientMutation({
 *   variables: {
 *      name: // value for 'name'
 *      roleIDs: // value for 'roleIDs'
 *      rootIDs: // value for 'rootIDs'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useCreateApiClientMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		CreateApiClientMutation,
		CreateApiClientMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		CreateApiClientMutation,
		CreateApiClientMutationVariables
	>(CreateApiClientDocument, options)
}
export type CreateApiClientMutationHookResult = ReturnType<
	typeof useCreateApiClientMutation
>
export type CreateApiClientMutationResult =
	Apollo.MutationResult<CreateApiClientMutation>
export type CreateApiClientMutationOptions = Apollo.BaseMutationOptions<
	CreateApiClientMutation,
	CreateApiClientMutationVariables
>
export const GetApiClientsDocument = gql`
	query GetApiClients {
		apiClients {
			id
			name
			clientKey
			roleIDs
			rootIDs
			isActive
			createdAt
			expiresAt
			lastUsed
		}
	}
`

/**
 * __useGetApiClientsQuery__
 *
 * To run a query within a React component, call `useGetApiClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiClientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApiClientsQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		GetApiClientsQuery,
		GetApiClientsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		GetApiClientsQuery,
		GetApiClientsQueryVariables
	>(GetApiClientsDocument, options)
}
export function useGetApiClientsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		GetApiClientsQuery,
		GetApiClientsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		GetApiClientsQuery,
		GetApiClientsQueryVariables
	>(GetApiClientsDocument, options)
}
export type GetApiClientsQueryHookResult = ReturnType<
	typeof useGetApiClientsQuery
>
export type GetApiClientsLazyQueryHookResult = ReturnType<
	typeof useGetApiClientsLazyQuery
>
export type GetApiClientsQueryResult = Apollo.QueryResult<
	GetApiClientsQuery,
	GetApiClientsQueryVariables
>
export const RevokeApiClientDocument = gql`
	mutation RevokeApiClient($id: ID!) {
		revokeApiClient(id: $id)
	}
`
export type RevokeApiClientMutationFn = Apollo.MutationFunction<
	RevokeApiClientMutation,
	RevokeApiClientMutationVariables
>

/**
 * __useRevokeApiClientMutation__
 *
 * To run a mutation, you first call `useRevokeApiClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeApiClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeApiClientMutation, { data, loading, error }] = useRevokeApiClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeApiClientMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		RevokeApiClientMutation,
		RevokeApiClientMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		RevokeApiClientMutation,
		RevokeApiClientMutationVariables
	>(RevokeApiClientDocument, options)
}
export type RevokeApiClientMutationHookResult = ReturnType<
	typeof useRevokeApiClientMutation
>
export type RevokeApiClientMutationResult =
	Apollo.MutationResult<RevokeApiClientMutation>
export type RevokeApiClientMutationOptions = Apollo.BaseMutationOptions<
	RevokeApiClientMutation,
	RevokeApiClientMutationVariables
>
export const RotateApiClientSecretDocument = gql`
	mutation RotateApiClientSecret($id: ID!) {
		rotateApiClientSecret(id: $id) {
			id
			name
			clientKey
			clientSecret
		}
	}
`
export type RotateApiClientSecretMutationFn = Apollo.MutationFunction<
	RotateApiClientSecretMutation,
	RotateApiClientSecretMutationVariables
>

/**
 * __useRotateApiClientSecretMutation__
 *
 * To run a mutation, you first call `useRotateApiClientSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRotateApiClientSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rotateApiClientSecretMutation, { data, loading, error }] = useRotateApiClientSecretMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRotateApiClientSecretMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		RotateApiClientSecretMutation,
		RotateApiClientSecretMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		RotateApiClientSecretMutation,
		RotateApiClientSecretMutationVariables
	>(RotateApiClientSecretDocument, options)
}
export type RotateApiClientSecretMutationHookResult = ReturnType<
	typeof useRotateApiClientSecretMutation
>
export type RotateApiClientSecretMutationResult =
	Apollo.MutationResult<RotateApiClientSecretMutation>
export type RotateApiClientSecretMutationOptions = Apollo.BaseMutationOptions<
	RotateApiClientSecretMutation,
	RotateApiClientSecretMutationVariables
>
export const AssetDownloadDocument = gql`
	query assetDownload($fileId: Int!) {
		getAsset(fileId: $fileId) {
			url
		}
	}
`

/**
 * __useAssetDownloadQuery__
 *
 * To run a query within a React component, call `useAssetDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetDownloadQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useAssetDownloadQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		AssetDownloadQuery,
		AssetDownloadQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		AssetDownloadQuery,
		AssetDownloadQueryVariables
	>(AssetDownloadDocument, options)
}
export function useAssetDownloadLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		AssetDownloadQuery,
		AssetDownloadQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		AssetDownloadQuery,
		AssetDownloadQueryVariables
	>(AssetDownloadDocument, options)
}
export type AssetDownloadQueryHookResult = ReturnType<
	typeof useAssetDownloadQuery
>
export type AssetDownloadLazyQueryHookResult = ReturnType<
	typeof useAssetDownloadLazyQuery
>
export type AssetDownloadQueryResult = Apollo.QueryResult<
	AssetDownloadQuery,
	AssetDownloadQueryVariables
>
export const CreateFolderDocument = gql`
	mutation createFolder($input: FolderInput!) {
		createFolder(input: $input) {
			errors {
				path
				message
			}
			success
			folder {
				id
			}
		}
	}
`
export type CreateFolderMutationFn = Apollo.MutationFunction<
	CreateFolderMutation,
	CreateFolderMutationVariables
>

/**
 * __useCreateFolderMutation__
 *
 * To run a mutation, you first call `useCreateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFolderMutation, { data, loading, error }] = useCreateFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFolderMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		CreateFolderMutation,
		CreateFolderMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		CreateFolderMutation,
		CreateFolderMutationVariables
	>(CreateFolderDocument, options)
}
export type CreateFolderMutationHookResult = ReturnType<
	typeof useCreateFolderMutation
>
export type CreateFolderMutationResult =
	Apollo.MutationResult<CreateFolderMutation>
export type CreateFolderMutationOptions = Apollo.BaseMutationOptions<
	CreateFolderMutation,
	CreateFolderMutationVariables
>
export const DeleteFileDocument = gql`
	mutation deleteFile($fileId: Int!) {
		deleteFile(fileId: $fileId) {
			success
			errors {
				path
				message
			}
		}
	}
`
export type DeleteFileMutationFn = Apollo.MutationFunction<
	DeleteFileMutation,
	DeleteFileMutationVariables
>

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteFileMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteFileMutation,
		DeleteFileMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteFileMutation,
		DeleteFileMutationVariables
	>(DeleteFileDocument, options)
}
export type DeleteFileMutationHookResult = ReturnType<
	typeof useDeleteFileMutation
>
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<
	DeleteFileMutation,
	DeleteFileMutationVariables
>
export const EditFileDocument = gql`
	mutation editFile($fileId: Int!, $input: EditFileInput!) {
		editFile(fileId: $fileId, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditFileMutationFn = Apollo.MutationFunction<
	EditFileMutation,
	EditFileMutationVariables
>

/**
 * __useEditFileMutation__
 *
 * To run a mutation, you first call `useEditFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFileMutation, { data, loading, error }] = useEditFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditFileMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditFileMutation,
		EditFileMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditFileMutation,
		EditFileMutationVariables
	>(EditFileDocument, options)
}
export type EditFileMutationHookResult = ReturnType<typeof useEditFileMutation>
export type EditFileMutationResult = Apollo.MutationResult<EditFileMutation>
export type EditFileMutationOptions = Apollo.BaseMutationOptions<
	EditFileMutation,
	EditFileMutationVariables
>
export const FileStructureDocument = gql`
	query fileStructure(
		$where: FileStructureFilter
		$limit: Int
		$offset: Int
	) {
		getFileStructure(where: $where, limit: $limit, offset: $offset) {
			nodes {
				id
				width
				height
				duration
				originalname
				filename
				mimetype
				isFolder
				thumbnail
			}
			totalCount
		}
	}
`

/**
 * __useFileStructureQuery__
 *
 * To run a query within a React component, call `useFileStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileStructureQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFileStructureQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		FileStructureQuery,
		FileStructureQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		FileStructureQuery,
		FileStructureQueryVariables
	>(FileStructureDocument, options)
}
export function useFileStructureLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		FileStructureQuery,
		FileStructureQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		FileStructureQuery,
		FileStructureQueryVariables
	>(FileStructureDocument, options)
}
export type FileStructureQueryHookResult = ReturnType<
	typeof useFileStructureQuery
>
export type FileStructureLazyQueryHookResult = ReturnType<
	typeof useFileStructureLazyQuery
>
export type FileStructureQueryResult = Apollo.QueryResult<
	FileStructureQuery,
	FileStructureQueryVariables
>
export const FilesDocument = gql`
	query files($where: FilesFilter, $offset: Int!, $limit: Int!) {
		files(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				duration
				isFolder
				originalname
				filename
				mimetype
				thumbnail
				width
				height
			}
			totalCount
		}
	}
`

/**
 * __useFilesQuery__
 *
 * To run a query within a React component, call `useFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFilesQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		FilesQuery,
		FilesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<FilesQuery, FilesQueryVariables>(
		FilesDocument,
		options
	)
}
export function useFilesLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		FilesQuery,
		FilesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<FilesQuery, FilesQueryVariables>(
		FilesDocument,
		options
	)
}
export type FilesQueryHookResult = ReturnType<typeof useFilesQuery>
export type FilesLazyQueryHookResult = ReturnType<typeof useFilesLazyQuery>
export type FilesQueryResult = Apollo.QueryResult<
	FilesQuery,
	FilesQueryVariables
>
export const GetFileDocument = gql`
	query getFile($where: FileFilter) {
		getFile(where: $where) {
			id
			duration
			isFolder
			originalname
			filename
			mimetype
			thumbnail
			width
			height
		}
	}
`

/**
 * __useGetFileQuery__
 *
 * To run a query within a React component, call `useGetFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetFileQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		GetFileQuery,
		GetFileQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<GetFileQuery, GetFileQueryVariables>(
		GetFileDocument,
		options
	)
}
export function useGetFileLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		GetFileQuery,
		GetFileQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<GetFileQuery, GetFileQueryVariables>(
		GetFileDocument,
		options
	)
}
export type GetFileQueryHookResult = ReturnType<typeof useGetFileQuery>
export type GetFileLazyQueryHookResult = ReturnType<typeof useGetFileLazyQuery>
export type GetFileQueryResult = Apollo.QueryResult<
	GetFileQuery,
	GetFileQueryVariables
>
export const GetFileChainDocument = gql`
	query getFileChain($where: FileChainFilter!) {
		getFileChain(where: $where) {
			id
			filename
			originalname
			type
		}
	}
`

/**
 * __useGetFileChainQuery__
 *
 * To run a query within a React component, call `useGetFileChainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileChainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileChainQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetFileChainQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		GetFileChainQuery,
		GetFileChainQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		GetFileChainQuery,
		GetFileChainQueryVariables
	>(GetFileChainDocument, options)
}
export function useGetFileChainLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		GetFileChainQuery,
		GetFileChainQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		GetFileChainQuery,
		GetFileChainQueryVariables
	>(GetFileChainDocument, options)
}
export type GetFileChainQueryHookResult = ReturnType<
	typeof useGetFileChainQuery
>
export type GetFileChainLazyQueryHookResult = ReturnType<
	typeof useGetFileChainLazyQuery
>
export type GetFileChainQueryResult = Apollo.QueryResult<
	GetFileChainQuery,
	GetFileChainQueryVariables
>
export const GetFileIdDocument = gql`
	query getFileId($where: FileFilter) {
		getFile(where: $where) {
			id
		}
	}
`

/**
 * __useGetFileIdQuery__
 *
 * To run a query within a React component, call `useGetFileIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileIdQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetFileIdQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		GetFileIdQuery,
		GetFileIdQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<GetFileIdQuery, GetFileIdQueryVariables>(
		GetFileIdDocument,
		options
	)
}
export function useGetFileIdLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		GetFileIdQuery,
		GetFileIdQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		GetFileIdQuery,
		GetFileIdQueryVariables
	>(GetFileIdDocument, options)
}
export type GetFileIdQueryHookResult = ReturnType<typeof useGetFileIdQuery>
export type GetFileIdLazyQueryHookResult = ReturnType<
	typeof useGetFileIdLazyQuery
>
export type GetFileIdQueryResult = Apollo.QueryResult<
	GetFileIdQuery,
	GetFileIdQueryVariables
>
export const MultiUploadDocument = gql`
	mutation multiUpload(
		$files: [Upload!]!
		$parentFolderId: Int
		$productAssign: Boolean
	) {
		multiUpload(
			files: $files
			parentFolderId: $parentFolderId
			productAssign: $productAssign
		) {
			errors {
				path
				message
			}
			file {
				id
				originalname
				filename
				mimetype
				encoding
				url
				isFolder
				thumbnail
			}
		}
	}
`
export type MultiUploadMutationFn = Apollo.MutationFunction<
	MultiUploadMutation,
	MultiUploadMutationVariables
>

/**
 * __useMultiUploadMutation__
 *
 * To run a mutation, you first call `useMultiUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMultiUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [multiUploadMutation, { data, loading, error }] = useMultiUploadMutation({
 *   variables: {
 *      files: // value for 'files'
 *      parentFolderId: // value for 'parentFolderId'
 *      productAssign: // value for 'productAssign'
 *   },
 * });
 */
export function useMultiUploadMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		MultiUploadMutation,
		MultiUploadMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		MultiUploadMutation,
		MultiUploadMutationVariables
	>(MultiUploadDocument, options)
}
export type MultiUploadMutationHookResult = ReturnType<
	typeof useMultiUploadMutation
>
export type MultiUploadMutationResult =
	Apollo.MutationResult<MultiUploadMutation>
export type MultiUploadMutationOptions = Apollo.BaseMutationOptions<
	MultiUploadMutation,
	MultiUploadMutationVariables
>
export const AddChannelDocument = gql`
	mutation addChannel($input: AddChannelInput!) {
		addChannel(input: $input) {
			errors {
				path
				message
			}
			channel {
				id
			}
		}
	}
`
export type AddChannelMutationFn = Apollo.MutationFunction<
	AddChannelMutation,
	AddChannelMutationVariables
>

/**
 * __useAddChannelMutation__
 *
 * To run a mutation, you first call `useAddChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addChannelMutation, { data, loading, error }] = useAddChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddChannelMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddChannelMutation,
		AddChannelMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddChannelMutation,
		AddChannelMutationVariables
	>(AddChannelDocument, options)
}
export type AddChannelMutationHookResult = ReturnType<
	typeof useAddChannelMutation
>
export type AddChannelMutationResult = Apollo.MutationResult<AddChannelMutation>
export type AddChannelMutationOptions = Apollo.BaseMutationOptions<
	AddChannelMutation,
	AddChannelMutationVariables
>
export const ChannelDocument = gql`
	query channel($channelId: Int!) {
		channel(id: $channelId) {
			channel {
				id
				name
				tags
				type
				orientation
				marketId
				market {
					id
					name
				}
				channelItems {
					id
					priority
					duration
					display {
						id
					}
					sequence
					file {
						id
						duration
						encoding
						isFolder
						filename
						originalname
						mimetype
						thumbnail
					}
					playlist {
						id
						name
						playlistItems {
							duration
							file {
								id
								encoding
								isFolder
								filename
								originalname
								mimetype
								thumbnail
							}
						}
					}
					schedule {
						dateRange
						weekdays
						id
						timeFrames
					}
				}
				displays {
					id
					name
					height
					width
					type
				}
			}
		}
	}
`

/**
 * __useChannelQuery__
 *
 * To run a query within a React component, call `useChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useChannelQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		ChannelQuery,
		ChannelQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<ChannelQuery, ChannelQueryVariables>(
		ChannelDocument,
		options
	)
}
export function useChannelLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ChannelQuery,
		ChannelQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<ChannelQuery, ChannelQueryVariables>(
		ChannelDocument,
		options
	)
}
export type ChannelQueryHookResult = ReturnType<typeof useChannelQuery>
export type ChannelLazyQueryHookResult = ReturnType<typeof useChannelLazyQuery>
export type ChannelQueryResult = Apollo.QueryResult<
	ChannelQuery,
	ChannelQueryVariables
>
export const ChannelsDocument = gql`
	query channels($where: ChannelsFilter, $offset: Int!, $limit: Int!) {
		channels(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				name
				tags
				type
				displays {
					id
					type
				}
				channelItems {
					id
					schedule {
						id
						weekdays
						timeFrames
						dateRange
					}
				}
				tvDevices {
					id
				}
				scales {
					id
				}
				devices {
					id
				}
			}
			totalCount
		}
	}
`

/**
 * __useChannelsQuery__
 *
 * To run a query within a React component, call `useChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useChannelsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		ChannelsQuery,
		ChannelsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<ChannelsQuery, ChannelsQueryVariables>(
		ChannelsDocument,
		options
	)
}
export function useChannelsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ChannelsQuery,
		ChannelsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<ChannelsQuery, ChannelsQueryVariables>(
		ChannelsDocument,
		options
	)
}
export type ChannelsQueryHookResult = ReturnType<typeof useChannelsQuery>
export type ChannelsLazyQueryHookResult = ReturnType<
	typeof useChannelsLazyQuery
>
export type ChannelsQueryResult = Apollo.QueryResult<
	ChannelsQuery,
	ChannelsQueryVariables
>
export const ChannelsSelectDocument = gql`
	query channelsSelect($where: ChannelsFilter, $offset: Int!, $limit: Int!) {
		channels(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				name
			}
		}
	}
`

/**
 * __useChannelsSelectQuery__
 *
 * To run a query within a React component, call `useChannelsSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelsSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelsSelectQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useChannelsSelectQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		ChannelsSelectQuery,
		ChannelsSelectQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		ChannelsSelectQuery,
		ChannelsSelectQueryVariables
	>(ChannelsSelectDocument, options)
}
export function useChannelsSelectLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ChannelsSelectQuery,
		ChannelsSelectQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		ChannelsSelectQuery,
		ChannelsSelectQueryVariables
	>(ChannelsSelectDocument, options)
}
export type ChannelsSelectQueryHookResult = ReturnType<
	typeof useChannelsSelectQuery
>
export type ChannelsSelectLazyQueryHookResult = ReturnType<
	typeof useChannelsSelectLazyQuery
>
export type ChannelsSelectQueryResult = Apollo.QueryResult<
	ChannelsSelectQuery,
	ChannelsSelectQueryVariables
>
export const DeleteChannelDocument = gql`
	mutation deleteChannel($channelId: Int!) {
		deleteChannel(channelId: $channelId) {
			errors {
				message
				path
			}
			success
		}
	}
`
export type DeleteChannelMutationFn = Apollo.MutationFunction<
	DeleteChannelMutation,
	DeleteChannelMutationVariables
>

/**
 * __useDeleteChannelMutation__
 *
 * To run a mutation, you first call `useDeleteChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChannelMutation, { data, loading, error }] = useDeleteChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useDeleteChannelMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteChannelMutation,
		DeleteChannelMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteChannelMutation,
		DeleteChannelMutationVariables
	>(DeleteChannelDocument, options)
}
export type DeleteChannelMutationHookResult = ReturnType<
	typeof useDeleteChannelMutation
>
export type DeleteChannelMutationResult =
	Apollo.MutationResult<DeleteChannelMutation>
export type DeleteChannelMutationOptions = Apollo.BaseMutationOptions<
	DeleteChannelMutation,
	DeleteChannelMutationVariables
>
export const EditPlaylistDocument = gql`
	mutation editPlaylist($playlistId: Int!, $input: EditPlaylistInput!) {
		editPlaylist(playlistId: $playlistId, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditPlaylistMutationFn = Apollo.MutationFunction<
	EditPlaylistMutation,
	EditPlaylistMutationVariables
>

/**
 * __useEditPlaylistMutation__
 *
 * To run a mutation, you first call `useEditPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPlaylistMutation, { data, loading, error }] = useEditPlaylistMutation({
 *   variables: {
 *      playlistId: // value for 'playlistId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPlaylistMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditPlaylistMutation,
		EditPlaylistMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditPlaylistMutation,
		EditPlaylistMutationVariables
	>(EditPlaylistDocument, options)
}
export type EditPlaylistMutationHookResult = ReturnType<
	typeof useEditPlaylistMutation
>
export type EditPlaylistMutationResult =
	Apollo.MutationResult<EditPlaylistMutation>
export type EditPlaylistMutationOptions = Apollo.BaseMutationOptions<
	EditPlaylistMutation,
	EditPlaylistMutationVariables
>
export const TagsDocument = gql`
	query tags($where: TagsFilter, $offset: Int!, $limit: Int!) {
		tags(where: $where, offset: $offset, limit: $limit) {
			nodes
		}
	}
`

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTagsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		TagsQuery,
		TagsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<TagsQuery, TagsQueryVariables>(
		TagsDocument,
		options
	)
}
export function useTagsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		TagsQuery,
		TagsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<TagsQuery, TagsQueryVariables>(
		TagsDocument,
		options
	)
}
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>
export const CustomerSettingsDocument = gql`
	query customerSettings($customer: String!) {
		customerSettings(customer: $customer) {
			usesMarkets
			usesDualProduct
			usesDeviceName
			usesRootProducts
			usesPlanogram
		}
	}
`

/**
 * __useCustomerSettingsQuery__
 *
 * To run a query within a React component, call `useCustomerSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSettingsQuery({
 *   variables: {
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useCustomerSettingsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		CustomerSettingsQuery,
		CustomerSettingsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		CustomerSettingsQuery,
		CustomerSettingsQueryVariables
	>(CustomerSettingsDocument, options)
}
export function useCustomerSettingsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		CustomerSettingsQuery,
		CustomerSettingsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		CustomerSettingsQuery,
		CustomerSettingsQueryVariables
	>(CustomerSettingsDocument, options)
}
export type CustomerSettingsQueryHookResult = ReturnType<
	typeof useCustomerSettingsQuery
>
export type CustomerSettingsLazyQueryHookResult = ReturnType<
	typeof useCustomerSettingsLazyQuery
>
export type CustomerSettingsQueryResult = Apollo.QueryResult<
	CustomerSettingsQuery,
	CustomerSettingsQueryVariables
>
export const LoginPageSettingsDocument = gql`
	query loginPageSettings($customer: String!) {
		loginPageSettings(customer: $customer) {
			logo
			loginLogo
			primaryColor
			textColor
		}
	}
`

/**
 * __useLoginPageSettingsQuery__
 *
 * To run a query within a React component, call `useLoginPageSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginPageSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginPageSettingsQuery({
 *   variables: {
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useLoginPageSettingsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		LoginPageSettingsQuery,
		LoginPageSettingsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		LoginPageSettingsQuery,
		LoginPageSettingsQueryVariables
	>(LoginPageSettingsDocument, options)
}
export function useLoginPageSettingsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		LoginPageSettingsQuery,
		LoginPageSettingsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		LoginPageSettingsQuery,
		LoginPageSettingsQueryVariables
	>(LoginPageSettingsDocument, options)
}
export type LoginPageSettingsQueryHookResult = ReturnType<
	typeof useLoginPageSettingsQuery
>
export type LoginPageSettingsLazyQueryHookResult = ReturnType<
	typeof useLoginPageSettingsLazyQuery
>
export type LoginPageSettingsQueryResult = Apollo.QueryResult<
	LoginPageSettingsQuery,
	LoginPageSettingsQueryVariables
>
export const AddTemplateDocument = gql`
	mutation addTemplate($input: TemplateInput!) {
		addTemplate(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type AddTemplateMutationFn = Apollo.MutationFunction<
	AddTemplateMutation,
	AddTemplateMutationVariables
>

/**
 * __useAddTemplateMutation__
 *
 * To run a mutation, you first call `useAddTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTemplateMutation, { data, loading, error }] = useAddTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTemplateMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddTemplateMutation,
		AddTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddTemplateMutation,
		AddTemplateMutationVariables
	>(AddTemplateDocument, options)
}
export type AddTemplateMutationHookResult = ReturnType<
	typeof useAddTemplateMutation
>
export type AddTemplateMutationResult =
	Apollo.MutationResult<AddTemplateMutation>
export type AddTemplateMutationOptions = Apollo.BaseMutationOptions<
	AddTemplateMutation,
	AddTemplateMutationVariables
>
export const AddTemplateVariantDocument = gql`
	mutation addTemplateVariant($input: TemplateVariantInput!) {
		addTemplateVariant(input: $input) {
			errors {
				message
				path
			}
			templateVariant {
				id
			}
		}
	}
`
export type AddTemplateVariantMutationFn = Apollo.MutationFunction<
	AddTemplateVariantMutation,
	AddTemplateVariantMutationVariables
>

/**
 * __useAddTemplateVariantMutation__
 *
 * To run a mutation, you first call `useAddTemplateVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTemplateVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTemplateVariantMutation, { data, loading, error }] = useAddTemplateVariantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTemplateVariantMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddTemplateVariantMutation,
		AddTemplateVariantMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddTemplateVariantMutation,
		AddTemplateVariantMutationVariables
	>(AddTemplateVariantDocument, options)
}
export type AddTemplateVariantMutationHookResult = ReturnType<
	typeof useAddTemplateVariantMutation
>
export type AddTemplateVariantMutationResult =
	Apollo.MutationResult<AddTemplateVariantMutation>
export type AddTemplateVariantMutationOptions = Apollo.BaseMutationOptions<
	AddTemplateVariantMutation,
	AddTemplateVariantMutationVariables
>
export const ComponentVarsDocument = gql`
	query componentVars(
		$offset: Int!
		$limit: Int!
		$where: ComponentVarsFilter
	) {
		componentVars(offset: $offset, limit: $limit, where: $where) {
			nodes {
				id
				name
				templateKey
				type
			}
		}
	}
`

/**
 * __useComponentVarsQuery__
 *
 * To run a query within a React component, call `useComponentVarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComponentVarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComponentVarsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useComponentVarsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		ComponentVarsQuery,
		ComponentVarsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		ComponentVarsQuery,
		ComponentVarsQueryVariables
	>(ComponentVarsDocument, options)
}
export function useComponentVarsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ComponentVarsQuery,
		ComponentVarsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		ComponentVarsQuery,
		ComponentVarsQueryVariables
	>(ComponentVarsDocument, options)
}
export type ComponentVarsQueryHookResult = ReturnType<
	typeof useComponentVarsQuery
>
export type ComponentVarsLazyQueryHookResult = ReturnType<
	typeof useComponentVarsLazyQuery
>
export type ComponentVarsQueryResult = Apollo.QueryResult<
	ComponentVarsQuery,
	ComponentVarsQueryVariables
>
export const DeleteTemplateDocument = gql`
	mutation deleteTemplate($input: DeleteTemplateInput!) {
		deleteTemplate(input: $input) {
			affected
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteTemplateMutationFn = Apollo.MutationFunction<
	DeleteTemplateMutation,
	DeleteTemplateMutationVariables
>

/**
 * __useDeleteTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateMutation, { data, loading, error }] = useDeleteTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTemplateMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteTemplateMutation,
		DeleteTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteTemplateMutation,
		DeleteTemplateMutationVariables
	>(DeleteTemplateDocument, options)
}
export type DeleteTemplateMutationHookResult = ReturnType<
	typeof useDeleteTemplateMutation
>
export type DeleteTemplateMutationResult =
	Apollo.MutationResult<DeleteTemplateMutation>
export type DeleteTemplateMutationOptions = Apollo.BaseMutationOptions<
	DeleteTemplateMutation,
	DeleteTemplateMutationVariables
>
export const DeleteTemplateVariantDocument = gql`
	mutation deleteTemplateVariant($input: DeleteTemplateVariantInput!) {
		deleteTemplateVariant(input: $input) {
			affected
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteTemplateVariantMutationFn = Apollo.MutationFunction<
	DeleteTemplateVariantMutation,
	DeleteTemplateVariantMutationVariables
>

/**
 * __useDeleteTemplateVariantMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateVariantMutation, { data, loading, error }] = useDeleteTemplateVariantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTemplateVariantMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteTemplateVariantMutation,
		DeleteTemplateVariantMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteTemplateVariantMutation,
		DeleteTemplateVariantMutationVariables
	>(DeleteTemplateVariantDocument, options)
}
export type DeleteTemplateVariantMutationHookResult = ReturnType<
	typeof useDeleteTemplateVariantMutation
>
export type DeleteTemplateVariantMutationResult =
	Apollo.MutationResult<DeleteTemplateVariantMutation>
export type DeleteTemplateVariantMutationOptions = Apollo.BaseMutationOptions<
	DeleteTemplateVariantMutation,
	DeleteTemplateVariantMutationVariables
>
export const DeleteTemplatesDocument = gql`
	mutation deleteTemplates($input: DeleteTemplatesInput!) {
		deleteTemplates(input: $input) {
			affected
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteTemplatesMutationFn = Apollo.MutationFunction<
	DeleteTemplatesMutation,
	DeleteTemplatesMutationVariables
>

/**
 * __useDeleteTemplatesMutation__
 *
 * To run a mutation, you first call `useDeleteTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplatesMutation, { data, loading, error }] = useDeleteTemplatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTemplatesMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteTemplatesMutation,
		DeleteTemplatesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteTemplatesMutation,
		DeleteTemplatesMutationVariables
	>(DeleteTemplatesDocument, options)
}
export type DeleteTemplatesMutationHookResult = ReturnType<
	typeof useDeleteTemplatesMutation
>
export type DeleteTemplatesMutationResult =
	Apollo.MutationResult<DeleteTemplatesMutation>
export type DeleteTemplatesMutationOptions = Apollo.BaseMutationOptions<
	DeleteTemplatesMutation,
	DeleteTemplatesMutationVariables
>
export const DisplayTemplateDocument = gql`
	query displayTemplate($id: Int!) {
		template(id: $id) {
			template {
				id
				deviceSize
				isCustom
				name
				templateVariant {
					id
					key
					name
					isDefault
				}
				landingTemplate {
					id
					key
					name
				}
				width
				height
				components {
					id
					name
					w
					h
					x
					y
					htmlContent
					type
				}
				templateVariables {
					id
					name
					maxLength
					templateKey
				}
			}
		}
	}
`

/**
 * __useDisplayTemplateQuery__
 *
 * To run a query within a React component, call `useDisplayTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisplayTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisplayTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisplayTemplateQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		DisplayTemplateQuery,
		DisplayTemplateQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		DisplayTemplateQuery,
		DisplayTemplateQueryVariables
	>(DisplayTemplateDocument, options)
}
export function useDisplayTemplateLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		DisplayTemplateQuery,
		DisplayTemplateQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		DisplayTemplateQuery,
		DisplayTemplateQueryVariables
	>(DisplayTemplateDocument, options)
}
export type DisplayTemplateQueryHookResult = ReturnType<
	typeof useDisplayTemplateQuery
>
export type DisplayTemplateLazyQueryHookResult = ReturnType<
	typeof useDisplayTemplateLazyQuery
>
export type DisplayTemplateQueryResult = Apollo.QueryResult<
	DisplayTemplateQuery,
	DisplayTemplateQueryVariables
>
export const DisplayTemplatesDocument = gql`
	query displayTemplates(
		$offset: Int!
		$limit: Int!
		$where: TemplatesFilter
	) {
		templates(offset: $offset, limit: $limit, where: $where) {
			nodes {
				id
				deviceSize
				name
				height
				width
				templateVariant {
					id
					key
					name
				}
			}
			totalCount
		}
	}
`

/**
 * __useDisplayTemplatesQuery__
 *
 * To run a query within a React component, call `useDisplayTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisplayTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisplayTemplatesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDisplayTemplatesQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		DisplayTemplatesQuery,
		DisplayTemplatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		DisplayTemplatesQuery,
		DisplayTemplatesQueryVariables
	>(DisplayTemplatesDocument, options)
}
export function useDisplayTemplatesLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		DisplayTemplatesQuery,
		DisplayTemplatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		DisplayTemplatesQuery,
		DisplayTemplatesQueryVariables
	>(DisplayTemplatesDocument, options)
}
export type DisplayTemplatesQueryHookResult = ReturnType<
	typeof useDisplayTemplatesQuery
>
export type DisplayTemplatesLazyQueryHookResult = ReturnType<
	typeof useDisplayTemplatesLazyQuery
>
export type DisplayTemplatesQueryResult = Apollo.QueryResult<
	DisplayTemplatesQuery,
	DisplayTemplatesQueryVariables
>
export const EditTemplateDocument = gql`
	mutation editTemplate($templateId: Int!, $input: EditTemplateInput!) {
		editTemplate(templateId: $templateId, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditTemplateMutationFn = Apollo.MutationFunction<
	EditTemplateMutation,
	EditTemplateMutationVariables
>

/**
 * __useEditTemplateMutation__
 *
 * To run a mutation, you first call `useEditTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTemplateMutation, { data, loading, error }] = useEditTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTemplateMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditTemplateMutation,
		EditTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditTemplateMutation,
		EditTemplateMutationVariables
	>(EditTemplateDocument, options)
}
export type EditTemplateMutationHookResult = ReturnType<
	typeof useEditTemplateMutation
>
export type EditTemplateMutationResult =
	Apollo.MutationResult<EditTemplateMutation>
export type EditTemplateMutationOptions = Apollo.BaseMutationOptions<
	EditTemplateMutation,
	EditTemplateMutationVariables
>
export const EditTemplateVariantDocument = gql`
	mutation editTemplateVariant(
		$templateVariantId: Int!
		$input: EditTemplateVariantInput!
	) {
		editTemplateVariant(
			templateVariantId: $templateVariantId
			input: $input
		) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditTemplateVariantMutationFn = Apollo.MutationFunction<
	EditTemplateVariantMutation,
	EditTemplateVariantMutationVariables
>

/**
 * __useEditTemplateVariantMutation__
 *
 * To run a mutation, you first call `useEditTemplateVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTemplateVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTemplateVariantMutation, { data, loading, error }] = useEditTemplateVariantMutation({
 *   variables: {
 *      templateVariantId: // value for 'templateVariantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTemplateVariantMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditTemplateVariantMutation,
		EditTemplateVariantMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditTemplateVariantMutation,
		EditTemplateVariantMutationVariables
	>(EditTemplateVariantDocument, options)
}
export type EditTemplateVariantMutationHookResult = ReturnType<
	typeof useEditTemplateVariantMutation
>
export type EditTemplateVariantMutationResult =
	Apollo.MutationResult<EditTemplateVariantMutation>
export type EditTemplateVariantMutationOptions = Apollo.BaseMutationOptions<
	EditTemplateVariantMutation,
	EditTemplateVariantMutationVariables
>
export const ParseTemplateDocument = gql`
	query parseTemplate($templateId: Int!, $productId: Int!) {
		parseTemplate(templateId: $templateId, productId: $productId) {
			template
			errors {
				message
				path
			}
		}
	}
`

/**
 * __useParseTemplateQuery__
 *
 * To run a query within a React component, call `useParseTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useParseTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParseTemplateQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useParseTemplateQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		ParseTemplateQuery,
		ParseTemplateQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		ParseTemplateQuery,
		ParseTemplateQueryVariables
	>(ParseTemplateDocument, options)
}
export function useParseTemplateLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ParseTemplateQuery,
		ParseTemplateQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		ParseTemplateQuery,
		ParseTemplateQueryVariables
	>(ParseTemplateDocument, options)
}
export type ParseTemplateQueryHookResult = ReturnType<
	typeof useParseTemplateQuery
>
export type ParseTemplateLazyQueryHookResult = ReturnType<
	typeof useParseTemplateLazyQuery
>
export type ParseTemplateQueryResult = Apollo.QueryResult<
	ParseTemplateQuery,
	ParseTemplateQueryVariables
>
export const TemplateVariantDocument = gql`
	query templateVariant($id: Int!) {
		templateVariant(id: $id) {
			templateVariant {
				id
				name
				key
				isActive
				orbisType
				marketIDs
			}
		}
	}
`

/**
 * __useTemplateVariantQuery__
 *
 * To run a query within a React component, call `useTemplateVariantQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateVariantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateVariantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTemplateVariantQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		TemplateVariantQuery,
		TemplateVariantQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		TemplateVariantQuery,
		TemplateVariantQueryVariables
	>(TemplateVariantDocument, options)
}
export function useTemplateVariantLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		TemplateVariantQuery,
		TemplateVariantQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		TemplateVariantQuery,
		TemplateVariantQueryVariables
	>(TemplateVariantDocument, options)
}
export type TemplateVariantQueryHookResult = ReturnType<
	typeof useTemplateVariantQuery
>
export type TemplateVariantLazyQueryHookResult = ReturnType<
	typeof useTemplateVariantLazyQuery
>
export type TemplateVariantQueryResult = Apollo.QueryResult<
	TemplateVariantQuery,
	TemplateVariantQueryVariables
>
export const TemplateVariantSupportsRotatedDocument = gql`
	query templateVariantSupportsRotated(
		$templateVariantId: Int!
		$deviceSize: DeviceSize!
	) {
		templateVariantSupportsRotated(
			templateVariantId: $templateVariantId
			deviceSize: $deviceSize
		)
	}
`

/**
 * __useTemplateVariantSupportsRotatedQuery__
 *
 * To run a query within a React component, call `useTemplateVariantSupportsRotatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateVariantSupportsRotatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateVariantSupportsRotatedQuery({
 *   variables: {
 *      templateVariantId: // value for 'templateVariantId'
 *      deviceSize: // value for 'deviceSize'
 *   },
 * });
 */
export function useTemplateVariantSupportsRotatedQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		TemplateVariantSupportsRotatedQuery,
		TemplateVariantSupportsRotatedQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		TemplateVariantSupportsRotatedQuery,
		TemplateVariantSupportsRotatedQueryVariables
	>(TemplateVariantSupportsRotatedDocument, options)
}
export function useTemplateVariantSupportsRotatedLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		TemplateVariantSupportsRotatedQuery,
		TemplateVariantSupportsRotatedQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		TemplateVariantSupportsRotatedQuery,
		TemplateVariantSupportsRotatedQueryVariables
	>(TemplateVariantSupportsRotatedDocument, options)
}
export type TemplateVariantSupportsRotatedQueryHookResult = ReturnType<
	typeof useTemplateVariantSupportsRotatedQuery
>
export type TemplateVariantSupportsRotatedLazyQueryHookResult = ReturnType<
	typeof useTemplateVariantSupportsRotatedLazyQuery
>
export type TemplateVariantSupportsRotatedQueryResult = Apollo.QueryResult<
	TemplateVariantSupportsRotatedQuery,
	TemplateVariantSupportsRotatedQueryVariables
>
export const TemplateVariantSupportsSplitDocument = gql`
	query templateVariantSupportsSplit(
		$templateVariantId: Int!
		$deviceSize: DeviceSize!
	) {
		templateVariantSupportsSplit(
			templateVariantId: $templateVariantId
			deviceSize: $deviceSize
		)
	}
`

/**
 * __useTemplateVariantSupportsSplitQuery__
 *
 * To run a query within a React component, call `useTemplateVariantSupportsSplitQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateVariantSupportsSplitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateVariantSupportsSplitQuery({
 *   variables: {
 *      templateVariantId: // value for 'templateVariantId'
 *      deviceSize: // value for 'deviceSize'
 *   },
 * });
 */
export function useTemplateVariantSupportsSplitQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		TemplateVariantSupportsSplitQuery,
		TemplateVariantSupportsSplitQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		TemplateVariantSupportsSplitQuery,
		TemplateVariantSupportsSplitQueryVariables
	>(TemplateVariantSupportsSplitDocument, options)
}
export function useTemplateVariantSupportsSplitLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		TemplateVariantSupportsSplitQuery,
		TemplateVariantSupportsSplitQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		TemplateVariantSupportsSplitQuery,
		TemplateVariantSupportsSplitQueryVariables
	>(TemplateVariantSupportsSplitDocument, options)
}
export type TemplateVariantSupportsSplitQueryHookResult = ReturnType<
	typeof useTemplateVariantSupportsSplitQuery
>
export type TemplateVariantSupportsSplitLazyQueryHookResult = ReturnType<
	typeof useTemplateVariantSupportsSplitLazyQuery
>
export type TemplateVariantSupportsSplitQueryResult = Apollo.QueryResult<
	TemplateVariantSupportsSplitQuery,
	TemplateVariantSupportsSplitQueryVariables
>
export const TemplateVariantTemplateTypesDocument = gql`
	query templateVariantTemplateTypes($templateVariantId: Int!) {
		templateVariantTemplateTypes(templateVariantId: $templateVariantId)
	}
`

/**
 * __useTemplateVariantTemplateTypesQuery__
 *
 * To run a query within a React component, call `useTemplateVariantTemplateTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateVariantTemplateTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateVariantTemplateTypesQuery({
 *   variables: {
 *      templateVariantId: // value for 'templateVariantId'
 *   },
 * });
 */
export function useTemplateVariantTemplateTypesQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		TemplateVariantTemplateTypesQuery,
		TemplateVariantTemplateTypesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		TemplateVariantTemplateTypesQuery,
		TemplateVariantTemplateTypesQueryVariables
	>(TemplateVariantTemplateTypesDocument, options)
}
export function useTemplateVariantTemplateTypesLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		TemplateVariantTemplateTypesQuery,
		TemplateVariantTemplateTypesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		TemplateVariantTemplateTypesQuery,
		TemplateVariantTemplateTypesQueryVariables
	>(TemplateVariantTemplateTypesDocument, options)
}
export type TemplateVariantTemplateTypesQueryHookResult = ReturnType<
	typeof useTemplateVariantTemplateTypesQuery
>
export type TemplateVariantTemplateTypesLazyQueryHookResult = ReturnType<
	typeof useTemplateVariantTemplateTypesLazyQuery
>
export type TemplateVariantTemplateTypesQueryResult = Apollo.QueryResult<
	TemplateVariantTemplateTypesQuery,
	TemplateVariantTemplateTypesQueryVariables
>
export const TemplateVariantsDocument = gql`
	query templateVariants(
		$where: TemplateVariantsFilter
		$limit: Int!
		$offset: Int!
	) {
		templateVariants(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				name
				key
				orbisType
				isDefault
				inUse
				isActive
				marketIDs
				templates {
					id
					deviceSize
					name
					height
					width
					isCustom
				}
			}
			totalCount
		}
	}
`

/**
 * __useTemplateVariantsQuery__
 *
 * To run a query within a React component, call `useTemplateVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateVariantsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useTemplateVariantsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		TemplateVariantsQuery,
		TemplateVariantsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		TemplateVariantsQuery,
		TemplateVariantsQueryVariables
	>(TemplateVariantsDocument, options)
}
export function useTemplateVariantsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		TemplateVariantsQuery,
		TemplateVariantsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		TemplateVariantsQuery,
		TemplateVariantsQueryVariables
	>(TemplateVariantsDocument, options)
}
export type TemplateVariantsQueryHookResult = ReturnType<
	typeof useTemplateVariantsQuery
>
export type TemplateVariantsLazyQueryHookResult = ReturnType<
	typeof useTemplateVariantsLazyQuery
>
export type TemplateVariantsQueryResult = Apollo.QueryResult<
	TemplateVariantsQuery,
	TemplateVariantsQueryVariables
>
export const AddFlowDocument = gql`
	mutation addFlow($input: AddFlowInput!) {
		addFlow(input: $input) {
			errors {
				path
				message
			}
			success
			flow {
				id
				name
			}
		}
	}
`
export type AddFlowMutationFn = Apollo.MutationFunction<
	AddFlowMutation,
	AddFlowMutationVariables
>

/**
 * __useAddFlowMutation__
 *
 * To run a mutation, you first call `useAddFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFlowMutation, { data, loading, error }] = useAddFlowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFlowMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddFlowMutation,
		AddFlowMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddFlowMutation,
		AddFlowMutationVariables
	>(AddFlowDocument, options)
}
export type AddFlowMutationHookResult = ReturnType<typeof useAddFlowMutation>
export type AddFlowMutationResult = Apollo.MutationResult<AddFlowMutation>
export type AddFlowMutationOptions = Apollo.BaseMutationOptions<
	AddFlowMutation,
	AddFlowMutationVariables
>
export const DeleteFlowDocument = gql`
	mutation deleteFlow($id: Int!) {
		deleteFlow(id: $id) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteFlowMutationFn = Apollo.MutationFunction<
	DeleteFlowMutation,
	DeleteFlowMutationVariables
>

/**
 * __useDeleteFlowMutation__
 *
 * To run a mutation, you first call `useDeleteFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFlowMutation, { data, loading, error }] = useDeleteFlowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFlowMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteFlowMutation,
		DeleteFlowMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteFlowMutation,
		DeleteFlowMutationVariables
	>(DeleteFlowDocument, options)
}
export type DeleteFlowMutationHookResult = ReturnType<
	typeof useDeleteFlowMutation
>
export type DeleteFlowMutationResult = Apollo.MutationResult<DeleteFlowMutation>
export type DeleteFlowMutationOptions = Apollo.BaseMutationOptions<
	DeleteFlowMutation,
	DeleteFlowMutationVariables
>
export const EditFlowDocument = gql`
	mutation editFlow($id: Int!, $input: EditFlowInput!) {
		editFlow(id: $id, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditFlowMutationFn = Apollo.MutationFunction<
	EditFlowMutation,
	EditFlowMutationVariables
>

/**
 * __useEditFlowMutation__
 *
 * To run a mutation, you first call `useEditFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFlowMutation, { data, loading, error }] = useEditFlowMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditFlowMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditFlowMutation,
		EditFlowMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditFlowMutation,
		EditFlowMutationVariables
	>(EditFlowDocument, options)
}
export type EditFlowMutationHookResult = ReturnType<typeof useEditFlowMutation>
export type EditFlowMutationResult = Apollo.MutationResult<EditFlowMutation>
export type EditFlowMutationOptions = Apollo.BaseMutationOptions<
	EditFlowMutation,
	EditFlowMutationVariables
>
export const FlowDocument = gql`
	query flow($flowId: Int!) {
		flow(flowId: $flowId) {
			flow {
				id
				name
				validFrom
				validTo
				isDone
				flowStatements {
					id
					type
					flowComponents {
						type
						value
					}
					products {
						id
						product {
							name
							internalId
							marketId
							valueEntities {
								templateKey
								value
								rootId
								root {
									name
								}
							}
						}
						valueEntities {
							templateKey
							initialValue
							value
							rootId
							root {
								name
							}
						}
					}
				}
			}
		}
	}
`

/**
 * __useFlowQuery__
 *
 * To run a query within a React component, call `useFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlowQuery({
 *   variables: {
 *      flowId: // value for 'flowId'
 *   },
 * });
 */
export function useFlowQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		FlowQuery,
		FlowQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<FlowQuery, FlowQueryVariables>(
		FlowDocument,
		options
	)
}
export function useFlowLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		FlowQuery,
		FlowQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<FlowQuery, FlowQueryVariables>(
		FlowDocument,
		options
	)
}
export type FlowQueryHookResult = ReturnType<typeof useFlowQuery>
export type FlowLazyQueryHookResult = ReturnType<typeof useFlowLazyQuery>
export type FlowQueryResult = Apollo.QueryResult<FlowQuery, FlowQueryVariables>
export const FlowsDocument = gql`
	query flows($where: FlowsFilter, $offset: Int!, $limit: Int!) {
		flows(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				name
				validFrom
				validTo
				flowStatements {
					id
					flowComponents {
						type
						value
					}
					type
				}
			}
			totalCount
		}
	}
`

/**
 * __useFlowsQuery__
 *
 * To run a query within a React component, call `useFlowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlowsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFlowsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		FlowsQuery,
		FlowsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<FlowsQuery, FlowsQueryVariables>(
		FlowsDocument,
		options
	)
}
export function useFlowsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		FlowsQuery,
		FlowsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<FlowsQuery, FlowsQueryVariables>(
		FlowsDocument,
		options
	)
}
export type FlowsQueryHookResult = ReturnType<typeof useFlowsQuery>
export type FlowsLazyQueryHookResult = ReturnType<typeof useFlowsLazyQuery>
export type FlowsQueryResult = Apollo.QueryResult<
	FlowsQuery,
	FlowsQueryVariables
>
export const HasFlowsDocument = gql`
	query hasFlows($productId: Int!) {
		hasFlows(productId: $productId)
	}
`

/**
 * __useHasFlowsQuery__
 *
 * To run a query within a React component, call `useHasFlowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasFlowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasFlowsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useHasFlowsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		HasFlowsQuery,
		HasFlowsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<HasFlowsQuery, HasFlowsQueryVariables>(
		HasFlowsDocument,
		options
	)
}
export function useHasFlowsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		HasFlowsQuery,
		HasFlowsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<HasFlowsQuery, HasFlowsQueryVariables>(
		HasFlowsDocument,
		options
	)
}
export type HasFlowsQueryHookResult = ReturnType<typeof useHasFlowsQuery>
export type HasFlowsLazyQueryHookResult = ReturnType<
	typeof useHasFlowsLazyQuery
>
export type HasFlowsQueryResult = Apollo.QueryResult<
	HasFlowsQuery,
	HasFlowsQueryVariables
>
export const InfoDocument = gql`
	query info {
		info {
			tenant
			smartLabelCount
			orbisLabelCount
			sensorLabelCount
			shelfBarCount
			signageDeviceCount
			industrialScaleCount
			rootCount
			routerCount
			hasLocationCoordinates
		}
	}
`

/**
 * __useInfoQuery__
 *
 * To run a query within a React component, call `useInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useInfoQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		InfoQuery,
		InfoQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<InfoQuery, InfoQueryVariables>(
		InfoDocument,
		options
	)
}
export function useInfoLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		InfoQuery,
		InfoQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<InfoQuery, InfoQueryVariables>(
		InfoDocument,
		options
	)
}
export type InfoQueryHookResult = ReturnType<typeof useInfoQuery>
export type InfoLazyQueryHookResult = ReturnType<typeof useInfoLazyQuery>
export type InfoQueryResult = Apollo.QueryResult<InfoQuery, InfoQueryVariables>
export const InfoAttentionDocument = gql`
	query infoAttention {
		info {
			batteryUnderCount
			deviceProcessingCount
			deviceErrCount
		}
	}
`

/**
 * __useInfoAttentionQuery__
 *
 * To run a query within a React component, call `useInfoAttentionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoAttentionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoAttentionQuery({
 *   variables: {
 *   },
 * });
 */
export function useInfoAttentionQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		InfoAttentionQuery,
		InfoAttentionQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		InfoAttentionQuery,
		InfoAttentionQueryVariables
	>(InfoAttentionDocument, options)
}
export function useInfoAttentionLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		InfoAttentionQuery,
		InfoAttentionQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		InfoAttentionQuery,
		InfoAttentionQueryVariables
	>(InfoAttentionDocument, options)
}
export type InfoAttentionQueryHookResult = ReturnType<
	typeof useInfoAttentionQuery
>
export type InfoAttentionLazyQueryHookResult = ReturnType<
	typeof useInfoAttentionLazyQuery
>
export type InfoAttentionQueryResult = Apollo.QueryResult<
	InfoAttentionQuery,
	InfoAttentionQueryVariables
>
export const InfoAttentionInfrastructureDocument = gql`
	query infoAttentionInfrastructure {
		info {
			routerOffline
		}
	}
`

/**
 * __useInfoAttentionInfrastructureQuery__
 *
 * To run a query within a React component, call `useInfoAttentionInfrastructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoAttentionInfrastructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoAttentionInfrastructureQuery({
 *   variables: {
 *   },
 * });
 */
export function useInfoAttentionInfrastructureQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		InfoAttentionInfrastructureQuery,
		InfoAttentionInfrastructureQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		InfoAttentionInfrastructureQuery,
		InfoAttentionInfrastructureQueryVariables
	>(InfoAttentionInfrastructureDocument, options)
}
export function useInfoAttentionInfrastructureLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		InfoAttentionInfrastructureQuery,
		InfoAttentionInfrastructureQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		InfoAttentionInfrastructureQuery,
		InfoAttentionInfrastructureQueryVariables
	>(InfoAttentionInfrastructureDocument, options)
}
export type InfoAttentionInfrastructureQueryHookResult = ReturnType<
	typeof useInfoAttentionInfrastructureQuery
>
export type InfoAttentionInfrastructureLazyQueryHookResult = ReturnType<
	typeof useInfoAttentionInfrastructureLazyQuery
>
export type InfoAttentionInfrastructureQueryResult = Apollo.QueryResult<
	InfoAttentionInfrastructureQuery,
	InfoAttentionInfrastructureQueryVariables
>
export const InfoAttentionOrbisDocument = gql`
	query infoAttentionOrbis {
		info {
			orbisBatteryUnderCount
			orbisDeviceProcessingCount
			orbisDeviceErrCount
		}
	}
`

/**
 * __useInfoAttentionOrbisQuery__
 *
 * To run a query within a React component, call `useInfoAttentionOrbisQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoAttentionOrbisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoAttentionOrbisQuery({
 *   variables: {
 *   },
 * });
 */
export function useInfoAttentionOrbisQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		InfoAttentionOrbisQuery,
		InfoAttentionOrbisQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		InfoAttentionOrbisQuery,
		InfoAttentionOrbisQueryVariables
	>(InfoAttentionOrbisDocument, options)
}
export function useInfoAttentionOrbisLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		InfoAttentionOrbisQuery,
		InfoAttentionOrbisQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		InfoAttentionOrbisQuery,
		InfoAttentionOrbisQueryVariables
	>(InfoAttentionOrbisDocument, options)
}
export type InfoAttentionOrbisQueryHookResult = ReturnType<
	typeof useInfoAttentionOrbisQuery
>
export type InfoAttentionOrbisLazyQueryHookResult = ReturnType<
	typeof useInfoAttentionOrbisLazyQuery
>
export type InfoAttentionOrbisQueryResult = Apollo.QueryResult<
	InfoAttentionOrbisQuery,
	InfoAttentionOrbisQueryVariables
>
export const InfoAttentionScalesDocument = gql`
	query infoAttentionScales {
		info {
			scaleBatteryUnderCount
			scaleDeviceProcessingCount
			scaleDeviceErrCount
		}
	}
`

/**
 * __useInfoAttentionScalesQuery__
 *
 * To run a query within a React component, call `useInfoAttentionScalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoAttentionScalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoAttentionScalesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInfoAttentionScalesQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		InfoAttentionScalesQuery,
		InfoAttentionScalesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		InfoAttentionScalesQuery,
		InfoAttentionScalesQueryVariables
	>(InfoAttentionScalesDocument, options)
}
export function useInfoAttentionScalesLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		InfoAttentionScalesQuery,
		InfoAttentionScalesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		InfoAttentionScalesQuery,
		InfoAttentionScalesQueryVariables
	>(InfoAttentionScalesDocument, options)
}
export type InfoAttentionScalesQueryHookResult = ReturnType<
	typeof useInfoAttentionScalesQuery
>
export type InfoAttentionScalesLazyQueryHookResult = ReturnType<
	typeof useInfoAttentionScalesLazyQuery
>
export type InfoAttentionScalesQueryResult = Apollo.QueryResult<
	InfoAttentionScalesQuery,
	InfoAttentionScalesQueryVariables
>
export const AddIntegrationDocument = gql`
	mutation addIntegration($input: AddIntegrationInput!) {
		addIntegration(input: $input) {
			integration {
				id
			}
			errors {
				path
				message
			}
		}
	}
`
export type AddIntegrationMutationFn = Apollo.MutationFunction<
	AddIntegrationMutation,
	AddIntegrationMutationVariables
>

/**
 * __useAddIntegrationMutation__
 *
 * To run a mutation, you first call `useAddIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addIntegrationMutation, { data, loading, error }] = useAddIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddIntegrationMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddIntegrationMutation,
		AddIntegrationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddIntegrationMutation,
		AddIntegrationMutationVariables
	>(AddIntegrationDocument, options)
}
export type AddIntegrationMutationHookResult = ReturnType<
	typeof useAddIntegrationMutation
>
export type AddIntegrationMutationResult =
	Apollo.MutationResult<AddIntegrationMutation>
export type AddIntegrationMutationOptions = Apollo.BaseMutationOptions<
	AddIntegrationMutation,
	AddIntegrationMutationVariables
>
export const DeleteIntegrationDocument = gql`
	mutation deleteIntegration($id: Int!) {
		deleteIntegration(id: $id) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteIntegrationMutationFn = Apollo.MutationFunction<
	DeleteIntegrationMutation,
	DeleteIntegrationMutationVariables
>

/**
 * __useDeleteIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIntegrationMutation, { data, loading, error }] = useDeleteIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIntegrationMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteIntegrationMutation,
		DeleteIntegrationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteIntegrationMutation,
		DeleteIntegrationMutationVariables
	>(DeleteIntegrationDocument, options)
}
export type DeleteIntegrationMutationHookResult = ReturnType<
	typeof useDeleteIntegrationMutation
>
export type DeleteIntegrationMutationResult =
	Apollo.MutationResult<DeleteIntegrationMutation>
export type DeleteIntegrationMutationOptions = Apollo.BaseMutationOptions<
	DeleteIntegrationMutation,
	DeleteIntegrationMutationVariables
>
export const EditIntegrationDocument = gql`
	mutation editIntegration($input: EditIntegrationInput!) {
		editIntegration(input: $input) {
			success
			errors {
				path
				message
			}
		}
	}
`
export type EditIntegrationMutationFn = Apollo.MutationFunction<
	EditIntegrationMutation,
	EditIntegrationMutationVariables
>

/**
 * __useEditIntegrationMutation__
 *
 * To run a mutation, you first call `useEditIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editIntegrationMutation, { data, loading, error }] = useEditIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditIntegrationMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditIntegrationMutation,
		EditIntegrationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditIntegrationMutation,
		EditIntegrationMutationVariables
	>(EditIntegrationDocument, options)
}
export type EditIntegrationMutationHookResult = ReturnType<
	typeof useEditIntegrationMutation
>
export type EditIntegrationMutationResult =
	Apollo.MutationResult<EditIntegrationMutation>
export type EditIntegrationMutationOptions = Apollo.BaseMutationOptions<
	EditIntegrationMutation,
	EditIntegrationMutationVariables
>
export const IntegrationDocument = gql`
	query integration($id: Int, $token: String) {
		integration(id: $id, token: $token) {
			integration {
				id
				name
				token
				syncTime
				weekDays
				triggerUrl
				cronUpdateUrl
				preset
				cron
			}
		}
	}
`

/**
 * __useIntegrationQuery__
 *
 * To run a query within a React component, call `useIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useIntegrationQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		IntegrationQuery,
		IntegrationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		IntegrationQuery,
		IntegrationQueryVariables
	>(IntegrationDocument, options)
}
export function useIntegrationLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		IntegrationQuery,
		IntegrationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		IntegrationQuery,
		IntegrationQueryVariables
	>(IntegrationDocument, options)
}
export type IntegrationQueryHookResult = ReturnType<typeof useIntegrationQuery>
export type IntegrationLazyQueryHookResult = ReturnType<
	typeof useIntegrationLazyQuery
>
export type IntegrationQueryResult = Apollo.QueryResult<
	IntegrationQuery,
	IntegrationQueryVariables
>
export const IntegrationsDocument = gql`
	query integrations(
		$where: IntegrationsFilter
		$offset: Int!
		$limit: Int!
	) {
		integrations(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				name
			}
		}
	}
`

/**
 * __useIntegrationsQuery__
 *
 * To run a query within a React component, call `useIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useIntegrationsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		IntegrationsQuery,
		IntegrationsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		IntegrationsQuery,
		IntegrationsQueryVariables
	>(IntegrationsDocument, options)
}
export function useIntegrationsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		IntegrationsQuery,
		IntegrationsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		IntegrationsQuery,
		IntegrationsQueryVariables
	>(IntegrationsDocument, options)
}
export type IntegrationsQueryHookResult = ReturnType<
	typeof useIntegrationsQuery
>
export type IntegrationsLazyQueryHookResult = ReturnType<
	typeof useIntegrationsLazyQuery
>
export type IntegrationsQueryResult = Apollo.QueryResult<
	IntegrationsQuery,
	IntegrationsQueryVariables
>
export const SynchronizationsDocument = gql`
	query synchronizations(
		$where: SynchronizationsFilter
		$offset: Int!
		$limit: Int!
	) {
		synchronizations(where: $where, offset: $offset, limit: $limit) {
			totalCount
			nodes {
				id
				status
				time
				note
				updatedProducts
			}
		}
	}
`

/**
 * __useSynchronizationsQuery__
 *
 * To run a query within a React component, call `useSynchronizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSynchronizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSynchronizationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSynchronizationsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		SynchronizationsQuery,
		SynchronizationsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		SynchronizationsQuery,
		SynchronizationsQueryVariables
	>(SynchronizationsDocument, options)
}
export function useSynchronizationsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		SynchronizationsQuery,
		SynchronizationsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		SynchronizationsQuery,
		SynchronizationsQueryVariables
	>(SynchronizationsDocument, options)
}
export type SynchronizationsQueryHookResult = ReturnType<
	typeof useSynchronizationsQuery
>
export type SynchronizationsLazyQueryHookResult = ReturnType<
	typeof useSynchronizationsLazyQuery
>
export type SynchronizationsQueryResult = Apollo.QueryResult<
	SynchronizationsQuery,
	SynchronizationsQueryVariables
>
export const TriggerSyncDocument = gql`
	mutation triggerSync($input: TriggerSyncInput!) {
		triggerSync(input: $input) {
			success
			errors {
				path
				message
			}
		}
	}
`
export type TriggerSyncMutationFn = Apollo.MutationFunction<
	TriggerSyncMutation,
	TriggerSyncMutationVariables
>

/**
 * __useTriggerSyncMutation__
 *
 * To run a mutation, you first call `useTriggerSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerSyncMutation, { data, loading, error }] = useTriggerSyncMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerSyncMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		TriggerSyncMutation,
		TriggerSyncMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		TriggerSyncMutation,
		TriggerSyncMutationVariables
	>(TriggerSyncDocument, options)
}
export type TriggerSyncMutationHookResult = ReturnType<
	typeof useTriggerSyncMutation
>
export type TriggerSyncMutationResult =
	Apollo.MutationResult<TriggerSyncMutation>
export type TriggerSyncMutationOptions = Apollo.BaseMutationOptions<
	TriggerSyncMutation,
	TriggerSyncMutationVariables
>
export const AddLandingTemplateDocument = gql`
	mutation addLandingTemplate($input: LandingTemplateInput!) {
		addLandingTemplate(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type AddLandingTemplateMutationFn = Apollo.MutationFunction<
	AddLandingTemplateMutation,
	AddLandingTemplateMutationVariables
>

/**
 * __useAddLandingTemplateMutation__
 *
 * To run a mutation, you first call `useAddLandingTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLandingTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLandingTemplateMutation, { data, loading, error }] = useAddLandingTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLandingTemplateMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddLandingTemplateMutation,
		AddLandingTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddLandingTemplateMutation,
		AddLandingTemplateMutationVariables
	>(AddLandingTemplateDocument, options)
}
export type AddLandingTemplateMutationHookResult = ReturnType<
	typeof useAddLandingTemplateMutation
>
export type AddLandingTemplateMutationResult =
	Apollo.MutationResult<AddLandingTemplateMutation>
export type AddLandingTemplateMutationOptions = Apollo.BaseMutationOptions<
	AddLandingTemplateMutation,
	AddLandingTemplateMutationVariables
>
export const DeleteLandingTemplateDocument = gql`
	mutation deleteLandingTemplate($input: DeleteLandingTemplateInput!) {
		deleteLandingTemplate(input: $input) {
			affected
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteLandingTemplateMutationFn = Apollo.MutationFunction<
	DeleteLandingTemplateMutation,
	DeleteLandingTemplateMutationVariables
>

/**
 * __useDeleteLandingTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteLandingTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLandingTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLandingTemplateMutation, { data, loading, error }] = useDeleteLandingTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLandingTemplateMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteLandingTemplateMutation,
		DeleteLandingTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteLandingTemplateMutation,
		DeleteLandingTemplateMutationVariables
	>(DeleteLandingTemplateDocument, options)
}
export type DeleteLandingTemplateMutationHookResult = ReturnType<
	typeof useDeleteLandingTemplateMutation
>
export type DeleteLandingTemplateMutationResult =
	Apollo.MutationResult<DeleteLandingTemplateMutation>
export type DeleteLandingTemplateMutationOptions = Apollo.BaseMutationOptions<
	DeleteLandingTemplateMutation,
	DeleteLandingTemplateMutationVariables
>
export const EditLandingTemplateDocument = gql`
	mutation editLandingTemplate(
		$landingTemplateId: Int!
		$input: EditLandingTemplateInput!
	) {
		editLandingTemplate(
			landingTemplateId: $landingTemplateId
			input: $input
		) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditLandingTemplateMutationFn = Apollo.MutationFunction<
	EditLandingTemplateMutation,
	EditLandingTemplateMutationVariables
>

/**
 * __useEditLandingTemplateMutation__
 *
 * To run a mutation, you first call `useEditLandingTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLandingTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLandingTemplateMutation, { data, loading, error }] = useEditLandingTemplateMutation({
 *   variables: {
 *      landingTemplateId: // value for 'landingTemplateId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditLandingTemplateMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditLandingTemplateMutation,
		EditLandingTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditLandingTemplateMutation,
		EditLandingTemplateMutationVariables
	>(EditLandingTemplateDocument, options)
}
export type EditLandingTemplateMutationHookResult = ReturnType<
	typeof useEditLandingTemplateMutation
>
export type EditLandingTemplateMutationResult =
	Apollo.MutationResult<EditLandingTemplateMutation>
export type EditLandingTemplateMutationOptions = Apollo.BaseMutationOptions<
	EditLandingTemplateMutation,
	EditLandingTemplateMutationVariables
>
export const LandingTemplateDocument = gql`
	query landingTemplate($id: Int!) {
		landingTemplate(id: $id) {
			landingTemplate {
				id
				name
				key
				isCustom
				width
				height
				components {
					id
					name
					w
					h
					x
					y
					htmlContent
					type
				}
			}
			errors {
				path
				message
			}
		}
	}
`

/**
 * __useLandingTemplateQuery__
 *
 * To run a query within a React component, call `useLandingTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLandingTemplateQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		LandingTemplateQuery,
		LandingTemplateQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		LandingTemplateQuery,
		LandingTemplateQueryVariables
	>(LandingTemplateDocument, options)
}
export function useLandingTemplateLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		LandingTemplateQuery,
		LandingTemplateQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		LandingTemplateQuery,
		LandingTemplateQueryVariables
	>(LandingTemplateDocument, options)
}
export type LandingTemplateQueryHookResult = ReturnType<
	typeof useLandingTemplateQuery
>
export type LandingTemplateLazyQueryHookResult = ReturnType<
	typeof useLandingTemplateLazyQuery
>
export type LandingTemplateQueryResult = Apollo.QueryResult<
	LandingTemplateQuery,
	LandingTemplateQueryVariables
>
export const LandingTemplatesDocument = gql`
	query landingTemplates(
		$offset: Int!
		$limit: Int!
		$where: LandingTemplatesFilter
	) {
		landingTemplates(offset: $offset, limit: $limit, where: $where) {
			nodes {
				id
				name
				key
				height
				width
				inUse
				isCustom
			}
			totalCount
		}
	}
`

/**
 * __useLandingTemplatesQuery__
 *
 * To run a query within a React component, call `useLandingTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingTemplatesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLandingTemplatesQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		LandingTemplatesQuery,
		LandingTemplatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		LandingTemplatesQuery,
		LandingTemplatesQueryVariables
	>(LandingTemplatesDocument, options)
}
export function useLandingTemplatesLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		LandingTemplatesQuery,
		LandingTemplatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		LandingTemplatesQuery,
		LandingTemplatesQueryVariables
	>(LandingTemplatesDocument, options)
}
export type LandingTemplatesQueryHookResult = ReturnType<
	typeof useLandingTemplatesQuery
>
export type LandingTemplatesLazyQueryHookResult = ReturnType<
	typeof useLandingTemplatesLazyQuery
>
export type LandingTemplatesQueryResult = Apollo.QueryResult<
	LandingTemplatesQuery,
	LandingTemplatesQueryVariables
>
export const AuditLogsDocument = gql`
	query auditLogs($where: AuditLogsFilter, $offset: Int!, $limit: Int!) {
		auditLogs(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				createdAt
				authorId
				authorType
				event
				entityId
				entityType
				entityBefore
				entityAfter
				author {
					id
					email
					firstName
					lastName
					username
				}
			}
			totalCount
		}
	}
`

/**
 * __useAuditLogsQuery__
 *
 * To run a query within a React component, call `useAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditLogsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAuditLogsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		AuditLogsQuery,
		AuditLogsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<AuditLogsQuery, AuditLogsQueryVariables>(
		AuditLogsDocument,
		options
	)
}
export function useAuditLogsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		AuditLogsQuery,
		AuditLogsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		AuditLogsQuery,
		AuditLogsQueryVariables
	>(AuditLogsDocument, options)
}
export type AuditLogsQueryHookResult = ReturnType<typeof useAuditLogsQuery>
export type AuditLogsLazyQueryHookResult = ReturnType<
	typeof useAuditLogsLazyQuery
>
export type AuditLogsQueryResult = Apollo.QueryResult<
	AuditLogsQuery,
	AuditLogsQueryVariables
>
export const EditDemoScreenDocument = gql`
	mutation editDemoScreen($input: EditDemoScreenInput!) {
		editDemoScreen(input: $input) {
			success
			filename
		}
	}
`
export type EditDemoScreenMutationFn = Apollo.MutationFunction<
	EditDemoScreenMutation,
	EditDemoScreenMutationVariables
>

/**
 * __useEditDemoScreenMutation__
 *
 * To run a mutation, you first call `useEditDemoScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDemoScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDemoScreenMutation, { data, loading, error }] = useEditDemoScreenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDemoScreenMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditDemoScreenMutation,
		EditDemoScreenMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditDemoScreenMutation,
		EditDemoScreenMutationVariables
	>(EditDemoScreenDocument, options)
}
export type EditDemoScreenMutationHookResult = ReturnType<
	typeof useEditDemoScreenMutation
>
export type EditDemoScreenMutationResult =
	Apollo.MutationResult<EditDemoScreenMutation>
export type EditDemoScreenMutationOptions = Apollo.BaseMutationOptions<
	EditDemoScreenMutation,
	EditDemoScreenMutationVariables
>
export const AddCalendarDocument = gql`
	mutation addCalendar($input: AddCalendarInput!) {
		addCalendar(input: $input) {
			errors {
				path
				message
			}
			success
			calendar {
				id
			}
		}
	}
`
export type AddCalendarMutationFn = Apollo.MutationFunction<
	AddCalendarMutation,
	AddCalendarMutationVariables
>

/**
 * __useAddCalendarMutation__
 *
 * To run a mutation, you first call `useAddCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCalendarMutation, { data, loading, error }] = useAddCalendarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCalendarMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddCalendarMutation,
		AddCalendarMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddCalendarMutation,
		AddCalendarMutationVariables
	>(AddCalendarDocument, options)
}
export type AddCalendarMutationHookResult = ReturnType<
	typeof useAddCalendarMutation
>
export type AddCalendarMutationResult =
	Apollo.MutationResult<AddCalendarMutation>
export type AddCalendarMutationOptions = Apollo.BaseMutationOptions<
	AddCalendarMutation,
	AddCalendarMutationVariables
>
export const CalendarDocument = gql`
	query calendar($id: Int!) {
		calendar(id: $id) {
			calendar {
				id
				calendarName
				userUuid
				calendarId
				email
				calendarType
				calendarProvider
				taskListName
				taskListId
				templateVariantId
				templateVariant {
					id
					key
					name
				}
				product {
					id
					name
					valueEntities {
						id
						templateKey
						type
						value
						rootId
					}
					devices {
						id
						serialNumber
						name
						size
						deviceType
						lastTransactionStatus
						lastSeen
						deviceMode
						firmwareVersion
						softwareVersion
						screenType
						rotated
						routerId
						router {
							id
							name
						}
						root {
							id
							name
							routers {
								id
								name
							}
						}
						config {
							id
							sleepTime
							awakeTime
							highPowerMode
						}
						lastConfigTransaction {
							stage
							ts
						}
						batteryLevel
						batteryCharging
						batteryError
						active
						rssi
						product {
							name
							internalId
							parentProduct {
								name
							}
						}
						product2nd {
							name
							internalId
							parentProduct {
								name
							}
						}
						lastSync
					}
				}
			}
		}
	}
`

/**
 * __useCalendarQuery__
 *
 * To run a query within a React component, call `useCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalendarQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		CalendarQuery,
		CalendarQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<CalendarQuery, CalendarQueryVariables>(
		CalendarDocument,
		options
	)
}
export function useCalendarLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		CalendarQuery,
		CalendarQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<CalendarQuery, CalendarQueryVariables>(
		CalendarDocument,
		options
	)
}
export type CalendarQueryHookResult = ReturnType<typeof useCalendarQuery>
export type CalendarLazyQueryHookResult = ReturnType<
	typeof useCalendarLazyQuery
>
export type CalendarQueryResult = Apollo.QueryResult<
	CalendarQuery,
	CalendarQueryVariables
>
export const CalendarsDocument = gql`
	query calendars($where: CalendarsFilter, $offset: Int!, $limit: Int!) {
		calendars(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				userUuid
				calendarId
				email
				calendarType
				calendarProvider
				product {
					id
					name
					valueEntities {
						id
						templateKey
						type
						value
						rootId
					}
					devices {
						id
						serialNumber
						active
						lastTransactionStatus
					}
				}
			}
		}
	}
`

/**
 * __useCalendarsQuery__
 *
 * To run a query within a React component, call `useCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCalendarsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		CalendarsQuery,
		CalendarsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<CalendarsQuery, CalendarsQueryVariables>(
		CalendarsDocument,
		options
	)
}
export function useCalendarsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		CalendarsQuery,
		CalendarsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		CalendarsQuery,
		CalendarsQueryVariables
	>(CalendarsDocument, options)
}
export type CalendarsQueryHookResult = ReturnType<typeof useCalendarsQuery>
export type CalendarsLazyQueryHookResult = ReturnType<
	typeof useCalendarsLazyQuery
>
export type CalendarsQueryResult = Apollo.QueryResult<
	CalendarsQuery,
	CalendarsQueryVariables
>
export const DeleteOrbisDeviceDocument = gql`
	mutation deleteOrbisDevice($deviceId: Int!) {
		deleteOrbisDevice(id: $deviceId) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteOrbisDeviceMutationFn = Apollo.MutationFunction<
	DeleteOrbisDeviceMutation,
	DeleteOrbisDeviceMutationVariables
>

/**
 * __useDeleteOrbisDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteOrbisDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrbisDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrbisDeviceMutation, { data, loading, error }] = useDeleteOrbisDeviceMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useDeleteOrbisDeviceMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteOrbisDeviceMutation,
		DeleteOrbisDeviceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteOrbisDeviceMutation,
		DeleteOrbisDeviceMutationVariables
	>(DeleteOrbisDeviceDocument, options)
}
export type DeleteOrbisDeviceMutationHookResult = ReturnType<
	typeof useDeleteOrbisDeviceMutation
>
export type DeleteOrbisDeviceMutationResult =
	Apollo.MutationResult<DeleteOrbisDeviceMutation>
export type DeleteOrbisDeviceMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrbisDeviceMutation,
	DeleteOrbisDeviceMutationVariables
>
export const DeleteCalendarDocument = gql`
	mutation deleteCalendar($id: Int!) {
		deleteCalendar(id: $id) {
			errors {
				message
				path
			}
			success
		}
	}
`
export type DeleteCalendarMutationFn = Apollo.MutationFunction<
	DeleteCalendarMutation,
	DeleteCalendarMutationVariables
>

/**
 * __useDeleteCalendarMutation__
 *
 * To run a mutation, you first call `useDeleteCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCalendarMutation, { data, loading, error }] = useDeleteCalendarMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCalendarMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteCalendarMutation,
		DeleteCalendarMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteCalendarMutation,
		DeleteCalendarMutationVariables
	>(DeleteCalendarDocument, options)
}
export type DeleteCalendarMutationHookResult = ReturnType<
	typeof useDeleteCalendarMutation
>
export type DeleteCalendarMutationResult =
	Apollo.MutationResult<DeleteCalendarMutation>
export type DeleteCalendarMutationOptions = Apollo.BaseMutationOptions<
	DeleteCalendarMutation,
	DeleteCalendarMutationVariables
>
export const EditCalendarDocument = gql`
	mutation editCalendar($input: EditCalendarInput!) {
		editCalendar(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditCalendarMutationFn = Apollo.MutationFunction<
	EditCalendarMutation,
	EditCalendarMutationVariables
>

/**
 * __useEditCalendarMutation__
 *
 * To run a mutation, you first call `useEditCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCalendarMutation, { data, loading, error }] = useEditCalendarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCalendarMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditCalendarMutation,
		EditCalendarMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditCalendarMutation,
		EditCalendarMutationVariables
	>(EditCalendarDocument, options)
}
export type EditCalendarMutationHookResult = ReturnType<
	typeof useEditCalendarMutation
>
export type EditCalendarMutationResult =
	Apollo.MutationResult<EditCalendarMutation>
export type EditCalendarMutationOptions = Apollo.BaseMutationOptions<
	EditCalendarMutation,
	EditCalendarMutationVariables
>
export const OrbisProductsDocument = gql`
	query orbisProducts($where: ProductsFilter, $offset: Int!, $limit: Int!) {
		products(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				name
				internalId
				valueEntities {
					templateKey
					value
				}
				products {
					id
					internalId
					name
					valueEntities {
						templateKey
						value
					}
					root {
						id
						name
					}
					supplier {
						id
						companyName
						supplierId
					}
					positions {
						id
						sequence
						shelf {
							key
							bay {
								key
								aisle {
									key
								}
							}
						}
					}
				}
				productImages {
					id
					file {
						thumbnail
					}
				}
			}
			totalCount
		}
	}
`

/**
 * __useOrbisProductsQuery__
 *
 * To run a query within a React component, call `useOrbisProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrbisProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrbisProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useOrbisProductsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		OrbisProductsQuery,
		OrbisProductsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		OrbisProductsQuery,
		OrbisProductsQueryVariables
	>(OrbisProductsDocument, options)
}
export function useOrbisProductsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		OrbisProductsQuery,
		OrbisProductsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		OrbisProductsQuery,
		OrbisProductsQueryVariables
	>(OrbisProductsDocument, options)
}
export type OrbisProductsQueryHookResult = ReturnType<
	typeof useOrbisProductsQuery
>
export type OrbisProductsLazyQueryHookResult = ReturnType<
	typeof useOrbisProductsLazyQuery
>
export type OrbisProductsQueryResult = Apollo.QueryResult<
	OrbisProductsQuery,
	OrbisProductsQueryVariables
>
export const AddAisleDocument = gql`
	mutation addAisle($input: IsleInput!) {
		addAisle(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type AddAisleMutationFn = Apollo.MutationFunction<
	AddAisleMutation,
	AddAisleMutationVariables
>

/**
 * __useAddAisleMutation__
 *
 * To run a mutation, you first call `useAddAisleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAisleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAisleMutation, { data, loading, error }] = useAddAisleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAisleMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddAisleMutation,
		AddAisleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddAisleMutation,
		AddAisleMutationVariables
	>(AddAisleDocument, options)
}
export type AddAisleMutationHookResult = ReturnType<typeof useAddAisleMutation>
export type AddAisleMutationResult = Apollo.MutationResult<AddAisleMutation>
export type AddAisleMutationOptions = Apollo.BaseMutationOptions<
	AddAisleMutation,
	AddAisleMutationVariables
>
export const AisleDocument = gql`
	query aisle($aisleId: Int!) {
		aisle(aisleId: $aisleId) {
			aisle {
				id
				key
				root {
					id
				}
			}
		}
	}
`

/**
 * __useAisleQuery__
 *
 * To run a query within a React component, call `useAisleQuery` and pass it any options that fit your needs.
 * When your component renders, `useAisleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAisleQuery({
 *   variables: {
 *      aisleId: // value for 'aisleId'
 *   },
 * });
 */
export function useAisleQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		AisleQuery,
		AisleQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<AisleQuery, AisleQueryVariables>(
		AisleDocument,
		options
	)
}
export function useAisleLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		AisleQuery,
		AisleQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<AisleQuery, AisleQueryVariables>(
		AisleDocument,
		options
	)
}
export type AisleQueryHookResult = ReturnType<typeof useAisleQuery>
export type AisleLazyQueryHookResult = ReturnType<typeof useAisleLazyQuery>
export type AisleQueryResult = Apollo.QueryResult<
	AisleQuery,
	AisleQueryVariables
>
export const AisleVisualDocument = gql`
	query aisleVisual($aisleId: Int!) {
		aisle(aisleId: $aisleId) {
			aisle {
				id
				key
				height
				bays {
					id
					key
					width
					sequence
					shelves {
						id
						key
						sequence
						positions {
							id
							key
							sequence
						}
					}
				}
			}
		}
	}
`

/**
 * __useAisleVisualQuery__
 *
 * To run a query within a React component, call `useAisleVisualQuery` and pass it any options that fit your needs.
 * When your component renders, `useAisleVisualQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAisleVisualQuery({
 *   variables: {
 *      aisleId: // value for 'aisleId'
 *   },
 * });
 */
export function useAisleVisualQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		AisleVisualQuery,
		AisleVisualQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		AisleVisualQuery,
		AisleVisualQueryVariables
	>(AisleVisualDocument, options)
}
export function useAisleVisualLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		AisleVisualQuery,
		AisleVisualQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		AisleVisualQuery,
		AisleVisualQueryVariables
	>(AisleVisualDocument, options)
}
export type AisleVisualQueryHookResult = ReturnType<typeof useAisleVisualQuery>
export type AisleVisualLazyQueryHookResult = ReturnType<
	typeof useAisleVisualLazyQuery
>
export type AisleVisualQueryResult = Apollo.QueryResult<
	AisleVisualQuery,
	AisleVisualQueryVariables
>
export const AislesDocument = gql`
	query aisles($where: IslesFilter, $offset: Int!, $limit: Int!) {
		aisles(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				key
				bays {
					id
					key
					shelves {
						id
						key
						positions {
							id
						}
					}
				}
			}
			totalCount
		}
	}
`

/**
 * __useAislesQuery__
 *
 * To run a query within a React component, call `useAislesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAislesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAislesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAislesQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		AislesQuery,
		AislesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<AislesQuery, AislesQueryVariables>(
		AislesDocument,
		options
	)
}
export function useAislesLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		AislesQuery,
		AislesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<AislesQuery, AislesQueryVariables>(
		AislesDocument,
		options
	)
}
export type AislesQueryHookResult = ReturnType<typeof useAislesQuery>
export type AislesLazyQueryHookResult = ReturnType<typeof useAislesLazyQuery>
export type AislesQueryResult = Apollo.QueryResult<
	AislesQuery,
	AislesQueryVariables
>
export const AislesVisualDocument = gql`
	query aislesVisual($where: IslesFilter, $offset: Int!, $limit: Int!) {
		aisles(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				key
				width
				height
				depth
				x
				y
				bays {
					id
					key
					width
					sequence
				}
			}
			totalCount
		}
	}
`

/**
 * __useAislesVisualQuery__
 *
 * To run a query within a React component, call `useAislesVisualQuery` and pass it any options that fit your needs.
 * When your component renders, `useAislesVisualQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAislesVisualQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAislesVisualQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		AislesVisualQuery,
		AislesVisualQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		AislesVisualQuery,
		AislesVisualQueryVariables
	>(AislesVisualDocument, options)
}
export function useAislesVisualLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		AislesVisualQuery,
		AislesVisualQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		AislesVisualQuery,
		AislesVisualQueryVariables
	>(AislesVisualDocument, options)
}
export type AislesVisualQueryHookResult = ReturnType<
	typeof useAislesVisualQuery
>
export type AislesVisualLazyQueryHookResult = ReturnType<
	typeof useAislesVisualLazyQuery
>
export type AislesVisualQueryResult = Apollo.QueryResult<
	AislesVisualQuery,
	AislesVisualQueryVariables
>
export const DeleteAisleDocument = gql`
	mutation deleteAisle($input: DeleteAisleInput!) {
		deleteAisle(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteAisleMutationFn = Apollo.MutationFunction<
	DeleteAisleMutation,
	DeleteAisleMutationVariables
>

/**
 * __useDeleteAisleMutation__
 *
 * To run a mutation, you first call `useDeleteAisleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAisleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAisleMutation, { data, loading, error }] = useDeleteAisleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAisleMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteAisleMutation,
		DeleteAisleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteAisleMutation,
		DeleteAisleMutationVariables
	>(DeleteAisleDocument, options)
}
export type DeleteAisleMutationHookResult = ReturnType<
	typeof useDeleteAisleMutation
>
export type DeleteAisleMutationResult =
	Apollo.MutationResult<DeleteAisleMutation>
export type DeleteAisleMutationOptions = Apollo.BaseMutationOptions<
	DeleteAisleMutation,
	DeleteAisleMutationVariables
>
export const EditAisleDocument = gql`
	mutation editAisle($aisleId: Int!, $input: EditAisleInput!) {
		editAisle(aisleId: $aisleId, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditAisleMutationFn = Apollo.MutationFunction<
	EditAisleMutation,
	EditAisleMutationVariables
>

/**
 * __useEditAisleMutation__
 *
 * To run a mutation, you first call `useEditAisleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAisleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAisleMutation, { data, loading, error }] = useEditAisleMutation({
 *   variables: {
 *      aisleId: // value for 'aisleId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditAisleMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditAisleMutation,
		EditAisleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditAisleMutation,
		EditAisleMutationVariables
	>(EditAisleDocument, options)
}
export type EditAisleMutationHookResult = ReturnType<
	typeof useEditAisleMutation
>
export type EditAisleMutationResult = Apollo.MutationResult<EditAisleMutation>
export type EditAisleMutationOptions = Apollo.BaseMutationOptions<
	EditAisleMutation,
	EditAisleMutationVariables
>
export const AddBayDocument = gql`
	mutation addBay($input: BayInput!) {
		addBay(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type AddBayMutationFn = Apollo.MutationFunction<
	AddBayMutation,
	AddBayMutationVariables
>

/**
 * __useAddBayMutation__
 *
 * To run a mutation, you first call `useAddBayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBayMutation, { data, loading, error }] = useAddBayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBayMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddBayMutation,
		AddBayMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddBayMutation,
		AddBayMutationVariables
	>(AddBayDocument, options)
}
export type AddBayMutationHookResult = ReturnType<typeof useAddBayMutation>
export type AddBayMutationResult = Apollo.MutationResult<AddBayMutation>
export type AddBayMutationOptions = Apollo.BaseMutationOptions<
	AddBayMutation,
	AddBayMutationVariables
>
export const BayDocument = gql`
	query bay($bayId: Int!) {
		bay(bayId: $bayId) {
			bay {
				id
				key
				aisle {
					id
					key
				}
			}
		}
	}
`

/**
 * __useBayQuery__
 *
 * To run a query within a React component, call `useBayQuery` and pass it any options that fit your needs.
 * When your component renders, `useBayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBayQuery({
 *   variables: {
 *      bayId: // value for 'bayId'
 *   },
 * });
 */
export function useBayQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<BayQuery, BayQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<BayQuery, BayQueryVariables>(
		BayDocument,
		options
	)
}
export function useBayLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		BayQuery,
		BayQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<BayQuery, BayQueryVariables>(
		BayDocument,
		options
	)
}
export type BayQueryHookResult = ReturnType<typeof useBayQuery>
export type BayLazyQueryHookResult = ReturnType<typeof useBayLazyQuery>
export type BayQueryResult = Apollo.QueryResult<BayQuery, BayQueryVariables>
export const BaysDocument = gql`
	query bays($where: baysFilter, $offset: Int!, $limit: Int!) {
		bays(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				key
				aisle {
					id
					key
				}
			}
			totalCount
		}
	}
`

/**
 * __useBaysQuery__
 *
 * To run a query within a React component, call `useBaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useBaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBaysQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBaysQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		BaysQuery,
		BaysQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<BaysQuery, BaysQueryVariables>(
		BaysDocument,
		options
	)
}
export function useBaysLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		BaysQuery,
		BaysQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<BaysQuery, BaysQueryVariables>(
		BaysDocument,
		options
	)
}
export type BaysQueryHookResult = ReturnType<typeof useBaysQuery>
export type BaysLazyQueryHookResult = ReturnType<typeof useBaysLazyQuery>
export type BaysQueryResult = Apollo.QueryResult<BaysQuery, BaysQueryVariables>
export const DeleteBayDocument = gql`
	mutation deleteBay($input: DeleteBayInput!) {
		deleteBay(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteBayMutationFn = Apollo.MutationFunction<
	DeleteBayMutation,
	DeleteBayMutationVariables
>

/**
 * __useDeleteBayMutation__
 *
 * To run a mutation, you first call `useDeleteBayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBayMutation, { data, loading, error }] = useDeleteBayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBayMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteBayMutation,
		DeleteBayMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteBayMutation,
		DeleteBayMutationVariables
	>(DeleteBayDocument, options)
}
export type DeleteBayMutationHookResult = ReturnType<
	typeof useDeleteBayMutation
>
export type DeleteBayMutationResult = Apollo.MutationResult<DeleteBayMutation>
export type DeleteBayMutationOptions = Apollo.BaseMutationOptions<
	DeleteBayMutation,
	DeleteBayMutationVariables
>
export const EditBayDocument = gql`
	mutation editBay($bayId: Int!, $input: EditBayInput!) {
		editBay(bayId: $bayId, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditBayMutationFn = Apollo.MutationFunction<
	EditBayMutation,
	EditBayMutationVariables
>

/**
 * __useEditBayMutation__
 *
 * To run a mutation, you first call `useEditBayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBayMutation, { data, loading, error }] = useEditBayMutation({
 *   variables: {
 *      bayId: // value for 'bayId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBayMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditBayMutation,
		EditBayMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditBayMutation,
		EditBayMutationVariables
	>(EditBayDocument, options)
}
export type EditBayMutationHookResult = ReturnType<typeof useEditBayMutation>
export type EditBayMutationResult = Apollo.MutationResult<EditBayMutation>
export type EditBayMutationOptions = Apollo.BaseMutationOptions<
	EditBayMutation,
	EditBayMutationVariables
>
export const PlanogramRootDocument = gql`
	query planogramRoot($rootId: Int!) {
		root(rootId: $rootId) {
			root {
				name
			}
		}
	}
`

/**
 * __usePlanogramRootQuery__
 *
 * To run a query within a React component, call `usePlanogramRootQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanogramRootQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanogramRootQuery({
 *   variables: {
 *      rootId: // value for 'rootId'
 *   },
 * });
 */
export function usePlanogramRootQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		PlanogramRootQuery,
		PlanogramRootQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		PlanogramRootQuery,
		PlanogramRootQueryVariables
	>(PlanogramRootDocument, options)
}
export function usePlanogramRootLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		PlanogramRootQuery,
		PlanogramRootQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		PlanogramRootQuery,
		PlanogramRootQueryVariables
	>(PlanogramRootDocument, options)
}
export type PlanogramRootQueryHookResult = ReturnType<
	typeof usePlanogramRootQuery
>
export type PlanogramRootLazyQueryHookResult = ReturnType<
	typeof usePlanogramRootLazyQuery
>
export type PlanogramRootQueryResult = Apollo.QueryResult<
	PlanogramRootQuery,
	PlanogramRootQueryVariables
>
export const AddPositionDocument = gql`
	mutation addPosition($input: PositionInput!) {
		addPosition(input: $input) {
			errors {
				message
			}
			success
		}
	}
`
export type AddPositionMutationFn = Apollo.MutationFunction<
	AddPositionMutation,
	AddPositionMutationVariables
>

/**
 * __useAddPositionMutation__
 *
 * To run a mutation, you first call `useAddPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPositionMutation, { data, loading, error }] = useAddPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPositionMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddPositionMutation,
		AddPositionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddPositionMutation,
		AddPositionMutationVariables
	>(AddPositionDocument, options)
}
export type AddPositionMutationHookResult = ReturnType<
	typeof useAddPositionMutation
>
export type AddPositionMutationResult =
	Apollo.MutationResult<AddPositionMutation>
export type AddPositionMutationOptions = Apollo.BaseMutationOptions<
	AddPositionMutation,
	AddPositionMutationVariables
>
export const DeletePositionDocument = gql`
	mutation deletePosition($positionId: Int!) {
		deletePosition(positionId: $positionId) {
			errors {
				message
			}
			success
		}
	}
`
export type DeletePositionMutationFn = Apollo.MutationFunction<
	DeletePositionMutation,
	DeletePositionMutationVariables
>

/**
 * __useDeletePositionMutation__
 *
 * To run a mutation, you first call `useDeletePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePositionMutation, { data, loading, error }] = useDeletePositionMutation({
 *   variables: {
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useDeletePositionMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeletePositionMutation,
		DeletePositionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeletePositionMutation,
		DeletePositionMutationVariables
	>(DeletePositionDocument, options)
}
export type DeletePositionMutationHookResult = ReturnType<
	typeof useDeletePositionMutation
>
export type DeletePositionMutationResult =
	Apollo.MutationResult<DeletePositionMutation>
export type DeletePositionMutationOptions = Apollo.BaseMutationOptions<
	DeletePositionMutation,
	DeletePositionMutationVariables
>
export const DeletePositionAndUntieDeviceDocument = gql`
	mutation deletePositionAndUntieDevice($positionId: Int!) {
		deletePositionAndUntieDevice(positionId: $positionId) {
			errors {
				message
			}
			success
		}
	}
`
export type DeletePositionAndUntieDeviceMutationFn = Apollo.MutationFunction<
	DeletePositionAndUntieDeviceMutation,
	DeletePositionAndUntieDeviceMutationVariables
>

/**
 * __useDeletePositionAndUntieDeviceMutation__
 *
 * To run a mutation, you first call `useDeletePositionAndUntieDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePositionAndUntieDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePositionAndUntieDeviceMutation, { data, loading, error }] = useDeletePositionAndUntieDeviceMutation({
 *   variables: {
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useDeletePositionAndUntieDeviceMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeletePositionAndUntieDeviceMutation,
		DeletePositionAndUntieDeviceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeletePositionAndUntieDeviceMutation,
		DeletePositionAndUntieDeviceMutationVariables
	>(DeletePositionAndUntieDeviceDocument, options)
}
export type DeletePositionAndUntieDeviceMutationHookResult = ReturnType<
	typeof useDeletePositionAndUntieDeviceMutation
>
export type DeletePositionAndUntieDeviceMutationResult =
	Apollo.MutationResult<DeletePositionAndUntieDeviceMutation>
export type DeletePositionAndUntieDeviceMutationOptions =
	Apollo.BaseMutationOptions<
		DeletePositionAndUntieDeviceMutation,
		DeletePositionAndUntieDeviceMutationVariables
	>
export const EditPositionDocument = gql`
	mutation editPosition($positionId: Int!, $input: EditPositionInput!) {
		editPosition(positionId: $positionId, input: $input) {
			errors {
				message
				path
			}
			success
		}
	}
`
export type EditPositionMutationFn = Apollo.MutationFunction<
	EditPositionMutation,
	EditPositionMutationVariables
>

/**
 * __useEditPositionMutation__
 *
 * To run a mutation, you first call `useEditPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPositionMutation, { data, loading, error }] = useEditPositionMutation({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPositionMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditPositionMutation,
		EditPositionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditPositionMutation,
		EditPositionMutationVariables
	>(EditPositionDocument, options)
}
export type EditPositionMutationHookResult = ReturnType<
	typeof useEditPositionMutation
>
export type EditPositionMutationResult =
	Apollo.MutationResult<EditPositionMutation>
export type EditPositionMutationOptions = Apollo.BaseMutationOptions<
	EditPositionMutation,
	EditPositionMutationVariables
>
export const EditPositionOldPositionDocument = gql`
	mutation editPositionOldPosition(
		$positionId: Int!
		$positionInput: EditPositionInput!
		$oldPositionId: Int!
		$oldPositionInput: EditPositionInput!
	) {
		A: editPosition(positionId: $positionId, input: $positionInput) {
			errors {
				message
				path
			}
			success
		}
		B: editPosition(positionId: $oldPositionId, input: $oldPositionInput) {
			errors {
				message
				path
			}
			success
		}
	}
`
export type EditPositionOldPositionMutationFn = Apollo.MutationFunction<
	EditPositionOldPositionMutation,
	EditPositionOldPositionMutationVariables
>

/**
 * __useEditPositionOldPositionMutation__
 *
 * To run a mutation, you first call `useEditPositionOldPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPositionOldPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPositionOldPositionMutation, { data, loading, error }] = useEditPositionOldPositionMutation({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      positionInput: // value for 'positionInput'
 *      oldPositionId: // value for 'oldPositionId'
 *      oldPositionInput: // value for 'oldPositionInput'
 *   },
 * });
 */
export function useEditPositionOldPositionMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditPositionOldPositionMutation,
		EditPositionOldPositionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditPositionOldPositionMutation,
		EditPositionOldPositionMutationVariables
	>(EditPositionOldPositionDocument, options)
}
export type EditPositionOldPositionMutationHookResult = ReturnType<
	typeof useEditPositionOldPositionMutation
>
export type EditPositionOldPositionMutationResult =
	Apollo.MutationResult<EditPositionOldPositionMutation>
export type EditPositionOldPositionMutationOptions = Apollo.BaseMutationOptions<
	EditPositionOldPositionMutation,
	EditPositionOldPositionMutationVariables
>
export const PlanogramPositionDocument = gql`
	query planogramPosition($positionId: Int!) {
		position(positionId: $positionId) {
			position {
				id
				key
				sequence
				x
				y
				z
				shelf {
					id
					key
					bay {
						key
						aisle {
							key
						}
					}
				}
				product {
					id
					internalId
					name
					parentProduct {
						name
					}
				}
				root {
					id
					market {
						id
					}
				}
				device {
					id
					serialNumber
					size
					product {
						id
						internalId
						name
						parentProduct {
							name
						}
					}
				}
				templateVariant {
					id
				}
			}
		}
	}
`

/**
 * __usePlanogramPositionQuery__
 *
 * To run a query within a React component, call `usePlanogramPositionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanogramPositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanogramPositionQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function usePlanogramPositionQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		PlanogramPositionQuery,
		PlanogramPositionQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		PlanogramPositionQuery,
		PlanogramPositionQueryVariables
	>(PlanogramPositionDocument, options)
}
export function usePlanogramPositionLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		PlanogramPositionQuery,
		PlanogramPositionQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		PlanogramPositionQuery,
		PlanogramPositionQueryVariables
	>(PlanogramPositionDocument, options)
}
export type PlanogramPositionQueryHookResult = ReturnType<
	typeof usePlanogramPositionQuery
>
export type PlanogramPositionLazyQueryHookResult = ReturnType<
	typeof usePlanogramPositionLazyQuery
>
export type PlanogramPositionQueryResult = Apollo.QueryResult<
	PlanogramPositionQuery,
	PlanogramPositionQueryVariables
>
export const PlanogramPositionsDocument = gql`
	query planogramPositions(
		$where: PositionsFilter
		$offset: Int!
		$limit: Int!
	) {
		positions(where: $where, limit: $limit, offset: $offset) {
			nodes {
				id
				key
				sequence
				shelf {
					key
					bay {
						key
						aisle {
							key
						}
					}
				}
				device {
					id
					serialNumber
				}
				templateVariant {
					id
					key
				}
				product {
					id
					internalId
					name
					parentProduct {
						id
						name
					}
				}
			}
		}
	}
`

/**
 * __usePlanogramPositionsQuery__
 *
 * To run a query within a React component, call `usePlanogramPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanogramPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanogramPositionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePlanogramPositionsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		PlanogramPositionsQuery,
		PlanogramPositionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		PlanogramPositionsQuery,
		PlanogramPositionsQueryVariables
	>(PlanogramPositionsDocument, options)
}
export function usePlanogramPositionsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		PlanogramPositionsQuery,
		PlanogramPositionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		PlanogramPositionsQuery,
		PlanogramPositionsQueryVariables
	>(PlanogramPositionsDocument, options)
}
export type PlanogramPositionsQueryHookResult = ReturnType<
	typeof usePlanogramPositionsQuery
>
export type PlanogramPositionsLazyQueryHookResult = ReturnType<
	typeof usePlanogramPositionsLazyQuery
>
export type PlanogramPositionsQueryResult = Apollo.QueryResult<
	PlanogramPositionsQuery,
	PlanogramPositionsQueryVariables
>
export const AddShelfDocument = gql`
	mutation addShelf($input: ShelfInput!) {
		addShelf(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type AddShelfMutationFn = Apollo.MutationFunction<
	AddShelfMutation,
	AddShelfMutationVariables
>

/**
 * __useAddShelfMutation__
 *
 * To run a mutation, you first call `useAddShelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddShelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addShelfMutation, { data, loading, error }] = useAddShelfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddShelfMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddShelfMutation,
		AddShelfMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddShelfMutation,
		AddShelfMutationVariables
	>(AddShelfDocument, options)
}
export type AddShelfMutationHookResult = ReturnType<typeof useAddShelfMutation>
export type AddShelfMutationResult = Apollo.MutationResult<AddShelfMutation>
export type AddShelfMutationOptions = Apollo.BaseMutationOptions<
	AddShelfMutation,
	AddShelfMutationVariables
>
export const AddShelfStructDocument = gql`
	mutation addShelfStruct($input: ShelfStructInput!) {
		addShelfStruct(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type AddShelfStructMutationFn = Apollo.MutationFunction<
	AddShelfStructMutation,
	AddShelfStructMutationVariables
>

/**
 * __useAddShelfStructMutation__
 *
 * To run a mutation, you first call `useAddShelfStructMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddShelfStructMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addShelfStructMutation, { data, loading, error }] = useAddShelfStructMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddShelfStructMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddShelfStructMutation,
		AddShelfStructMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddShelfStructMutation,
		AddShelfStructMutationVariables
	>(AddShelfStructDocument, options)
}
export type AddShelfStructMutationHookResult = ReturnType<
	typeof useAddShelfStructMutation
>
export type AddShelfStructMutationResult =
	Apollo.MutationResult<AddShelfStructMutation>
export type AddShelfStructMutationOptions = Apollo.BaseMutationOptions<
	AddShelfStructMutation,
	AddShelfStructMutationVariables
>
export const DeleteShelfDocument = gql`
	mutation deleteShelf($input: DeleteShelfInput!) {
		deleteShelf(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteShelfMutationFn = Apollo.MutationFunction<
	DeleteShelfMutation,
	DeleteShelfMutationVariables
>

/**
 * __useDeleteShelfMutation__
 *
 * To run a mutation, you first call `useDeleteShelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShelfMutation, { data, loading, error }] = useDeleteShelfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteShelfMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteShelfMutation,
		DeleteShelfMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteShelfMutation,
		DeleteShelfMutationVariables
	>(DeleteShelfDocument, options)
}
export type DeleteShelfMutationHookResult = ReturnType<
	typeof useDeleteShelfMutation
>
export type DeleteShelfMutationResult =
	Apollo.MutationResult<DeleteShelfMutation>
export type DeleteShelfMutationOptions = Apollo.BaseMutationOptions<
	DeleteShelfMutation,
	DeleteShelfMutationVariables
>
export const EditShelfDocument = gql`
	mutation editShelf($shelfId: Int!, $input: EditShelfInput!) {
		editShelf(shelfId: $shelfId, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditShelfMutationFn = Apollo.MutationFunction<
	EditShelfMutation,
	EditShelfMutationVariables
>

/**
 * __useEditShelfMutation__
 *
 * To run a mutation, you first call `useEditShelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditShelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editShelfMutation, { data, loading, error }] = useEditShelfMutation({
 *   variables: {
 *      shelfId: // value for 'shelfId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditShelfMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditShelfMutation,
		EditShelfMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditShelfMutation,
		EditShelfMutationVariables
	>(EditShelfDocument, options)
}
export type EditShelfMutationHookResult = ReturnType<
	typeof useEditShelfMutation
>
export type EditShelfMutationResult = Apollo.MutationResult<EditShelfMutation>
export type EditShelfMutationOptions = Apollo.BaseMutationOptions<
	EditShelfMutation,
	EditShelfMutationVariables
>
export const ShelfDocument = gql`
	query shelf($shelfId: Int!) {
		shelf(shelfId: $shelfId) {
			shelf {
				id
				key
				bay {
					id
					key
					aisle {
						id
						key
					}
				}
				root {
					id
				}
				positions {
					id
					name
					sequence
					product {
						id
						internalId
						name
						parentProduct {
							name
						}
					}
					device {
						id
						serialNumber
					}
					root {
						id
					}
				}
			}
		}
	}
`

/**
 * __useShelfQuery__
 *
 * To run a query within a React component, call `useShelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useShelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShelfQuery({
 *   variables: {
 *      shelfId: // value for 'shelfId'
 *   },
 * });
 */
export function useShelfQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		ShelfQuery,
		ShelfQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<ShelfQuery, ShelfQueryVariables>(
		ShelfDocument,
		options
	)
}
export function useShelfLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ShelfQuery,
		ShelfQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<ShelfQuery, ShelfQueryVariables>(
		ShelfDocument,
		options
	)
}
export type ShelfQueryHookResult = ReturnType<typeof useShelfQuery>
export type ShelfLazyQueryHookResult = ReturnType<typeof useShelfLazyQuery>
export type ShelfQueryResult = Apollo.QueryResult<
	ShelfQuery,
	ShelfQueryVariables
>
export const ShelvesDocument = gql`
	query shelves($where: shelvesFilter, $offset: Int!, $limit: Int!) {
		shelves(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				key
				bay {
					key
					aisle {
						key
					}
				}
			}
			totalCount
		}
	}
`

/**
 * __useShelvesQuery__
 *
 * To run a query within a React component, call `useShelvesQuery` and pass it any options that fit your needs.
 * When your component renders, `useShelvesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShelvesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useShelvesQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		ShelvesQuery,
		ShelvesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<ShelvesQuery, ShelvesQueryVariables>(
		ShelvesDocument,
		options
	)
}
export function useShelvesLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ShelvesQuery,
		ShelvesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<ShelvesQuery, ShelvesQueryVariables>(
		ShelvesDocument,
		options
	)
}
export type ShelvesQueryHookResult = ReturnType<typeof useShelvesQuery>
export type ShelvesLazyQueryHookResult = ReturnType<typeof useShelvesLazyQuery>
export type ShelvesQueryResult = Apollo.QueryResult<
	ShelvesQuery,
	ShelvesQueryVariables
>
export const StockPlanogramPositionsDocument = gql`
	query stockPlanogramPositions(
		$where: PositionsFilter
		$offset: Int!
		$limit: Int!
	) {
		positions(where: $where, limit: $limit, offset: $offset) {
			nodes {
				id
				key
				sequence
				device {
					id
					serialNumber
				}
				templateVariant {
					id
					key
				}
				product {
					id
					internalId
					parentProduct {
						id
						name
					}
				}
			}
		}
	}
`

/**
 * __useStockPlanogramPositionsQuery__
 *
 * To run a query within a React component, call `useStockPlanogramPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockPlanogramPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockPlanogramPositionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useStockPlanogramPositionsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		StockPlanogramPositionsQuery,
		StockPlanogramPositionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		StockPlanogramPositionsQuery,
		StockPlanogramPositionsQueryVariables
	>(StockPlanogramPositionsDocument, options)
}
export function useStockPlanogramPositionsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		StockPlanogramPositionsQuery,
		StockPlanogramPositionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		StockPlanogramPositionsQuery,
		StockPlanogramPositionsQueryVariables
	>(StockPlanogramPositionsDocument, options)
}
export type StockPlanogramPositionsQueryHookResult = ReturnType<
	typeof useStockPlanogramPositionsQuery
>
export type StockPlanogramPositionsLazyQueryHookResult = ReturnType<
	typeof useStockPlanogramPositionsLazyQuery
>
export type StockPlanogramPositionsQueryResult = Apollo.QueryResult<
	StockPlanogramPositionsQuery,
	StockPlanogramPositionsQueryVariables
>
export const AddPlaylistDocument = gql`
	mutation addPlaylist($input: AddPlaylistInput!) {
		addPlaylist(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type AddPlaylistMutationFn = Apollo.MutationFunction<
	AddPlaylistMutation,
	AddPlaylistMutationVariables
>

/**
 * __useAddPlaylistMutation__
 *
 * To run a mutation, you first call `useAddPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPlaylistMutation, { data, loading, error }] = useAddPlaylistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPlaylistMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddPlaylistMutation,
		AddPlaylistMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddPlaylistMutation,
		AddPlaylistMutationVariables
	>(AddPlaylistDocument, options)
}
export type AddPlaylistMutationHookResult = ReturnType<
	typeof useAddPlaylistMutation
>
export type AddPlaylistMutationResult =
	Apollo.MutationResult<AddPlaylistMutation>
export type AddPlaylistMutationOptions = Apollo.BaseMutationOptions<
	AddPlaylistMutation,
	AddPlaylistMutationVariables
>
export const DeletePlaylistDocument = gql`
	mutation deletePlaylist($playlistId: Int!) {
		deletePlaylist(playlistId: $playlistId) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeletePlaylistMutationFn = Apollo.MutationFunction<
	DeletePlaylistMutation,
	DeletePlaylistMutationVariables
>

/**
 * __useDeletePlaylistMutation__
 *
 * To run a mutation, you first call `useDeletePlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlaylistMutation, { data, loading, error }] = useDeletePlaylistMutation({
 *   variables: {
 *      playlistId: // value for 'playlistId'
 *   },
 * });
 */
export function useDeletePlaylistMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeletePlaylistMutation,
		DeletePlaylistMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeletePlaylistMutation,
		DeletePlaylistMutationVariables
	>(DeletePlaylistDocument, options)
}
export type DeletePlaylistMutationHookResult = ReturnType<
	typeof useDeletePlaylistMutation
>
export type DeletePlaylistMutationResult =
	Apollo.MutationResult<DeletePlaylistMutation>
export type DeletePlaylistMutationOptions = Apollo.BaseMutationOptions<
	DeletePlaylistMutation,
	DeletePlaylistMutationVariables
>
export const EditChannelDocument = gql`
	mutation editChannel($channelId: Int!, $input: EditChannelInput!) {
		editChannel(channelId: $channelId, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditChannelMutationFn = Apollo.MutationFunction<
	EditChannelMutation,
	EditChannelMutationVariables
>

/**
 * __useEditChannelMutation__
 *
 * To run a mutation, you first call `useEditChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editChannelMutation, { data, loading, error }] = useEditChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditChannelMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditChannelMutation,
		EditChannelMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditChannelMutation,
		EditChannelMutationVariables
	>(EditChannelDocument, options)
}
export type EditChannelMutationHookResult = ReturnType<
	typeof useEditChannelMutation
>
export type EditChannelMutationResult =
	Apollo.MutationResult<EditChannelMutation>
export type EditChannelMutationOptions = Apollo.BaseMutationOptions<
	EditChannelMutation,
	EditChannelMutationVariables
>
export const PlaylistDocument = gql`
	query playlist($playlistId: Int!) {
		playlist(id: $playlistId) {
			playlist {
				id
				name
				playlistItems {
					id
					duration
					sequence
					file {
						id
						duration
						encoding
						mimetype
						filename
						originalname
						thumbnail
					}
				}
			}
		}
	}
`

/**
 * __usePlaylistQuery__
 *
 * To run a query within a React component, call `usePlaylistQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistQuery({
 *   variables: {
 *      playlistId: // value for 'playlistId'
 *   },
 * });
 */
export function usePlaylistQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		PlaylistQuery,
		PlaylistQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<PlaylistQuery, PlaylistQueryVariables>(
		PlaylistDocument,
		options
	)
}
export function usePlaylistLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		PlaylistQuery,
		PlaylistQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<PlaylistQuery, PlaylistQueryVariables>(
		PlaylistDocument,
		options
	)
}
export type PlaylistQueryHookResult = ReturnType<typeof usePlaylistQuery>
export type PlaylistLazyQueryHookResult = ReturnType<
	typeof usePlaylistLazyQuery
>
export type PlaylistQueryResult = Apollo.QueryResult<
	PlaylistQuery,
	PlaylistQueryVariables
>
export const PlaylistsDocument = gql`
	query playlists($where: PlaylistsFilter, $offset: Int!, $limit: Int!) {
		playlists(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				name
			}
			totalCount
		}
	}
`

/**
 * __usePlaylistsQuery__
 *
 * To run a query within a React component, call `usePlaylistsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePlaylistsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		PlaylistsQuery,
		PlaylistsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<PlaylistsQuery, PlaylistsQueryVariables>(
		PlaylistsDocument,
		options
	)
}
export function usePlaylistsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		PlaylistsQuery,
		PlaylistsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		PlaylistsQuery,
		PlaylistsQueryVariables
	>(PlaylistsDocument, options)
}
export type PlaylistsQueryHookResult = ReturnType<typeof usePlaylistsQuery>
export type PlaylistsLazyQueryHookResult = ReturnType<
	typeof usePlaylistsLazyQuery
>
export type PlaylistsQueryResult = Apollo.QueryResult<
	PlaylistsQuery,
	PlaylistsQueryVariables
>
export const PlaylistsWithItemsDocument = gql`
	query playlistsWithItems(
		$where: PlaylistsFilter
		$offset: Int!
		$limit: Int!
	) {
		playlists(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				name
				playlistItems {
					duration
					file {
						mimetype
						filename
						thumbnail
					}
				}
			}
			totalCount
		}
	}
`

/**
 * __usePlaylistsWithItemsQuery__
 *
 * To run a query within a React component, call `usePlaylistsWithItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistsWithItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistsWithItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePlaylistsWithItemsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		PlaylistsWithItemsQuery,
		PlaylistsWithItemsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		PlaylistsWithItemsQuery,
		PlaylistsWithItemsQueryVariables
	>(PlaylistsWithItemsDocument, options)
}
export function usePlaylistsWithItemsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		PlaylistsWithItemsQuery,
		PlaylistsWithItemsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		PlaylistsWithItemsQuery,
		PlaylistsWithItemsQueryVariables
	>(PlaylistsWithItemsDocument, options)
}
export type PlaylistsWithItemsQueryHookResult = ReturnType<
	typeof usePlaylistsWithItemsQuery
>
export type PlaylistsWithItemsLazyQueryHookResult = ReturnType<
	typeof usePlaylistsWithItemsLazyQuery
>
export type PlaylistsWithItemsQueryResult = Apollo.QueryResult<
	PlaylistsWithItemsQuery,
	PlaylistsWithItemsQueryVariables
>
export const AddEditProductsDocument = gql`
	mutation addEditProducts($input: [ProductInput!]!) {
		addEditProducts(input: $input) {
			errors {
				path
				message
			}
			success
			isAssignedToShelves
			addedProducts {
				id
				internalId
				name
				eanCodes
				valueEntities {
					id
					name
					templateKey
					type
					value
				}
				productImages {
					id
					primary
					file {
						id
						originalname
						filename
						mimetype
						encoding
						url
						isFolder
						width
						height
						thumbnail
					}
				}
			}
		}
	}
`
export type AddEditProductsMutationFn = Apollo.MutationFunction<
	AddEditProductsMutation,
	AddEditProductsMutationVariables
>

/**
 * __useAddEditProductsMutation__
 *
 * To run a mutation, you first call `useAddEditProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEditProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEditProductsMutation, { data, loading, error }] = useAddEditProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEditProductsMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddEditProductsMutation,
		AddEditProductsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddEditProductsMutation,
		AddEditProductsMutationVariables
	>(AddEditProductsDocument, options)
}
export type AddEditProductsMutationHookResult = ReturnType<
	typeof useAddEditProductsMutation
>
export type AddEditProductsMutationResult =
	Apollo.MutationResult<AddEditProductsMutation>
export type AddEditProductsMutationOptions = Apollo.BaseMutationOptions<
	AddEditProductsMutation,
	AddEditProductsMutationVariables
>
export const AddProductDocument = gql`
	mutation addProduct($input: ProductInput!) {
		addProduct(input: $input) {
			errors {
				path
				message
			}
			success
			product {
				id
			}
		}
	}
`
export type AddProductMutationFn = Apollo.MutationFunction<
	AddProductMutation,
	AddProductMutationVariables
>

/**
 * __useAddProductMutation__
 *
 * To run a mutation, you first call `useAddProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductMutation, { data, loading, error }] = useAddProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProductMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddProductMutation,
		AddProductMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddProductMutation,
		AddProductMutationVariables
	>(AddProductDocument, options)
}
export type AddProductMutationHookResult = ReturnType<
	typeof useAddProductMutation
>
export type AddProductMutationResult = Apollo.MutationResult<AddProductMutation>
export type AddProductMutationOptions = Apollo.BaseMutationOptions<
	AddProductMutation,
	AddProductMutationVariables
>
export const DeleteProductDocument = gql`
	mutation deleteProduct($id: Int!) {
		deleteProduct(id: $id) {
			errors {
				message
				path
			}
			success
		}
	}
`
export type DeleteProductMutationFn = Apollo.MutationFunction<
	DeleteProductMutation,
	DeleteProductMutationVariables
>

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteProductMutation,
		DeleteProductMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteProductMutation,
		DeleteProductMutationVariables
	>(DeleteProductDocument, options)
}
export type DeleteProductMutationHookResult = ReturnType<
	typeof useDeleteProductMutation
>
export type DeleteProductMutationResult =
	Apollo.MutationResult<DeleteProductMutation>
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<
	DeleteProductMutation,
	DeleteProductMutationVariables
>
export const DeleteProductsDocument = gql`
	mutation deleteProducts($input: DeleteProductInput!) {
		deleteProducts(input: $input) {
			affected
			errors {
				message
				path
			}
			success
		}
	}
`
export type DeleteProductsMutationFn = Apollo.MutationFunction<
	DeleteProductsMutation,
	DeleteProductsMutationVariables
>

/**
 * __useDeleteProductsMutation__
 *
 * To run a mutation, you first call `useDeleteProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductsMutation, { data, loading, error }] = useDeleteProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductsMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteProductsMutation,
		DeleteProductsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteProductsMutation,
		DeleteProductsMutationVariables
	>(DeleteProductsDocument, options)
}
export type DeleteProductsMutationHookResult = ReturnType<
	typeof useDeleteProductsMutation
>
export type DeleteProductsMutationResult =
	Apollo.MutationResult<DeleteProductsMutation>
export type DeleteProductsMutationOptions = Apollo.BaseMutationOptions<
	DeleteProductsMutation,
	DeleteProductsMutationVariables
>
export const DeleteValueEntitiesDocument = gql`
	mutation deleteValueEntities($ids: [Int!]) {
		deleteValueEntities(ids: $ids) {
			errors {
				message
				path
			}
			success
		}
	}
`
export type DeleteValueEntitiesMutationFn = Apollo.MutationFunction<
	DeleteValueEntitiesMutation,
	DeleteValueEntitiesMutationVariables
>

/**
 * __useDeleteValueEntitiesMutation__
 *
 * To run a mutation, you first call `useDeleteValueEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteValueEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteValueEntitiesMutation, { data, loading, error }] = useDeleteValueEntitiesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteValueEntitiesMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteValueEntitiesMutation,
		DeleteValueEntitiesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteValueEntitiesMutation,
		DeleteValueEntitiesMutationVariables
	>(DeleteValueEntitiesDocument, options)
}
export type DeleteValueEntitiesMutationHookResult = ReturnType<
	typeof useDeleteValueEntitiesMutation
>
export type DeleteValueEntitiesMutationResult =
	Apollo.MutationResult<DeleteValueEntitiesMutation>
export type DeleteValueEntitiesMutationOptions = Apollo.BaseMutationOptions<
	DeleteValueEntitiesMutation,
	DeleteValueEntitiesMutationVariables
>
export const EditProductDocument = gql`
	mutation editProduct($input: EditProductInput!) {
		editProduct(input: $input) {
			errors {
				path
				message
			}
			success
			isAssignedToShelves
		}
	}
`
export type EditProductMutationFn = Apollo.MutationFunction<
	EditProductMutation,
	EditProductMutationVariables
>

/**
 * __useEditProductMutation__
 *
 * To run a mutation, you first call `useEditProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProductMutation, { data, loading, error }] = useEditProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProductMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditProductMutation,
		EditProductMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditProductMutation,
		EditProductMutationVariables
	>(EditProductDocument, options)
}
export type EditProductMutationHookResult = ReturnType<
	typeof useEditProductMutation
>
export type EditProductMutationResult =
	Apollo.MutationResult<EditProductMutation>
export type EditProductMutationOptions = Apollo.BaseMutationOptions<
	EditProductMutation,
	EditProductMutationVariables
>
export const ProductDetailsDocument = gql`
	query productDetails($id: Int!) {
		product(id: $id) {
			product {
				id
				internalId
				name
				valueEntities {
					id
					templateKey
					type
					value
					rootId
				}
				parentProduct {
					id
					internalId
				}
				products {
					id
					internalId
				}
				market {
					id
					name
				}
			}
		}
	}
`

/**
 * __useProductDetailsQuery__
 *
 * To run a query within a React component, call `useProductDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductDetailsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		ProductDetailsQuery,
		ProductDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		ProductDetailsQuery,
		ProductDetailsQueryVariables
	>(ProductDetailsDocument, options)
}
export function useProductDetailsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ProductDetailsQuery,
		ProductDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		ProductDetailsQuery,
		ProductDetailsQueryVariables
	>(ProductDetailsDocument, options)
}
export type ProductDetailsQueryHookResult = ReturnType<
	typeof useProductDetailsQuery
>
export type ProductDetailsLazyQueryHookResult = ReturnType<
	typeof useProductDetailsLazyQuery
>
export type ProductDetailsQueryResult = Apollo.QueryResult<
	ProductDetailsQuery,
	ProductDetailsQueryVariables
>
export const ProductDetailsListDocument = gql`
	query productDetailsList($where: ProductsFilter) {
		products(where: $where, limit: 100, offset: 0) {
			nodes {
				id
				internalId
				name
				valueEntities {
					name
					templateKey
					type
					value
				}
				parentProduct {
					id
					internalId
				}
				products {
					id
					internalId
				}
			}
		}
	}
`

/**
 * __useProductDetailsListQuery__
 *
 * To run a query within a React component, call `useProductDetailsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDetailsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDetailsListQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProductDetailsListQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		ProductDetailsListQuery,
		ProductDetailsListQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		ProductDetailsListQuery,
		ProductDetailsListQueryVariables
	>(ProductDetailsListDocument, options)
}
export function useProductDetailsListLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ProductDetailsListQuery,
		ProductDetailsListQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		ProductDetailsListQuery,
		ProductDetailsListQueryVariables
	>(ProductDetailsListDocument, options)
}
export type ProductDetailsListQueryHookResult = ReturnType<
	typeof useProductDetailsListQuery
>
export type ProductDetailsListLazyQueryHookResult = ReturnType<
	typeof useProductDetailsListLazyQuery
>
export type ProductDetailsListQueryResult = Apollo.QueryResult<
	ProductDetailsListQuery,
	ProductDetailsListQueryVariables
>
export const ProductExistsDocument = gql`
	query productExists($internalId: String!) {
		product(internalId: $internalId) {
			product {
				id
				internalId
				name
			}
		}
	}
`

/**
 * __useProductExistsQuery__
 *
 * To run a query within a React component, call `useProductExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductExistsQuery({
 *   variables: {
 *      internalId: // value for 'internalId'
 *   },
 * });
 */
export function useProductExistsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		ProductExistsQuery,
		ProductExistsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		ProductExistsQuery,
		ProductExistsQueryVariables
	>(ProductExistsDocument, options)
}
export function useProductExistsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ProductExistsQuery,
		ProductExistsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		ProductExistsQuery,
		ProductExistsQueryVariables
	>(ProductExistsDocument, options)
}
export type ProductExistsQueryHookResult = ReturnType<
	typeof useProductExistsQuery
>
export type ProductExistsLazyQueryHookResult = ReturnType<
	typeof useProductExistsLazyQuery
>
export type ProductExistsQueryResult = Apollo.QueryResult<
	ProductExistsQuery,
	ProductExistsQueryVariables
>
export const ProductMarketDocument = gql`
	query productMarket($id: Int!) {
		product(id: $id) {
			product {
				market {
					id
					name
				}
			}
		}
	}
`

/**
 * __useProductMarketQuery__
 *
 * To run a query within a React component, call `useProductMarketQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductMarketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductMarketQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductMarketQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		ProductMarketQuery,
		ProductMarketQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		ProductMarketQuery,
		ProductMarketQueryVariables
	>(ProductMarketDocument, options)
}
export function useProductMarketLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ProductMarketQuery,
		ProductMarketQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		ProductMarketQuery,
		ProductMarketQueryVariables
	>(ProductMarketDocument, options)
}
export type ProductMarketQueryHookResult = ReturnType<
	typeof useProductMarketQuery
>
export type ProductMarketLazyQueryHookResult = ReturnType<
	typeof useProductMarketLazyQuery
>
export type ProductMarketQueryResult = Apollo.QueryResult<
	ProductMarketQuery,
	ProductMarketQueryVariables
>
export const ProductUsageReportDocument = gql`
	query productUsageReport(
		$where: ProductUsageReportFilter
		$offset: Int
		$limit: Int
		$withValues: Boolean = false
	) {
		productUsageReport(where: $where, offset: $offset, limit: $limit) {
			nodes {
				serialNumber
				productName
				internalId
				locationName
				valueEntities @include(if: $withValues) {
					id
					templateKey
					value
					rootId
					root {
						name
					}
				}
			}
			totalCount
		}
	}
`

/**
 * __useProductUsageReportQuery__
 *
 * To run a query within a React component, call `useProductUsageReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductUsageReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductUsageReportQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      withValues: // value for 'withValues'
 *   },
 * });
 */
export function useProductUsageReportQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		ProductUsageReportQuery,
		ProductUsageReportQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		ProductUsageReportQuery,
		ProductUsageReportQueryVariables
	>(ProductUsageReportDocument, options)
}
export function useProductUsageReportLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ProductUsageReportQuery,
		ProductUsageReportQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		ProductUsageReportQuery,
		ProductUsageReportQueryVariables
	>(ProductUsageReportDocument, options)
}
export type ProductUsageReportQueryHookResult = ReturnType<
	typeof useProductUsageReportQuery
>
export type ProductUsageReportLazyQueryHookResult = ReturnType<
	typeof useProductUsageReportLazyQuery
>
export type ProductUsageReportQueryResult = Apollo.QueryResult<
	ProductUsageReportQuery,
	ProductUsageReportQueryVariables
>
export const ProductsDocument = gql`
	query products($where: ProductsFilter, $offset: Int!, $limit: Int!) {
		products(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				eanCodes
				internalId
				name
				productType
				productImages {
					id
					file {
						id
						thumbnail
					}
				}
			}
			totalCount
		}
	}
`

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProductsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		ProductsQuery,
		ProductsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<ProductsQuery, ProductsQueryVariables>(
		ProductsDocument,
		options
	)
}
export function useProductsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ProductsQuery,
		ProductsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<ProductsQuery, ProductsQueryVariables>(
		ProductsDocument,
		options
	)
}
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>
export type ProductsLazyQueryHookResult = ReturnType<
	typeof useProductsLazyQuery
>
export type ProductsQueryResult = Apollo.QueryResult<
	ProductsQuery,
	ProductsQueryVariables
>
export const ProductsFlowListDocument = gql`
	query productsFlowList(
		$where: ProductsFilter
		$offset: Int!
		$limit: Int!
	) {
		products(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				eanCodes
				internalId
				name
				productType
				marketId
				valueEntities {
					templateKey
					value
					rootId
					root {
						id
						name
					}
				}
			}
			totalCount
		}
	}
`

/**
 * __useProductsFlowListQuery__
 *
 * To run a query within a React component, call `useProductsFlowListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsFlowListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsFlowListQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProductsFlowListQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		ProductsFlowListQuery,
		ProductsFlowListQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		ProductsFlowListQuery,
		ProductsFlowListQueryVariables
	>(ProductsFlowListDocument, options)
}
export function useProductsFlowListLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ProductsFlowListQuery,
		ProductsFlowListQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		ProductsFlowListQuery,
		ProductsFlowListQueryVariables
	>(ProductsFlowListDocument, options)
}
export type ProductsFlowListQueryHookResult = ReturnType<
	typeof useProductsFlowListQuery
>
export type ProductsFlowListLazyQueryHookResult = ReturnType<
	typeof useProductsFlowListLazyQuery
>
export type ProductsFlowListQueryResult = Apollo.QueryResult<
	ProductsFlowListQuery,
	ProductsFlowListQueryVariables
>
export const SearchProductsDocument = gql`
	query searchProducts($where: ProductsFilter, $offset: Int!, $limit: Int!) {
		products(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				eanCodes
				internalId
				name
				parentProduct {
					name
				}
			}
			totalCount
		}
	}
`

/**
 * __useSearchProductsQuery__
 *
 * To run a query within a React component, call `useSearchProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchProductsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		SearchProductsQuery,
		SearchProductsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		SearchProductsQuery,
		SearchProductsQueryVariables
	>(SearchProductsDocument, options)
}
export function useSearchProductsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		SearchProductsQuery,
		SearchProductsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		SearchProductsQuery,
		SearchProductsQueryVariables
	>(SearchProductsDocument, options)
}
export type SearchProductsQueryHookResult = ReturnType<
	typeof useSearchProductsQuery
>
export type SearchProductsLazyQueryHookResult = ReturnType<
	typeof useSearchProductsLazyQuery
>
export type SearchProductsQueryResult = Apollo.QueryResult<
	SearchProductsQuery,
	SearchProductsQueryVariables
>
export const AddDeviceAlarmReportDocument = gql`
	mutation addDeviceAlarmReport($input: AddDeviceAlarmReportInput!) {
		addDeviceAlarmReport(input: $input) {
			success
			deviceAlarmReport {
				id
			}
		}
	}
`
export type AddDeviceAlarmReportMutationFn = Apollo.MutationFunction<
	AddDeviceAlarmReportMutation,
	AddDeviceAlarmReportMutationVariables
>

/**
 * __useAddDeviceAlarmReportMutation__
 *
 * To run a mutation, you first call `useAddDeviceAlarmReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDeviceAlarmReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDeviceAlarmReportMutation, { data, loading, error }] = useAddDeviceAlarmReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDeviceAlarmReportMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddDeviceAlarmReportMutation,
		AddDeviceAlarmReportMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddDeviceAlarmReportMutation,
		AddDeviceAlarmReportMutationVariables
	>(AddDeviceAlarmReportDocument, options)
}
export type AddDeviceAlarmReportMutationHookResult = ReturnType<
	typeof useAddDeviceAlarmReportMutation
>
export type AddDeviceAlarmReportMutationResult =
	Apollo.MutationResult<AddDeviceAlarmReportMutation>
export type AddDeviceAlarmReportMutationOptions = Apollo.BaseMutationOptions<
	AddDeviceAlarmReportMutation,
	AddDeviceAlarmReportMutationVariables
>
export const BatchTransactionsDocument = gql`
	query BatchTransactions($batchUUID: String!) {
		batchTransactions(batchUUID: $batchUUID) {
			transactions {
				stage
				transactionid
				ts
				device {
					size
					serialNumber
					product {
						name
						internalId
					}
					template {
						templateVariant {
							key
						}
					}
					root {
						name
					}
					position {
						id
						name
						key
						sequence
						shelf {
							id
							key
							bay {
								id
								key
								aisle {
									id
									key
								}
							}
						}
					}
				}
			}
		}
	}
`

/**
 * __useBatchTransactionsQuery__
 *
 * To run a query within a React component, call `useBatchTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBatchTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBatchTransactionsQuery({
 *   variables: {
 *      batchUUID: // value for 'batchUUID'
 *   },
 * });
 */
export function useBatchTransactionsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		BatchTransactionsQuery,
		BatchTransactionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		BatchTransactionsQuery,
		BatchTransactionsQueryVariables
	>(BatchTransactionsDocument, options)
}
export function useBatchTransactionsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		BatchTransactionsQuery,
		BatchTransactionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		BatchTransactionsQuery,
		BatchTransactionsQueryVariables
	>(BatchTransactionsDocument, options)
}
export type BatchTransactionsQueryHookResult = ReturnType<
	typeof useBatchTransactionsQuery
>
export type BatchTransactionsLazyQueryHookResult = ReturnType<
	typeof useBatchTransactionsLazyQuery
>
export type BatchTransactionsQueryResult = Apollo.QueryResult<
	BatchTransactionsQuery,
	BatchTransactionsQueryVariables
>
export const DeleteDeviceAlarmReportDocument = gql`
	mutation deleteDeviceAlarmReport($id: Int!) {
		deleteDeviceAlarmReport(id: $id) {
			success
		}
	}
`
export type DeleteDeviceAlarmReportMutationFn = Apollo.MutationFunction<
	DeleteDeviceAlarmReportMutation,
	DeleteDeviceAlarmReportMutationVariables
>

/**
 * __useDeleteDeviceAlarmReportMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceAlarmReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceAlarmReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceAlarmReportMutation, { data, loading, error }] = useDeleteDeviceAlarmReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDeviceAlarmReportMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteDeviceAlarmReportMutation,
		DeleteDeviceAlarmReportMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteDeviceAlarmReportMutation,
		DeleteDeviceAlarmReportMutationVariables
	>(DeleteDeviceAlarmReportDocument, options)
}
export type DeleteDeviceAlarmReportMutationHookResult = ReturnType<
	typeof useDeleteDeviceAlarmReportMutation
>
export type DeleteDeviceAlarmReportMutationResult =
	Apollo.MutationResult<DeleteDeviceAlarmReportMutation>
export type DeleteDeviceAlarmReportMutationOptions = Apollo.BaseMutationOptions<
	DeleteDeviceAlarmReportMutation,
	DeleteDeviceAlarmReportMutationVariables
>
export const DeviceAlarmReportDocument = gql`
	query deviceAlarmReport($id: Int!) {
		deviceAlarmReport(id: $id) {
			deviceAlarmReport {
				id
				created
				updated
				name
				days
				time
				batteryPercentage
				roots {
					id
					name
				}
				users {
					id
					username
				}
				batteryUnderCount
				deviceErrCount
				deviceOffline
				routerOffline
				includeAllLocations
			}
		}
	}
`

/**
 * __useDeviceAlarmReportQuery__
 *
 * To run a query within a React component, call `useDeviceAlarmReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceAlarmReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceAlarmReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeviceAlarmReportQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		DeviceAlarmReportQuery,
		DeviceAlarmReportQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		DeviceAlarmReportQuery,
		DeviceAlarmReportQueryVariables
	>(DeviceAlarmReportDocument, options)
}
export function useDeviceAlarmReportLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		DeviceAlarmReportQuery,
		DeviceAlarmReportQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		DeviceAlarmReportQuery,
		DeviceAlarmReportQueryVariables
	>(DeviceAlarmReportDocument, options)
}
export type DeviceAlarmReportQueryHookResult = ReturnType<
	typeof useDeviceAlarmReportQuery
>
export type DeviceAlarmReportLazyQueryHookResult = ReturnType<
	typeof useDeviceAlarmReportLazyQuery
>
export type DeviceAlarmReportQueryResult = Apollo.QueryResult<
	DeviceAlarmReportQuery,
	DeviceAlarmReportQueryVariables
>
export const DeviceAlarmReportsDocument = gql`
	query deviceAlarmReports(
		$where: DeviceAlarmReportsFilter
		$offset: Int!
		$limit: Int!
	) {
		deviceAlarmReports(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				name
				days
				users {
					id
					username
				}
				roots {
					id
					name
				}
				includeAllLocations
				batteryPercentage
			}
			totalCount
		}
	}
`

/**
 * __useDeviceAlarmReportsQuery__
 *
 * To run a query within a React component, call `useDeviceAlarmReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceAlarmReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceAlarmReportsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDeviceAlarmReportsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		DeviceAlarmReportsQuery,
		DeviceAlarmReportsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		DeviceAlarmReportsQuery,
		DeviceAlarmReportsQueryVariables
	>(DeviceAlarmReportsDocument, options)
}
export function useDeviceAlarmReportsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		DeviceAlarmReportsQuery,
		DeviceAlarmReportsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		DeviceAlarmReportsQuery,
		DeviceAlarmReportsQueryVariables
	>(DeviceAlarmReportsDocument, options)
}
export type DeviceAlarmReportsQueryHookResult = ReturnType<
	typeof useDeviceAlarmReportsQuery
>
export type DeviceAlarmReportsLazyQueryHookResult = ReturnType<
	typeof useDeviceAlarmReportsLazyQuery
>
export type DeviceAlarmReportsQueryResult = Apollo.QueryResult<
	DeviceAlarmReportsQuery,
	DeviceAlarmReportsQueryVariables
>
export const EditDeviceAlarmReportDocument = gql`
	mutation editDeviceAlarmReport($input: EditDeviceAlarmReportInput!) {
		editDeviceAlarmReport(input: $input) {
			success
			errors {
				path
				message
			}
		}
	}
`
export type EditDeviceAlarmReportMutationFn = Apollo.MutationFunction<
	EditDeviceAlarmReportMutation,
	EditDeviceAlarmReportMutationVariables
>

/**
 * __useEditDeviceAlarmReportMutation__
 *
 * To run a mutation, you first call `useEditDeviceAlarmReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDeviceAlarmReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDeviceAlarmReportMutation, { data, loading, error }] = useEditDeviceAlarmReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDeviceAlarmReportMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditDeviceAlarmReportMutation,
		EditDeviceAlarmReportMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditDeviceAlarmReportMutation,
		EditDeviceAlarmReportMutationVariables
	>(EditDeviceAlarmReportDocument, options)
}
export type EditDeviceAlarmReportMutationHookResult = ReturnType<
	typeof useEditDeviceAlarmReportMutation
>
export type EditDeviceAlarmReportMutationResult =
	Apollo.MutationResult<EditDeviceAlarmReportMutation>
export type EditDeviceAlarmReportMutationOptions = Apollo.BaseMutationOptions<
	EditDeviceAlarmReportMutation,
	EditDeviceAlarmReportMutationVariables
>
export const AddRoleDocument = gql`
	mutation addRole($input: AddRoleInput!) {
		addRole(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type AddRoleMutationFn = Apollo.MutationFunction<
	AddRoleMutation,
	AddRoleMutationVariables
>

/**
 * __useAddRoleMutation__
 *
 * To run a mutation, you first call `useAddRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRoleMutation, { data, loading, error }] = useAddRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRoleMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddRoleMutation,
		AddRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddRoleMutation,
		AddRoleMutationVariables
	>(AddRoleDocument, options)
}
export type AddRoleMutationHookResult = ReturnType<typeof useAddRoleMutation>
export type AddRoleMutationResult = Apollo.MutationResult<AddRoleMutation>
export type AddRoleMutationOptions = Apollo.BaseMutationOptions<
	AddRoleMutation,
	AddRoleMutationVariables
>
export const EditRolezDocument = gql`
	mutation editRolez($roleId: Int!, $input: EditRoleInput!) {
		editRole(roleId: $roleId, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditRolezMutationFn = Apollo.MutationFunction<
	EditRolezMutation,
	EditRolezMutationVariables
>

/**
 * __useEditRolezMutation__
 *
 * To run a mutation, you first call `useEditRolezMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRolezMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRolezMutation, { data, loading, error }] = useEditRolezMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditRolezMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditRolezMutation,
		EditRolezMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditRolezMutation,
		EditRolezMutationVariables
	>(EditRolezDocument, options)
}
export type EditRolezMutationHookResult = ReturnType<
	typeof useEditRolezMutation
>
export type EditRolezMutationResult = Apollo.MutationResult<EditRolezMutation>
export type EditRolezMutationOptions = Apollo.BaseMutationOptions<
	EditRolezMutation,
	EditRolezMutationVariables
>
export const DeleteRoleDocument = gql`
	mutation deleteRole($id: Int!) {
		deleteRole(id: $id) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteRoleMutationFn = Apollo.MutationFunction<
	DeleteRoleMutation,
	DeleteRoleMutationVariables
>

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRoleMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteRoleMutation,
		DeleteRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteRoleMutation,
		DeleteRoleMutationVariables
	>(DeleteRoleDocument, options)
}
export type DeleteRoleMutationHookResult = ReturnType<
	typeof useDeleteRoleMutation
>
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<
	DeleteRoleMutation,
	DeleteRoleMutationVariables
>
export const EditRoleDocument = gql`
	mutation editRole($roleId: Int!, $input: EditRoleInput!) {
		editRole(roleId: $roleId, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditRoleMutationFn = Apollo.MutationFunction<
	EditRoleMutation,
	EditRoleMutationVariables
>

/**
 * __useEditRoleMutation__
 *
 * To run a mutation, you first call `useEditRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRoleMutation, { data, loading, error }] = useEditRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditRoleMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditRoleMutation,
		EditRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditRoleMutation,
		EditRoleMutationVariables
	>(EditRoleDocument, options)
}
export type EditRoleMutationHookResult = ReturnType<typeof useEditRoleMutation>
export type EditRoleMutationResult = Apollo.MutationResult<EditRoleMutation>
export type EditRoleMutationOptions = Apollo.BaseMutationOptions<
	EditRoleMutation,
	EditRoleMutationVariables
>
export const RoleDocument = gql`
	query role($roleId: Int!) {
		role(roleId: $roleId) {
			role {
				id
				value
				permissions
			}
		}
	}
`

/**
 * __useRoleQuery__
 *
 * To run a query within a React component, call `useRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useRoleQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		RoleQuery,
		RoleQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<RoleQuery, RoleQueryVariables>(
		RoleDocument,
		options
	)
}
export function useRoleLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		RoleQuery,
		RoleQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<RoleQuery, RoleQueryVariables>(
		RoleDocument,
		options
	)
}
export type RoleQueryHookResult = ReturnType<typeof useRoleQuery>
export type RoleLazyQueryHookResult = ReturnType<typeof useRoleLazyQuery>
export type RoleQueryResult = Apollo.QueryResult<RoleQuery, RoleQueryVariables>
export const RolesDocument = gql`
	query roles($where: RolesFilter, $offset: Int!, $limit: Int!) {
		roles(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				value
			}
		}
	}
`

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRolesQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		RolesQuery,
		RolesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<RolesQuery, RolesQueryVariables>(
		RolesDocument,
		options
	)
}
export function useRolesLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		RolesQuery,
		RolesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<RolesQuery, RolesQueryVariables>(
		RolesDocument,
		options
	)
}
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>
export type RolesQueryResult = Apollo.QueryResult<
	RolesQuery,
	RolesQueryVariables
>
export const AddSmartButtonDocument = gql`
	mutation addSmartButton($input: AddButton!) {
		addButton(input: $input) {
			errors {
				path
				message
			}
			button {
				id
			}
		}
	}
`
export type AddSmartButtonMutationFn = Apollo.MutationFunction<
	AddSmartButtonMutation,
	AddSmartButtonMutationVariables
>

/**
 * __useAddSmartButtonMutation__
 *
 * To run a mutation, you first call `useAddSmartButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSmartButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSmartButtonMutation, { data, loading, error }] = useAddSmartButtonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSmartButtonMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddSmartButtonMutation,
		AddSmartButtonMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddSmartButtonMutation,
		AddSmartButtonMutationVariables
	>(AddSmartButtonDocument, options)
}
export type AddSmartButtonMutationHookResult = ReturnType<
	typeof useAddSmartButtonMutation
>
export type AddSmartButtonMutationResult =
	Apollo.MutationResult<AddSmartButtonMutation>
export type AddSmartButtonMutationOptions = Apollo.BaseMutationOptions<
	AddSmartButtonMutation,
	AddSmartButtonMutationVariables
>
export const DeleteSmartButtonDocument = gql`
	mutation deleteSmartButton($id: Int!) {
		deleteButton(id: $id) {
			success
			errors {
				path
				message
			}
		}
	}
`
export type DeleteSmartButtonMutationFn = Apollo.MutationFunction<
	DeleteSmartButtonMutation,
	DeleteSmartButtonMutationVariables
>

/**
 * __useDeleteSmartButtonMutation__
 *
 * To run a mutation, you first call `useDeleteSmartButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSmartButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSmartButtonMutation, { data, loading, error }] = useDeleteSmartButtonMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSmartButtonMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteSmartButtonMutation,
		DeleteSmartButtonMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteSmartButtonMutation,
		DeleteSmartButtonMutationVariables
	>(DeleteSmartButtonDocument, options)
}
export type DeleteSmartButtonMutationHookResult = ReturnType<
	typeof useDeleteSmartButtonMutation
>
export type DeleteSmartButtonMutationResult =
	Apollo.MutationResult<DeleteSmartButtonMutation>
export type DeleteSmartButtonMutationOptions = Apollo.BaseMutationOptions<
	DeleteSmartButtonMutation,
	DeleteSmartButtonMutationVariables
>
export const DeviceSizesDocument = gql`
	query deviceSizes {
		deviceSizes
	}
`

/**
 * __useDeviceSizesQuery__
 *
 * To run a query within a React component, call `useDeviceSizesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceSizesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceSizesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeviceSizesQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		DeviceSizesQuery,
		DeviceSizesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		DeviceSizesQuery,
		DeviceSizesQueryVariables
	>(DeviceSizesDocument, options)
}
export function useDeviceSizesLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		DeviceSizesQuery,
		DeviceSizesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		DeviceSizesQuery,
		DeviceSizesQueryVariables
	>(DeviceSizesDocument, options)
}
export type DeviceSizesQueryHookResult = ReturnType<typeof useDeviceSizesQuery>
export type DeviceSizesLazyQueryHookResult = ReturnType<
	typeof useDeviceSizesLazyQuery
>
export type DeviceSizesQueryResult = Apollo.QueryResult<
	DeviceSizesQuery,
	DeviceSizesQueryVariables
>
export const EditSmartButtonDocument = gql`
	mutation editSmartButton($input: EditButton!) {
		editButton(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditSmartButtonMutationFn = Apollo.MutationFunction<
	EditSmartButtonMutation,
	EditSmartButtonMutationVariables
>

/**
 * __useEditSmartButtonMutation__
 *
 * To run a mutation, you first call `useEditSmartButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSmartButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSmartButtonMutation, { data, loading, error }] = useEditSmartButtonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSmartButtonMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditSmartButtonMutation,
		EditSmartButtonMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditSmartButtonMutation,
		EditSmartButtonMutationVariables
	>(EditSmartButtonDocument, options)
}
export type EditSmartButtonMutationHookResult = ReturnType<
	typeof useEditSmartButtonMutation
>
export type EditSmartButtonMutationResult =
	Apollo.MutationResult<EditSmartButtonMutation>
export type EditSmartButtonMutationOptions = Apollo.BaseMutationOptions<
	EditSmartButtonMutation,
	EditSmartButtonMutationVariables
>
export const AddSignageButtonDocument = gql`
	mutation addSignageButton($input: AddSignageButton!) {
		addSignageButton(input: $input) {
			errors {
				path
				message
			}
			signageButton {
				id
			}
		}
	}
`
export type AddSignageButtonMutationFn = Apollo.MutationFunction<
	AddSignageButtonMutation,
	AddSignageButtonMutationVariables
>

/**
 * __useAddSignageButtonMutation__
 *
 * To run a mutation, you first call `useAddSignageButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSignageButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSignageButtonMutation, { data, loading, error }] = useAddSignageButtonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSignageButtonMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddSignageButtonMutation,
		AddSignageButtonMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddSignageButtonMutation,
		AddSignageButtonMutationVariables
	>(AddSignageButtonDocument, options)
}
export type AddSignageButtonMutationHookResult = ReturnType<
	typeof useAddSignageButtonMutation
>
export type AddSignageButtonMutationResult =
	Apollo.MutationResult<AddSignageButtonMutation>
export type AddSignageButtonMutationOptions = Apollo.BaseMutationOptions<
	AddSignageButtonMutation,
	AddSignageButtonMutationVariables
>
export const DeleteSignageButtonDocument = gql`
	mutation deleteSignageButton($id: Int!) {
		deleteSignageButton(id: $id) {
			success
			errors {
				path
				message
			}
		}
	}
`
export type DeleteSignageButtonMutationFn = Apollo.MutationFunction<
	DeleteSignageButtonMutation,
	DeleteSignageButtonMutationVariables
>

/**
 * __useDeleteSignageButtonMutation__
 *
 * To run a mutation, you first call `useDeleteSignageButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSignageButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSignageButtonMutation, { data, loading, error }] = useDeleteSignageButtonMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSignageButtonMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteSignageButtonMutation,
		DeleteSignageButtonMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteSignageButtonMutation,
		DeleteSignageButtonMutationVariables
	>(DeleteSignageButtonDocument, options)
}
export type DeleteSignageButtonMutationHookResult = ReturnType<
	typeof useDeleteSignageButtonMutation
>
export type DeleteSignageButtonMutationResult =
	Apollo.MutationResult<DeleteSignageButtonMutation>
export type DeleteSignageButtonMutationOptions = Apollo.BaseMutationOptions<
	DeleteSignageButtonMutation,
	DeleteSignageButtonMutationVariables
>
export const EditSignageButtonDocument = gql`
	mutation editSignageButton($input: EditSignageButton!) {
		editSignageButton(input: $input) {
			success
			errors {
				path
				message
			}
		}
	}
`
export type EditSignageButtonMutationFn = Apollo.MutationFunction<
	EditSignageButtonMutation,
	EditSignageButtonMutationVariables
>

/**
 * __useEditSignageButtonMutation__
 *
 * To run a mutation, you first call `useEditSignageButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSignageButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSignageButtonMutation, { data, loading, error }] = useEditSignageButtonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSignageButtonMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditSignageButtonMutation,
		EditSignageButtonMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditSignageButtonMutation,
		EditSignageButtonMutationVariables
	>(EditSignageButtonDocument, options)
}
export type EditSignageButtonMutationHookResult = ReturnType<
	typeof useEditSignageButtonMutation
>
export type EditSignageButtonMutationResult =
	Apollo.MutationResult<EditSignageButtonMutation>
export type EditSignageButtonMutationOptions = Apollo.BaseMutationOptions<
	EditSignageButtonMutation,
	EditSignageButtonMutationVariables
>
export const SmartButtonDocument = gql`
	query smartButton($id: Int!) {
		button(buttonId: $id) {
			button {
				id
				serialNumber
				name
				router {
					id
					name
				}
				root {
					id
					name
					routers {
						id
					}
				}
				rootId
				routerId
				batteryLevel
				active
				rssi
			}
		}
	}
`

/**
 * __useSmartButtonQuery__
 *
 * To run a query within a React component, call `useSmartButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartButtonQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSmartButtonQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		SmartButtonQuery,
		SmartButtonQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		SmartButtonQuery,
		SmartButtonQueryVariables
	>(SmartButtonDocument, options)
}
export function useSmartButtonLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		SmartButtonQuery,
		SmartButtonQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		SmartButtonQuery,
		SmartButtonQueryVariables
	>(SmartButtonDocument, options)
}
export type SmartButtonQueryHookResult = ReturnType<typeof useSmartButtonQuery>
export type SmartButtonLazyQueryHookResult = ReturnType<
	typeof useSmartButtonLazyQuery
>
export type SmartButtonQueryResult = Apollo.QueryResult<
	SmartButtonQuery,
	SmartButtonQueryVariables
>
export const SmartButtonsDocument = gql`
	query smartButtons($where: ButtonsFilter, $limit: Int!, $offset: Int!) {
		buttons(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				serialNumber
				name
				root {
					name
				}
				batteryLevel
				active
			}
			totalCount
		}
	}
`

/**
 * __useSmartButtonsQuery__
 *
 * To run a query within a React component, call `useSmartButtonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartButtonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartButtonsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSmartButtonsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		SmartButtonsQuery,
		SmartButtonsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		SmartButtonsQuery,
		SmartButtonsQueryVariables
	>(SmartButtonsDocument, options)
}
export function useSmartButtonsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		SmartButtonsQuery,
		SmartButtonsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		SmartButtonsQuery,
		SmartButtonsQueryVariables
	>(SmartButtonsDocument, options)
}
export type SmartButtonsQueryHookResult = ReturnType<
	typeof useSmartButtonsQuery
>
export type SmartButtonsLazyQueryHookResult = ReturnType<
	typeof useSmartButtonsLazyQuery
>
export type SmartButtonsQueryResult = Apollo.QueryResult<
	SmartButtonsQuery,
	SmartButtonsQueryVariables
>
export const ClearDeviceDocument = gql`
	mutation clearDevice($deviceId: Int!) {
		clearDevice(id: $deviceId) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type ClearDeviceMutationFn = Apollo.MutationFunction<
	ClearDeviceMutation,
	ClearDeviceMutationVariables
>

/**
 * __useClearDeviceMutation__
 *
 * To run a mutation, you first call `useClearDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearDeviceMutation, { data, loading, error }] = useClearDeviceMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useClearDeviceMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		ClearDeviceMutation,
		ClearDeviceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		ClearDeviceMutation,
		ClearDeviceMutationVariables
	>(ClearDeviceDocument, options)
}
export type ClearDeviceMutationHookResult = ReturnType<
	typeof useClearDeviceMutation
>
export type ClearDeviceMutationResult =
	Apollo.MutationResult<ClearDeviceMutation>
export type ClearDeviceMutationOptions = Apollo.BaseMutationOptions<
	ClearDeviceMutation,
	ClearDeviceMutationVariables
>
export const DeleteDeviceDocument = gql`
	mutation deleteDevice($deviceId: Int!) {
		deleteDevice(id: $deviceId) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteDeviceMutationFn = Apollo.MutationFunction<
	DeleteDeviceMutation,
	DeleteDeviceMutationVariables
>

/**
 * __useDeleteDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceMutation, { data, loading, error }] = useDeleteDeviceMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useDeleteDeviceMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteDeviceMutation,
		DeleteDeviceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteDeviceMutation,
		DeleteDeviceMutationVariables
	>(DeleteDeviceDocument, options)
}
export type DeleteDeviceMutationHookResult = ReturnType<
	typeof useDeleteDeviceMutation
>
export type DeleteDeviceMutationResult =
	Apollo.MutationResult<DeleteDeviceMutation>
export type DeleteDeviceMutationOptions = Apollo.BaseMutationOptions<
	DeleteDeviceMutation,
	DeleteDeviceMutationVariables
>
export const DeviceDocument = gql`
	query device($deviceSerialNumber: String!, $deviceSize: DeviceSize) {
		device(deviceSerialNumber: $deviceSerialNumber) {
			device {
				id
				serialNumber
				name
				size
				firmwareVersion
				softwareVersion
				deviceMode
				lastSeen
				config {
					id
					sleepTime
					awakeTime
					highPowerMode
					version
				}
				root {
					id
					name
					routers {
						id
					}
					market {
						id
						name
					}
				}
				template {
					id
					name
					width
					templateVariant {
						id
						key
						name
					}
				}
				position {
					id
					name
					key
					sequence
					templateVariant {
						id
						key
						name
						supportsSplit(deviceSize: $deviceSize)
						supportsRotated(deviceSize: $deviceSize)
					}
					shelf {
						id
						key
						bay {
							id
							key
							aisle {
								id
								key
							}
						}
					}
				}
				product {
					id
					name
					internalId
					parentProduct {
						name
					}
				}
				product2nd {
					id
					name
					internalId
					parentProduct {
						name
					}
				}
				lastTransactionStatus
				lastConfigTransaction {
					stage
					ts
				}
				shelf {
					id
					key
					bay {
						id
						key
						aisle {
							id
							key
						}
					}
				}
				lastSync
				batteryLevel
				batteryCharging
				batteryError
				active
				rssi
				shortPressAction
				longPressAction
				shortPressEnabled
				longPressEnabled
				deviceType
				rotated
				routerId
				router {
					id
					name
				}
				screenType
				deviceMode
				flipped
				channelId
				channel {
					id
					name
				}
			}
		}
	}
`

/**
 * __useDeviceQuery__
 *
 * To run a query within a React component, call `useDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceQuery({
 *   variables: {
 *      deviceSerialNumber: // value for 'deviceSerialNumber'
 *      deviceSize: // value for 'deviceSize'
 *   },
 * });
 */
export function useDeviceQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		DeviceQuery,
		DeviceQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<DeviceQuery, DeviceQueryVariables>(
		DeviceDocument,
		options
	)
}
export function useDeviceLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		DeviceQuery,
		DeviceQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<DeviceQuery, DeviceQueryVariables>(
		DeviceDocument,
		options
	)
}
export type DeviceQueryHookResult = ReturnType<typeof useDeviceQuery>
export type DeviceLazyQueryHookResult = ReturnType<typeof useDeviceLazyQuery>
export type DeviceQueryResult = Apollo.QueryResult<
	DeviceQuery,
	DeviceQueryVariables
>
export const AddDeviceConfigDocument = gql`
	mutation addDeviceConfig($input: DeviceConfigInput!) {
		addDeviceConfig(input: $input) {
			errors {
				path
				message
			}
			deviceConfig {
				id
			}
		}
	}
`
export type AddDeviceConfigMutationFn = Apollo.MutationFunction<
	AddDeviceConfigMutation,
	AddDeviceConfigMutationVariables
>

/**
 * __useAddDeviceConfigMutation__
 *
 * To run a mutation, you first call `useAddDeviceConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDeviceConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDeviceConfigMutation, { data, loading, error }] = useAddDeviceConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDeviceConfigMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddDeviceConfigMutation,
		AddDeviceConfigMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddDeviceConfigMutation,
		AddDeviceConfigMutationVariables
	>(AddDeviceConfigDocument, options)
}
export type AddDeviceConfigMutationHookResult = ReturnType<
	typeof useAddDeviceConfigMutation
>
export type AddDeviceConfigMutationResult =
	Apollo.MutationResult<AddDeviceConfigMutation>
export type AddDeviceConfigMutationOptions = Apollo.BaseMutationOptions<
	AddDeviceConfigMutation,
	AddDeviceConfigMutationVariables
>
export const EditDeviceConfigDocument = gql`
	mutation editDeviceConfig($input: EditDeviceConfigInput!) {
		editDeviceConfig(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditDeviceConfigMutationFn = Apollo.MutationFunction<
	EditDeviceConfigMutation,
	EditDeviceConfigMutationVariables
>

/**
 * __useEditDeviceConfigMutation__
 *
 * To run a mutation, you first call `useEditDeviceConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDeviceConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDeviceConfigMutation, { data, loading, error }] = useEditDeviceConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDeviceConfigMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditDeviceConfigMutation,
		EditDeviceConfigMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditDeviceConfigMutation,
		EditDeviceConfigMutationVariables
	>(EditDeviceConfigDocument, options)
}
export type EditDeviceConfigMutationHookResult = ReturnType<
	typeof useEditDeviceConfigMutation
>
export type EditDeviceConfigMutationResult =
	Apollo.MutationResult<EditDeviceConfigMutation>
export type EditDeviceConfigMutationOptions = Apollo.BaseMutationOptions<
	EditDeviceConfigMutation,
	EditDeviceConfigMutationVariables
>
export const DeviceIdsDocument = gql`
	query deviceIds(
		$where: DevicesFilter
		$offset: Int!
		$limit: Int!
		$order: DeviceOrder
	) {
		devices(where: $where, offset: $offset, limit: $limit, order: $order) {
			nodes {
				id
			}
			totalCount
		}
	}
`

/**
 * __useDeviceIdsQuery__
 *
 * To run a query within a React component, call `useDeviceIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceIdsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useDeviceIdsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		DeviceIdsQuery,
		DeviceIdsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<DeviceIdsQuery, DeviceIdsQueryVariables>(
		DeviceIdsDocument,
		options
	)
}
export function useDeviceIdsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		DeviceIdsQuery,
		DeviceIdsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		DeviceIdsQuery,
		DeviceIdsQueryVariables
	>(DeviceIdsDocument, options)
}
export type DeviceIdsQueryHookResult = ReturnType<typeof useDeviceIdsQuery>
export type DeviceIdsLazyQueryHookResult = ReturnType<
	typeof useDeviceIdsLazyQuery
>
export type DeviceIdsQueryResult = Apollo.QueryResult<
	DeviceIdsQuery,
	DeviceIdsQueryVariables
>
export const DevicePositionsDocument = gql`
	query devicePositions(
		$where: PositionsFilter
		$offset: Int!
		$limit: Int!
	) {
		positions(where: $where, limit: $limit, offset: $offset) {
			nodes {
				id
				key
				device {
					id
				}
			}
		}
	}
`

/**
 * __useDevicePositionsQuery__
 *
 * To run a query within a React component, call `useDevicePositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicePositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicePositionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDevicePositionsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		DevicePositionsQuery,
		DevicePositionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		DevicePositionsQuery,
		DevicePositionsQueryVariables
	>(DevicePositionsDocument, options)
}
export function useDevicePositionsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		DevicePositionsQuery,
		DevicePositionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		DevicePositionsQuery,
		DevicePositionsQueryVariables
	>(DevicePositionsDocument, options)
}
export type DevicePositionsQueryHookResult = ReturnType<
	typeof useDevicePositionsQuery
>
export type DevicePositionsLazyQueryHookResult = ReturnType<
	typeof useDevicePositionsLazyQuery
>
export type DevicePositionsQueryResult = Apollo.QueryResult<
	DevicePositionsQuery,
	DevicePositionsQueryVariables
>
export const DevicePreviewDocument = gql`
	query devicePreview($deviceSerialNumber: String!) {
		devicePreview(deviceSerialNumber: $deviceSerialNumber) {
			currentData {
				image
				flipped
			}
			previewData {
				image
				flipped
			}
		}
	}
`

/**
 * __useDevicePreviewQuery__
 *
 * To run a query within a React component, call `useDevicePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicePreviewQuery({
 *   variables: {
 *      deviceSerialNumber: // value for 'deviceSerialNumber'
 *   },
 * });
 */
export function useDevicePreviewQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		DevicePreviewQuery,
		DevicePreviewQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		DevicePreviewQuery,
		DevicePreviewQueryVariables
	>(DevicePreviewDocument, options)
}
export function useDevicePreviewLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		DevicePreviewQuery,
		DevicePreviewQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		DevicePreviewQuery,
		DevicePreviewQueryVariables
	>(DevicePreviewDocument, options)
}
export type DevicePreviewQueryHookResult = ReturnType<
	typeof useDevicePreviewQuery
>
export type DevicePreviewLazyQueryHookResult = ReturnType<
	typeof useDevicePreviewLazyQuery
>
export type DevicePreviewQueryResult = Apollo.QueryResult<
	DevicePreviewQuery,
	DevicePreviewQueryVariables
>
export const DeviceSocHistoryDocument = gql`
	query deviceSocHistory(
		$deviceSerialNumber: String!
		$from: DateTime!
		$to: DateTime
	) {
		deviceSocHistory(
			deviceSerialNumber: $deviceSerialNumber
			from: $from
			to: $to
		) {
			timestamp
			soc
			voltage
			charging
			rssi
			routerName
		}
	}
`

/**
 * __useDeviceSocHistoryQuery__
 *
 * To run a query within a React component, call `useDeviceSocHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceSocHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceSocHistoryQuery({
 *   variables: {
 *      deviceSerialNumber: // value for 'deviceSerialNumber'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useDeviceSocHistoryQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		DeviceSocHistoryQuery,
		DeviceSocHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		DeviceSocHistoryQuery,
		DeviceSocHistoryQueryVariables
	>(DeviceSocHistoryDocument, options)
}
export function useDeviceSocHistoryLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		DeviceSocHistoryQuery,
		DeviceSocHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		DeviceSocHistoryQuery,
		DeviceSocHistoryQueryVariables
	>(DeviceSocHistoryDocument, options)
}
export type DeviceSocHistoryQueryHookResult = ReturnType<
	typeof useDeviceSocHistoryQuery
>
export type DeviceSocHistoryLazyQueryHookResult = ReturnType<
	typeof useDeviceSocHistoryLazyQuery
>
export type DeviceSocHistoryQueryResult = Apollo.QueryResult<
	DeviceSocHistoryQuery,
	DeviceSocHistoryQueryVariables
>
export const DeviceTempHistoryDocument = gql`
	query DeviceTempHistory(
		$deviceSerialNumber: String!
		$from: DateTime!
		$to: DateTime
	) {
		deviceTempHistory(
			deviceSerialNumber: $deviceSerialNumber
			from: $from
			to: $to
		) {
			timestamp
			panelTemp
		}
	}
`

/**
 * __useDeviceTempHistoryQuery__
 *
 * To run a query within a React component, call `useDeviceTempHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceTempHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceTempHistoryQuery({
 *   variables: {
 *      deviceSerialNumber: // value for 'deviceSerialNumber'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useDeviceTempHistoryQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		DeviceTempHistoryQuery,
		DeviceTempHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		DeviceTempHistoryQuery,
		DeviceTempHistoryQueryVariables
	>(DeviceTempHistoryDocument, options)
}
export function useDeviceTempHistoryLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		DeviceTempHistoryQuery,
		DeviceTempHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		DeviceTempHistoryQuery,
		DeviceTempHistoryQueryVariables
	>(DeviceTempHistoryDocument, options)
}
export type DeviceTempHistoryQueryHookResult = ReturnType<
	typeof useDeviceTempHistoryQuery
>
export type DeviceTempHistoryLazyQueryHookResult = ReturnType<
	typeof useDeviceTempHistoryLazyQuery
>
export type DeviceTempHistoryQueryResult = Apollo.QueryResult<
	DeviceTempHistoryQuery,
	DeviceTempHistoryQueryVariables
>
export const DeviceTransactionsDocument = gql`
	query DeviceTransactions($deviceId: Int!, $limit: Int!, $offset: Int!) {
		deviceTransactions(
			deviceId: $deviceId
			limit: $limit
			offset: $offset
		) {
			totalCount
			transactions {
				transactionid
				ts
				stage
				duration
				cached
				reset
				clear
				burnInPrevention
				productName
				template {
					id
					templateVariant {
						id
						key
						name
						isDefault
						isActive
					}
				}
			}
		}
	}
`

/**
 * __useDeviceTransactionsQuery__
 *
 * To run a query within a React component, call `useDeviceTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceTransactionsQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useDeviceTransactionsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		DeviceTransactionsQuery,
		DeviceTransactionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		DeviceTransactionsQuery,
		DeviceTransactionsQueryVariables
	>(DeviceTransactionsDocument, options)
}
export function useDeviceTransactionsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		DeviceTransactionsQuery,
		DeviceTransactionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		DeviceTransactionsQuery,
		DeviceTransactionsQueryVariables
	>(DeviceTransactionsDocument, options)
}
export type DeviceTransactionsQueryHookResult = ReturnType<
	typeof useDeviceTransactionsQuery
>
export type DeviceTransactionsLazyQueryHookResult = ReturnType<
	typeof useDeviceTransactionsLazyQuery
>
export type DeviceTransactionsQueryResult = Apollo.QueryResult<
	DeviceTransactionsQuery,
	DeviceTransactionsQueryVariables
>
export const DevicesDocument = gql`
	query devices(
		$where: DevicesFilter
		$offset: Int!
		$limit: Int!
		$order: DeviceOrder
	) {
		devices(where: $where, offset: $offset, limit: $limit, order: $order) {
			nodes {
				id
				serialNumber
				name
				size
				deviceType
				lastTransactionStatus
				position {
					key
					sequence
					shelf {
						key
						bay {
							key
							aisle {
								key
							}
						}
					}
				}
				root {
					id
					name
				}
				product {
					name
					internalId
					parentProduct {
						name
					}
				}
				product2nd {
					name
					internalId
					parentProduct {
						name
					}
				}
				template {
					id
					width
					deviceSize
					templateVariant {
						key
						name
					}
				}
				shelf {
					key
					bay {
						key
						aisle {
							key
						}
					}
				}
				lastSync
				batteryLevel
				batteryCharging
				batteryError
				active
				rssi
				screenType
				deviceMode
				channelId
				channel {
					id
					name
				}
			}
			totalCount
		}
	}
`

/**
 * __useDevicesQuery__
 *
 * To run a query within a React component, call `useDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useDevicesQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		DevicesQuery,
		DevicesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<DevicesQuery, DevicesQueryVariables>(
		DevicesDocument,
		options
	)
}
export function useDevicesLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		DevicesQuery,
		DevicesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<DevicesQuery, DevicesQueryVariables>(
		DevicesDocument,
		options
	)
}
export type DevicesQueryHookResult = ReturnType<typeof useDevicesQuery>
export type DevicesLazyQueryHookResult = ReturnType<typeof useDevicesLazyQuery>
export type DevicesQueryResult = Apollo.QueryResult<
	DevicesQuery,
	DevicesQueryVariables
>
export const EditDeviceDocument = gql`
	mutation editDevice($deviceId: Int!, $input: EditDeviceInput!) {
		editDevice(deviceId: $deviceId, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditDeviceMutationFn = Apollo.MutationFunction<
	EditDeviceMutation,
	EditDeviceMutationVariables
>

/**
 * __useEditDeviceMutation__
 *
 * To run a mutation, you first call `useEditDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDeviceMutation, { data, loading, error }] = useEditDeviceMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDeviceMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditDeviceMutation,
		EditDeviceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditDeviceMutation,
		EditDeviceMutationVariables
	>(EditDeviceDocument, options)
}
export type EditDeviceMutationHookResult = ReturnType<
	typeof useEditDeviceMutation
>
export type EditDeviceMutationResult = Apollo.MutationResult<EditDeviceMutation>
export type EditDeviceMutationOptions = Apollo.BaseMutationOptions<
	EditDeviceMutation,
	EditDeviceMutationVariables
>
export const EditDeviceNameDocument = gql`
	mutation editDeviceName($deviceId: Int!, $name: String!) {
		editDeviceName(deviceId: $deviceId, name: $name) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditDeviceNameMutationFn = Apollo.MutationFunction<
	EditDeviceNameMutation,
	EditDeviceNameMutationVariables
>

/**
 * __useEditDeviceNameMutation__
 *
 * To run a mutation, you first call `useEditDeviceNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDeviceNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDeviceNameMutation, { data, loading, error }] = useEditDeviceNameMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEditDeviceNameMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditDeviceNameMutation,
		EditDeviceNameMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditDeviceNameMutation,
		EditDeviceNameMutationVariables
	>(EditDeviceNameDocument, options)
}
export type EditDeviceNameMutationHookResult = ReturnType<
	typeof useEditDeviceNameMutation
>
export type EditDeviceNameMutationResult =
	Apollo.MutationResult<EditDeviceNameMutation>
export type EditDeviceNameMutationOptions = Apollo.BaseMutationOptions<
	EditDeviceNameMutation,
	EditDeviceNameMutationVariables
>
export const EditDeviceTemplatesDocument = gql`
	mutation editDeviceTemplates(
		$deviceIds: [Int!]!
		$templateVariantId: Int!
	) {
		editDeviceTemplates(
			deviceIds: $deviceIds
			templateVariantId: $templateVariantId
		) {
			errors {
				path
				message
			}
			success
			failedDevices {
				device {
					id
					serialNumber
				}
				errors {
					path
					message
				}
			}
		}
	}
`
export type EditDeviceTemplatesMutationFn = Apollo.MutationFunction<
	EditDeviceTemplatesMutation,
	EditDeviceTemplatesMutationVariables
>

/**
 * __useEditDeviceTemplatesMutation__
 *
 * To run a mutation, you first call `useEditDeviceTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDeviceTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDeviceTemplatesMutation, { data, loading, error }] = useEditDeviceTemplatesMutation({
 *   variables: {
 *      deviceIds: // value for 'deviceIds'
 *      templateVariantId: // value for 'templateVariantId'
 *   },
 * });
 */
export function useEditDeviceTemplatesMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditDeviceTemplatesMutation,
		EditDeviceTemplatesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditDeviceTemplatesMutation,
		EditDeviceTemplatesMutationVariables
	>(EditDeviceTemplatesDocument, options)
}
export type EditDeviceTemplatesMutationHookResult = ReturnType<
	typeof useEditDeviceTemplatesMutation
>
export type EditDeviceTemplatesMutationResult =
	Apollo.MutationResult<EditDeviceTemplatesMutation>
export type EditDeviceTemplatesMutationOptions = Apollo.BaseMutationOptions<
	EditDeviceTemplatesMutation,
	EditDeviceTemplatesMutationVariables
>
export const ExportDevicesDocument = gql`
	query exportDevices(
		$where: DevicesFilter
		$offset: Int!
		$limit: Int!
		$order: DeviceOrder
	) {
		devices(where: $where, offset: $offset, limit: $limit, order: $order) {
			nodes {
				id
				name
				product {
					name
					internalId
					parentProduct {
						name
					}
				}
				product2nd {
					name
					internalId
					parentProduct {
						name
					}
				}
				position {
					key
					sequence
					product {
						name
						internalId
						parentProduct {
							name
						}
					}
				}
				serialNumber
				screenType
				root {
					id
					name
				}
				template {
					id
					templateVariant {
						key
						name
					}
				}
				batteryLevel
				batteryCharging
				batteryError
				rssi
				firmwareVersion
			}
			totalCount
		}
	}
`

/**
 * __useExportDevicesQuery__
 *
 * To run a query within a React component, call `useExportDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportDevicesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useExportDevicesQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		ExportDevicesQuery,
		ExportDevicesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		ExportDevicesQuery,
		ExportDevicesQueryVariables
	>(ExportDevicesDocument, options)
}
export function useExportDevicesLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ExportDevicesQuery,
		ExportDevicesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		ExportDevicesQuery,
		ExportDevicesQueryVariables
	>(ExportDevicesDocument, options)
}
export type ExportDevicesQueryHookResult = ReturnType<
	typeof useExportDevicesQuery
>
export type ExportDevicesLazyQueryHookResult = ReturnType<
	typeof useExportDevicesLazyQuery
>
export type ExportDevicesQueryResult = Apollo.QueryResult<
	ExportDevicesQuery,
	ExportDevicesQueryVariables
>
export const ForceRefreshDeviceDocument = gql`
	mutation forceRefreshDevice($deviceId: Int!) {
		forceRefreshDevice(deviceId: $deviceId) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type ForceRefreshDeviceMutationFn = Apollo.MutationFunction<
	ForceRefreshDeviceMutation,
	ForceRefreshDeviceMutationVariables
>

/**
 * __useForceRefreshDeviceMutation__
 *
 * To run a mutation, you first call `useForceRefreshDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceRefreshDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceRefreshDeviceMutation, { data, loading, error }] = useForceRefreshDeviceMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useForceRefreshDeviceMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		ForceRefreshDeviceMutation,
		ForceRefreshDeviceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		ForceRefreshDeviceMutation,
		ForceRefreshDeviceMutationVariables
	>(ForceRefreshDeviceDocument, options)
}
export type ForceRefreshDeviceMutationHookResult = ReturnType<
	typeof useForceRefreshDeviceMutation
>
export type ForceRefreshDeviceMutationResult =
	Apollo.MutationResult<ForceRefreshDeviceMutation>
export type ForceRefreshDeviceMutationOptions = Apollo.BaseMutationOptions<
	ForceRefreshDeviceMutation,
	ForceRefreshDeviceMutationVariables
>
export const ForceRefreshDevicesDocument = gql`
	mutation forceRefreshDevices($deviceIds: [Int!]!) {
		forceRefreshDevices(deviceIds: $deviceIds) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type ForceRefreshDevicesMutationFn = Apollo.MutationFunction<
	ForceRefreshDevicesMutation,
	ForceRefreshDevicesMutationVariables
>

/**
 * __useForceRefreshDevicesMutation__
 *
 * To run a mutation, you first call `useForceRefreshDevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceRefreshDevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceRefreshDevicesMutation, { data, loading, error }] = useForceRefreshDevicesMutation({
 *   variables: {
 *      deviceIds: // value for 'deviceIds'
 *   },
 * });
 */
export function useForceRefreshDevicesMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		ForceRefreshDevicesMutation,
		ForceRefreshDevicesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		ForceRefreshDevicesMutation,
		ForceRefreshDevicesMutationVariables
	>(ForceRefreshDevicesDocument, options)
}
export type ForceRefreshDevicesMutationHookResult = ReturnType<
	typeof useForceRefreshDevicesMutation
>
export type ForceRefreshDevicesMutationResult =
	Apollo.MutationResult<ForceRefreshDevicesMutation>
export type ForceRefreshDevicesMutationOptions = Apollo.BaseMutationOptions<
	ForceRefreshDevicesMutation,
	ForceRefreshDevicesMutationVariables
>
export const GroupsDocument = gql`
	query groups($where: GroupsFilter, $offset: Int!, $limit: Int!) {
		groups(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				name
				level
			}
		}
	}
`

/**
 * __useGroupsQuery__
 *
 * To run a query within a React component, call `useGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGroupsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		GroupsQuery,
		GroupsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<GroupsQuery, GroupsQueryVariables>(
		GroupsDocument,
		options
	)
}
export function useGroupsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		GroupsQuery,
		GroupsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<GroupsQuery, GroupsQueryVariables>(
		GroupsDocument,
		options
	)
}
export type GroupsQueryHookResult = ReturnType<typeof useGroupsQuery>
export type GroupsLazyQueryHookResult = ReturnType<typeof useGroupsLazyQuery>
export type GroupsQueryResult = Apollo.QueryResult<
	GroupsQuery,
	GroupsQueryVariables
>
export const RefreshDevicesDocument = gql`
	mutation refreshDevices($deviceIds: [Int!]!) {
		refreshDevices(deviceIds: $deviceIds) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type RefreshDevicesMutationFn = Apollo.MutationFunction<
	RefreshDevicesMutation,
	RefreshDevicesMutationVariables
>

/**
 * __useRefreshDevicesMutation__
 *
 * To run a mutation, you first call `useRefreshDevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshDevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshDevicesMutation, { data, loading, error }] = useRefreshDevicesMutation({
 *   variables: {
 *      deviceIds: // value for 'deviceIds'
 *   },
 * });
 */
export function useRefreshDevicesMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		RefreshDevicesMutation,
		RefreshDevicesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		RefreshDevicesMutation,
		RefreshDevicesMutationVariables
	>(RefreshDevicesDocument, options)
}
export type RefreshDevicesMutationHookResult = ReturnType<
	typeof useRefreshDevicesMutation
>
export type RefreshDevicesMutationResult =
	Apollo.MutationResult<RefreshDevicesMutation>
export type RefreshDevicesMutationOptions = Apollo.BaseMutationOptions<
	RefreshDevicesMutation,
	RefreshDevicesMutationVariables
>
export const RegisterDeviceDocument = gql`
	mutation registerDevice($input: DeviceRegisterInput!) {
		registerDevice(input: $input) {
			errors {
				path
				message
			}
			device {
				id
				name
				serialNumber
				template {
					id
					name
					templateVariant {
						id
						key
					}
				}
				product {
					id
					internalId
					name
					parentProduct {
						name
					}
				}
				root {
					id
					name
				}
				position {
					id
					sequence
					shelf {
						id
						key
						bay {
							key
							aisle {
								key
							}
						}
					}
				}
				health
				batteryLevel
				batteryError
				active
				rssi
				size
				rotated
			}
		}
	}
`
export type RegisterDeviceMutationFn = Apollo.MutationFunction<
	RegisterDeviceMutation,
	RegisterDeviceMutationVariables
>

/**
 * __useRegisterDeviceMutation__
 *
 * To run a mutation, you first call `useRegisterDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerDeviceMutation, { data, loading, error }] = useRegisterDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterDeviceMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		RegisterDeviceMutation,
		RegisterDeviceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		RegisterDeviceMutation,
		RegisterDeviceMutationVariables
	>(RegisterDeviceDocument, options)
}
export type RegisterDeviceMutationHookResult = ReturnType<
	typeof useRegisterDeviceMutation
>
export type RegisterDeviceMutationResult =
	Apollo.MutationResult<RegisterDeviceMutation>
export type RegisterDeviceMutationOptions = Apollo.BaseMutationOptions<
	RegisterDeviceMutation,
	RegisterDeviceMutationVariables
>
export const SwapDeviceProductsDocument = gql`
	mutation swapDeviceProducts(
		$deviceIds: [Int!]!
		$fromProductId: Int!
		$toProductId: Int!
	) {
		swapDeviceProducts(
			deviceIds: $deviceIds
			fromProductId: $fromProductId
			toProductId: $toProductId
		) {
			success
			errors {
				path
				message
			}
		}
	}
`
export type SwapDeviceProductsMutationFn = Apollo.MutationFunction<
	SwapDeviceProductsMutation,
	SwapDeviceProductsMutationVariables
>

/**
 * __useSwapDeviceProductsMutation__
 *
 * To run a mutation, you first call `useSwapDeviceProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwapDeviceProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [swapDeviceProductsMutation, { data, loading, error }] = useSwapDeviceProductsMutation({
 *   variables: {
 *      deviceIds: // value for 'deviceIds'
 *      fromProductId: // value for 'fromProductId'
 *      toProductId: // value for 'toProductId'
 *   },
 * });
 */
export function useSwapDeviceProductsMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		SwapDeviceProductsMutation,
		SwapDeviceProductsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		SwapDeviceProductsMutation,
		SwapDeviceProductsMutationVariables
	>(SwapDeviceProductsDocument, options)
}
export type SwapDeviceProductsMutationHookResult = ReturnType<
	typeof useSwapDeviceProductsMutation
>
export type SwapDeviceProductsMutationResult =
	Apollo.MutationResult<SwapDeviceProductsMutation>
export type SwapDeviceProductsMutationOptions = Apollo.BaseMutationOptions<
	SwapDeviceProductsMutation,
	SwapDeviceProductsMutationVariables
>
export const TemplatesDocument = gql`
	query templates($where: TemplatesFilter, $offset: Int!, $limit: Int!) {
		templates(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				name
				width
			}
		}
	}
`

/**
 * __useTemplatesQuery__
 *
 * To run a query within a React component, call `useTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTemplatesQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		TemplatesQuery,
		TemplatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<TemplatesQuery, TemplatesQueryVariables>(
		TemplatesDocument,
		options
	)
}
export function useTemplatesLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		TemplatesQuery,
		TemplatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		TemplatesQuery,
		TemplatesQueryVariables
	>(TemplatesDocument, options)
}
export type TemplatesQueryHookResult = ReturnType<typeof useTemplatesQuery>
export type TemplatesLazyQueryHookResult = ReturnType<
	typeof useTemplatesLazyQuery
>
export type TemplatesQueryResult = Apollo.QueryResult<
	TemplatesQuery,
	TemplatesQueryVariables
>
export const UnassignDeviceProductDocument = gql`
	mutation unassignDeviceProduct($deviceIds: [Int!]!, $productId: Int!) {
		unassignDeviceProduct(deviceIds: $deviceIds, productId: $productId) {
			success
			errors {
				path
				message
			}
			failedDevices {
				device {
					id
					serialNumber
				}
				errors {
					path
					message
				}
			}
		}
	}
`
export type UnassignDeviceProductMutationFn = Apollo.MutationFunction<
	UnassignDeviceProductMutation,
	UnassignDeviceProductMutationVariables
>

/**
 * __useUnassignDeviceProductMutation__
 *
 * To run a mutation, you first call `useUnassignDeviceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignDeviceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignDeviceProductMutation, { data, loading, error }] = useUnassignDeviceProductMutation({
 *   variables: {
 *      deviceIds: // value for 'deviceIds'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useUnassignDeviceProductMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		UnassignDeviceProductMutation,
		UnassignDeviceProductMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		UnassignDeviceProductMutation,
		UnassignDeviceProductMutationVariables
	>(UnassignDeviceProductDocument, options)
}
export type UnassignDeviceProductMutationHookResult = ReturnType<
	typeof useUnassignDeviceProductMutation
>
export type UnassignDeviceProductMutationResult =
	Apollo.MutationResult<UnassignDeviceProductMutation>
export type UnassignDeviceProductMutationOptions = Apollo.BaseMutationOptions<
	UnassignDeviceProductMutation,
	UnassignDeviceProductMutationVariables
>
export const UpdateDevicesDocument = gql`
	mutation updateDevices($input: UpdateDevicesInput!) {
		updateDevices(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type UpdateDevicesMutationFn = Apollo.MutationFunction<
	UpdateDevicesMutation,
	UpdateDevicesMutationVariables
>

/**
 * __useUpdateDevicesMutation__
 *
 * To run a mutation, you first call `useUpdateDevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDevicesMutation, { data, loading, error }] = useUpdateDevicesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDevicesMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		UpdateDevicesMutation,
		UpdateDevicesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		UpdateDevicesMutation,
		UpdateDevicesMutationVariables
	>(UpdateDevicesDocument, options)
}
export type UpdateDevicesMutationHookResult = ReturnType<
	typeof useUpdateDevicesMutation
>
export type UpdateDevicesMutationResult =
	Apollo.MutationResult<UpdateDevicesMutation>
export type UpdateDevicesMutationOptions = Apollo.BaseMutationOptions<
	UpdateDevicesMutation,
	UpdateDevicesMutationVariables
>
export const AddSmartSensorLabelDocument = gql`
	mutation addSmartSensorLabel($input: AddSensorInput!) {
		addSensor(input: $input) {
			errors {
				path
				message
			}
			sensor {
				id
			}
		}
	}
`
export type AddSmartSensorLabelMutationFn = Apollo.MutationFunction<
	AddSmartSensorLabelMutation,
	AddSmartSensorLabelMutationVariables
>

/**
 * __useAddSmartSensorLabelMutation__
 *
 * To run a mutation, you first call `useAddSmartSensorLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSmartSensorLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSmartSensorLabelMutation, { data, loading, error }] = useAddSmartSensorLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSmartSensorLabelMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddSmartSensorLabelMutation,
		AddSmartSensorLabelMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddSmartSensorLabelMutation,
		AddSmartSensorLabelMutationVariables
	>(AddSmartSensorLabelDocument, options)
}
export type AddSmartSensorLabelMutationHookResult = ReturnType<
	typeof useAddSmartSensorLabelMutation
>
export type AddSmartSensorLabelMutationResult =
	Apollo.MutationResult<AddSmartSensorLabelMutation>
export type AddSmartSensorLabelMutationOptions = Apollo.BaseMutationOptions<
	AddSmartSensorLabelMutation,
	AddSmartSensorLabelMutationVariables
>
export const EditSmartSensorLabelDocument = gql`
	mutation editSmartSensorLabel($id: Int!, $input: EditSensorInput!) {
		editSensor(sensorId: $id, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditSmartSensorLabelMutationFn = Apollo.MutationFunction<
	EditSmartSensorLabelMutation,
	EditSmartSensorLabelMutationVariables
>

/**
 * __useEditSmartSensorLabelMutation__
 *
 * To run a mutation, you first call `useEditSmartSensorLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSmartSensorLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSmartSensorLabelMutation, { data, loading, error }] = useEditSmartSensorLabelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSmartSensorLabelMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditSmartSensorLabelMutation,
		EditSmartSensorLabelMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditSmartSensorLabelMutation,
		EditSmartSensorLabelMutationVariables
	>(EditSmartSensorLabelDocument, options)
}
export type EditSmartSensorLabelMutationHookResult = ReturnType<
	typeof useEditSmartSensorLabelMutation
>
export type EditSmartSensorLabelMutationResult =
	Apollo.MutationResult<EditSmartSensorLabelMutation>
export type EditSmartSensorLabelMutationOptions = Apollo.BaseMutationOptions<
	EditSmartSensorLabelMutation,
	EditSmartSensorLabelMutationVariables
>
export const SmartSensorLabelDocument = gql`
	query smartSensorLabel($serialNumber: String!) {
		sensor(serialNumber: $serialNumber) {
			sensor {
				id
				battery
				serialNumber
				name
				tags
				sensorType
				root {
					id
					name
				}
			}
		}
	}
`

/**
 * __useSmartSensorLabelQuery__
 *
 * To run a query within a React component, call `useSmartSensorLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartSensorLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartSensorLabelQuery({
 *   variables: {
 *      serialNumber: // value for 'serialNumber'
 *   },
 * });
 */
export function useSmartSensorLabelQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		SmartSensorLabelQuery,
		SmartSensorLabelQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		SmartSensorLabelQuery,
		SmartSensorLabelQueryVariables
	>(SmartSensorLabelDocument, options)
}
export function useSmartSensorLabelLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		SmartSensorLabelQuery,
		SmartSensorLabelQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		SmartSensorLabelQuery,
		SmartSensorLabelQueryVariables
	>(SmartSensorLabelDocument, options)
}
export type SmartSensorLabelQueryHookResult = ReturnType<
	typeof useSmartSensorLabelQuery
>
export type SmartSensorLabelLazyQueryHookResult = ReturnType<
	typeof useSmartSensorLabelLazyQuery
>
export type SmartSensorLabelQueryResult = Apollo.QueryResult<
	SmartSensorLabelQuery,
	SmartSensorLabelQueryVariables
>
export const SmartSensorLabelMeasurementHistoryDocument = gql`
	query smartSensorLabelMeasurementHistory(
		$serialNumber: String!
		$from: DateTime!
		$to: DateTime
	) {
		sensorMeasurementHistory(
			serialNumber: $serialNumber
			from: $from
			to: $to
		) {
			time
			airQualityIndex
			eco2
			accuracy
		}
	}
`

/**
 * __useSmartSensorLabelMeasurementHistoryQuery__
 *
 * To run a query within a React component, call `useSmartSensorLabelMeasurementHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartSensorLabelMeasurementHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartSensorLabelMeasurementHistoryQuery({
 *   variables: {
 *      serialNumber: // value for 'serialNumber'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useSmartSensorLabelMeasurementHistoryQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		SmartSensorLabelMeasurementHistoryQuery,
		SmartSensorLabelMeasurementHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		SmartSensorLabelMeasurementHistoryQuery,
		SmartSensorLabelMeasurementHistoryQueryVariables
	>(SmartSensorLabelMeasurementHistoryDocument, options)
}
export function useSmartSensorLabelMeasurementHistoryLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		SmartSensorLabelMeasurementHistoryQuery,
		SmartSensorLabelMeasurementHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		SmartSensorLabelMeasurementHistoryQuery,
		SmartSensorLabelMeasurementHistoryQueryVariables
	>(SmartSensorLabelMeasurementHistoryDocument, options)
}
export type SmartSensorLabelMeasurementHistoryQueryHookResult = ReturnType<
	typeof useSmartSensorLabelMeasurementHistoryQuery
>
export type SmartSensorLabelMeasurementHistoryLazyQueryHookResult = ReturnType<
	typeof useSmartSensorLabelMeasurementHistoryLazyQuery
>
export type SmartSensorLabelMeasurementHistoryQueryResult = Apollo.QueryResult<
	SmartSensorLabelMeasurementHistoryQuery,
	SmartSensorLabelMeasurementHistoryQueryVariables
>
export const SmartSensorLabelMeasurementsDocument = gql`
	query smartSensorLabelMeasurements(
		$serialNumber: String!
		$measurementType: MeasurementType!
		$from: DateTime!
		$to: DateTime
	) {
		sensor(serialNumber: $serialNumber) {
			sensor {
				measurement(type: $measurementType, from: $from, to: $to) {
					_time
					_value
				}
			}
		}
	}
`

/**
 * __useSmartSensorLabelMeasurementsQuery__
 *
 * To run a query within a React component, call `useSmartSensorLabelMeasurementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartSensorLabelMeasurementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartSensorLabelMeasurementsQuery({
 *   variables: {
 *      serialNumber: // value for 'serialNumber'
 *      measurementType: // value for 'measurementType'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useSmartSensorLabelMeasurementsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		SmartSensorLabelMeasurementsQuery,
		SmartSensorLabelMeasurementsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		SmartSensorLabelMeasurementsQuery,
		SmartSensorLabelMeasurementsQueryVariables
	>(SmartSensorLabelMeasurementsDocument, options)
}
export function useSmartSensorLabelMeasurementsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		SmartSensorLabelMeasurementsQuery,
		SmartSensorLabelMeasurementsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		SmartSensorLabelMeasurementsQuery,
		SmartSensorLabelMeasurementsQueryVariables
	>(SmartSensorLabelMeasurementsDocument, options)
}
export type SmartSensorLabelMeasurementsQueryHookResult = ReturnType<
	typeof useSmartSensorLabelMeasurementsQuery
>
export type SmartSensorLabelMeasurementsLazyQueryHookResult = ReturnType<
	typeof useSmartSensorLabelMeasurementsLazyQuery
>
export type SmartSensorLabelMeasurementsQueryResult = Apollo.QueryResult<
	SmartSensorLabelMeasurementsQuery,
	SmartSensorLabelMeasurementsQueryVariables
>
export const SmartSensorLabelsDocument = gql`
	query smartSensorLabels(
		$where: SensorsFilter
		$limit: Int!
		$offset: Int!
	) {
		sensors(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				battery
				serialNumber
				name
				tags
				active
				sensorType
				root {
					name
				}
			}
		}
	}
`

/**
 * __useSmartSensorLabelsQuery__
 *
 * To run a query within a React component, call `useSmartSensorLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartSensorLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartSensorLabelsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSmartSensorLabelsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		SmartSensorLabelsQuery,
		SmartSensorLabelsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		SmartSensorLabelsQuery,
		SmartSensorLabelsQueryVariables
	>(SmartSensorLabelsDocument, options)
}
export function useSmartSensorLabelsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		SmartSensorLabelsQuery,
		SmartSensorLabelsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		SmartSensorLabelsQuery,
		SmartSensorLabelsQueryVariables
	>(SmartSensorLabelsDocument, options)
}
export type SmartSensorLabelsQueryHookResult = ReturnType<
	typeof useSmartSensorLabelsQuery
>
export type SmartSensorLabelsLazyQueryHookResult = ReturnType<
	typeof useSmartSensorLabelsLazyQuery
>
export type SmartSensorLabelsQueryResult = Apollo.QueryResult<
	SmartSensorLabelsQuery,
	SmartSensorLabelsQueryVariables
>
export const EditSmartShelfBarDocument = gql`
	mutation editSmartShelfBar($barId: Int!, $input: EditBarInput!) {
		editBar(barId: $barId, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditSmartShelfBarMutationFn = Apollo.MutationFunction<
	EditSmartShelfBarMutation,
	EditSmartShelfBarMutationVariables
>

/**
 * __useEditSmartShelfBarMutation__
 *
 * To run a mutation, you first call `useEditSmartShelfBarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSmartShelfBarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSmartShelfBarMutation, { data, loading, error }] = useEditSmartShelfBarMutation({
 *   variables: {
 *      barId: // value for 'barId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSmartShelfBarMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditSmartShelfBarMutation,
		EditSmartShelfBarMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditSmartShelfBarMutation,
		EditSmartShelfBarMutationVariables
	>(EditSmartShelfBarDocument, options)
}
export type EditSmartShelfBarMutationHookResult = ReturnType<
	typeof useEditSmartShelfBarMutation
>
export type EditSmartShelfBarMutationResult =
	Apollo.MutationResult<EditSmartShelfBarMutation>
export type EditSmartShelfBarMutationOptions = Apollo.BaseMutationOptions<
	EditSmartShelfBarMutation,
	EditSmartShelfBarMutationVariables
>
export const SmartShelfBarDocument = gql`
	query smartShelfBar($barId: Int) {
		bar(barId: $barId) {
			bar {
				id
				macAddress
				name
				size
				x
				backgroundFile {
					id
					filename
					mimetype
				}
				group {
					id
					name
				}
				devices {
					id
					serialNumber
					x
					y
					z
					product {
						id
						name
						internalId
					}
					template {
						width
						templateVariant {
							id
						}
					}
					position {
						x
						sequence
						product {
							id
						}
						templateVariant {
							id
						}
					}
				}
				shelf {
					id
				}
				root {
					id
					market {
						id
					}
				}
			}
		}
	}
`

/**
 * __useSmartShelfBarQuery__
 *
 * To run a query within a React component, call `useSmartShelfBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartShelfBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartShelfBarQuery({
 *   variables: {
 *      barId: // value for 'barId'
 *   },
 * });
 */
export function useSmartShelfBarQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		SmartShelfBarQuery,
		SmartShelfBarQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		SmartShelfBarQuery,
		SmartShelfBarQueryVariables
	>(SmartShelfBarDocument, options)
}
export function useSmartShelfBarLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		SmartShelfBarQuery,
		SmartShelfBarQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		SmartShelfBarQuery,
		SmartShelfBarQueryVariables
	>(SmartShelfBarDocument, options)
}
export type SmartShelfBarQueryHookResult = ReturnType<
	typeof useSmartShelfBarQuery
>
export type SmartShelfBarLazyQueryHookResult = ReturnType<
	typeof useSmartShelfBarLazyQuery
>
export type SmartShelfBarQueryResult = Apollo.QueryResult<
	SmartShelfBarQuery,
	SmartShelfBarQueryVariables
>
export const SmartShelfBarsDocument = gql`
	query smartShelfBars($where: BarsFilter, $limit: Int!, $offset: Int!) {
		bars(where: $where, limit: $limit, offset: $offset) {
			nodes {
				id
				macAddress
				name
				size
				root {
					name
				}
				shelf {
					key
					bay {
						key
						aisle {
							key
						}
					}
				}
			}
		}
	}
`

/**
 * __useSmartShelfBarsQuery__
 *
 * To run a query within a React component, call `useSmartShelfBarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartShelfBarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartShelfBarsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSmartShelfBarsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		SmartShelfBarsQuery,
		SmartShelfBarsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		SmartShelfBarsQuery,
		SmartShelfBarsQueryVariables
	>(SmartShelfBarsDocument, options)
}
export function useSmartShelfBarsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		SmartShelfBarsQuery,
		SmartShelfBarsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		SmartShelfBarsQuery,
		SmartShelfBarsQueryVariables
	>(SmartShelfBarsDocument, options)
}
export type SmartShelfBarsQueryHookResult = ReturnType<
	typeof useSmartShelfBarsQuery
>
export type SmartShelfBarsLazyQueryHookResult = ReturnType<
	typeof useSmartShelfBarsLazyQuery
>
export type SmartShelfBarsQueryResult = Apollo.QueryResult<
	SmartShelfBarsQuery,
	SmartShelfBarsQueryVariables
>
export const EditScaleDocument = gql`
	mutation editScale($scaleId: Int!, $input: EditScaleInput!) {
		editScale(scaleId: $scaleId, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditScaleMutationFn = Apollo.MutationFunction<
	EditScaleMutation,
	EditScaleMutationVariables
>

/**
 * __useEditScaleMutation__
 *
 * To run a mutation, you first call `useEditScaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditScaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editScaleMutation, { data, loading, error }] = useEditScaleMutation({
 *   variables: {
 *      scaleId: // value for 'scaleId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditScaleMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditScaleMutation,
		EditScaleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditScaleMutation,
		EditScaleMutationVariables
	>(EditScaleDocument, options)
}
export type EditScaleMutationHookResult = ReturnType<
	typeof useEditScaleMutation
>
export type EditScaleMutationResult = Apollo.MutationResult<EditScaleMutation>
export type EditScaleMutationOptions = Apollo.BaseMutationOptions<
	EditScaleMutation,
	EditScaleMutationVariables
>
export const EditTvDeviceDocument = gql`
	mutation editTvDevice($tvDeviceId: Int!, $input: EditTvDeviceInput!) {
		editTvDevice(tvDeviceId: $tvDeviceId, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditTvDeviceMutationFn = Apollo.MutationFunction<
	EditTvDeviceMutation,
	EditTvDeviceMutationVariables
>

/**
 * __useEditTvDeviceMutation__
 *
 * To run a mutation, you first call `useEditTvDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTvDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTvDeviceMutation, { data, loading, error }] = useEditTvDeviceMutation({
 *   variables: {
 *      tvDeviceId: // value for 'tvDeviceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTvDeviceMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditTvDeviceMutation,
		EditTvDeviceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditTvDeviceMutation,
		EditTvDeviceMutationVariables
	>(EditTvDeviceDocument, options)
}
export type EditTvDeviceMutationHookResult = ReturnType<
	typeof useEditTvDeviceMutation
>
export type EditTvDeviceMutationResult =
	Apollo.MutationResult<EditTvDeviceMutation>
export type EditTvDeviceMutationOptions = Apollo.BaseMutationOptions<
	EditTvDeviceMutation,
	EditTvDeviceMutationVariables
>
export const RegisterScaleDocument = gql`
	mutation registerScale($input: ScaleRegisterInput!) {
		registerScale(input: $input) {
			errors {
				path
				message
			}
			scale {
				id
			}
		}
	}
`
export type RegisterScaleMutationFn = Apollo.MutationFunction<
	RegisterScaleMutation,
	RegisterScaleMutationVariables
>

/**
 * __useRegisterScaleMutation__
 *
 * To run a mutation, you first call `useRegisterScaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterScaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerScaleMutation, { data, loading, error }] = useRegisterScaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterScaleMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		RegisterScaleMutation,
		RegisterScaleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		RegisterScaleMutation,
		RegisterScaleMutationVariables
	>(RegisterScaleDocument, options)
}
export type RegisterScaleMutationHookResult = ReturnType<
	typeof useRegisterScaleMutation
>
export type RegisterScaleMutationResult =
	Apollo.MutationResult<RegisterScaleMutation>
export type RegisterScaleMutationOptions = Apollo.BaseMutationOptions<
	RegisterScaleMutation,
	RegisterScaleMutationVariables
>
export const ScaleDocument = gql`
	query scale($scaleId: Int!) {
		scale(scaleId: $scaleId) {
			scale {
				id
				name
				username
				ip
				tags
				root {
					id
				}
				channel {
					id
				}
				type
			}
		}
	}
`

/**
 * __useScaleQuery__
 *
 * To run a query within a React component, call `useScaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useScaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScaleQuery({
 *   variables: {
 *      scaleId: // value for 'scaleId'
 *   },
 * });
 */
export function useScaleQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		ScaleQuery,
		ScaleQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<ScaleQuery, ScaleQueryVariables>(
		ScaleDocument,
		options
	)
}
export function useScaleLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ScaleQuery,
		ScaleQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<ScaleQuery, ScaleQueryVariables>(
		ScaleDocument,
		options
	)
}
export type ScaleQueryHookResult = ReturnType<typeof useScaleQuery>
export type ScaleLazyQueryHookResult = ReturnType<typeof useScaleLazyQuery>
export type ScaleQueryResult = Apollo.QueryResult<
	ScaleQuery,
	ScaleQueryVariables
>
export const ScalesDocument = gql`
	query scales($offset: Int!, $limit: Int!, $where: ScalesFilter) {
		scales(offset: $offset, limit: $limit, where: $where) {
			nodes {
				id
				name
				ip
				tags
				root {
					name
					marketId
				}
				channel {
					id
					name
				}
				type
			}
			totalCount
		}
	}
`

/**
 * __useScalesQuery__
 *
 * To run a query within a React component, call `useScalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useScalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScalesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useScalesQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		ScalesQuery,
		ScalesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<ScalesQuery, ScalesQueryVariables>(
		ScalesDocument,
		options
	)
}
export function useScalesLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ScalesQuery,
		ScalesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<ScalesQuery, ScalesQueryVariables>(
		ScalesDocument,
		options
	)
}
export type ScalesQueryHookResult = ReturnType<typeof useScalesQuery>
export type ScalesLazyQueryHookResult = ReturnType<typeof useScalesLazyQuery>
export type ScalesQueryResult = Apollo.QueryResult<
	ScalesQuery,
	ScalesQueryVariables
>
export const TvDevicesDocument = gql`
	query tvDevices($offset: Int!, $limit: Int!, $where: TVDevicesFilter) {
		tvDevices(offset: $offset, limit: $limit, where: $where) {
			nodes {
				id
				token
				uuid
				name
				width
				height
				tags
				root {
					name
					marketId
				}
				channel {
					id
					name
				}
			}
			totalCount
		}
	}
`

/**
 * __useTvDevicesQuery__
 *
 * To run a query within a React component, call `useTvDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTvDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTvDevicesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTvDevicesQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		TvDevicesQuery,
		TvDevicesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<TvDevicesQuery, TvDevicesQueryVariables>(
		TvDevicesDocument,
		options
	)
}
export function useTvDevicesLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		TvDevicesQuery,
		TvDevicesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		TvDevicesQuery,
		TvDevicesQueryVariables
	>(TvDevicesDocument, options)
}
export type TvDevicesQueryHookResult = ReturnType<typeof useTvDevicesQuery>
export type TvDevicesLazyQueryHookResult = ReturnType<
	typeof useTvDevicesLazyQuery
>
export type TvDevicesQueryResult = Apollo.QueryResult<
	TvDevicesQuery,
	TvDevicesQueryVariables
>
export const AddUserDocument = gql`
	mutation addUser($input: AddUserInput!) {
		addUser(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type AddUserMutationFn = Apollo.MutationFunction<
	AddUserMutation,
	AddUserMutationVariables
>

/**
 * __useAddUserMutation__
 *
 * To run a mutation, you first call `useAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserMutation, { data, loading, error }] = useAddUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddUserMutation,
		AddUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddUserMutation,
		AddUserMutationVariables
	>(AddUserDocument, options)
}
export type AddUserMutationHookResult = ReturnType<typeof useAddUserMutation>
export type AddUserMutationResult = Apollo.MutationResult<AddUserMutation>
export type AddUserMutationOptions = Apollo.BaseMutationOptions<
	AddUserMutation,
	AddUserMutationVariables
>
export const AdminDisable2FaDocument = gql`
	mutation adminDisable2FA($userId: Int!) {
		adminDisable2FA(userId: $userId) {
			success
			errors {
				path
				message
			}
		}
	}
`
export type AdminDisable2FaMutationFn = Apollo.MutationFunction<
	AdminDisable2FaMutation,
	AdminDisable2FaMutationVariables
>

/**
 * __useAdminDisable2FaMutation__
 *
 * To run a mutation, you first call `useAdminDisable2FaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDisable2FaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDisable2FaMutation, { data, loading, error }] = useAdminDisable2FaMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminDisable2FaMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AdminDisable2FaMutation,
		AdminDisable2FaMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AdminDisable2FaMutation,
		AdminDisable2FaMutationVariables
	>(AdminDisable2FaDocument, options)
}
export type AdminDisable2FaMutationHookResult = ReturnType<
	typeof useAdminDisable2FaMutation
>
export type AdminDisable2FaMutationResult =
	Apollo.MutationResult<AdminDisable2FaMutation>
export type AdminDisable2FaMutationOptions = Apollo.BaseMutationOptions<
	AdminDisable2FaMutation,
	AdminDisable2FaMutationVariables
>
export const CustomerInfoDocument = gql`
	query customerInfo {
		customerInfo {
			purchasedModules
		}
	}
`

/**
 * __useCustomerInfoQuery__
 *
 * To run a query within a React component, call `useCustomerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerInfoQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		CustomerInfoQuery,
		CustomerInfoQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		CustomerInfoQuery,
		CustomerInfoQueryVariables
	>(CustomerInfoDocument, options)
}
export function useCustomerInfoLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		CustomerInfoQuery,
		CustomerInfoQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		CustomerInfoQuery,
		CustomerInfoQueryVariables
	>(CustomerInfoDocument, options)
}
export type CustomerInfoQueryHookResult = ReturnType<
	typeof useCustomerInfoQuery
>
export type CustomerInfoLazyQueryHookResult = ReturnType<
	typeof useCustomerInfoLazyQuery
>
export type CustomerInfoQueryResult = Apollo.QueryResult<
	CustomerInfoQuery,
	CustomerInfoQueryVariables
>
export const DeleteUserDocument = gql`
	mutation deleteUser($id: Int!) {
		deleteUser(id: $id) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteUserMutationFn = Apollo.MutationFunction<
	DeleteUserMutation,
	DeleteUserMutationVariables
>

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteUserMutation,
		DeleteUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteUserMutation,
		DeleteUserMutationVariables
	>(DeleteUserDocument, options)
}
export type DeleteUserMutationHookResult = ReturnType<
	typeof useDeleteUserMutation
>
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<
	DeleteUserMutation,
	DeleteUserMutationVariables
>
export const Disable2FaDocument = gql`
	mutation disable2FA($code: String!) {
		disable2FA(code: $code) {
			success
			delta
			errors {
				path
				message
			}
		}
	}
`
export type Disable2FaMutationFn = Apollo.MutationFunction<
	Disable2FaMutation,
	Disable2FaMutationVariables
>

/**
 * __useDisable2FaMutation__
 *
 * To run a mutation, you first call `useDisable2FaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisable2FaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disable2FaMutation, { data, loading, error }] = useDisable2FaMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useDisable2FaMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		Disable2FaMutation,
		Disable2FaMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		Disable2FaMutation,
		Disable2FaMutationVariables
	>(Disable2FaDocument, options)
}
export type Disable2FaMutationHookResult = ReturnType<
	typeof useDisable2FaMutation
>
export type Disable2FaMutationResult = Apollo.MutationResult<Disable2FaMutation>
export type Disable2FaMutationOptions = Apollo.BaseMutationOptions<
	Disable2FaMutation,
	Disable2FaMutationVariables
>
export const EditUserDocument = gql`
	mutation editUser($userId: Int!, $input: EditUserInput!) {
		editUser(userId: $userId, input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditUserMutationFn = Apollo.MutationFunction<
	EditUserMutation,
	EditUserMutationVariables
>

/**
 * __useEditUserMutation__
 *
 * To run a mutation, you first call `useEditUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserMutation, { data, loading, error }] = useEditUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditUserMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditUserMutation,
		EditUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditUserMutation,
		EditUserMutationVariables
	>(EditUserDocument, options)
}
export type EditUserMutationHookResult = ReturnType<typeof useEditUserMutation>
export type EditUserMutationResult = Apollo.MutationResult<EditUserMutation>
export type EditUserMutationOptions = Apollo.BaseMutationOptions<
	EditUserMutation,
	EditUserMutationVariables
>
export const Enable2FaDocument = gql`
	mutation enable2FA($code: String!) {
		enable2FA(code: $code) {
			success
			delta
			errors {
				path
				message
			}
		}
	}
`
export type Enable2FaMutationFn = Apollo.MutationFunction<
	Enable2FaMutation,
	Enable2FaMutationVariables
>

/**
 * __useEnable2FaMutation__
 *
 * To run a mutation, you first call `useEnable2FaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnable2FaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enable2FaMutation, { data, loading, error }] = useEnable2FaMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useEnable2FaMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		Enable2FaMutation,
		Enable2FaMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		Enable2FaMutation,
		Enable2FaMutationVariables
	>(Enable2FaDocument, options)
}
export type Enable2FaMutationHookResult = ReturnType<
	typeof useEnable2FaMutation
>
export type Enable2FaMutationResult = Apollo.MutationResult<Enable2FaMutation>
export type Enable2FaMutationOptions = Apollo.BaseMutationOptions<
	Enable2FaMutation,
	Enable2FaMutationVariables
>
export const Generate2FaSecretDocument = gql`
	mutation generate2FASecret {
		generate2FASecret {
			secret
			uri
		}
	}
`
export type Generate2FaSecretMutationFn = Apollo.MutationFunction<
	Generate2FaSecretMutation,
	Generate2FaSecretMutationVariables
>

/**
 * __useGenerate2FaSecretMutation__
 *
 * To run a mutation, you first call `useGenerate2FaSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerate2FaSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generate2FaSecretMutation, { data, loading, error }] = useGenerate2FaSecretMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerate2FaSecretMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		Generate2FaSecretMutation,
		Generate2FaSecretMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		Generate2FaSecretMutation,
		Generate2FaSecretMutationVariables
	>(Generate2FaSecretDocument, options)
}
export type Generate2FaSecretMutationHookResult = ReturnType<
	typeof useGenerate2FaSecretMutation
>
export type Generate2FaSecretMutationResult =
	Apollo.MutationResult<Generate2FaSecretMutation>
export type Generate2FaSecretMutationOptions = Apollo.BaseMutationOptions<
	Generate2FaSecretMutation,
	Generate2FaSecretMutationVariables
>
export const GetGoogleAuthDocument = gql`
	mutation getGoogleAuth($code: String!, $redirectUri: String!) {
		getGoogleAuth(code: $code, redirectUri: $redirectUri) {
			googleAuth {
				name
				email
				accessToken
				expiresAt
			}
			success
			errors {
				path
				message
			}
		}
	}
`
export type GetGoogleAuthMutationFn = Apollo.MutationFunction<
	GetGoogleAuthMutation,
	GetGoogleAuthMutationVariables
>

/**
 * __useGetGoogleAuthMutation__
 *
 * To run a mutation, you first call `useGetGoogleAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getGoogleAuthMutation, { data, loading, error }] = useGetGoogleAuthMutation({
 *   variables: {
 *      code: // value for 'code'
 *      redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useGetGoogleAuthMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		GetGoogleAuthMutation,
		GetGoogleAuthMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		GetGoogleAuthMutation,
		GetGoogleAuthMutationVariables
	>(GetGoogleAuthDocument, options)
}
export type GetGoogleAuthMutationHookResult = ReturnType<
	typeof useGetGoogleAuthMutation
>
export type GetGoogleAuthMutationResult =
	Apollo.MutationResult<GetGoogleAuthMutation>
export type GetGoogleAuthMutationOptions = Apollo.BaseMutationOptions<
	GetGoogleAuthMutation,
	GetGoogleAuthMutationVariables
>
export const MeDocument = gql`
	query me {
		me {
			id
			email
			fullName
			allowedIPs
			roles {
				id
				value
			}
			rootIDs
			permissions
			microsoftAuth {
				uuid
				name
				email
				tenantId
				accessToken
				expiresAt
				scopes
			}
			googleAuth {
				name
				email
				accessToken
				refreshToken
				expiresAt
			}
			ledConfig {
				blinkSpeed
				blinkTime
				color
			}
		}
	}
`

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<MeQuery, MeQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<MeQuery, MeQueryVariables>(
		MeDocument,
		options
	)
}
export function useMeLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		MeQuery,
		MeQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<MeQuery, MeQueryVariables>(
		MeDocument,
		options
	)
}
export type MeQueryHookResult = ReturnType<typeof useMeQuery>
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>
export const UserDocument = gql`
	query user($userId: Int!) {
		user(userId: $userId) {
			user {
				id
				email
				firstName
				lastName
				username
				roles {
					value
					id
					rank
					permissions
				}
				rootIDs
				marketIDs
				locationRestrictions {
					name
				}
				marketRestrictions {
					name
				}
				isRootRestricted
				isTwoFactorEnabled
				verifiedEmail
			}
			errors {
				path
				message
			}
		}
	}
`

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		UserQuery,
		UserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<UserQuery, UserQueryVariables>(
		UserDocument,
		options
	)
}
export function useUserLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		UserQuery,
		UserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<UserQuery, UserQueryVariables>(
		UserDocument,
		options
	)
}
export type UserQueryHookResult = ReturnType<typeof useUserQuery>
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>
export const UsersDocument = gql`
	query users($where: UsersFilter, $offset: Int!, $limit: Int!) {
		users(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				username
				email
				firstName
				lastName
				roles {
					value
				}
			}
			totalCount
		}
	}
`

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUsersQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		UsersQuery,
		UsersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<UsersQuery, UsersQueryVariables>(
		UsersDocument,
		options
	)
}
export function useUsersLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		UsersQuery,
		UsersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<UsersQuery, UsersQueryVariables>(
		UsersDocument,
		options
	)
}
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>
export type UsersQueryResult = Apollo.QueryResult<
	UsersQuery,
	UsersQueryVariables
>
export const UsersInfoDocument = gql`
	query usersInfo {
		usersInfo {
			numOfUsers
			maxUsers
		}
	}
`

/**
 * __useUsersInfoQuery__
 *
 * To run a query within a React component, call `useUsersInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersInfoQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		UsersInfoQuery,
		UsersInfoQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<UsersInfoQuery, UsersInfoQueryVariables>(
		UsersInfoDocument,
		options
	)
}
export function useUsersInfoLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		UsersInfoQuery,
		UsersInfoQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		UsersInfoQuery,
		UsersInfoQueryVariables
	>(UsersInfoDocument, options)
}
export type UsersInfoQueryHookResult = ReturnType<typeof useUsersInfoQuery>
export type UsersInfoLazyQueryHookResult = ReturnType<
	typeof useUsersInfoLazyQuery
>
export type UsersInfoQueryResult = Apollo.QueryResult<
	UsersInfoQuery,
	UsersInfoQueryVariables
>
export const VerifyEmailDocument = gql`
	mutation verifyEmail($token: String!) {
		verifyEmail(token: $token) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type VerifyEmailMutationFn = Apollo.MutationFunction<
	VerifyEmailMutation,
	VerifyEmailMutationVariables
>

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyEmailMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		VerifyEmailMutation,
		VerifyEmailMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		VerifyEmailMutation,
		VerifyEmailMutationVariables
	>(VerifyEmailDocument, options)
}
export type VerifyEmailMutationHookResult = ReturnType<
	typeof useVerifyEmailMutation
>
export type VerifyEmailMutationResult =
	Apollo.MutationResult<VerifyEmailMutation>
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<
	VerifyEmailMutation,
	VerifyEmailMutationVariables
>
export const UniqueValueEntityColumnsDocument = gql`
	query uniqueValueEntityColumns($templateKey: String!) {
		uniqueValueEntityColumns(templateKey: $templateKey) {
			nodes {
				name
			}
		}
	}
`

/**
 * __useUniqueValueEntityColumnsQuery__
 *
 * To run a query within a React component, call `useUniqueValueEntityColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniqueValueEntityColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniqueValueEntityColumnsQuery({
 *   variables: {
 *      templateKey: // value for 'templateKey'
 *   },
 * });
 */
export function useUniqueValueEntityColumnsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		UniqueValueEntityColumnsQuery,
		UniqueValueEntityColumnsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		UniqueValueEntityColumnsQuery,
		UniqueValueEntityColumnsQueryVariables
	>(UniqueValueEntityColumnsDocument, options)
}
export function useUniqueValueEntityColumnsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		UniqueValueEntityColumnsQuery,
		UniqueValueEntityColumnsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		UniqueValueEntityColumnsQuery,
		UniqueValueEntityColumnsQueryVariables
	>(UniqueValueEntityColumnsDocument, options)
}
export type UniqueValueEntityColumnsQueryHookResult = ReturnType<
	typeof useUniqueValueEntityColumnsQuery
>
export type UniqueValueEntityColumnsLazyQueryHookResult = ReturnType<
	typeof useUniqueValueEntityColumnsLazyQuery
>
export type UniqueValueEntityColumnsQueryResult = Apollo.QueryResult<
	UniqueValueEntityColumnsQuery,
	UniqueValueEntityColumnsQueryVariables
>
export const AddVirtualMultiScreenDocument = gql`
	mutation addVirtualMultiScreen($input: AddVirtualMultiScreenInput!) {
		addVirtualMultiScreen(input: $input) {
			errors {
				path
				message
			}
			virtualMultiScreen {
				id
			}
		}
	}
`
export type AddVirtualMultiScreenMutationFn = Apollo.MutationFunction<
	AddVirtualMultiScreenMutation,
	AddVirtualMultiScreenMutationVariables
>

/**
 * __useAddVirtualMultiScreenMutation__
 *
 * To run a mutation, you first call `useAddVirtualMultiScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVirtualMultiScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVirtualMultiScreenMutation, { data, loading, error }] = useAddVirtualMultiScreenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddVirtualMultiScreenMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddVirtualMultiScreenMutation,
		AddVirtualMultiScreenMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddVirtualMultiScreenMutation,
		AddVirtualMultiScreenMutationVariables
	>(AddVirtualMultiScreenDocument, options)
}
export type AddVirtualMultiScreenMutationHookResult = ReturnType<
	typeof useAddVirtualMultiScreenMutation
>
export type AddVirtualMultiScreenMutationResult =
	Apollo.MutationResult<AddVirtualMultiScreenMutation>
export type AddVirtualMultiScreenMutationOptions = Apollo.BaseMutationOptions<
	AddVirtualMultiScreenMutation,
	AddVirtualMultiScreenMutationVariables
>
export const DeleteVirtualMultiScreenDocument = gql`
	mutation deleteVirtualMultiScreen($id: Int!) {
		deleteVirtualMultiScreen(id: $id) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteVirtualMultiScreenMutationFn = Apollo.MutationFunction<
	DeleteVirtualMultiScreenMutation,
	DeleteVirtualMultiScreenMutationVariables
>

/**
 * __useDeleteVirtualMultiScreenMutation__
 *
 * To run a mutation, you first call `useDeleteVirtualMultiScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVirtualMultiScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVirtualMultiScreenMutation, { data, loading, error }] = useDeleteVirtualMultiScreenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVirtualMultiScreenMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteVirtualMultiScreenMutation,
		DeleteVirtualMultiScreenMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteVirtualMultiScreenMutation,
		DeleteVirtualMultiScreenMutationVariables
	>(DeleteVirtualMultiScreenDocument, options)
}
export type DeleteVirtualMultiScreenMutationHookResult = ReturnType<
	typeof useDeleteVirtualMultiScreenMutation
>
export type DeleteVirtualMultiScreenMutationResult =
	Apollo.MutationResult<DeleteVirtualMultiScreenMutation>
export type DeleteVirtualMultiScreenMutationOptions =
	Apollo.BaseMutationOptions<
		DeleteVirtualMultiScreenMutation,
		DeleteVirtualMultiScreenMutationVariables
	>
export const EditVirtualMultiScreenDocument = gql`
	mutation editVirtualMultiScreen($input: EditVirtualMultiScreenInput!) {
		editVirtualMultiScreen(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditVirtualMultiScreenMutationFn = Apollo.MutationFunction<
	EditVirtualMultiScreenMutation,
	EditVirtualMultiScreenMutationVariables
>

/**
 * __useEditVirtualMultiScreenMutation__
 *
 * To run a mutation, you first call `useEditVirtualMultiScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVirtualMultiScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVirtualMultiScreenMutation, { data, loading, error }] = useEditVirtualMultiScreenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditVirtualMultiScreenMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditVirtualMultiScreenMutation,
		EditVirtualMultiScreenMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditVirtualMultiScreenMutation,
		EditVirtualMultiScreenMutationVariables
	>(EditVirtualMultiScreenDocument, options)
}
export type EditVirtualMultiScreenMutationHookResult = ReturnType<
	typeof useEditVirtualMultiScreenMutation
>
export type EditVirtualMultiScreenMutationResult =
	Apollo.MutationResult<EditVirtualMultiScreenMutation>
export type EditVirtualMultiScreenMutationOptions = Apollo.BaseMutationOptions<
	EditVirtualMultiScreenMutation,
	EditVirtualMultiScreenMutationVariables
>
export const VirtualMultiScreenDocument = gql`
	query virtualMultiScreen($virtualMultiScreenId: Int!) {
		virtualMultiScreen(virtualMultiScreenId: $virtualMultiScreenId) {
			virtualMultiScreen {
				id
				name
				virtualMultiScreenPositions {
					id
					sequence
					channel {
						id
						name
					}
					virtualCategoryPoint {
						id
						name
					}
					virtualRack {
						id
						name
						virtualShelfPositions {
							id
							virtualShelf {
								id
								spacing
								virtualProductPositions {
									id
									zoom
									rotation
									itemCount
									product {
										id
										name
										productImages {
											id
											file {
												id
												thumbnail
												filename
												width
												height
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`

/**
 * __useVirtualMultiScreenQuery__
 *
 * To run a query within a React component, call `useVirtualMultiScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualMultiScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualMultiScreenQuery({
 *   variables: {
 *      virtualMultiScreenId: // value for 'virtualMultiScreenId'
 *   },
 * });
 */
export function useVirtualMultiScreenQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		VirtualMultiScreenQuery,
		VirtualMultiScreenQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		VirtualMultiScreenQuery,
		VirtualMultiScreenQueryVariables
	>(VirtualMultiScreenDocument, options)
}
export function useVirtualMultiScreenLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		VirtualMultiScreenQuery,
		VirtualMultiScreenQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		VirtualMultiScreenQuery,
		VirtualMultiScreenQueryVariables
	>(VirtualMultiScreenDocument, options)
}
export type VirtualMultiScreenQueryHookResult = ReturnType<
	typeof useVirtualMultiScreenQuery
>
export type VirtualMultiScreenLazyQueryHookResult = ReturnType<
	typeof useVirtualMultiScreenLazyQuery
>
export type VirtualMultiScreenQueryResult = Apollo.QueryResult<
	VirtualMultiScreenQuery,
	VirtualMultiScreenQueryVariables
>
export const VirtualMultiScreensDocument = gql`
	query virtualMultiScreens(
		$offset: Int!
		$limit: Int!
		$where: VirtualMultiScreensFilter
	) {
		virtualMultiScreens(offset: $offset, limit: $limit, where: $where) {
			nodes {
				id
				name
			}
			totalCount
		}
	}
`

/**
 * __useVirtualMultiScreensQuery__
 *
 * To run a query within a React component, call `useVirtualMultiScreensQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualMultiScreensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualMultiScreensQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVirtualMultiScreensQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		VirtualMultiScreensQuery,
		VirtualMultiScreensQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		VirtualMultiScreensQuery,
		VirtualMultiScreensQueryVariables
	>(VirtualMultiScreensDocument, options)
}
export function useVirtualMultiScreensLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		VirtualMultiScreensQuery,
		VirtualMultiScreensQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		VirtualMultiScreensQuery,
		VirtualMultiScreensQueryVariables
	>(VirtualMultiScreensDocument, options)
}
export type VirtualMultiScreensQueryHookResult = ReturnType<
	typeof useVirtualMultiScreensQuery
>
export type VirtualMultiScreensLazyQueryHookResult = ReturnType<
	typeof useVirtualMultiScreensLazyQuery
>
export type VirtualMultiScreensQueryResult = Apollo.QueryResult<
	VirtualMultiScreensQuery,
	VirtualMultiScreensQueryVariables
>
export const EditOrderDocument = gql`
	mutation editOrder($input: EditOrderInput!) {
		editOrder(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditOrderMutationFn = Apollo.MutationFunction<
	EditOrderMutation,
	EditOrderMutationVariables
>

/**
 * __useEditOrderMutation__
 *
 * To run a mutation, you first call `useEditOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrderMutation, { data, loading, error }] = useEditOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditOrderMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditOrderMutation,
		EditOrderMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditOrderMutation,
		EditOrderMutationVariables
	>(EditOrderDocument, options)
}
export type EditOrderMutationHookResult = ReturnType<
	typeof useEditOrderMutation
>
export type EditOrderMutationResult = Apollo.MutationResult<EditOrderMutation>
export type EditOrderMutationOptions = Apollo.BaseMutationOptions<
	EditOrderMutation,
	EditOrderMutationVariables
>
export const EditOrderItemDocument = gql`
	mutation editOrderItem($id: Int!, $input: EditOrderItemInput!) {
		editOrderItem(id: $id, input: $input) {
			errors {
				path
				message
			}
			success
			archivedOrder
		}
	}
`
export type EditOrderItemMutationFn = Apollo.MutationFunction<
	EditOrderItemMutation,
	EditOrderItemMutationVariables
>

/**
 * __useEditOrderItemMutation__
 *
 * To run a mutation, you first call `useEditOrderItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrderItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrderItemMutation, { data, loading, error }] = useEditOrderItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditOrderItemMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditOrderItemMutation,
		EditOrderItemMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditOrderItemMutation,
		EditOrderItemMutationVariables
	>(EditOrderItemDocument, options)
}
export type EditOrderItemMutationHookResult = ReturnType<
	typeof useEditOrderItemMutation
>
export type EditOrderItemMutationResult =
	Apollo.MutationResult<EditOrderItemMutation>
export type EditOrderItemMutationOptions = Apollo.BaseMutationOptions<
	EditOrderItemMutation,
	EditOrderItemMutationVariables
>
export const OrderDocument = gql`
	query order($id: Int!) {
		order(id: $id) {
			order {
				id
				created
				orderNumber
				mode
				costumerId
				rootId
				supplier {
					id
					companyName
				}
				orderItems {
					id
					quantity
					status
					deliveryDate
					productName
					internalId
					partnerId
					product {
						id
						parentProduct {
							name
						}
						internalId
						eanCodes
						valueEntities {
							id
							name
							templateKey
							type
							value
						}
					}
				}
			}
			errors {
				path
				message
			}
		}
	}
`

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		OrderQuery,
		OrderQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<OrderQuery, OrderQueryVariables>(
		OrderDocument,
		options
	)
}
export function useOrderLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		OrderQuery,
		OrderQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<OrderQuery, OrderQueryVariables>(
		OrderDocument,
		options
	)
}
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>
export type OrderQueryResult = Apollo.QueryResult<
	OrderQuery,
	OrderQueryVariables
>
export const OrderItemLogsDocument = gql`
	query orderItemLogs(
		$offset: Int!
		$limit: Int!
		$where: OrderItemLogsFilter
	) {
		orderItemLogs(offset: $offset, limit: $limit, where: $where) {
			nodes {
				id
				time
				type
				user {
					firstName
					lastName
				}
				quantity
				status
				deliveryDate
			}
			totalCount
		}
	}
`

/**
 * __useOrderItemLogsQuery__
 *
 * To run a query within a React component, call `useOrderItemLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderItemLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderItemLogsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrderItemLogsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		OrderItemLogsQuery,
		OrderItemLogsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		OrderItemLogsQuery,
		OrderItemLogsQueryVariables
	>(OrderItemLogsDocument, options)
}
export function useOrderItemLogsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		OrderItemLogsQuery,
		OrderItemLogsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		OrderItemLogsQuery,
		OrderItemLogsQueryVariables
	>(OrderItemLogsDocument, options)
}
export type OrderItemLogsQueryHookResult = ReturnType<
	typeof useOrderItemLogsQuery
>
export type OrderItemLogsLazyQueryHookResult = ReturnType<
	typeof useOrderItemLogsLazyQuery
>
export type OrderItemLogsQueryResult = Apollo.QueryResult<
	OrderItemLogsQuery,
	OrderItemLogsQueryVariables
>
export const OrdersDocument = gql`
	query orders($offset: Int!, $limit: Int!, $where: OrderFilter) {
		orders(offset: $offset, limit: $limit, where: $where) {
			nodes {
				id
				created
				orderNumber
				mode
				costumerId
				rootId
				orderItems {
					id
					quantity
					status
					deliveryDate
					product {
						id
						name
						internalId
					}
				}
				supplier {
					id
					companyName
					supplierId
				}
			}
			totalCount
		}
	}
`

/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrdersQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		OrdersQuery,
		OrdersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<OrdersQuery, OrdersQueryVariables>(
		OrdersDocument,
		options
	)
}
export function useOrdersLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		OrdersQuery,
		OrdersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<OrdersQuery, OrdersQueryVariables>(
		OrdersDocument,
		options
	)
}
export type OrdersQueryHookResult = ReturnType<typeof useOrdersQuery>
export type OrdersLazyQueryHookResult = ReturnType<typeof useOrdersLazyQuery>
export type OrdersQueryResult = Apollo.QueryResult<
	OrdersQuery,
	OrdersQueryVariables
>
export const DeleteProductImageDocument = gql`
	mutation deleteProductImage($productImageId: Int!) {
		deleteProductImage(productImageId: $productImageId) {
			success
			errors {
				path
				message
			}
		}
	}
`
export type DeleteProductImageMutationFn = Apollo.MutationFunction<
	DeleteProductImageMutation,
	DeleteProductImageMutationVariables
>

/**
 * __useDeleteProductImageMutation__
 *
 * To run a mutation, you first call `useDeleteProductImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductImageMutation, { data, loading, error }] = useDeleteProductImageMutation({
 *   variables: {
 *      productImageId: // value for 'productImageId'
 *   },
 * });
 */
export function useDeleteProductImageMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteProductImageMutation,
		DeleteProductImageMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteProductImageMutation,
		DeleteProductImageMutationVariables
	>(DeleteProductImageDocument, options)
}
export type DeleteProductImageMutationHookResult = ReturnType<
	typeof useDeleteProductImageMutation
>
export type DeleteProductImageMutationResult =
	Apollo.MutationResult<DeleteProductImageMutation>
export type DeleteProductImageMutationOptions = Apollo.BaseMutationOptions<
	DeleteProductImageMutation,
	DeleteProductImageMutationVariables
>
export const ProductEditDetailsDocument = gql`
	query productEditDetails($internalId: String, $id: Int) {
		product(internalId: $internalId, id: $id) {
			product {
				id
				internalId
				name
				eanCodes
				active
				virtualProductPositions {
					virtualShelf {
						id
						name
					}
				}
				productImages {
					id
					primary
					file {
						id
						originalname
						filename
						mimetype
						encoding
						url
						isFolder
						width
						height
						thumbnail
					}
				}
				valueEntities {
					id
					name
					templateKey
					type
					value
				}
				products {
					id
					internalId
					name
					eanCodes
					valueEntities {
						id
						name
						templateKey
						type
						value
					}
					productImages {
						id
						primary
						file {
							id
							originalname
							filename
							mimetype
							encoding
							url
							isFolder
							width
							height
							thumbnail
						}
					}
				}
			}
		}
	}
`

/**
 * __useProductEditDetailsQuery__
 *
 * To run a query within a React component, call `useProductEditDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductEditDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductEditDetailsQuery({
 *   variables: {
 *      internalId: // value for 'internalId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductEditDetailsQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		ProductEditDetailsQuery,
		ProductEditDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		ProductEditDetailsQuery,
		ProductEditDetailsQueryVariables
	>(ProductEditDetailsDocument, options)
}
export function useProductEditDetailsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ProductEditDetailsQuery,
		ProductEditDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		ProductEditDetailsQuery,
		ProductEditDetailsQueryVariables
	>(ProductEditDetailsDocument, options)
}
export type ProductEditDetailsQueryHookResult = ReturnType<
	typeof useProductEditDetailsQuery
>
export type ProductEditDetailsLazyQueryHookResult = ReturnType<
	typeof useProductEditDetailsLazyQuery
>
export type ProductEditDetailsQueryResult = Apollo.QueryResult<
	ProductEditDetailsQuery,
	ProductEditDetailsQueryVariables
>
export const UploadProductImageDocument = gql`
	mutation uploadProductImage(
		$file: Upload!
		$internalId: String
		$primary: Boolean
		$productType: ProductType
	) {
		uploadProductImage(
			file: $file
			internalId: $internalId
			primary: $primary
			productType: $productType
		) {
			file {
				id
				isFolder
				originalname
				filename
				mimetype
				encoding
				url
				thumbnail
			}
			productImage {
				id
				primary
				file {
					id
					isFolder
					originalname
					filename
					mimetype
					encoding
					url
					thumbnail
				}
			}
		}
	}
`
export type UploadProductImageMutationFn = Apollo.MutationFunction<
	UploadProductImageMutation,
	UploadProductImageMutationVariables
>

/**
 * __useUploadProductImageMutation__
 *
 * To run a mutation, you first call `useUploadProductImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProductImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProductImageMutation, { data, loading, error }] = useUploadProductImageMutation({
 *   variables: {
 *      file: // value for 'file'
 *      internalId: // value for 'internalId'
 *      primary: // value for 'primary'
 *      productType: // value for 'productType'
 *   },
 * });
 */
export function useUploadProductImageMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		UploadProductImageMutation,
		UploadProductImageMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		UploadProductImageMutation,
		UploadProductImageMutationVariables
	>(UploadProductImageDocument, options)
}
export type UploadProductImageMutationHookResult = ReturnType<
	typeof useUploadProductImageMutation
>
export type UploadProductImageMutationResult =
	Apollo.MutationResult<UploadProductImageMutation>
export type UploadProductImageMutationOptions = Apollo.BaseMutationOptions<
	UploadProductImageMutation,
	UploadProductImageMutationVariables
>
export const VirtualStoreProductsDocument = gql`
	query virtualStoreProducts(
		$where: ProductsFilter
		$offset: Int!
		$limit: Int!
	) {
		products(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				eanCodes
				internalId
				name
				productType
				active
				productImages {
					id
					file {
						id
						thumbnail
					}
				}
				valueEntities {
					id
					templateKey
					type
					value
				}
			}
			totalCount
		}
	}
`

/**
 * __useVirtualStoreProductsQuery__
 *
 * To run a query within a React component, call `useVirtualStoreProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualStoreProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualStoreProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useVirtualStoreProductsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		VirtualStoreProductsQuery,
		VirtualStoreProductsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		VirtualStoreProductsQuery,
		VirtualStoreProductsQueryVariables
	>(VirtualStoreProductsDocument, options)
}
export function useVirtualStoreProductsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		VirtualStoreProductsQuery,
		VirtualStoreProductsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		VirtualStoreProductsQuery,
		VirtualStoreProductsQueryVariables
	>(VirtualStoreProductsDocument, options)
}
export type VirtualStoreProductsQueryHookResult = ReturnType<
	typeof useVirtualStoreProductsQuery
>
export type VirtualStoreProductsLazyQueryHookResult = ReturnType<
	typeof useVirtualStoreProductsLazyQuery
>
export type VirtualStoreProductsQueryResult = Apollo.QueryResult<
	VirtualStoreProductsQuery,
	VirtualStoreProductsQueryVariables
>
export const AddVirtualCategoryPointDocument = gql`
	mutation addVirtualCategoryPoint($input: AddVirtualCategoryPointInput!) {
		addVirtualCategoryPoint(input: $input) {
			errors {
				path
				message
			}
			virtualCategoryPoint {
				id
			}
		}
	}
`
export type AddVirtualCategoryPointMutationFn = Apollo.MutationFunction<
	AddVirtualCategoryPointMutation,
	AddVirtualCategoryPointMutationVariables
>

/**
 * __useAddVirtualCategoryPointMutation__
 *
 * To run a mutation, you first call `useAddVirtualCategoryPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVirtualCategoryPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVirtualCategoryPointMutation, { data, loading, error }] = useAddVirtualCategoryPointMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddVirtualCategoryPointMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddVirtualCategoryPointMutation,
		AddVirtualCategoryPointMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddVirtualCategoryPointMutation,
		AddVirtualCategoryPointMutationVariables
	>(AddVirtualCategoryPointDocument, options)
}
export type AddVirtualCategoryPointMutationHookResult = ReturnType<
	typeof useAddVirtualCategoryPointMutation
>
export type AddVirtualCategoryPointMutationResult =
	Apollo.MutationResult<AddVirtualCategoryPointMutation>
export type AddVirtualCategoryPointMutationOptions = Apollo.BaseMutationOptions<
	AddVirtualCategoryPointMutation,
	AddVirtualCategoryPointMutationVariables
>
export const DeleteVirtualCategoryPointDocument = gql`
	mutation deleteVirtualCategoryPoint($id: Int!) {
		deleteVirtualCategoryPoint(id: $id) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteVirtualCategoryPointMutationFn = Apollo.MutationFunction<
	DeleteVirtualCategoryPointMutation,
	DeleteVirtualCategoryPointMutationVariables
>

/**
 * __useDeleteVirtualCategoryPointMutation__
 *
 * To run a mutation, you first call `useDeleteVirtualCategoryPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVirtualCategoryPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVirtualCategoryPointMutation, { data, loading, error }] = useDeleteVirtualCategoryPointMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVirtualCategoryPointMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteVirtualCategoryPointMutation,
		DeleteVirtualCategoryPointMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteVirtualCategoryPointMutation,
		DeleteVirtualCategoryPointMutationVariables
	>(DeleteVirtualCategoryPointDocument, options)
}
export type DeleteVirtualCategoryPointMutationHookResult = ReturnType<
	typeof useDeleteVirtualCategoryPointMutation
>
export type DeleteVirtualCategoryPointMutationResult =
	Apollo.MutationResult<DeleteVirtualCategoryPointMutation>
export type DeleteVirtualCategoryPointMutationOptions =
	Apollo.BaseMutationOptions<
		DeleteVirtualCategoryPointMutation,
		DeleteVirtualCategoryPointMutationVariables
	>
export const EditVirtualCategoryPointDocument = gql`
	mutation editVirtualCategoryPoint($input: EditVirtualCategoryPointInput!) {
		editVirtualCategoryPoint(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditVirtualCategoryPointMutationFn = Apollo.MutationFunction<
	EditVirtualCategoryPointMutation,
	EditVirtualCategoryPointMutationVariables
>

/**
 * __useEditVirtualCategoryPointMutation__
 *
 * To run a mutation, you first call `useEditVirtualCategoryPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVirtualCategoryPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVirtualCategoryPointMutation, { data, loading, error }] = useEditVirtualCategoryPointMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditVirtualCategoryPointMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditVirtualCategoryPointMutation,
		EditVirtualCategoryPointMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditVirtualCategoryPointMutation,
		EditVirtualCategoryPointMutationVariables
	>(EditVirtualCategoryPointDocument, options)
}
export type EditVirtualCategoryPointMutationHookResult = ReturnType<
	typeof useEditVirtualCategoryPointMutation
>
export type EditVirtualCategoryPointMutationResult =
	Apollo.MutationResult<EditVirtualCategoryPointMutation>
export type EditVirtualCategoryPointMutationOptions =
	Apollo.BaseMutationOptions<
		EditVirtualCategoryPointMutation,
		EditVirtualCategoryPointMutationVariables
	>
export const VirtualCategoryPointDocument = gql`
	query virtualCategoryPoint($virtualCategoryPointId: Int!) {
		virtualCategoryPoint(virtualCategoryPointId: $virtualCategoryPointId) {
			virtualCategoryPoint {
				id
				name
				virtualRacks {
					id
					name
					virtualShelfPositions {
						virtualShelf {
							id
							name
							spacing
							variant
							virtualProductPositions {
								zoom
								rotation
								itemCount
								product {
									id
									name
									productImages {
										file {
											filename
											thumbnail
											width
											height
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`

/**
 * __useVirtualCategoryPointQuery__
 *
 * To run a query within a React component, call `useVirtualCategoryPointQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualCategoryPointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualCategoryPointQuery({
 *   variables: {
 *      virtualCategoryPointId: // value for 'virtualCategoryPointId'
 *   },
 * });
 */
export function useVirtualCategoryPointQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		VirtualCategoryPointQuery,
		VirtualCategoryPointQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		VirtualCategoryPointQuery,
		VirtualCategoryPointQueryVariables
	>(VirtualCategoryPointDocument, options)
}
export function useVirtualCategoryPointLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		VirtualCategoryPointQuery,
		VirtualCategoryPointQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		VirtualCategoryPointQuery,
		VirtualCategoryPointQueryVariables
	>(VirtualCategoryPointDocument, options)
}
export type VirtualCategoryPointQueryHookResult = ReturnType<
	typeof useVirtualCategoryPointQuery
>
export type VirtualCategoryPointLazyQueryHookResult = ReturnType<
	typeof useVirtualCategoryPointLazyQuery
>
export type VirtualCategoryPointQueryResult = Apollo.QueryResult<
	VirtualCategoryPointQuery,
	VirtualCategoryPointQueryVariables
>
export const VirtualCategoryPointsDocument = gql`
	query virtualCategoryPoints(
		$offset: Int!
		$limit: Int!
		$where: VirtualCategoryPointsFilter
	) {
		virtualCategoryPoints(offset: $offset, limit: $limit, where: $where) {
			nodes {
				id
				name
				virtualRacks {
					id
					name
				}
			}
			totalCount
		}
	}
`

/**
 * __useVirtualCategoryPointsQuery__
 *
 * To run a query within a React component, call `useVirtualCategoryPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualCategoryPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualCategoryPointsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVirtualCategoryPointsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		VirtualCategoryPointsQuery,
		VirtualCategoryPointsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		VirtualCategoryPointsQuery,
		VirtualCategoryPointsQueryVariables
	>(VirtualCategoryPointsDocument, options)
}
export function useVirtualCategoryPointsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		VirtualCategoryPointsQuery,
		VirtualCategoryPointsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		VirtualCategoryPointsQuery,
		VirtualCategoryPointsQueryVariables
	>(VirtualCategoryPointsDocument, options)
}
export type VirtualCategoryPointsQueryHookResult = ReturnType<
	typeof useVirtualCategoryPointsQuery
>
export type VirtualCategoryPointsLazyQueryHookResult = ReturnType<
	typeof useVirtualCategoryPointsLazyQuery
>
export type VirtualCategoryPointsQueryResult = Apollo.QueryResult<
	VirtualCategoryPointsQuery,
	VirtualCategoryPointsQueryVariables
>
export const AddVirtualCategoryScreenDocument = gql`
	mutation addVirtualCategoryScreen($input: AddVirtualCategoryScreenInput!) {
		addVirtualCategoryScreen(input: $input) {
			errors {
				path
				message
			}
			virtualCategoryScreen {
				id
			}
		}
	}
`
export type AddVirtualCategoryScreenMutationFn = Apollo.MutationFunction<
	AddVirtualCategoryScreenMutation,
	AddVirtualCategoryScreenMutationVariables
>

/**
 * __useAddVirtualCategoryScreenMutation__
 *
 * To run a mutation, you first call `useAddVirtualCategoryScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVirtualCategoryScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVirtualCategoryScreenMutation, { data, loading, error }] = useAddVirtualCategoryScreenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddVirtualCategoryScreenMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddVirtualCategoryScreenMutation,
		AddVirtualCategoryScreenMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddVirtualCategoryScreenMutation,
		AddVirtualCategoryScreenMutationVariables
	>(AddVirtualCategoryScreenDocument, options)
}
export type AddVirtualCategoryScreenMutationHookResult = ReturnType<
	typeof useAddVirtualCategoryScreenMutation
>
export type AddVirtualCategoryScreenMutationResult =
	Apollo.MutationResult<AddVirtualCategoryScreenMutation>
export type AddVirtualCategoryScreenMutationOptions =
	Apollo.BaseMutationOptions<
		AddVirtualCategoryScreenMutation,
		AddVirtualCategoryScreenMutationVariables
	>
export const DeleteCategoryScreenImageDocument = gql`
	mutation deleteCategoryScreenImage($categoryId: Int!) {
		deleteVirtualCategoryScreenImage(categoryId: $categoryId) {
			success
			errors {
				path
				message
			}
		}
	}
`
export type DeleteCategoryScreenImageMutationFn = Apollo.MutationFunction<
	DeleteCategoryScreenImageMutation,
	DeleteCategoryScreenImageMutationVariables
>

/**
 * __useDeleteCategoryScreenImageMutation__
 *
 * To run a mutation, you first call `useDeleteCategoryScreenImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoryScreenImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCategoryScreenImageMutation, { data, loading, error }] = useDeleteCategoryScreenImageMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useDeleteCategoryScreenImageMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteCategoryScreenImageMutation,
		DeleteCategoryScreenImageMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteCategoryScreenImageMutation,
		DeleteCategoryScreenImageMutationVariables
	>(DeleteCategoryScreenImageDocument, options)
}
export type DeleteCategoryScreenImageMutationHookResult = ReturnType<
	typeof useDeleteCategoryScreenImageMutation
>
export type DeleteCategoryScreenImageMutationResult =
	Apollo.MutationResult<DeleteCategoryScreenImageMutation>
export type DeleteCategoryScreenImageMutationOptions =
	Apollo.BaseMutationOptions<
		DeleteCategoryScreenImageMutation,
		DeleteCategoryScreenImageMutationVariables
	>
export const DeleteVirtualCategoryScreenDocument = gql`
	mutation deleteVirtualCategoryScreen($id: Int!) {
		deleteVirtualCategoryScreen(id: $id) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteVirtualCategoryScreenMutationFn = Apollo.MutationFunction<
	DeleteVirtualCategoryScreenMutation,
	DeleteVirtualCategoryScreenMutationVariables
>

/**
 * __useDeleteVirtualCategoryScreenMutation__
 *
 * To run a mutation, you first call `useDeleteVirtualCategoryScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVirtualCategoryScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVirtualCategoryScreenMutation, { data, loading, error }] = useDeleteVirtualCategoryScreenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVirtualCategoryScreenMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteVirtualCategoryScreenMutation,
		DeleteVirtualCategoryScreenMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteVirtualCategoryScreenMutation,
		DeleteVirtualCategoryScreenMutationVariables
	>(DeleteVirtualCategoryScreenDocument, options)
}
export type DeleteVirtualCategoryScreenMutationHookResult = ReturnType<
	typeof useDeleteVirtualCategoryScreenMutation
>
export type DeleteVirtualCategoryScreenMutationResult =
	Apollo.MutationResult<DeleteVirtualCategoryScreenMutation>
export type DeleteVirtualCategoryScreenMutationOptions =
	Apollo.BaseMutationOptions<
		DeleteVirtualCategoryScreenMutation,
		DeleteVirtualCategoryScreenMutationVariables
	>
export const EditVirtualCategoryScreenDocument = gql`
	mutation editVirtualCategoryScreen(
		$input: EditVirtualCategoryScreenInput!
	) {
		editVirtualCategoryScreen(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditVirtualCategoryScreenMutationFn = Apollo.MutationFunction<
	EditVirtualCategoryScreenMutation,
	EditVirtualCategoryScreenMutationVariables
>

/**
 * __useEditVirtualCategoryScreenMutation__
 *
 * To run a mutation, you first call `useEditVirtualCategoryScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVirtualCategoryScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVirtualCategoryScreenMutation, { data, loading, error }] = useEditVirtualCategoryScreenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditVirtualCategoryScreenMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditVirtualCategoryScreenMutation,
		EditVirtualCategoryScreenMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditVirtualCategoryScreenMutation,
		EditVirtualCategoryScreenMutationVariables
	>(EditVirtualCategoryScreenDocument, options)
}
export type EditVirtualCategoryScreenMutationHookResult = ReturnType<
	typeof useEditVirtualCategoryScreenMutation
>
export type EditVirtualCategoryScreenMutationResult =
	Apollo.MutationResult<EditVirtualCategoryScreenMutation>
export type EditVirtualCategoryScreenMutationOptions =
	Apollo.BaseMutationOptions<
		EditVirtualCategoryScreenMutation,
		EditVirtualCategoryScreenMutationVariables
	>
export const UploadVirtualStoreScreenDocument = gql`
	mutation uploadVirtualStoreScreen(
		$file: Upload!
		$virtualCategoryScreenId: Int
	) {
		uploadVirtualStoreScreen(
			file: $file
			virtualCategoryScreenId: $virtualCategoryScreenId
		) {
			id
			originalname
			filename
			mimetype
			encoding
			url
			isFolder
			thumbnail
			width
			height
		}
	}
`
export type UploadVirtualStoreScreenMutationFn = Apollo.MutationFunction<
	UploadVirtualStoreScreenMutation,
	UploadVirtualStoreScreenMutationVariables
>

/**
 * __useUploadVirtualStoreScreenMutation__
 *
 * To run a mutation, you first call `useUploadVirtualStoreScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadVirtualStoreScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadVirtualStoreScreenMutation, { data, loading, error }] = useUploadVirtualStoreScreenMutation({
 *   variables: {
 *      file: // value for 'file'
 *      virtualCategoryScreenId: // value for 'virtualCategoryScreenId'
 *   },
 * });
 */
export function useUploadVirtualStoreScreenMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		UploadVirtualStoreScreenMutation,
		UploadVirtualStoreScreenMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		UploadVirtualStoreScreenMutation,
		UploadVirtualStoreScreenMutationVariables
	>(UploadVirtualStoreScreenDocument, options)
}
export type UploadVirtualStoreScreenMutationHookResult = ReturnType<
	typeof useUploadVirtualStoreScreenMutation
>
export type UploadVirtualStoreScreenMutationResult =
	Apollo.MutationResult<UploadVirtualStoreScreenMutation>
export type UploadVirtualStoreScreenMutationOptions =
	Apollo.BaseMutationOptions<
		UploadVirtualStoreScreenMutation,
		UploadVirtualStoreScreenMutationVariables
	>
export const VirtualCategoryScreenDocument = gql`
	query virtualCategoryScreen($virtualCategoryScreenId: Int!) {
		virtualCategoryScreen(
			virtualCategoryScreenId: $virtualCategoryScreenId
		) {
			virtualCategoryScreen {
				id
				name
				timeout
				catalogMode
				channel {
					id
				}
				file {
					id
					originalname
					filename
					mimetype
					encoding
					url
					isFolder
					width
					height
				}
				backgroundFile {
					id
					originalname
					filename
					mimetype
					encoding
					url
					isFolder
					width
					height
				}
				virtualCategoryPointPositions {
					id
					x
					y
					virtualCategoryPoint {
						id
						name
					}
				}
			}
		}
	}
`

/**
 * __useVirtualCategoryScreenQuery__
 *
 * To run a query within a React component, call `useVirtualCategoryScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualCategoryScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualCategoryScreenQuery({
 *   variables: {
 *      virtualCategoryScreenId: // value for 'virtualCategoryScreenId'
 *   },
 * });
 */
export function useVirtualCategoryScreenQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		VirtualCategoryScreenQuery,
		VirtualCategoryScreenQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		VirtualCategoryScreenQuery,
		VirtualCategoryScreenQueryVariables
	>(VirtualCategoryScreenDocument, options)
}
export function useVirtualCategoryScreenLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		VirtualCategoryScreenQuery,
		VirtualCategoryScreenQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		VirtualCategoryScreenQuery,
		VirtualCategoryScreenQueryVariables
	>(VirtualCategoryScreenDocument, options)
}
export type VirtualCategoryScreenQueryHookResult = ReturnType<
	typeof useVirtualCategoryScreenQuery
>
export type VirtualCategoryScreenLazyQueryHookResult = ReturnType<
	typeof useVirtualCategoryScreenLazyQuery
>
export type VirtualCategoryScreenQueryResult = Apollo.QueryResult<
	VirtualCategoryScreenQuery,
	VirtualCategoryScreenQueryVariables
>
export const VirtualCategoryScreensDocument = gql`
	query virtualCategoryScreens(
		$offset: Int!
		$limit: Int!
		$where: VirtualCategoryScreensFilter
	) {
		virtualCategoryScreens(offset: $offset, limit: $limit, where: $where) {
			nodes {
				id
				name
				virtualCategoryPointPositions {
					id
					x
					y
					virtualCategoryPoint {
						id
						name
					}
				}
			}
			totalCount
		}
	}
`

/**
 * __useVirtualCategoryScreensQuery__
 *
 * To run a query within a React component, call `useVirtualCategoryScreensQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualCategoryScreensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualCategoryScreensQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVirtualCategoryScreensQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		VirtualCategoryScreensQuery,
		VirtualCategoryScreensQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		VirtualCategoryScreensQuery,
		VirtualCategoryScreensQueryVariables
	>(VirtualCategoryScreensDocument, options)
}
export function useVirtualCategoryScreensLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		VirtualCategoryScreensQuery,
		VirtualCategoryScreensQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		VirtualCategoryScreensQuery,
		VirtualCategoryScreensQueryVariables
	>(VirtualCategoryScreensDocument, options)
}
export type VirtualCategoryScreensQueryHookResult = ReturnType<
	typeof useVirtualCategoryScreensQuery
>
export type VirtualCategoryScreensLazyQueryHookResult = ReturnType<
	typeof useVirtualCategoryScreensLazyQuery
>
export type VirtualCategoryScreensQueryResult = Apollo.QueryResult<
	VirtualCategoryScreensQuery,
	VirtualCategoryScreensQueryVariables
>
export const AddVirtualRackDocument = gql`
	mutation addVirtualRack($input: AddVirtualRackInput!) {
		addVirtualRack(input: $input) {
			errors {
				path
				message
			}
			virtualRack {
				id
			}
		}
	}
`
export type AddVirtualRackMutationFn = Apollo.MutationFunction<
	AddVirtualRackMutation,
	AddVirtualRackMutationVariables
>

/**
 * __useAddVirtualRackMutation__
 *
 * To run a mutation, you first call `useAddVirtualRackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVirtualRackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVirtualRackMutation, { data, loading, error }] = useAddVirtualRackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddVirtualRackMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddVirtualRackMutation,
		AddVirtualRackMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddVirtualRackMutation,
		AddVirtualRackMutationVariables
	>(AddVirtualRackDocument, options)
}
export type AddVirtualRackMutationHookResult = ReturnType<
	typeof useAddVirtualRackMutation
>
export type AddVirtualRackMutationResult =
	Apollo.MutationResult<AddVirtualRackMutation>
export type AddVirtualRackMutationOptions = Apollo.BaseMutationOptions<
	AddVirtualRackMutation,
	AddVirtualRackMutationVariables
>
export const DeleteVirtualRackDocument = gql`
	mutation deleteVirtualRack($id: Int!) {
		deleteVirtualRack(id: $id) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteVirtualRackMutationFn = Apollo.MutationFunction<
	DeleteVirtualRackMutation,
	DeleteVirtualRackMutationVariables
>

/**
 * __useDeleteVirtualRackMutation__
 *
 * To run a mutation, you first call `useDeleteVirtualRackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVirtualRackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVirtualRackMutation, { data, loading, error }] = useDeleteVirtualRackMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVirtualRackMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteVirtualRackMutation,
		DeleteVirtualRackMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteVirtualRackMutation,
		DeleteVirtualRackMutationVariables
	>(DeleteVirtualRackDocument, options)
}
export type DeleteVirtualRackMutationHookResult = ReturnType<
	typeof useDeleteVirtualRackMutation
>
export type DeleteVirtualRackMutationResult =
	Apollo.MutationResult<DeleteVirtualRackMutation>
export type DeleteVirtualRackMutationOptions = Apollo.BaseMutationOptions<
	DeleteVirtualRackMutation,
	DeleteVirtualRackMutationVariables
>
export const EditVirtualRackDocument = gql`
	mutation editVirtualRack($input: EditVirtualRackInput!) {
		editVirtualRack(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditVirtualRackMutationFn = Apollo.MutationFunction<
	EditVirtualRackMutation,
	EditVirtualRackMutationVariables
>

/**
 * __useEditVirtualRackMutation__
 *
 * To run a mutation, you first call `useEditVirtualRackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVirtualRackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVirtualRackMutation, { data, loading, error }] = useEditVirtualRackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditVirtualRackMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditVirtualRackMutation,
		EditVirtualRackMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditVirtualRackMutation,
		EditVirtualRackMutationVariables
	>(EditVirtualRackDocument, options)
}
export type EditVirtualRackMutationHookResult = ReturnType<
	typeof useEditVirtualRackMutation
>
export type EditVirtualRackMutationResult =
	Apollo.MutationResult<EditVirtualRackMutation>
export type EditVirtualRackMutationOptions = Apollo.BaseMutationOptions<
	EditVirtualRackMutation,
	EditVirtualRackMutationVariables
>
export const VirtualRackDocument = gql`
	query virtualRack($virtualRackId: Int!) {
		virtualRack(virtualRackId: $virtualRackId) {
			virtualRack {
				id
				name
				removePadding
				file {
					id
					originalname
				}
				virtualShelfPositions {
					id
					virtualShelf {
						id
						name
						spacing
						variant
						virtualProductPositions {
							id
							zoom
							rotation
							itemCount
							product {
								id
								name
								valueEntities {
									value
									templateKey
								}
								productImages {
									id
									file {
										id
										thumbnail
										filename
										width
										height
									}
								}
							}
						}
					}
				}
			}
		}
	}
`

/**
 * __useVirtualRackQuery__
 *
 * To run a query within a React component, call `useVirtualRackQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualRackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualRackQuery({
 *   variables: {
 *      virtualRackId: // value for 'virtualRackId'
 *   },
 * });
 */
export function useVirtualRackQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		VirtualRackQuery,
		VirtualRackQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		VirtualRackQuery,
		VirtualRackQueryVariables
	>(VirtualRackDocument, options)
}
export function useVirtualRackLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		VirtualRackQuery,
		VirtualRackQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		VirtualRackQuery,
		VirtualRackQueryVariables
	>(VirtualRackDocument, options)
}
export type VirtualRackQueryHookResult = ReturnType<typeof useVirtualRackQuery>
export type VirtualRackLazyQueryHookResult = ReturnType<
	typeof useVirtualRackLazyQuery
>
export type VirtualRackQueryResult = Apollo.QueryResult<
	VirtualRackQuery,
	VirtualRackQueryVariables
>
export const VirtualRacksDocument = gql`
	query virtualRacks(
		$offset: Int!
		$limit: Int!
		$where: VirtualRacksFilter
	) {
		virtualRacks(offset: $offset, limit: $limit, where: $where) {
			nodes {
				id
				name
				file {
					id
					thumbnail
					width
					height
				}
				virtualShelfPositions {
					id
					virtualShelf {
						variant
						spacing
						virtualProductPositions {
							zoom
							rotation
							itemCount
							product {
								productImages {
									file {
										id
										thumbnail
										width
										height
									}
								}
							}
						}
					}
				}
			}
			totalCount
		}
	}
`

/**
 * __useVirtualRacksQuery__
 *
 * To run a query within a React component, call `useVirtualRacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualRacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualRacksQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVirtualRacksQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		VirtualRacksQuery,
		VirtualRacksQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		VirtualRacksQuery,
		VirtualRacksQueryVariables
	>(VirtualRacksDocument, options)
}
export function useVirtualRacksLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		VirtualRacksQuery,
		VirtualRacksQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		VirtualRacksQuery,
		VirtualRacksQueryVariables
	>(VirtualRacksDocument, options)
}
export type VirtualRacksQueryHookResult = ReturnType<
	typeof useVirtualRacksQuery
>
export type VirtualRacksLazyQueryHookResult = ReturnType<
	typeof useVirtualRacksLazyQuery
>
export type VirtualRacksQueryResult = Apollo.QueryResult<
	VirtualRacksQuery,
	VirtualRacksQueryVariables
>
export const AddVirtualShelfDocument = gql`
	mutation addVirtualShelf($input: AddVirtualShelfInput!) {
		addVirtualShelf(input: $input) {
			errors {
				path
				message
			}
			virtualShelf {
				id
			}
		}
	}
`
export type AddVirtualShelfMutationFn = Apollo.MutationFunction<
	AddVirtualShelfMutation,
	AddVirtualShelfMutationVariables
>

/**
 * __useAddVirtualShelfMutation__
 *
 * To run a mutation, you first call `useAddVirtualShelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVirtualShelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVirtualShelfMutation, { data, loading, error }] = useAddVirtualShelfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddVirtualShelfMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddVirtualShelfMutation,
		AddVirtualShelfMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddVirtualShelfMutation,
		AddVirtualShelfMutationVariables
	>(AddVirtualShelfDocument, options)
}
export type AddVirtualShelfMutationHookResult = ReturnType<
	typeof useAddVirtualShelfMutation
>
export type AddVirtualShelfMutationResult =
	Apollo.MutationResult<AddVirtualShelfMutation>
export type AddVirtualShelfMutationOptions = Apollo.BaseMutationOptions<
	AddVirtualShelfMutation,
	AddVirtualShelfMutationVariables
>
export const DeleteVirtualShelfDocument = gql`
	mutation deleteVirtualShelf($id: Int!) {
		deleteVirtualShelf(id: $id) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteVirtualShelfMutationFn = Apollo.MutationFunction<
	DeleteVirtualShelfMutation,
	DeleteVirtualShelfMutationVariables
>

/**
 * __useDeleteVirtualShelfMutation__
 *
 * To run a mutation, you first call `useDeleteVirtualShelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVirtualShelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVirtualShelfMutation, { data, loading, error }] = useDeleteVirtualShelfMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVirtualShelfMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteVirtualShelfMutation,
		DeleteVirtualShelfMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteVirtualShelfMutation,
		DeleteVirtualShelfMutationVariables
	>(DeleteVirtualShelfDocument, options)
}
export type DeleteVirtualShelfMutationHookResult = ReturnType<
	typeof useDeleteVirtualShelfMutation
>
export type DeleteVirtualShelfMutationResult =
	Apollo.MutationResult<DeleteVirtualShelfMutation>
export type DeleteVirtualShelfMutationOptions = Apollo.BaseMutationOptions<
	DeleteVirtualShelfMutation,
	DeleteVirtualShelfMutationVariables
>
export const EditVirtualShelfDocument = gql`
	mutation editVirtualShelf($input: EditVirtualShelfInput!) {
		editVirtualShelf(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditVirtualShelfMutationFn = Apollo.MutationFunction<
	EditVirtualShelfMutation,
	EditVirtualShelfMutationVariables
>

/**
 * __useEditVirtualShelfMutation__
 *
 * To run a mutation, you first call `useEditVirtualShelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVirtualShelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVirtualShelfMutation, { data, loading, error }] = useEditVirtualShelfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditVirtualShelfMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditVirtualShelfMutation,
		EditVirtualShelfMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditVirtualShelfMutation,
		EditVirtualShelfMutationVariables
	>(EditVirtualShelfDocument, options)
}
export type EditVirtualShelfMutationHookResult = ReturnType<
	typeof useEditVirtualShelfMutation
>
export type EditVirtualShelfMutationResult =
	Apollo.MutationResult<EditVirtualShelfMutation>
export type EditVirtualShelfMutationOptions = Apollo.BaseMutationOptions<
	EditVirtualShelfMutation,
	EditVirtualShelfMutationVariables
>
export const VirtualShelfDocument = gql`
	query virtualShelf($virtualShelfId: Int!) {
		virtualShelf(virtualShelfId: $virtualShelfId) {
			virtualShelf {
				id
				name
				spacing
				variant
				virtualProductPositions {
					id
					zoom
					rotation
					itemCount
					product {
						id
						name
						internalId
						valueEntities {
							templateKey
							value
						}
						productImages {
							id
							file {
								thumbnail
								filename
								width
								height
							}
						}
					}
				}
			}
		}
	}
`

/**
 * __useVirtualShelfQuery__
 *
 * To run a query within a React component, call `useVirtualShelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualShelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualShelfQuery({
 *   variables: {
 *      virtualShelfId: // value for 'virtualShelfId'
 *   },
 * });
 */
export function useVirtualShelfQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		VirtualShelfQuery,
		VirtualShelfQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		VirtualShelfQuery,
		VirtualShelfQueryVariables
	>(VirtualShelfDocument, options)
}
export function useVirtualShelfLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		VirtualShelfQuery,
		VirtualShelfQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		VirtualShelfQuery,
		VirtualShelfQueryVariables
	>(VirtualShelfDocument, options)
}
export type VirtualShelfQueryHookResult = ReturnType<
	typeof useVirtualShelfQuery
>
export type VirtualShelfLazyQueryHookResult = ReturnType<
	typeof useVirtualShelfLazyQuery
>
export type VirtualShelfQueryResult = Apollo.QueryResult<
	VirtualShelfQuery,
	VirtualShelfQueryVariables
>
export const VirtualShelfProductsDocument = gql`
	query VirtualShelfProducts(
		$where: ProductsFilter
		$offset: Int!
		$limit: Int!
	) {
		products(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				name
				internalId
				valueEntities {
					templateKey
					value
					type
				}
				productImages {
					id
					file {
						id
						thumbnail
						width
						height
					}
				}
			}
			totalCount
		}
	}
`

/**
 * __useVirtualShelfProductsQuery__
 *
 * To run a query within a React component, call `useVirtualShelfProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualShelfProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualShelfProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useVirtualShelfProductsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		VirtualShelfProductsQuery,
		VirtualShelfProductsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		VirtualShelfProductsQuery,
		VirtualShelfProductsQueryVariables
	>(VirtualShelfProductsDocument, options)
}
export function useVirtualShelfProductsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		VirtualShelfProductsQuery,
		VirtualShelfProductsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		VirtualShelfProductsQuery,
		VirtualShelfProductsQueryVariables
	>(VirtualShelfProductsDocument, options)
}
export type VirtualShelfProductsQueryHookResult = ReturnType<
	typeof useVirtualShelfProductsQuery
>
export type VirtualShelfProductsLazyQueryHookResult = ReturnType<
	typeof useVirtualShelfProductsLazyQuery
>
export type VirtualShelfProductsQueryResult = Apollo.QueryResult<
	VirtualShelfProductsQuery,
	VirtualShelfProductsQueryVariables
>
export const VirtualShelvesDocument = gql`
	query VirtualShelves(
		$offset: Int!
		$limit: Int!
		$where: VirtualShelvesFilter
	) {
		virtualShelves(offset: $offset, limit: $limit, where: $where) {
			nodes {
				id
				name
				spacing
				variant
				virtualProductPositions {
					id
					zoom
					rotation
					itemCount
					product {
						id
						productImages {
							file {
								id
								thumbnail
								width
								height
							}
						}
					}
				}
			}
			totalCount
		}
	}
`

/**
 * __useVirtualShelvesQuery__
 *
 * To run a query within a React component, call `useVirtualShelvesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualShelvesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualShelvesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVirtualShelvesQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		VirtualShelvesQuery,
		VirtualShelvesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		VirtualShelvesQuery,
		VirtualShelvesQueryVariables
	>(VirtualShelvesDocument, options)
}
export function useVirtualShelvesLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		VirtualShelvesQuery,
		VirtualShelvesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		VirtualShelvesQuery,
		VirtualShelvesQueryVariables
	>(VirtualShelvesDocument, options)
}
export type VirtualShelvesQueryHookResult = ReturnType<
	typeof useVirtualShelvesQuery
>
export type VirtualShelvesLazyQueryHookResult = ReturnType<
	typeof useVirtualShelvesLazyQuery
>
export type VirtualShelvesQueryResult = Apollo.QueryResult<
	VirtualShelvesQuery,
	VirtualShelvesQueryVariables
>
export const AddVirtualStoreDeviceDocument = gql`
	mutation addVirtualStoreDevice($input: AddVirtualStoreDeviceInput!) {
		addVirtualStoreDevice(input: $input) {
			virtualStoreDevice {
				id
			}
			errors {
				path
				message
			}
		}
	}
`
export type AddVirtualStoreDeviceMutationFn = Apollo.MutationFunction<
	AddVirtualStoreDeviceMutation,
	AddVirtualStoreDeviceMutationVariables
>

/**
 * __useAddVirtualStoreDeviceMutation__
 *
 * To run a mutation, you first call `useAddVirtualStoreDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVirtualStoreDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVirtualStoreDeviceMutation, { data, loading, error }] = useAddVirtualStoreDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddVirtualStoreDeviceMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddVirtualStoreDeviceMutation,
		AddVirtualStoreDeviceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddVirtualStoreDeviceMutation,
		AddVirtualStoreDeviceMutationVariables
	>(AddVirtualStoreDeviceDocument, options)
}
export type AddVirtualStoreDeviceMutationHookResult = ReturnType<
	typeof useAddVirtualStoreDeviceMutation
>
export type AddVirtualStoreDeviceMutationResult =
	Apollo.MutationResult<AddVirtualStoreDeviceMutation>
export type AddVirtualStoreDeviceMutationOptions = Apollo.BaseMutationOptions<
	AddVirtualStoreDeviceMutation,
	AddVirtualStoreDeviceMutationVariables
>
export const DeleteVirtualStoreDeviceDocument = gql`
	mutation deleteVirtualStoreDevice($id: Int!) {
		deleteVirtualStoreDevice(id: $id) {
			success
			errors {
				path
				message
			}
		}
	}
`
export type DeleteVirtualStoreDeviceMutationFn = Apollo.MutationFunction<
	DeleteVirtualStoreDeviceMutation,
	DeleteVirtualStoreDeviceMutationVariables
>

/**
 * __useDeleteVirtualStoreDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteVirtualStoreDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVirtualStoreDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVirtualStoreDeviceMutation, { data, loading, error }] = useDeleteVirtualStoreDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVirtualStoreDeviceMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteVirtualStoreDeviceMutation,
		DeleteVirtualStoreDeviceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteVirtualStoreDeviceMutation,
		DeleteVirtualStoreDeviceMutationVariables
	>(DeleteVirtualStoreDeviceDocument, options)
}
export type DeleteVirtualStoreDeviceMutationHookResult = ReturnType<
	typeof useDeleteVirtualStoreDeviceMutation
>
export type DeleteVirtualStoreDeviceMutationResult =
	Apollo.MutationResult<DeleteVirtualStoreDeviceMutation>
export type DeleteVirtualStoreDeviceMutationOptions =
	Apollo.BaseMutationOptions<
		DeleteVirtualStoreDeviceMutation,
		DeleteVirtualStoreDeviceMutationVariables
	>
export const EditVirtualStoreDeviceDocument = gql`
	mutation editVirtualStoreDevice($input: EditVirtualStoreDeviceInput!) {
		editVirtualStoreDevice(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditVirtualStoreDeviceMutationFn = Apollo.MutationFunction<
	EditVirtualStoreDeviceMutation,
	EditVirtualStoreDeviceMutationVariables
>

/**
 * __useEditVirtualStoreDeviceMutation__
 *
 * To run a mutation, you first call `useEditVirtualStoreDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVirtualStoreDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVirtualStoreDeviceMutation, { data, loading, error }] = useEditVirtualStoreDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditVirtualStoreDeviceMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditVirtualStoreDeviceMutation,
		EditVirtualStoreDeviceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditVirtualStoreDeviceMutation,
		EditVirtualStoreDeviceMutationVariables
	>(EditVirtualStoreDeviceDocument, options)
}
export type EditVirtualStoreDeviceMutationHookResult = ReturnType<
	typeof useEditVirtualStoreDeviceMutation
>
export type EditVirtualStoreDeviceMutationResult =
	Apollo.MutationResult<EditVirtualStoreDeviceMutation>
export type EditVirtualStoreDeviceMutationOptions = Apollo.BaseMutationOptions<
	EditVirtualStoreDeviceMutation,
	EditVirtualStoreDeviceMutationVariables
>
export const VirtualStoreDeviceDocument = gql`
	query virtualStoreDevice($virtualStoreDeviceId: Int!) {
		virtualStoreDevice(virtualStoreDeviceId: $virtualStoreDeviceId) {
			virtualStoreDevice {
				id
				name
				tags
				token
				note
				powerWindows {
					weekday
					from
					to
				}
				root {
					id
					name
				}
				virtualCategoryScreen {
					id
					name
				}
				channel {
					id
					name
				}
				virtualMultiScreen {
					id
					name
				}
				signageButtons {
					id
					virtualStoreDeviceId
					durationSeconds
					button {
						id
						name
					}
					channel {
						id
						name
					}
				}
			}
		}
	}
`

/**
 * __useVirtualStoreDeviceQuery__
 *
 * To run a query within a React component, call `useVirtualStoreDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualStoreDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualStoreDeviceQuery({
 *   variables: {
 *      virtualStoreDeviceId: // value for 'virtualStoreDeviceId'
 *   },
 * });
 */
export function useVirtualStoreDeviceQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		VirtualStoreDeviceQuery,
		VirtualStoreDeviceQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		VirtualStoreDeviceQuery,
		VirtualStoreDeviceQueryVariables
	>(VirtualStoreDeviceDocument, options)
}
export function useVirtualStoreDeviceLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		VirtualStoreDeviceQuery,
		VirtualStoreDeviceQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		VirtualStoreDeviceQuery,
		VirtualStoreDeviceQueryVariables
	>(VirtualStoreDeviceDocument, options)
}
export type VirtualStoreDeviceQueryHookResult = ReturnType<
	typeof useVirtualStoreDeviceQuery
>
export type VirtualStoreDeviceLazyQueryHookResult = ReturnType<
	typeof useVirtualStoreDeviceLazyQuery
>
export type VirtualStoreDeviceQueryResult = Apollo.QueryResult<
	VirtualStoreDeviceQuery,
	VirtualStoreDeviceQueryVariables
>
export const VirtualStoreDevicesDocument = gql`
	query virtualStoreDevices(
		$offset: Int!
		$limit: Int!
		$where: VirtualStoreDevicesFilter
	) {
		virtualStoreDevices(offset: $offset, limit: $limit, where: $where) {
			nodes {
				id
				name
				root {
					id
					name
					marketId
				}
				channel {
					id
					name
				}
				virtualCategoryScreen {
					id
					name
				}
				virtualMultiScreen {
					id
					name
				}
				virtualCategoryPoint {
					id
					name
				}
				tags
				active
				width
				height
				version
				messageReceived
			}
			totalCount
		}
	}
`

/**
 * __useVirtualStoreDevicesQuery__
 *
 * To run a query within a React component, call `useVirtualStoreDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualStoreDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualStoreDevicesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVirtualStoreDevicesQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		VirtualStoreDevicesQuery,
		VirtualStoreDevicesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		VirtualStoreDevicesQuery,
		VirtualStoreDevicesQueryVariables
	>(VirtualStoreDevicesDocument, options)
}
export function useVirtualStoreDevicesLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		VirtualStoreDevicesQuery,
		VirtualStoreDevicesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		VirtualStoreDevicesQuery,
		VirtualStoreDevicesQueryVariables
	>(VirtualStoreDevicesDocument, options)
}
export type VirtualStoreDevicesQueryHookResult = ReturnType<
	typeof useVirtualStoreDevicesQuery
>
export type VirtualStoreDevicesLazyQueryHookResult = ReturnType<
	typeof useVirtualStoreDevicesLazyQuery
>
export type VirtualStoreDevicesQueryResult = Apollo.QueryResult<
	VirtualStoreDevicesQuery,
	VirtualStoreDevicesQueryVariables
>
export const WarehouseParentsWithChildrenDocument = gql`
	query WarehouseParentsWithChildren(
		$any: String
		$rootId: Int
		$supplierId: Int
		$alarmType: AlarmType
		$offset: Int!
		$limit: Int!
		$shelfId: Int
		$bayId: Int
		$aisleId: Int
	) {
		warehouseParentsWithChildren(
			where: {
				any: $any
				rootId: $rootId
				supplierId: $supplierId
				alarmType: $alarmType
				shelfId: $shelfId
				bayId: $bayId
				aisleId: $aisleId
			}
			offset: $offset
			limit: $limit
		) {
			nodes {
				id
				name
				internalId
				valueEntities {
					templateKey
					value
				}
				products(
					rootId: $rootId
					supplierId: $supplierId
					alarmType: $alarmType
					shelfId: $shelfId
					bayId: $bayId
					aisleId: $aisleId
				) {
					id
					internalId
					expirationDate
					valueEntities {
						templateKey
						value
					}
					root {
						id
						name
					}
					supplier {
						id
						companyName
						supplierId
					}
					positions {
						sequence
						shelf {
							key
							bay {
								key
								aisle {
									key
								}
							}
						}
					}
				}
			}
			totalCount
		}
	}
`

/**
 * __useWarehouseParentsWithChildrenQuery__
 *
 * To run a query within a React component, call `useWarehouseParentsWithChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseParentsWithChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseParentsWithChildrenQuery({
 *   variables: {
 *      any: // value for 'any'
 *      rootId: // value for 'rootId'
 *      supplierId: // value for 'supplierId'
 *      alarmType: // value for 'alarmType'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      shelfId: // value for 'shelfId'
 *      bayId: // value for 'bayId'
 *      aisleId: // value for 'aisleId'
 *   },
 * });
 */
export function useWarehouseParentsWithChildrenQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		WarehouseParentsWithChildrenQuery,
		WarehouseParentsWithChildrenQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		WarehouseParentsWithChildrenQuery,
		WarehouseParentsWithChildrenQueryVariables
	>(WarehouseParentsWithChildrenDocument, options)
}
export function useWarehouseParentsWithChildrenLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		WarehouseParentsWithChildrenQuery,
		WarehouseParentsWithChildrenQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		WarehouseParentsWithChildrenQuery,
		WarehouseParentsWithChildrenQueryVariables
	>(WarehouseParentsWithChildrenDocument, options)
}
export type WarehouseParentsWithChildrenQueryHookResult = ReturnType<
	typeof useWarehouseParentsWithChildrenQuery
>
export type WarehouseParentsWithChildrenLazyQueryHookResult = ReturnType<
	typeof useWarehouseParentsWithChildrenLazyQuery
>
export type WarehouseParentsWithChildrenQueryResult = Apollo.QueryResult<
	WarehouseParentsWithChildrenQuery,
	WarehouseParentsWithChildrenQueryVariables
>
export const DownloadPricesDocument = gql`
	query downloadPrices(
		$productType: ProductType!
		$rootId: Int
		$supplierId: Int
	) {
		downloadPrices(
			productType: $productType
			rootId: $rootId
			supplierId: $supplierId
		) {
			nodes {
				internalId
				price
			}
		}
	}
`

/**
 * __useDownloadPricesQuery__
 *
 * To run a query within a React component, call `useDownloadPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadPricesQuery({
 *   variables: {
 *      productType: // value for 'productType'
 *      rootId: // value for 'rootId'
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useDownloadPricesQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		DownloadPricesQuery,
		DownloadPricesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		DownloadPricesQuery,
		DownloadPricesQueryVariables
	>(DownloadPricesDocument, options)
}
export function useDownloadPricesLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		DownloadPricesQuery,
		DownloadPricesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		DownloadPricesQuery,
		DownloadPricesQueryVariables
	>(DownloadPricesDocument, options)
}
export type DownloadPricesQueryHookResult = ReturnType<
	typeof useDownloadPricesQuery
>
export type DownloadPricesLazyQueryHookResult = ReturnType<
	typeof useDownloadPricesLazyQuery
>
export type DownloadPricesQueryResult = Apollo.QueryResult<
	DownloadPricesQuery,
	DownloadPricesQueryVariables
>
export const OrderReportInfoDocument = gql`
	query orderReportInfo {
		info {
			rootCount
			warehouseProductCount
			totalWarehouseOrderCount
			openWarehouseOrderCount
		}
	}
`

/**
 * __useOrderReportInfoQuery__
 *
 * To run a query within a React component, call `useOrderReportInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderReportInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderReportInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderReportInfoQuery(
	baseOptions?: ApolloReactHooks.QueryHookOptions<
		OrderReportInfoQuery,
		OrderReportInfoQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		OrderReportInfoQuery,
		OrderReportInfoQueryVariables
	>(OrderReportInfoDocument, options)
}
export function useOrderReportInfoLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		OrderReportInfoQuery,
		OrderReportInfoQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		OrderReportInfoQuery,
		OrderReportInfoQueryVariables
	>(OrderReportInfoDocument, options)
}
export type OrderReportInfoQueryHookResult = ReturnType<
	typeof useOrderReportInfoQuery
>
export type OrderReportInfoLazyQueryHookResult = ReturnType<
	typeof useOrderReportInfoLazyQuery
>
export type OrderReportInfoQueryResult = Apollo.QueryResult<
	OrderReportInfoQuery,
	OrderReportInfoQueryVariables
>
export const PredictOrderQuantityDocument = gql`
	query predictOrderQuantity(
		$productId: Int!
		$startDate: DateTime!
		$endDate: DateTime!
		$deliveryTime: Int!
	) {
		predictOrderQuantity(
			productId: $productId
			startDate: $startDate
			endDate: $endDate
			deliveryTime: $deliveryTime
		) {
			quantity
			deliveryTimeDays
			avgDailyConsumption
			cleanedDataPoints
			detectedDeliveries
			regressionSlope
			errors {
				path
				message
			}
		}
	}
`

/**
 * __usePredictOrderQuantityQuery__
 *
 * To run a query within a React component, call `usePredictOrderQuantityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePredictOrderQuantityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePredictOrderQuantityQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      deliveryTime: // value for 'deliveryTime'
 *   },
 * });
 */
export function usePredictOrderQuantityQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		PredictOrderQuantityQuery,
		PredictOrderQuantityQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		PredictOrderQuantityQuery,
		PredictOrderQuantityQueryVariables
	>(PredictOrderQuantityDocument, options)
}
export function usePredictOrderQuantityLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		PredictOrderQuantityQuery,
		PredictOrderQuantityQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		PredictOrderQuantityQuery,
		PredictOrderQuantityQueryVariables
	>(PredictOrderQuantityDocument, options)
}
export type PredictOrderQuantityQueryHookResult = ReturnType<
	typeof usePredictOrderQuantityQuery
>
export type PredictOrderQuantityLazyQueryHookResult = ReturnType<
	typeof usePredictOrderQuantityLazyQuery
>
export type PredictOrderQuantityQueryResult = Apollo.QueryResult<
	PredictOrderQuantityQuery,
	PredictOrderQuantityQueryVariables
>
export const ProductQuantityHistoryDocument = gql`
	query productQuantityHistory(
		$productId: Int!
		$where: QuantityHistoryFilter
		$offset: Int!
		$limit: Int!
	) {
		quantityHistory(
			productId: $productId
			where: $where
			offset: $offset
			limit: $limit
		) {
			nodes {
				id
				created
				quantity
				quantityChange
				mode
			}
			totalCount
		}
	}
`

/**
 * __useProductQuantityHistoryQuery__
 *
 * To run a query within a React component, call `useProductQuantityHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuantityHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuantityHistoryQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProductQuantityHistoryQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		ProductQuantityHistoryQuery,
		ProductQuantityHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		ProductQuantityHistoryQuery,
		ProductQuantityHistoryQueryVariables
	>(ProductQuantityHistoryDocument, options)
}
export function useProductQuantityHistoryLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		ProductQuantityHistoryQuery,
		ProductQuantityHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		ProductQuantityHistoryQuery,
		ProductQuantityHistoryQueryVariables
	>(ProductQuantityHistoryDocument, options)
}
export type ProductQuantityHistoryQueryHookResult = ReturnType<
	typeof useProductQuantityHistoryQuery
>
export type ProductQuantityHistoryLazyQueryHookResult = ReturnType<
	typeof useProductQuantityHistoryLazyQuery
>
export type ProductQuantityHistoryQueryResult = Apollo.QueryResult<
	ProductQuantityHistoryQuery,
	ProductQuantityHistoryQueryVariables
>
export const QuantityUsageHistoryDocument = gql`
	query quantityUsageHistory(
		$productId: Int!
		$where: QuantityUsageFilter!
		$offset: Int!
		$limit: Int!
	) {
		quantityUsage(
			productId: $productId
			where: $where
			offset: $offset
			limit: $limit
		) {
			usage {
				date
				quantity
			}
			quantity {
				date
				quantity
			}
			deliveries {
				date
				quantity
				isKnown
			}
		}
	}
`

/**
 * __useQuantityUsageHistoryQuery__
 *
 * To run a query within a React component, call `useQuantityUsageHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuantityUsageHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuantityUsageHistoryQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useQuantityUsageHistoryQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		QuantityUsageHistoryQuery,
		QuantityUsageHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		QuantityUsageHistoryQuery,
		QuantityUsageHistoryQueryVariables
	>(QuantityUsageHistoryDocument, options)
}
export function useQuantityUsageHistoryLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		QuantityUsageHistoryQuery,
		QuantityUsageHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		QuantityUsageHistoryQuery,
		QuantityUsageHistoryQueryVariables
	>(QuantityUsageHistoryDocument, options)
}
export type QuantityUsageHistoryQueryHookResult = ReturnType<
	typeof useQuantityUsageHistoryQuery
>
export type QuantityUsageHistoryLazyQueryHookResult = ReturnType<
	typeof useQuantityUsageHistoryLazyQuery
>
export type QuantityUsageHistoryQueryResult = Apollo.QueryResult<
	QuantityUsageHistoryQuery,
	QuantityUsageHistoryQueryVariables
>
export const SearchChildProductsDocument = gql`
	query searchChildProducts(
		$where: ProductsFilter
		$offset: Int!
		$limit: Int!
	) {
		warehouseChildren(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				internalId
				name
				parentProduct {
					id
					name
					internalId
				}
				devices {
					id
				}
				positions {
					id
				}
			}
			totalCount
		}
	}
`

/**
 * __useSearchChildProductsQuery__
 *
 * To run a query within a React component, call `useSearchChildProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchChildProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchChildProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchChildProductsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		SearchChildProductsQuery,
		SearchChildProductsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		SearchChildProductsQuery,
		SearchChildProductsQueryVariables
	>(SearchChildProductsDocument, options)
}
export function useSearchChildProductsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		SearchChildProductsQuery,
		SearchChildProductsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		SearchChildProductsQuery,
		SearchChildProductsQueryVariables
	>(SearchChildProductsDocument, options)
}
export type SearchChildProductsQueryHookResult = ReturnType<
	typeof useSearchChildProductsQuery
>
export type SearchChildProductsLazyQueryHookResult = ReturnType<
	typeof useSearchChildProductsLazyQuery
>
export type SearchChildProductsQueryResult = Apollo.QueryResult<
	SearchChildProductsQuery,
	SearchChildProductsQueryVariables
>
export const WarehouseProductValueReportDocument = gql`
	query WarehouseProductValueReport(
		$startDate: DateTime!
		$rootId: Int
		$supplierId: Int
		$shelfId: Int
		$bayId: Int
		$aisleId: Int
	) {
		warehouseProductValueReport(
			startDate: $startDate
			rootId: $rootId
			supplierId: $supplierId
			shelfId: $shelfId
			bayId: $bayId
			aisleId: $aisleId
		) {
			reports {
				month
				EUR
				USD
				GBP
				CHF
				date
			}
		}
	}
`

/**
 * __useWarehouseProductValueReportQuery__
 *
 * To run a query within a React component, call `useWarehouseProductValueReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseProductValueReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseProductValueReportQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      rootId: // value for 'rootId'
 *      supplierId: // value for 'supplierId'
 *      shelfId: // value for 'shelfId'
 *      bayId: // value for 'bayId'
 *      aisleId: // value for 'aisleId'
 *   },
 * });
 */
export function useWarehouseProductValueReportQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		WarehouseProductValueReportQuery,
		WarehouseProductValueReportQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		WarehouseProductValueReportQuery,
		WarehouseProductValueReportQueryVariables
	>(WarehouseProductValueReportDocument, options)
}
export function useWarehouseProductValueReportLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		WarehouseProductValueReportQuery,
		WarehouseProductValueReportQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		WarehouseProductValueReportQuery,
		WarehouseProductValueReportQueryVariables
	>(WarehouseProductValueReportDocument, options)
}
export type WarehouseProductValueReportQueryHookResult = ReturnType<
	typeof useWarehouseProductValueReportQuery
>
export type WarehouseProductValueReportLazyQueryHookResult = ReturnType<
	typeof useWarehouseProductValueReportLazyQuery
>
export type WarehouseProductValueReportQueryResult = Apollo.QueryResult<
	WarehouseProductValueReportQuery,
	WarehouseProductValueReportQueryVariables
>
export const AddSupplierDocument = gql`
	mutation addSupplier($input: AddSupplier!) {
		addSupplier(input: $input) {
			errors {
				path
				message
			}
			supplier {
				id
			}
		}
	}
`
export type AddSupplierMutationFn = Apollo.MutationFunction<
	AddSupplierMutation,
	AddSupplierMutationVariables
>

/**
 * __useAddSupplierMutation__
 *
 * To run a mutation, you first call `useAddSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSupplierMutation, { data, loading, error }] = useAddSupplierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSupplierMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddSupplierMutation,
		AddSupplierMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddSupplierMutation,
		AddSupplierMutationVariables
	>(AddSupplierDocument, options)
}
export type AddSupplierMutationHookResult = ReturnType<
	typeof useAddSupplierMutation
>
export type AddSupplierMutationResult =
	Apollo.MutationResult<AddSupplierMutation>
export type AddSupplierMutationOptions = Apollo.BaseMutationOptions<
	AddSupplierMutation,
	AddSupplierMutationVariables
>
export const DeleteSupplierDocument = gql`
	mutation deleteSupplier($id: Int!) {
		deleteSupplier(id: $id) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type DeleteSupplierMutationFn = Apollo.MutationFunction<
	DeleteSupplierMutation,
	DeleteSupplierMutationVariables
>

/**
 * __useDeleteSupplierMutation__
 *
 * To run a mutation, you first call `useDeleteSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSupplierMutation, { data, loading, error }] = useDeleteSupplierMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSupplierMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		DeleteSupplierMutation,
		DeleteSupplierMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		DeleteSupplierMutation,
		DeleteSupplierMutationVariables
	>(DeleteSupplierDocument, options)
}
export type DeleteSupplierMutationHookResult = ReturnType<
	typeof useDeleteSupplierMutation
>
export type DeleteSupplierMutationResult =
	Apollo.MutationResult<DeleteSupplierMutation>
export type DeleteSupplierMutationOptions = Apollo.BaseMutationOptions<
	DeleteSupplierMutation,
	DeleteSupplierMutationVariables
>
export const EditSupplierDocument = gql`
	mutation editSupplier($input: EditSupplier!) {
		editSupplier(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type EditSupplierMutationFn = Apollo.MutationFunction<
	EditSupplierMutation,
	EditSupplierMutationVariables
>

/**
 * __useEditSupplierMutation__
 *
 * To run a mutation, you first call `useEditSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSupplierMutation, { data, loading, error }] = useEditSupplierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSupplierMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		EditSupplierMutation,
		EditSupplierMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		EditSupplierMutation,
		EditSupplierMutationVariables
	>(EditSupplierDocument, options)
}
export type EditSupplierMutationHookResult = ReturnType<
	typeof useEditSupplierMutation
>
export type EditSupplierMutationResult =
	Apollo.MutationResult<EditSupplierMutation>
export type EditSupplierMutationOptions = Apollo.BaseMutationOptions<
	EditSupplierMutation,
	EditSupplierMutationVariables
>
export const SupplierDocument = gql`
	query supplier($id: Int!) {
		supplier(supplierId: $id) {
			supplier {
				id
				companyName
				email
				supplierId
				address
				addressNumber
				country
				postCode
				city
				vat
				email
				verifiedEmail
				supplierRootSettings {
					id
					rootId
					root {
						id
						name
					}
					supplierId
					deliveryTime
				}
			}
		}
	}
`

/**
 * __useSupplierQuery__
 *
 * To run a query within a React component, call `useSupplierQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSupplierQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		SupplierQuery,
		SupplierQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<SupplierQuery, SupplierQueryVariables>(
		SupplierDocument,
		options
	)
}
export function useSupplierLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		SupplierQuery,
		SupplierQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<SupplierQuery, SupplierQueryVariables>(
		SupplierDocument,
		options
	)
}
export type SupplierQueryHookResult = ReturnType<typeof useSupplierQuery>
export type SupplierLazyQueryHookResult = ReturnType<
	typeof useSupplierLazyQuery
>
export type SupplierQueryResult = Apollo.QueryResult<
	SupplierQuery,
	SupplierQueryVariables
>
export const SuppliersDocument = gql`
	query suppliers($where: SuppliersFilter, $offset: Int!, $limit: Int!) {
		suppliers(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				companyName
				supplierId
				country
				address
				postCode
				city
			}
			totalCount
		}
	}
`

/**
 * __useSuppliersQuery__
 *
 * To run a query within a React component, call `useSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppliersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSuppliersQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		SuppliersQuery,
		SuppliersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<SuppliersQuery, SuppliersQueryVariables>(
		SuppliersDocument,
		options
	)
}
export function useSuppliersLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		SuppliersQuery,
		SuppliersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		SuppliersQuery,
		SuppliersQueryVariables
	>(SuppliersDocument, options)
}
export type SuppliersQueryHookResult = ReturnType<typeof useSuppliersQuery>
export type SuppliersLazyQueryHookResult = ReturnType<
	typeof useSuppliersLazyQuery
>
export type SuppliersQueryResult = Apollo.QueryResult<
	SuppliersQuery,
	SuppliersQueryVariables
>
export const TriggerDeviceLedDocument = gql`
	mutation triggerDeviceLed($input: TriggerDeviceLedInput!) {
		triggerDeviceLed(input: $input) {
			errors {
				path
				message
			}
			success
		}
	}
`
export type TriggerDeviceLedMutationFn = Apollo.MutationFunction<
	TriggerDeviceLedMutation,
	TriggerDeviceLedMutationVariables
>

/**
 * __useTriggerDeviceLedMutation__
 *
 * To run a mutation, you first call `useTriggerDeviceLedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerDeviceLedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerDeviceLedMutation, { data, loading, error }] = useTriggerDeviceLedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerDeviceLedMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		TriggerDeviceLedMutation,
		TriggerDeviceLedMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		TriggerDeviceLedMutation,
		TriggerDeviceLedMutationVariables
	>(TriggerDeviceLedDocument, options)
}
export type TriggerDeviceLedMutationHookResult = ReturnType<
	typeof useTriggerDeviceLedMutation
>
export type TriggerDeviceLedMutationResult =
	Apollo.MutationResult<TriggerDeviceLedMutation>
export type TriggerDeviceLedMutationOptions = Apollo.BaseMutationOptions<
	TriggerDeviceLedMutation,
	TriggerDeviceLedMutationVariables
>
export const WarehouseOrderReportDocument = gql`
	query warehouseOrderReport($input: WarehouseOrderReportInput!) {
		warehouseOrderReport(input: $input) {
			allOrders {
				date
				normalCount
				expressCount
				total
			}
			stockValue {
				date
				EUR
				USD
				GBP
				CHF
			}
		}
	}
`

/**
 * __useWarehouseOrderReportQuery__
 *
 * To run a query within a React component, call `useWarehouseOrderReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseOrderReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseOrderReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWarehouseOrderReportQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		WarehouseOrderReportQuery,
		WarehouseOrderReportQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		WarehouseOrderReportQuery,
		WarehouseOrderReportQueryVariables
	>(WarehouseOrderReportDocument, options)
}
export function useWarehouseOrderReportLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		WarehouseOrderReportQuery,
		WarehouseOrderReportQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		WarehouseOrderReportQuery,
		WarehouseOrderReportQueryVariables
	>(WarehouseOrderReportDocument, options)
}
export type WarehouseOrderReportQueryHookResult = ReturnType<
	typeof useWarehouseOrderReportQuery
>
export type WarehouseOrderReportLazyQueryHookResult = ReturnType<
	typeof useWarehouseOrderReportLazyQuery
>
export type WarehouseOrderReportQueryResult = Apollo.QueryResult<
	WarehouseOrderReportQuery,
	WarehouseOrderReportQueryVariables
>
export const WarehouseParentProductDocument = gql`
	query warehouseParentProduct($id: Int!) {
		product(id: $id) {
			product {
				id
				internalId
				name
				valueEntities {
					templateKey
					value
				}
				productImages {
					id
					primary
					file {
						id
						originalname
						filename
						mimetype
						encoding
						url
						isFolder
						width
						height
						thumbnail
					}
				}
			}
		}
	}
`

/**
 * __useWarehouseParentProductQuery__
 *
 * To run a query within a React component, call `useWarehouseParentProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseParentProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseParentProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWarehouseParentProductQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		WarehouseParentProductQuery,
		WarehouseParentProductQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		WarehouseParentProductQuery,
		WarehouseParentProductQueryVariables
	>(WarehouseParentProductDocument, options)
}
export function useWarehouseParentProductLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		WarehouseParentProductQuery,
		WarehouseParentProductQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		WarehouseParentProductQuery,
		WarehouseParentProductQueryVariables
	>(WarehouseParentProductDocument, options)
}
export type WarehouseParentProductQueryHookResult = ReturnType<
	typeof useWarehouseParentProductQuery
>
export type WarehouseParentProductLazyQueryHookResult = ReturnType<
	typeof useWarehouseParentProductLazyQuery
>
export type WarehouseParentProductQueryResult = Apollo.QueryResult<
	WarehouseParentProductQuery,
	WarehouseParentProductQueryVariables
>
export const WarehouseParentProductsDocument = gql`
	query warehouseParentProducts(
		$where: ProductsFilter
		$offset: Int!
		$limit: Int!
	) {
		products(where: $where, offset: $offset, limit: $limit) {
			nodes {
				id
				name
				internalId
				valueEntities {
					templateKey
					value
				}
				products {
					id
					internalId
					name
					valueEntities {
						templateKey
						value
					}
					root {
						id
						name
					}
					supplier {
						id
						companyName
						supplierId
					}
					positions {
						id
						sequence
						shelf {
							key
							bay {
								key
								aisle {
									key
								}
							}
						}
					}
				}
				productImages {
					id
					file {
						thumbnail
					}
				}
			}
			totalCount
		}
	}
`

/**
 * __useWarehouseParentProductsQuery__
 *
 * To run a query within a React component, call `useWarehouseParentProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseParentProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseParentProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useWarehouseParentProductsQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		WarehouseParentProductsQuery,
		WarehouseParentProductsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		WarehouseParentProductsQuery,
		WarehouseParentProductsQueryVariables
	>(WarehouseParentProductsDocument, options)
}
export function useWarehouseParentProductsLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		WarehouseParentProductsQuery,
		WarehouseParentProductsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		WarehouseParentProductsQuery,
		WarehouseParentProductsQueryVariables
	>(WarehouseParentProductsDocument, options)
}
export type WarehouseParentProductsQueryHookResult = ReturnType<
	typeof useWarehouseParentProductsQuery
>
export type WarehouseParentProductsLazyQueryHookResult = ReturnType<
	typeof useWarehouseParentProductsLazyQuery
>
export type WarehouseParentProductsQueryResult = Apollo.QueryResult<
	WarehouseParentProductsQuery,
	WarehouseParentProductsQueryVariables
>
export const WarehouseProductDocument = gql`
	query warehouseProduct($id: Int!) {
		product(id: $id) {
			product {
				id
				internalId
				name
				rootId
				expirationDate
				parentProduct {
					id
					name
					internalId
					valueEntities {
						templateKey
						value
					}
					productImages {
						id
						primary
						file {
							id
							originalname
							filename
							mimetype
							encoding
							url
							isFolder
							width
							height
							thumbnail
						}
					}
				}
				supplier {
					id
					supplierId
					companyName
					supplierRootSettings {
						rootId
						deliveryTime
					}
				}
				valueEntities {
					templateKey
					value
				}
				positions {
					id
					sequence
					device {
						id
						serialNumber
					}
					shelf {
						key
						bay {
							key
							aisle {
								key
							}
						}
					}
				}
				devices {
					id
					serialNumber
				}
			}
		}
	}
`

/**
 * __useWarehouseProductQuery__
 *
 * To run a query within a React component, call `useWarehouseProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWarehouseProductQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		WarehouseProductQuery,
		WarehouseProductQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		WarehouseProductQuery,
		WarehouseProductQueryVariables
	>(WarehouseProductDocument, options)
}
export function useWarehouseProductLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		WarehouseProductQuery,
		WarehouseProductQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		WarehouseProductQuery,
		WarehouseProductQueryVariables
	>(WarehouseProductDocument, options)
}
export type WarehouseProductQueryHookResult = ReturnType<
	typeof useWarehouseProductQuery
>
export type WarehouseProductLazyQueryHookResult = ReturnType<
	typeof useWarehouseProductLazyQuery
>
export type WarehouseProductQueryResult = Apollo.QueryResult<
	WarehouseProductQuery,
	WarehouseProductQueryVariables
>
export const AddWarehouseProductsDocument = gql`
	mutation addWarehouseProducts($input: [ProductInput!]!) {
		addEditProducts(input: $input) {
			errors {
				path
				message
			}
			success
			addedProducts {
				id
				internalId
				name
				rootId
				valueEntities {
					id
					name
					templateKey
					type
					value
				}
			}
		}
	}
`
export type AddWarehouseProductsMutationFn = Apollo.MutationFunction<
	AddWarehouseProductsMutation,
	AddWarehouseProductsMutationVariables
>

/**
 * __useAddWarehouseProductsMutation__
 *
 * To run a mutation, you first call `useAddWarehouseProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWarehouseProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWarehouseProductsMutation, { data, loading, error }] = useAddWarehouseProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddWarehouseProductsMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddWarehouseProductsMutation,
		AddWarehouseProductsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddWarehouseProductsMutation,
		AddWarehouseProductsMutationVariables
	>(AddWarehouseProductsDocument, options)
}
export type AddWarehouseProductsMutationHookResult = ReturnType<
	typeof useAddWarehouseProductsMutation
>
export type AddWarehouseProductsMutationResult =
	Apollo.MutationResult<AddWarehouseProductsMutation>
export type AddWarehouseProductsMutationOptions = Apollo.BaseMutationOptions<
	AddWarehouseProductsMutation,
	AddWarehouseProductsMutationVariables
>
export const AddEditWarehouseProductsNewPositionDocument = gql`
	mutation addEditWarehouseProductsNewPosition(
		$input: [ProductInput!]!
		$positionId: Int!
		$positionInput: EditPositionInput!
	) {
		addEditProducts(input: $input) {
			errors {
				path
				message
			}
			success
			addedProducts {
				id
				internalId
				name
				rootId
				valueEntities {
					id
					name
					templateKey
					type
					value
				}
			}
		}
		editPosition(positionId: $positionId, input: $positionInput) {
			errors {
				message
				path
			}
			success
		}
	}
`
export type AddEditWarehouseProductsNewPositionMutationFn =
	Apollo.MutationFunction<
		AddEditWarehouseProductsNewPositionMutation,
		AddEditWarehouseProductsNewPositionMutationVariables
	>

/**
 * __useAddEditWarehouseProductsNewPositionMutation__
 *
 * To run a mutation, you first call `useAddEditWarehouseProductsNewPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEditWarehouseProductsNewPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEditWarehouseProductsNewPositionMutation, { data, loading, error }] = useAddEditWarehouseProductsNewPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      positionId: // value for 'positionId'
 *      positionInput: // value for 'positionInput'
 *   },
 * });
 */
export function useAddEditWarehouseProductsNewPositionMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddEditWarehouseProductsNewPositionMutation,
		AddEditWarehouseProductsNewPositionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddEditWarehouseProductsNewPositionMutation,
		AddEditWarehouseProductsNewPositionMutationVariables
	>(AddEditWarehouseProductsNewPositionDocument, options)
}
export type AddEditWarehouseProductsNewPositionMutationHookResult = ReturnType<
	typeof useAddEditWarehouseProductsNewPositionMutation
>
export type AddEditWarehouseProductsNewPositionMutationResult =
	Apollo.MutationResult<AddEditWarehouseProductsNewPositionMutation>
export type AddEditWarehouseProductsNewPositionMutationOptions =
	Apollo.BaseMutationOptions<
		AddEditWarehouseProductsNewPositionMutation,
		AddEditWarehouseProductsNewPositionMutationVariables
	>
export const AddEditWarehouseProductsOldPositionDocument = gql`
	mutation addEditWarehouseProductsOldPosition(
		$input: [ProductInput!]!
		$oldPositionId: Int!
		$oldPositionInput: EditPositionInput!
	) {
		addEditProducts(input: $input) {
			errors {
				path
				message
			}
			success
			addedProducts {
				id
				internalId
				name
				rootId
				valueEntities {
					id
					name
					templateKey
					type
					value
				}
			}
		}
		editPosition(positionId: $oldPositionId, input: $oldPositionInput) {
			errors {
				message
				path
			}
			success
		}
	}
`
export type AddEditWarehouseProductsOldPositionMutationFn =
	Apollo.MutationFunction<
		AddEditWarehouseProductsOldPositionMutation,
		AddEditWarehouseProductsOldPositionMutationVariables
	>

/**
 * __useAddEditWarehouseProductsOldPositionMutation__
 *
 * To run a mutation, you first call `useAddEditWarehouseProductsOldPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEditWarehouseProductsOldPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEditWarehouseProductsOldPositionMutation, { data, loading, error }] = useAddEditWarehouseProductsOldPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      oldPositionId: // value for 'oldPositionId'
 *      oldPositionInput: // value for 'oldPositionInput'
 *   },
 * });
 */
export function useAddEditWarehouseProductsOldPositionMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddEditWarehouseProductsOldPositionMutation,
		AddEditWarehouseProductsOldPositionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddEditWarehouseProductsOldPositionMutation,
		AddEditWarehouseProductsOldPositionMutationVariables
	>(AddEditWarehouseProductsOldPositionDocument, options)
}
export type AddEditWarehouseProductsOldPositionMutationHookResult = ReturnType<
	typeof useAddEditWarehouseProductsOldPositionMutation
>
export type AddEditWarehouseProductsOldPositionMutationResult =
	Apollo.MutationResult<AddEditWarehouseProductsOldPositionMutation>
export type AddEditWarehouseProductsOldPositionMutationOptions =
	Apollo.BaseMutationOptions<
		AddEditWarehouseProductsOldPositionMutation,
		AddEditWarehouseProductsOldPositionMutationVariables
	>
export const AddEditWarehouseProductsOldPositionNewPositionDocument = gql`
	mutation addEditWarehouseProductsOldPositionNewPosition(
		$input: [ProductInput!]!
		$positionId: Int!
		$positionInput: EditPositionInput!
		$oldPositionId: Int!
		$oldPositionInput: EditPositionInput!
	) {
		addEditProducts(input: $input) {
			errors {
				path
				message
			}
			success
			addedProducts {
				id
				internalId
				name
				rootId
				valueEntities {
					id
					name
					templateKey
					type
					value
				}
			}
		}
		A: editPosition(positionId: $positionId, input: $positionInput) {
			errors {
				message
				path
			}
			success
		}
		B: editPosition(positionId: $oldPositionId, input: $oldPositionInput) {
			errors {
				message
				path
			}
			success
		}
	}
`
export type AddEditWarehouseProductsOldPositionNewPositionMutationFn =
	Apollo.MutationFunction<
		AddEditWarehouseProductsOldPositionNewPositionMutation,
		AddEditWarehouseProductsOldPositionNewPositionMutationVariables
	>

/**
 * __useAddEditWarehouseProductsOldPositionNewPositionMutation__
 *
 * To run a mutation, you first call `useAddEditWarehouseProductsOldPositionNewPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEditWarehouseProductsOldPositionNewPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEditWarehouseProductsOldPositionNewPositionMutation, { data, loading, error }] = useAddEditWarehouseProductsOldPositionNewPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      positionId: // value for 'positionId'
 *      positionInput: // value for 'positionInput'
 *      oldPositionId: // value for 'oldPositionId'
 *      oldPositionInput: // value for 'oldPositionInput'
 *   },
 * });
 */
export function useAddEditWarehouseProductsOldPositionNewPositionMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddEditWarehouseProductsOldPositionNewPositionMutation,
		AddEditWarehouseProductsOldPositionNewPositionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddEditWarehouseProductsOldPositionNewPositionMutation,
		AddEditWarehouseProductsOldPositionNewPositionMutationVariables
	>(AddEditWarehouseProductsOldPositionNewPositionDocument, options)
}
export type AddEditWarehouseProductsOldPositionNewPositionMutationHookResult =
	ReturnType<typeof useAddEditWarehouseProductsOldPositionNewPositionMutation>
export type AddEditWarehouseProductsOldPositionNewPositionMutationResult =
	Apollo.MutationResult<AddEditWarehouseProductsOldPositionNewPositionMutation>
export type AddEditWarehouseProductsOldPositionNewPositionMutationOptions =
	Apollo.BaseMutationOptions<
		AddEditWarehouseProductsOldPositionNewPositionMutation,
		AddEditWarehouseProductsOldPositionNewPositionMutationVariables
	>
export const AddWarehouseProductDocument = gql`
	mutation addWarehouseProduct($input: ProductInput!) {
		addProduct(input: $input) {
			errors {
				path
				message
			}
			success
			product {
				id
			}
		}
	}
`
export type AddWarehouseProductMutationFn = Apollo.MutationFunction<
	AddWarehouseProductMutation,
	AddWarehouseProductMutationVariables
>

/**
 * __useAddWarehouseProductMutation__
 *
 * To run a mutation, you first call `useAddWarehouseProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWarehouseProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWarehouseProductMutation, { data, loading, error }] = useAddWarehouseProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddWarehouseProductMutation(
	baseOptions?: ApolloReactHooks.MutationHookOptions<
		AddWarehouseProductMutation,
		AddWarehouseProductMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useMutation<
		AddWarehouseProductMutation,
		AddWarehouseProductMutationVariables
	>(AddWarehouseProductDocument, options)
}
export type AddWarehouseProductMutationHookResult = ReturnType<
	typeof useAddWarehouseProductMutation
>
export type AddWarehouseProductMutationResult =
	Apollo.MutationResult<AddWarehouseProductMutation>
export type AddWarehouseProductMutationOptions = Apollo.BaseMutationOptions<
	AddWarehouseProductMutation,
	AddWarehouseProductMutationVariables
>
export const WarehouseProductReportDocument = gql`
	query warehouseProductReport(
		$date: DateTime!
		$rootId: Int
		$supplierId: Int
		$shelfId: Int
		$bayId: Int
		$aisleId: Int
	) {
		warehouseProductReport(
			date: $date
			rootId: $rootId
			supplierId: $supplierId
			shelfId: $shelfId
			bayId: $bayId
			aisleId: $aisleId
		) {
			product {
				id
				internalId
				name
				root {
					name
				}
				supplier {
					companyName
				}
				valueEntities {
					templateKey
					value
				}
				parentProduct {
					name
				}
				products {
					id
					internalId
					name
					valueEntities {
						templateKey
						value
					}
				}
			}
			quantity
			lastChange
			mode
		}
	}
`

/**
 * __useWarehouseProductReportQuery__
 *
 * To run a query within a React component, call `useWarehouseProductReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseProductReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseProductReportQuery({
 *   variables: {
 *      date: // value for 'date'
 *      rootId: // value for 'rootId'
 *      supplierId: // value for 'supplierId'
 *      shelfId: // value for 'shelfId'
 *      bayId: // value for 'bayId'
 *      aisleId: // value for 'aisleId'
 *   },
 * });
 */
export function useWarehouseProductReportQuery(
	baseOptions: ApolloReactHooks.QueryHookOptions<
		WarehouseProductReportQuery,
		WarehouseProductReportQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useQuery<
		WarehouseProductReportQuery,
		WarehouseProductReportQueryVariables
	>(WarehouseProductReportDocument, options)
}
export function useWarehouseProductReportLazyQuery(
	baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
		WarehouseProductReportQuery,
		WarehouseProductReportQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions }
	return ApolloReactHooks.useLazyQuery<
		WarehouseProductReportQuery,
		WarehouseProductReportQueryVariables
	>(WarehouseProductReportDocument, options)
}
export type WarehouseProductReportQueryHookResult = ReturnType<
	typeof useWarehouseProductReportQuery
>
export type WarehouseProductReportLazyQueryHookResult = ReturnType<
	typeof useWarehouseProductReportLazyQuery
>
export type WarehouseProductReportQueryResult = Apollo.QueryResult<
	WarehouseProductReportQuery,
	WarehouseProductReportQueryVariables
>
